var Bp = Object.defineProperty;
var xl = (e) => {
  throw TypeError(e);
};
var kp = (e, t, n) => t in e ? Bp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ie = (e, t, n) => kp(e, typeof t != "symbol" ? t + "" : t, n), fi = (e, t, n) => t.has(e) || xl("Cannot " + n);
var L = (e, t, n) => (fi(e, t, "read from private field"), n ? n.call(e) : t.get(e)), de = (e, t, n) => t.has(e) ? xl("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), ee = (e, t, n, a) => (fi(e, t, "write to private field"), a ? a.call(e, n) : t.set(e, n), n), et = (e, t, n) => (fi(e, t, "access private method"), n);
var Js = (e, t, n, a) => ({
  set _(s) {
    ee(e, t, s, n);
  },
  get _() {
    return L(e, t, a);
  }
});
import { inject as Ht, reactive as un, defineComponent as j, computed as U, resolveComponent as se, createElementBlock as O, openBlock as C, normalizeClass as J, createElementVNode as x, createVNode as B, ref as T, onMounted as Ge, toDisplayString as P, unref as k, Fragment as me, renderList as qe, normalizeStyle as Le, renderSlot as X, mergeModels as It, useModel as Ie, createBlock as H, withCtx as D, watch as ye, createCommentVNode as $, h as Qo, isRef as Mu, nextTick as Tn, resolveDirective as ws, withDirectives as an, createTextVNode as Te, toRefs as ft, onBeforeMount as Uo, onUnmounted as Mn, withKeys as Is, withModifiers as xt, vModelDynamic as _p, shallowRef as wr, getCurrentInstance as za, Text as Sp, vShow as Li, Teleport as Dp, watchEffect as qn, mergeProps as Ir, toHandlers as Lu, useCssVars as Br, createStaticVNode as Tp, render as Ne, readonly as Mp, onBeforeUpdate as Lp, onBeforeUnmount as Op } from "vue";
import { defineStore as aa, storeToRefs as Np, setActivePinia as Rp } from "pinia";
import Pp from "primevue/toggleswitch";
import { v5 as Fp } from "uuid";
import { STLLibrary as po, WebCADModule as Qp, AuthAPI as Up } from "@xlabmedical/medic-api";
import { updatePreset as Gp, definePreset as Co } from "@primevue/themes";
import Yp from "primevue/config";
import jp from "primevue/autocomplete";
import Hp from "primevue/accordion";
import Vp from "primevue/accordiontab";
import Kp from "primevue/avatar";
import Wp from "primevue/avatargroup";
import zp from "primevue/badge";
import $p from "primevue/badgedirective";
import Vn from "primevue/button";
import qp from "primevue/breadcrumb";
import Jp from "primevue/calendar";
import Xp from "primevue/card";
import Zp from "primevue/cascadeselect";
import em from "primevue/carousel";
import tm from "primevue/checkbox";
import Ou from "primevue/chip";
import nm from "primevue/chips";
import kr from "primevue/colorpicker";
import am from "primevue/column";
import sm from "primevue/confirmdialog";
import om from "primevue/confirmpopup";
import Nu from "primevue/contextmenu";
import im from "primevue/confirmationservice";
import rm from "primevue/datatable";
import Ru from "primevue/dialog";
import Pu from "primevue/divider";
import lm from "primevue/dropdown";
import cm from "primevue/fieldset";
import um from "primevue/fileupload";
import dm from "primevue/galleria";
import Fu from "primevue/image";
import fm from "primevue/inlinemessage";
import pm from "primevue/inplace";
import Qu from "primevue/inputswitch";
import _r from "primevue/inputtext";
import mm from "primevue/inputmask";
import Go from "primevue/inputnumber";
import Am from "primevue/knob";
import Uu from "primevue/listbox";
import gm from "primevue/megamenu";
import hm from "primevue/menu";
import vm from "primevue/menubar";
import ym from "primevue/message";
import bm from "primevue/multiselect";
import xm from "primevue/orderlist";
import Em from "primevue/organizationchart";
import Bs from "primevue/popover";
import Cm from "primevue/paginator";
import wm from "primevue/panel";
import Im from "primevue/panelmenu";
import Bm from "primevue/password";
import km from "primevue/picklist";
import _m from "primevue/progressbar";
import Sm from "primevue/rating";
import Dm from "primevue/radiobutton";
import Tm from "primevue/ripple";
import Mm from "primevue/selectbutton";
import Lm from "primevue/scrollpanel";
import Om from "primevue/scrolltop";
import Nm from "primevue/skeleton";
import Sr from "primevue/slider";
import Rm from "primevue/sidebar";
import Pm from "primevue/splitbutton";
import Fm from "primevue/splitter";
import Qm from "primevue/splitterpanel";
import Um from "primevue/steps";
import Gm from "primevue/tabmenu";
import Ym from "primevue/tieredmenu";
import jm from "primevue/textarea";
import Hm from "primevue/toast";
import Vm from "primevue/toolbar";
import Km from "primevue/tabview";
import Wm from "primevue/tabpanel";
import zm from "primevue/tag";
import $m from "primevue/timeline";
import qm from "primevue/toastservice";
import Jm from "primevue/togglebutton";
import Xm from "primevue/tooltip";
import Zm from "primevue/tree";
import eA from "primevue/treeselect";
import tA from "primevue/treetable";
import { useToast as nA } from "primevue/usetoast";
import { useLocalStorage as aA } from "@vueuse/core";
import El from "primevue/dialogservice";
import sA from "@primevue/themes/aura";
import { useDialog as Gu } from "primevue/usedialog";
import Yo from "primevue/select";
import oA from "primevue/progressspinner";
import iA from "primevue/steplist";
import rA from "primevue/step";
import lA from "primevue/stepper";
import { useRoute as cA } from "vue-router";
function Yu(e, t) {
  for (var n = 0; n < t.length; n++) {
    const a = t[n];
    if (typeof a != "string" && !Array.isArray(a)) {
      for (const s in a)
        if (s !== "default" && !(s in e)) {
          const o = Object.getOwnPropertyDescriptor(a, s);
          o && Object.defineProperty(e, s, o.get ? o : {
            enumerable: !0,
            get: () => a[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function jo() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(t, n) {
      let a = e.get(t);
      return a ? a.push(n) : a = [n], e.set(t, a), this;
    },
    off(t, n) {
      let a = e.get(t);
      return a && a.splice(a.indexOf(n) >>> 0, 1), this;
    },
    emit(t, n) {
      let a = e.get(t);
      a && a.slice().map((s) => {
        s(n);
      });
    },
    clear() {
      e.clear();
    }
  };
}
const uA = jo();
var V = /* @__PURE__ */ ((e) => (e.EN = "en", e.IT = "it", e.BG = "bg", e.ZH_HANS = "zh_hans", e.HR = "hr", e.CS = "cs", e.DA = "da", e.NL = "nl", e.FR = "fr", e.DE = "de", e.HU = "hu", e.JA = "ja", e.KO = "ko", e.LT = "lt", e.PL = "pl", e.PT = "pt", e.RO = "ro", e.SK = "sk", e.SL = "sl", e.ES = "es", e.SV = "sv", e.TR = "tr", e))(V || {}), sn = /* @__PURE__ */ ((e) => (e.SIDEBAR = "sidebar", e.STATIC = "static", e.OVERLAY = "overlay", e.HORIZONTAL = "horizontal", e.SLIM = "slim", e))(sn || {}), $a = /* @__PURE__ */ ((e) => (e.DARK = "dark", e.LIGHT = "light", e))($a || {}), yn = /* @__PURE__ */ ((e) => (e.BLUE = "blue", e.GREEN = "green", e.MAGENTA = "magenta", e.ORANGE = "orange", e.PURPLE = "purple", e.RED = "red", e.TEAL = "teal", e.YELLOW = "yellow", e))(yn || {});
function dA() {
  const e = localStorage.getItem("navBarPos");
  return e ? JSON.parse(e) : "sidebar";
}
function fA() {
  return "default-blue";
}
function pA() {
  const e = localStorage.getItem("colorScheme");
  return e ? JSON.parse(e) : "dark";
}
class ju {
  constructor() {
    ie(this, "activeInlineProfile", !1);
    ie(this, "configActive", !1);
    ie(this, "configClick", !1);
    ie(this, "inlineMenuClick", !1);
    ie(this, "menu", []);
    ie(this, "menuActive", !1);
    ie(this, "menuClick", !1);
    ie(this, "menuMode", dA());
    ie(this, "overlayMenuActive", !1);
    ie(this, "pinActive", !1);
    ie(this, "rightMenuActive", !1);
    ie(this, "rightMenuClick", !1);
    ie(this, "search", !1);
    ie(this, "searchActive", !1);
    ie(this, "searchClick", !1);
    ie(this, "sidebarActive", !1);
    ie(this, "sidebarStatic", !1);
    ie(this, "staticMenuDesktopInactive", !1);
    ie(this, "staticMenuMobileActive", !1);
    ie(this, "topbarItemClick", !1);
    ie(this, "topbarMenuActive", !1);
    ie(this, "colorScheme", pA());
    ie(this, "componentTheme", "");
    ie(this, "theme", fA());
    ie(this, "topbarTheme", "");
  }
  isHorizontal() {
    return this.menuMode === "horizontal";
  }
  isSlim() {
    return this.menuMode === "slim";
  }
  isOverlay() {
    return this.menuMode === "overlay";
  }
  isStatic() {
    return this.menuMode === "static";
  }
  isSidebar() {
    return this.menuMode === "sidebar";
  }
  isDesktop() {
    return window.innerWidth > 991;
  }
  isMobile() {
    return window.innerWidth <= 991;
  }
  onChangeColorScheme(t) {
    this.changeStyleSheetUrl("layout-css", "layout-" + t + ".css", 1), this.changeStyleSheetUrl("theme-css", "theme-" + t + ".css", 1), this.colorScheme = t;
  }
  onChangeMenuTheme(t) {
    const n = document.getElementById("layout-css"), a = "layout/css/" + t + "/layout-" + this.colorScheme + ".css";
    n && this.replaceLink(n, a), this.theme = t;
  }
  onChangeComponentTheme(t) {
    const n = document.getElementById("theme-css"), a = "theme/" + t + "/theme-" + this.colorScheme + ".css";
    n && this.replaceLink(n, a), this.componentTheme = t;
  }
  changeStyleSheetUrl(t, n, a) {
    const s = document.getElementById(t);
    if (s) {
      const o = s.getAttribute("href");
      if (o) {
        const i = o.split("/");
        a === 1 ? i[i.length - 1] = n : a === 2 && (i[i.length - 2] = n);
        const r = i.join("/");
        this.replaceLink(s, r);
      }
    }
  }
  replaceLink(t, n, a) {
    const s = t.getAttribute("id"), o = t.cloneNode(!0);
    o.setAttribute("href", n), o.setAttribute("id", s + "-clone");
    const i = t.parentNode;
    i && i.insertBefore(o, t.nextSibling), o.addEventListener("load", () => {
      t.remove(), s && (o.setAttribute("id", s), a && a());
    });
  }
}
const mA = {
  symbol: Symbol(),
  install(e) {
    const t = un(new ju()), n = un({ theme: "Aura", darkTheme: !0 });
    t.menu = [], e.config.globalProperties.$guiConfig = t, e.config.globalProperties.$appState = n, e.provide(this.symbol, t);
  }
};
function Hu() {
  const e = Ht(mA.symbol);
  return e === void 0 ? new ju() : e;
}
const Kn = aa("userSettingsStore", {
  state: () => ({
    loading: !1,
    menuMode: {},
    colorScheme: {},
    colorTheme: {},
    wizardLayouts: {},
    selectedWizardIndex: {},
    lastSelectedImplantId: void 0,
    lastSelectedAbutmentId: void 0,
    lastSelectedSleeveId: void 0,
    lastAppliedImplant: {},
    showDoctorsOnPatientList: !1,
    patientListFilter: {},
    timezone: ""
  }),
  actions: {
    prepareDefaults(e) {
      const t = localStorage.getItem("navBarPos");
      if (this.menuMode = t ? JSON.parse(t) : sn.SIDEBAR, e) {
        const i = localStorage.getItem("wizardLayouts");
        this.wizardLayouts = i ? JSON.parse(i) : e;
      }
      const n = localStorage.getItem("selectedWizardIndex");
      this.selectedWizardIndex = n ? JSON.parse(n) : 0;
      const a = localStorage.getItem("colorScheme");
      this.colorScheme = a ? JSON.parse(a) : $a.DARK, this.colorTheme = "default-blue", this.lastSelectedImplantId = localStorage.getItem("lastSelectedImplantId") ?? "", this.lastSelectedAbutmentId = localStorage.getItem("lastSelectedAbutmentId") ?? "", this.lastSelectedSleeveId = localStorage.getItem("lastSelectedSleeveId") ?? "", localStorage.getItem("lastAppliedImplant") && (this.lastAppliedImplant = JSON.parse(localStorage.getItem("lastAppliedImplant") ?? ""));
      const o = localStorage.getItem("showDoctorsOnPatientList") ?? !1;
      this.showDoctorsOnPatientList = o ? JSON.parse(o) : !1;
    },
    prepareWeblinkDefaults() {
      this.timezone = "";
    },
    setNavbarPosition(e) {
      localStorage.setItem("navBarPos", JSON.stringify(e)), this.menuMode = e;
    },
    getNavbarPosition() {
      const e = localStorage.getItem("navBarPos");
      return e ? this.menuMode = JSON.parse(e) : this.menuMode = sn.SIDEBAR;
    },
    getColorScheme() {
      const e = localStorage.getItem("colorScheme");
      return e ? this.colorScheme = JSON.parse(e) : this.colorScheme = $a.DARK;
    },
    updateColorScheme(e) {
      this.colorScheme = e, this.colorScheme && localStorage.setItem("colorScheme", JSON.stringify(this.colorScheme));
    },
    getColorTheme() {
      return this.colorTheme || "default-blue";
    },
    updateColorTheme(e) {
      this.colorTheme = e, localStorage.setItem("colorTheme", JSON.stringify(this.colorTheme) ?? "");
    },
    setWizardLayout(e, t) {
      this.wizardLayouts[e] = t, localStorage.setItem("wizardLayouts", JSON.stringify(this.wizardLayouts));
    },
    updateSelectedWizardIndex(e) {
      this.selectedWizardIndex = e, localStorage.setItem("selectedWizardIndex", JSON.stringify(this.selectedWizardIndex));
    },
    updateLastSelection(e) {
      this.updateLastSelectedImplantId(e.implantId), this.updateLastSelectedAbutmentId(e.abutmentId), this.updateLastSelectedSleeveId(e.sleeveId);
    },
    updateLastSelectedImplantId(e) {
      this.lastSelectedImplantId = e, e ? localStorage.setItem("lastSelectedImplantId", e) : localStorage.removeItem("lastSelectedImplantId");
    },
    updateLastSelectedAbutmentId(e) {
      this.lastSelectedAbutmentId = e, e ? localStorage.setItem("lastSelectedAbutmentId", e) : localStorage.removeItem("lastSelectedAbutmentId");
    },
    updateLastSelectedSleeveId(e) {
      this.lastSelectedSleeveId = e, e ? localStorage.setItem("lastSelectedSleeveId", e) : localStorage.removeItem("lastSelectedSleeveId");
    },
    getLastAppliedImplant() {
      return this.lastAppliedImplant;
    },
    updateLastAppliedImplant(e) {
      this.lastAppliedImplant = e, localStorage.setItem("lastAppliedImplant", JSON.stringify(e));
    },
    getShowDoctorsOnPatientList() {
      return this.showDoctorsOnPatientList;
    },
    updateShowDoctorsOnPatientList() {
      this.showDoctorsOnPatientList = !this.showDoctorsOnPatientList, localStorage.setItem("showDoctorsOnPatientList", JSON.stringify(this.showDoctorsOnPatientList));
    },
    getUserTimezone() {
      return this.timezone ?? "";
    },
    updateUserTimezone(e) {
      this.timezone = e;
    }
  }
}), AA = {
  class: "layout-main bg-body",
  id: "div-body"
}, gA = {
  class: "layout-main-content",
  style: { padding: "0" }
}, pD = /* @__PURE__ */ j({
  __name: "App",
  emits: [
    "layout-mode-change",
    "menu-theme",
    "layoutModeChange",
    "sidebar-mouse-over",
    "sidebar-mouse-leave",
    "change-color-scheme",
    "change-component-theme",
    "change-menu-theme",
    "change-inlinemenu"
  ],
  setup(e, { emit: t }) {
    const n = Hu(), a = Kn(), { menuMode: s } = Np(a);
    function o() {
      n.menuClick || ((n.isHorizontal() || n.isSlim()) && (n.menuActive = !1, uA.emit("reset-active-index")), (n.overlayMenuActive || n.staticMenuMobileActive) && (n.overlayMenuActive = !1, n.staticMenuMobileActive = !1), i(), r()), n.configActive && !n.configClick && (n.configActive = !1), n.menuClick = !1, n.configClick = !1;
    }
    function i() {
      n.overlayMenuActive = !1, n.staticMenuMobileActive = !1;
    }
    function r() {
      document.body.classList ? document.body.classList.remove("blocked-scroll") : document.body.className = document.body.className.replace(new RegExp("(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function l() {
      n.menuMode = s.value;
    }
    const c = U(() => (l(), [
      "layout-wrapper",
      {
        "layout-static": n.menuMode === "static",
        "layout-overlay": n.menuMode === "overlay",
        "layout-overlay-active": n.overlayMenuActive,
        "layout-slim": n.menuMode === "slim",
        "layout-horizontal": n.menuMode === "horizontal",
        "layout-active": n.menuActive,
        "layout-mobile-active": n.staticMenuMobileActive,
        "layout-sidebar": n.menuMode === "sidebar",
        "layout-sidebar-static": n.menuMode === "sidebar" && n.sidebarStatic,
        "layout-static-inactive": n.staticMenuDesktopInactive && n.menuMode === "static"
        // "p-ripple-disabled": app.$primevue.config.ripple === false
      }
    ]));
    return (u, d) => {
      const m = se("router-view");
      return C(), O("div", {
        class: J(c.value),
        onClick: o,
        id: "layout-container-div"
      }, [
        x("div", AA, [
          x("div", gA, [
            B(m)
          ])
        ])
      ], 2);
    };
  }
}), hA = { id: "menu-type-combo" }, vA = { class: "p-field-radiobutton" }, yA = { for: "mode3" }, bA = { class: "p-field-radiobutton" }, xA = { for: "mode4" }, EA = { class: "p-field-radiobutton" }, CA = { for: "mode5" }, wA = { class: "p-field-radiobutton" }, IA = { for: "theme1" }, BA = { class: "p-field-radiobutton" }, kA = { for: "theme2" }, _A = { class: "layout-themes" }, SA = ["title", "onClick"], mD = /* @__PURE__ */ j({
  __name: "AppConfig",
  props: {
    configActive: { type: Boolean },
    configClick: { type: Boolean },
    colorScheme: {},
    theme: {},
    componentTheme: {},
    menuMode: {}
  },
  emits: ["config-button-click", "config-click", "hange-color-scheme", "change-menu-theme", "change-component-theme", "change-menu-mode", "close-menu-config"],
  setup(e, { emit: t }) {
    const n = e, a = T(n.menuMode), s = T(n.colorScheme), o = U(() => n.configActive), i = t, r = T([
      {
        name: "blue",
        color: "#0F8BFD",
        hover: "#0E81E6",
        lighten: "#55a8ff",
        scaleLightness60: "#94cfff",
        scaleLightnessMinus60: "#004cae",
        scaleLightnessMinus20: "#0c5fb9",
        darken: "#075b99",
        scaleAlpha24: "#0f8bfd3d"
      },
      {
        name: "green",
        color: "#0BD18A",
        hover: "#0A9B79",
        lighten: "#49e1a9",
        scaleLightness60: "#8af7cf",
        scaleLightnessMinus60: "#004a34",
        scaleLightnessMinus20: "#0a7c5d",
        darken: "#068059",
        scaleAlpha24: "#0bd18a3d"
      },
      {
        name: "magenta",
        color: "#EC4DBC",
        hover: "#D142A7",
        lighten: "#f07ed3",
        scaleLightness60: "#ffa3eb",
        scaleLightnessMinus60: "#7a116e",
        scaleLightnessMinus20: "#ac4586",
        darken: "#b72e9f",
        scaleAlpha24: "#ec4dbc3d"
      },
      {
        name: "orange",
        color: "#FD9214",
        hover: "#E28212",
        lighten: "#ffb343",
        scaleLightness60: "#ffd39c",
        scaleLightnessMinus60: "#7f5701",
        scaleLightnessMinus20: "#b57f03",
        darken: "#a76d0f",
        scaleAlpha24: "#fd92143d"
      },
      {
        name: "purple",
        color: "#873EFE",
        hover: "#7735E5",
        lighten: "#a268fe",
        scaleLightness60: "#d4a3ff",
        scaleLightnessMinus60: "#3503ba",
        scaleLightnessMinus20: "#4f26d1",
        darken: "#6d38e7",
        scaleAlpha24: "#873efe3d"
      },
      {
        name: "red",
        color: "#FC6161",
        hover: "#E25555",
        lighten: "#fd8c8c",
        scaleLightness60: "#ffb3b3",
        scaleLightnessMinus60: "#7f0707",
        scaleLightnessMinus20: "#b51d1d",
        darken: "#a31717",
        scaleAlpha24: "#fc61613d"
      },
      {
        name: "teal",
        color: "#00D0DE",
        hover: "#00B9C1",
        lighten: "#4fe7ee",
        scaleLightness60: "#8fffff",
        scaleLightnessMinus60: "#005d66",
        scaleLightnessMinus20: "#00899b",
        darken: "#0096a5",
        scaleAlpha24: "#00d0de3d"
      },
      {
        name: "yellow",
        color: "#EEE500",
        hover: "#D4CC00",
        lighten: "#fff34c",
        scaleLightness60: "#fffb9c",
        scaleLightnessMinus60: "#7f7a00",
        scaleLightnessMinus20: "#b5ad00",
        darken: "#ad9c00",
        scaleAlpha24: "#eee5003d"
      }
    ]), l = Kn(), c = () => {
      i("close-menu-config");
    }, u = (A) => {
      i("change-component-theme", A);
    }, d = (A) => {
      var _, M;
      const f = document.documentElement;
      f.style.setProperty("--webcad-primary-color", A);
      const p = r.value.find((S) => S.color === A);
      p && (f.style.setProperty("--webcad-primary-color-hover", p.hover), f.style.setProperty("--webcad-primary-color-lighten", p.lighten), f.style.setProperty("--webcad-primary-color-light", p.scaleLightness60), f.style.setProperty("--webcad-primary-color-dark", p.scaleLightnessMinus60), f.style.setProperty("--webcad-primary-color-darker", p.scaleLightnessMinus20), f.style.setProperty("--webcad-primary-color-darken", p.darken), f.style.setProperty("--webcad-primary-color-scale-alpha", p.scaleAlpha24));
      const v = Kn();
      v.updateColorTheme((_ = r.value.find((S) => S.color.toString() === A.toString())) == null ? void 0 : _.name), u(((M = r.value.find((S) => S.color === A)) == null ? void 0 : M.name) ?? "blue");
      let b = v.colorScheme === "dark" ? "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)" : "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)", y = v.colorScheme === "dark" ? "#FFFFFF" : "#000000";
      f.style.removeProperty("--webcad-top-navbar-icon-color"), f.style.setProperty("--webcad-top-navbar-icon-color", b), h(), f.style.removeProperty("--top-navbar-text-color"), f.style.setProperty("--top-navbar-text-color", y);
    }, m = (A) => {
      const f = document.documentElement, p = A === "dark";
      Kn().updateColorScheme(A), f.style.setProperty("--webcad-primary-text-color", p ? "#FFFFFF" : "#000000"), f.style.setProperty("--webcad-primary-text-color-inverse", p ? "#000000" : "#FFFFFF"), f.style.setProperty("--webcad-text-color-inverse", p ? "#000000" : "#FFFFFF"), f.style.setProperty("--webcad-text-color", p ? "#FFFFFF" : "#343434"), f.style.setProperty("--webcad-body-bg", p ? "#28292C" : "#EEEEEE"), f.style.setProperty("--webcad-main-bg", p ? "#28292C" : "#FFFFFF"), f.style.setProperty("--webcad-patient-list-bg", "#FFFFFF"), f.style.setProperty("--webcad-card-wizard-bg", p ? "#333437" : "#EEEEEE"), f.style.setProperty("--webcad-bg-not-selected", "#707070"), f.style.setProperty("--webcad-main-card-color", p ? "#32343A" : "#E2E2E2"), f.style.setProperty("--webcad-bg-input-text", "#FFFFFF"), f.style.setProperty("--webcad-bg-patient-item", p ? "#3C3E46" : "#EEEEEE"), f.style.setProperty("--webcad-bg-patient-item-image-card", "#1B1C1E"), f.style.setProperty("--webcad-bg-main-menu-btn", "#EEEEEE"), f.style.setProperty("--webcad-bg-main-menu-item", p ? "#3C3E46" : "#E2E2E2"), f.style.setProperty("--webcad-tab-menu-color", "#868C9B"), f.style.setProperty("--webcad-btn-selected-item-main-tab", "#EEEEEE"), f.style.setProperty("--webcad-top-navbar-bg", p ? "#28292C" : "#E2E2E2"), f.style.setProperty("--webcad-sidebar-wiz-bg", p ? "#28292C" : "#E2E2E2"), f.style.setProperty("--webcad-sidebar-wiz-item-bg", p ? "#32343A" : "#EEEEEE"), f.style.setProperty("--webcad-footer-text-color", "#808080"), f.style.setProperty("--webcad-card-menu-item-bg", p ? "#32343A" : "#EEEEEE"), f.style.setProperty("--webcad-wiz-bg", "#3D3D3D"), f.style.setProperty("--webcad-object-list-bg", p ? "#707070" : "#FFFFFF"), f.style.setProperty("--webcad-object-list-text-color", p ? "#B7B7B7" : "#000000"), f.style.setProperty("--footer-text-color", "#808080"), f.style.setProperty(
        "--webcad-primary-icon-color",
        p ? "invert(0%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)" : "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)"
      ), f.style.setProperty(
        "--webcad-primary-icon-color-inverse",
        p ? "invert(100%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)" : "invert(0%) sepia(0%) saturate(2110%) hue-rotate(303deg) brightness(109%) contrast(69%)"
      ), f.style.setProperty("--webcad-paginator-color", p ? "#FFFFFF" : "#3C3E46"), f.style.setProperty("--webcad-input-placeholder-color", p ? "#868C9B" : "#8A8EA6"), f.style.setProperty("--webcad-tab-border-color", p ? "#808080" : "#FFFFFF"), f.style.setProperty("--webcad-input-background", p ? "#3C3E46" : "#EEEEEE"), f.style.setProperty("--webcad-progress-bar-background", p ? "#32343A" : "#D6D7DB"), f.style.setProperty("--webcad-modal-background", p ? "#3E3E3E" : "#E2E2E2"), f.style.setProperty("--webcad-modal-text-color", p ? "#FFFFFF" : "#000000"), f.style.setProperty("--webcad-dropdown-bg-color", p ? "#535763 " : "#C6C6C6"), f.style.setProperty("--webcad-dropdown-hover-bg-color", p ? "rgba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.07)"), f.style.setProperty("--webcad-switch-bg-color", p ? "gba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.07)"), f.style.setProperty("--webcad-switch-before-bg-color", p ? "#C8CCD8" : "#676B89"), f.style.setProperty("--webcad-accorion-header-bg", p ? "rgba(255, 255, 255, 0.15)" : "rgba(68, 72, 109, 0.12)"), f.style.setProperty("--webcad-accorion-header-border-color", p ? "rgba(255, 255, 255, 0.05)" : "rgba(68, 72, 109, 0.17)"), f.style.setProperty("--webcad-accorion-header-color", p ? "#FFFFFF" : "#44486D"), f.style.setProperty("--webcad-accorion-header-color-hover", p ? "#b9b8b8" : "#92939d"), f.style.setProperty("--webcad-overlay-bg-color", p ? "#535763" : "#ECECF9"), f.style.setProperty("--webcad-input-card-background", p ? "#464646" : "#C6C6C6"), f.style.setProperty("--webcad-toast-bg", p ? "#0A061A" : "#F8FCFC"), f.style.setProperty("--webcad-progress-next-step", p ? "#505259" : "#FDFDFF"), f.style.setProperty("--webcad-dropdown-text-color", p ? "#FFFFFF" : "#000000");
      let b = p ? "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)" : "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)", y = p ? "#FFFFFF" : "#000000";
      f.style.removeProperty("--webcad-top-navbar-icon-color"), f.style.setProperty("--webcad-top-navbar-icon-color", b), f.style.removeProperty("--top-navbar-text-color"), f.style.setProperty("--top-navbar-text-color", y);
    }, g = (A) => {
      Kn().setNavbarPosition(A), i("change-menu-mode", A);
    };
    function h() {
      const A = document.documentElement;
      let f = "";
      switch (l.getColorTheme()) {
        case yn.BLUE:
          f = "invert(41%) sepia(100%) saturate(432%) hue-rotate(166deg) brightness(95%) contrast(91%)";
          break;
        case yn.GREEN:
          f = "invert(60%) sepia(27%) saturate(3523%) hue-rotate(115deg) brightness(101%) contrast(91%)";
          break;
        case yn.MAGENTA:
          f = "invert(46%) sepia(47%) saturate(3111%) hue-rotate(291deg) brightness(96%) contrast(91%)";
          break;
        case yn.ORANGE:
          f = "invert(64%) sepia(98%) saturate(2224%) hue-rotate(350deg) brightness(101%) contrast(98%)";
          break;
        case yn.PURPLE:
          f = "invert(35%) sepia(64%) saturate(6258%) hue-rotate(252deg) brightness(99%) contrast(102%)";
          break;
        case yn.RED:
          f = "invert(47%) sepia(63%) saturate(804%) hue-rotate(316deg) brightness(106%) contrast(101%)";
          break;
        case yn.TEAL:
          f = "invert(59%) sepia(23%) saturate(1740%) hue-rotate(136deg) brightness(101%) contrast(105%)";
          break;
        case yn.YELLOW:
          f = "invert(82%) sepia(43%) saturate(3357%) hue-rotate(12deg) brightness(104%) contrast(119%)";
          break;
      }
      A.style.setProperty("--webcad-horizontal-icon-color", f, "important");
    }
    return Ge(() => {
      var A;
      d(((A = r.value.find((f) => f.name === l.getColorTheme())) == null ? void 0 : A.color) ?? "blue"), m(l.getColorScheme());
    }), (A, f) => {
      const p = se("RadioButton");
      return C(), O("div", {
        id: "layout-config",
        onmouseleave: c
      }, [
        x("div", {
          class: J([{ "layout-config-active": o.value }, "layout-config"])
        }, [
          x("span", hA, [
            x("h5", null, P(A.$t("medic-web-framework.menuType")), 1),
            x("div", vA, [
              B(p, {
                id: "mode3",
                modelValue: a.value,
                "onUpdate:modelValue": f[0] || (f[0] = (v) => a.value = v),
                name: "menuMode",
                value: "slim",
                onChange: f[1] || (f[1] = (v) => g(k(sn).SLIM))
              }, null, 8, ["modelValue"]),
              x("label", yA, P(A.$t("medic-web-framework.slim")), 1)
            ]),
            x("div", bA, [
              B(p, {
                id: "mode4",
                modelValue: a.value,
                "onUpdate:modelValue": f[2] || (f[2] = (v) => a.value = v),
                name: "menuMode",
                value: "horizontal",
                onChange: f[3] || (f[3] = (v) => g(k(sn).HORIZONTAL))
              }, null, 8, ["modelValue"]),
              x("label", xA, P(A.$t("shared.horizontal")), 1)
            ]),
            x("div", EA, [
              B(p, {
                id: "mode5",
                modelValue: a.value,
                "onUpdate:modelValue": f[4] || (f[4] = (v) => a.value = v),
                name: "menuMode",
                value: "sidebar",
                onChange: f[5] || (f[5] = (v) => g(k(sn).SIDEBAR))
              }, null, 8, ["modelValue"]),
              x("label", CA, P(A.$t("medic-web-framework.sidebar")), 1)
            ]),
            f[10] || (f[10] = x("hr", null, null, -1))
          ]),
          x("h5", null, P(A.$t("medic-web-framework.colorScheme")), 1),
          x("div", wA, [
            B(p, {
              id: "theme1",
              modelValue: s.value,
              "onUpdate:modelValue": f[6] || (f[6] = (v) => s.value = v),
              name: "colorScheme",
              value: "light",
              onChange: f[7] || (f[7] = (v) => m("light"))
            }, null, 8, ["modelValue"]),
            x("label", IA, P(A.$t("medic-web-framework.light")), 1)
          ]),
          x("div", BA, [
            B(p, {
              id: "theme2",
              modelValue: s.value,
              "onUpdate:modelValue": f[8] || (f[8] = (v) => s.value = v),
              name: "colorScheme",
              value: "dark",
              onChange: f[9] || (f[9] = (v) => m("dark"))
            }, null, 8, ["modelValue"]),
            x("label", kA, P(A.$t("medic-web-framework.dark")), 1)
          ]),
          f[11] || (f[11] = x("hr", null, null, -1)),
          x("h5", null, P(A.$t("medic-web-framework.layouts")), 1),
          x("div", _A, [
            (C(!0), O(me, null, qe(r.value, (v) => (C(), O("div", {
              key: v.name
            }, [
              x("a", {
                style: Le([{ "background-color": v.color }, { cursor: "pointer" }]),
                title: v.name,
                onClick: (b) => d(v.color)
              }, null, 12, SA)
            ]))), 128))
          ])
        ], 2)
      ]);
    };
  }
}), fe = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, s] of t)
    n[a] = s;
  return n;
}, DA = {}, TA = { class: "flex" };
function MA(e, t) {
  return C(), O("div", TA, [
    X(e.$slots, "default")
  ]);
}
const ae = /* @__PURE__ */ fe(DA, [["render", MA]]);
function LA() {
  return {
    root: {
      background: "transparent",
      checkedBackground: "var(--p-primary-color)",
      checkedHoverBackground: "var(--p-primary-hover-color)",
      width: "28px",
      height: "15px",
      border: {
        width: "2px !important",
        color: "var(--p-text-color) !important"
      }
    },
    handle: {
      size: "0.6rem",
      background: "var(--p-text-color) !important",
      checkedHoverBackground: "var(--p-form-field-hover-border-color)"
    }
  };
}
const mo = /* @__PURE__ */ j({
  __name: "MFSwitch",
  props: {
    state: { type: Boolean, required: !0 },
    stateModifiers: {},
    disabled: { type: Boolean },
    disabledModifiers: {}
  },
  emits: /* @__PURE__ */ It(["change"], ["update:state", "update:disabled"]),
  setup(e, { emit: t }) {
    const n = Ie(e, "state"), a = Ie(e, "disabled"), s = t, o = T(LA());
    return (i, r) => (C(), H(ae, {
      class: "flex-row",
      style: { "align-items": "center" }
    }, {
      default: D(() => [
        X(i.$slots, "falseLabel"),
        B(k(Pp), {
          modelValue: n.value,
          "onUpdate:modelValue": r[0] || (r[0] = (l) => n.value = l),
          dt: o.value,
          onChange: r[1] || (r[1] = (l) => s("change", n.value)),
          disabled: a.value
        }, null, 8, ["modelValue", "dt", "disabled"]),
        X(i.$slots, "trueLabel")
      ]),
      _: 3
    }));
  }
}), OA = ["src"], NA = /* @__PURE__ */ j({
  __name: "MButton",
  props: {
    class: {},
    icon: {},
    label: {},
    modelValue: {}
  },
  setup(e) {
    const t = e, n = U(() => !t.modelValue || !t.modelValue.pressable ? !1 : a.value), a = T();
    t.modelValue && ye(t.modelValue, () => {
      a.value = t.modelValue ? t.modelValue.pressed : !1;
    });
    const s = () => {
      var r;
      t.modelValue && (r = t.modelValue) != null && r.pressable && (a.value = !a.value);
    }, o = U(() => {
      var l;
      let r = t.class ? `${t.class} flex items-center justify-center` : "flex items-center justify-center";
      return n.value && (r += (l = t.modelValue) != null && l.toggleable ? " btn-pressed-toggle" : " btn-pressed"), r;
    }), i = U(() => t.modelValue ? t.modelValue.disabled : !1);
    return (r, l) => {
      const c = se("Button");
      return C(), H(c, {
        class: J([o.value, i.value ? "p-disabled" : ""]),
        disabled: i.value,
        type: "button",
        onClick: s
      }, {
        default: D(() => [
          t.icon ? (C(), O("img", {
            key: 0,
            src: t.icon,
            alt: "logo",
            class: "ml-1",
            style: { width: "1.5rem" },
            draggable: "false"
          }, null, 8, OA)) : $("", !0),
          x("span", {
            class: J([t.icon ? "ml-1" : ""])
          }, P(t.label), 3)
        ]),
        _: 1
      }, 8, ["class", "disabled"]);
    };
  }
}), RA = "85cc4579-fe41-48be-abaf-fdec1d587ec8";
async function AD(e) {
  const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-256", t);
  return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
}
async function gD(e) {
  const t = new TextEncoder().encode(e), n = await crypto.subtle.digest("SHA-1", t);
  return Array.from(new Uint8Array(n)).map((o) => o.toString(16).padStart(2, "0")).join("");
}
function hD(e) {
  return Fp(e, RA);
}
const vD = (e) => /Chrome|Chromium/.test(e) && !/Edg|OPR|Opera|Brave|SamsungBrowser/.test(e), yD = () => {
  var r;
  if (typeof navigator > "u")
    return !1;
  const e = navigator.userAgent || "", t = navigator.platform || "", n = navigator.maxTouchPoints || 0, a = (((r = navigator.userAgentData) == null ? void 0 : r.platform) ?? "").toLowerCase(), s = /iPad|iPhone|iPod/.test(e), o = t === "MacIntel" && n > 1, i = a.includes("ios") || a.includes("ipados");
  return s || o || i;
}, bD = (e) => Array.isArray(e) ? e.some((t) => t === "1" || t === "true") : e === "1" || e === "true";
class xD extends Map {
  constructor(n) {
    super();
    ie(this, "constructFunc");
    this.constructFunc = n;
  }
  get(n) {
    super.has(n) || super.set(n, this.constructFunc());
    const a = super.get(n);
    if (a === void 0)
      throw new Error(`Key "${n}" not found`);
    return a;
  }
  merge(n, a) {
    this.set(n, {
      ...this.get(n),
      ...a
    });
  }
}
function ED(e, t) {
  const n = document.createElement("a");
  n.href = window.URL.createObjectURL(new Blob([e], { type: "application/zip" })), n.download = t, n.click();
}
const PA = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function FA(e) {
  const t = PA;
  console.log("metaEnv:", t);
  const a = (t == null ? void 0 : t.MODE) === "development", s = !0, o = a;
  console.log("Is development mode:", a, "debugEnabled:", o);
  const i = typeof console < "u", r = e.trim() ? `[${e}]` : "", l = (c, u) => (...d) => {
    if (!(!u || !i)) {
      if (r) {
        console[c](r, ...d);
        return;
      }
      console[c](...d);
    }
  };
  return {
    debug: l("debug", o),
    log: l("log", s),
    info: l("info", s),
    warn: l("warn", s),
    error: l("error", s)
  };
}
const CD = FA("WebCAD-JS");
var QA = /* @__PURE__ */ ((e) => (e[e.START = 900] = "START", e[e.PLAN = 901] = "PLAN", e[e.PRO = 902] = "PRO", e[e.DESIGN = 903] = "DESIGN", e[e.GUIDE_DIGITAL_DOC = 904] = "GUIDE_DIGITAL_DOC", e[e.GUIDE_DIGITAL_DOC_ENTERPRISE = 905] = "GUIDE_DIGITAL_DOC_ENTERPRISE", e[e.CAD = 906] = "CAD", e[e.CAD_PLUS = 907] = "CAD_PLUS", e[e.FULL_SUITE = 908] = "FULL_SUITE", e))(QA || {});
const UA = [
  [
    "FULL SUITE",
    908
    /* FULL_SUITE */
  ],
  [
    "CAD+",
    907
    /* CAD_PLUS */
  ],
  [
    "CAD",
    906
    /* CAD */
  ],
  // put before CAD+ to prevent false match
  [
    "GUIDE ENTERPRISE",
    905
    /* GUIDE_DIGITAL_DOC_ENTERPRISE */
  ],
  [
    "GUIDE DIGITAL DOC ENTERPRISE",
    905
    /* GUIDE_DIGITAL_DOC_ENTERPRISE */
  ],
  [
    "GUIDE DIGITAL DOC",
    904
    /* GUIDE_DIGITAL_DOC */
  ],
  [
    "DESIGN",
    903
    /* DESIGN */
  ],
  [
    "PRO",
    902
    /* PRO */
  ],
  [
    "PLAN",
    901
    /* PLAN */
  ],
  [
    "START",
    900
    /* START */
  ]
];
function GA(e) {
  if (typeof e != "string") {
    console.warn("Invalid input to getRealGuideConfigurationIdentifier:", e);
    return;
  }
  const t = e.trim().toUpperCase();
  for (const [n, a] of UA)
    if (t.includes(n))
      return a;
}
var YA = /* @__PURE__ */ ((e) => (e.REALGUIDE_3DIEMME = "00001", e._3P = "00002", e._8853 = "00003", e.AB_DENTAL = "00004", e.ACTEON = "00005", e.BIOMEC_OXY_IMPLANT = "00006", e.BTK = "00007", e.CEFLA_1 = "00008", e.CEFLA_2 = "00009", e.CEFLA_3 = "00010", e.CGM = "00011", e.IDI_EVOLUTION = "00012", e.IPD = "00013", e.IRES = "00014", e.ISOMED = "00015", e.ITAKA = "00016", e.JDENTALCARE = "00017", e.LEONE = "00018", e.MEDENTIS_MMEDICAL = "00019", e.MICERIUM = "00020", e.NEW_ANCORVIS = "00021", e.NORIS_MEDICAL = "00022", e.NSEQUENCE = "00023", e.ORANGE_DENTAL = "00024", e.PRODENT = "00025", e.PROFESSIONE_SORRISO = "00026", e.SWEDEN_MARTINA = "00027", e.TRIDENT = "00028", e.ZIMMERBIOMET_EU = "00029", e.ZIMMERBIOMET_US = "00030", e.ZIMMERBIOMET_LATAM = "00031", e.BREDENT = "00032", e.BIOMAX = "00033", e.ZIMVIE_CHINA = "00034", e.ZIMVIE_JAPAN = "00035", e))(YA || {});
const Cl = [
  ["00001", ["RealGUIDE 3Diemme", "RealGUIDE", "realguide", "3Diemme"]],
  ["00002", ["3P", "3P Guide", "3pguide", "3guide"]],
  ["00003", ["8853", "3DLynx", "3dlynx", "88dent"]],
  ["00004", ["AB dental", "AB Guided Service"]],
  ["00005", ["Acteon", "AIS 3D APP", "AIS3D App", "acteon", "acteon-us", "DeGoetzen"]],
  ["00006", ["Biomec - OXY Implant", "ODS Guide", "oxy"]],
  ["00007", ["BTK", "Opera", "btk"]],
  ["00008", ["Cefla", "MyRay 5", "cefla-myray"]],
  ["00009", ["Cefla 2", "cefla-neutral"]],
  ["00010", ["NewTom 5", "cefla-newtom"]],
  ["00011", ["CGM", "X-Ray", "cgm"]],
  ["00012", ["IDI Evolution", "IDI Double Guide", "idievolution"]],
  ["00013", ["IPD", "Model PRO", "ipd"]],
  ["00014", ["iRes", "SmartGuide", "ires", "IESS", "IESS Guide"]],
  ["00015", ["Isomed", "IsoGUIDE", "isomed"]],
  ["00016", ["Itaka", "ITAKAD", "itaka", "itakad"]],
  ["00017", ["Jdentalcare", "JDigital Guide", "JD", "jdental"]],
  ["00018", ["Leone", "Leone 3D", "degis"]],
  ["00019", ["Medentis Mmedical", "Medentis ICX", "ICX Magellan", "MagellanX", "magellan", "Medentis"]],
  ["00020", ["Micerium", "Micos GUIDE", "micerium"]],
  ["00021", ["New Ancorvis", "RealGUIDE NA", "newAncorvisStyle"]],
  ["00022", ["Noris Medical", "EZPlan", "noris"]],
  ["00023", ["nSequence", "Maven PRO"]],
  ["00024", ["Orange Dental", "Byzz3D"]],
  ["00025", ["Prodent", "Prodent 3D", "prodent"]],
  ["00026", ["Professione sorriso", "Speedy3D", "speedy3d"]],
  ["00027", ["Sweden & Martina", "S&M", "Archiplan 3D", "sweden-martina"]],
  ["00028", ["Trident", "Insight"]],
  ["00029", ["ZimmerBiomet EU", "ZimmerBiomet/ZimVie EU", "ZimVie EU", "ZimVie_EMEA", "zimmer-eu", "zimvie"]],
  ["00030", ["ZimmerBiomet US", "ZimmerBiomet/ZimVie US", "ZimVie US", "ZimVie_US", "zimmer-us", "realguide-na"]],
  ["00031", ["ZimmerBiomet LATAM", "ZimmerBiomet/ZimVie LATAM", "ZimVie LATAM", "ZimVie_LATAM", "zimmer-latam", "ZimmerBiomet"]],
  ["00032", ["bredent", "SKY Pro plan GUIDE", "SKY Pro Guide Plan", "bredent"]],
  ["00033", ["Biomax", "Biomax Digital Suite", "biomax"]],
  ["00034", ["ZimVie China", "zimmer-chinese"]],
  ["00035", ["ZimVie Japan", "zimmer-jpn"]]
];
function pi(e) {
  return e.trim().toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ");
}
function wD(e) {
  if (typeof e != "string")
    return;
  const t = pi(e);
  for (const [n, a] of Cl)
    for (const s of a)
      if (t === pi(s))
        return n;
  for (const [n, a] of Cl)
    for (const s of a)
      if (t.includes(pi(s)))
        return n;
}
function wl(e, t) {
  return e ? e.split(";").filter(Boolean).some((n) => {
    const [a, s] = n.split("=");
    return a === t && s === "1";
  }) : !1;
}
const jA = "20260402", Il = {
  name: "3DIEMME Srl",
  address: "Via Risorgimento 9 - 22063 Cantù (CO) - ITALY",
  website: "www.3diemme.it",
  email: "support@3diemme.it",
  telephone: "+39 0317073353"
}, mi = {
  name: "ZimVie US Corp LLC",
  address: "4555 Riverside Drive",
  addressLines: ["4555 Riverside Drive", "Palm Beach Gardens, FL 33410", "USA"],
  website: "www.zimvie.com",
  email: "",
  telephone: ""
}, HA = {
  "02": {
    license: "3P Guide",
    company: {
      name: "Leader Medica S.r.l.",
      address: "Via Longhin 11 - 35129 Padova (PD) - Italy",
      website: "www.leadermedica.com",
      email: "info@leadermedica.com",
      telephone: "+39 049 99 13 364"
    }
  },
  "03": {
    license: "3DLynx",
    company: {
      name: "8853 SpA I div. 88Dent",
      address: "Via Pitagora 11 - 20016 Pero (MI) - Italy",
      website: "www.88dent.com",
      email: "info@88dent.com",
      telephone: "+39 02 8853501"
    }
  },
  "05": {
    license: "AIS3D App",
    company: {
      name: "De Götzen Srl",
      address: "Strada Provinciale Busto-Cassano 3 - 21054 Fagnano Olona (VA) - Italy",
      website: "www.acteongroup.com",
      email: "imaging.italysupport@acteongroup.com",
      telephone: "+39 0331 376760"
    }
  },
  "06": {
    license: "ODS Guide",
    company: {
      name: "Biomec Srl",
      address: "Via Nazionale Nord 21/A - 23823 Colico (LC) - Italy",
      website: "www.oxyimplant.com",
      email: "info@oxyimplant.com",
      telephone: "+39 0341 930166"
    }
  },
  "07": {
    license: "Opera",
    company: {
      name: "Biotec srl",
      address: "Via Industria 53 - 36031 Povolaro di Dueville (Vi) - Italy",
      website: "www.btk.dental",
      email: "info@btk.dental",
      telephone: "+39 0444 361251"
    }
  },
  12: {
    license: "IDI Double Guide",
    realGuideLogoCaption: "IDI Double Guide",
    company: {
      name: "IDI Evolution Srl",
      address: "Via Monza 31 - Concorezzo (MB) - Italy",
      website: "www.idievolution.it",
      email: "info@idievolution.it",
      telephone: "+39 039 690876"
    }
  },
  13: {
    license: "Model PRO",
    company: {
      name: "IPD2004",
      address: "C. Rosa dels Vents, nº 9-15 - 08338 Premià de Dalt (Barcelona) - Spain",
      website: "www.ipd2004.com",
      email: "info@ipd2004.com",
      telephone: "+34 93 278 84 91"
    }
  },
  14: {
    license: "IESS Guide",
    company: {
      name: "IESS Group Srl",
      address: "Via Madonna della Salute 23 - 33050 Pozzuolo del Friuli (UD) - Italy",
      website: "www.iess.dental",
      email: "info@iess.dental",
      telephone: "+39 0432 669191"
    }
  },
  15: {
    license: "IsoGUIDE",
    company: {
      name: "ISOMED Srl",
      address: "Via Mezzavia 126 - 35020 Due Carrare (PD) - Italy",
      website: "www.isomed.it",
      email: "info@isomed.it",
      telephone: "+39 049 8629612"
    }
  },
  16: {
    license: "Itakad",
    company: {
      name: "ITAKA WAY MED Srl",
      address: "Via delle Industrie 29/h - 30020 Marcon (VE) - Italy",
      website: "www.itakawaymed.it",
      email: "info@itakawaymed.com",
      telephone: "+39 041 308 1079"
    }
  },
  17: {
    license: "JDigital Guide",
    company: {
      name: "JDentalCare Srl",
      address: "Via Dino Campana 2 - 41123 Modena - Italy",
      website: "www.jdentalcare.com",
      email: "info@jdentalcare.com",
      telephone: "+39 059 454255"
    }
  },
  19: {
    license: "ICX Magellan",
    company: {
      name: "medentis medical GmbH",
      address: "Walporzheimer Str. 48-52 - 53474 Bad Neuenahr-Ahrweiler - Germany",
      website: "www.medentis.com",
      email: "",
      telephone: "+49 (0)2641 9110-0"
    }
  },
  21: {
    license: "RealGUIDE NA",
    company: {
      name: "New Ancorvis Srl",
      address: "Via dell’Industria 15 - 40012 Calderara di Reno (BO) - Italy",
      website: "www.newancorvis.eu",
      email: "info@newancorvis.eu",
      telephone: "+39 0516463070"
    }
  },
  22: {
    license: "EZPlan",
    company: {
      name: "Noris Medical Israel",
      address: "8 Hataasia st. - Nesher 3688808 - Israel",
      website: "www.norismedical.com",
      email: "info@norismedical.com",
      telephone: "+972-73-796-4477"
    }
  },
  25: {
    license: "Prodent Guide",
    company: {
      name: "Prodent Italia Srl",
      address: "Via Pitagora 9 - 20016 Pero (MI) - Italy",
      website: "www.prodentitalia.eu",
      email: "info@prodentitalia.it",
      telephone: "+39 02 3535227"
    }
  },
  27: {
    license: "Archiplan 3D",
    company: {
      name: "Sweden & Martina SpA",
      address: "Via Veneto 10 - 35020 Due Carrare (PD) - Italy",
      website: "www.sweden-martina.com",
      email: "info@sweden-martina.com",
      telephone: ""
    }
  },
  29: {
    license: "RealGUIDE Z3D",
    company: mi,
    realGuideLogoCaption: "RealGUIDE Z3D"
  },
  30: {
    license: "RealGUIDE Z3D",
    company: mi,
    realGuideLogoCaption: "RealGUIDE Z3D"
  },
  31: {
    license: "RealGUIDE Z3D",
    company: mi,
    realGuideLogoCaption: "RealGUIDE Z3D"
  },
  32: {
    license: "SKY Pro Guide Plan",
    company: {
      name: "bredent medical GmbH & Co.KG",
      address: "Weissenhorner Str. 2 - 89250 Senden - Germany",
      website: "www.bredent-group.com",
      email: "info@bredent.com",
      telephone: "+49 7309 872-6 00"
    }
  },
  33: {
    license: "Biomax Digital Suite",
    company: {
      name: "Biomax S.p.A.",
      address: "Via Zamenhof Ludovico Lazzaro 615 - 36100 Vicenza - Italy",
      website: "www.biomax.it",
      email: "info@biomax.it",
      telephone: "+39 0444 913410 / +39 0444 911962"
    }
  }
};
function VA(e) {
  var n;
  const t = e == null ? void 0 : e.trim();
  if (t)
    return (n = Object.entries(HA).find(([a]) => t.endsWith(a))) == null ? void 0 : n[1];
}
function ID(e, t, n) {
  const a = GA(e.name), s = VA(t);
  return {
    model: "RealGUIDE",
    version: "RealGUIDE WEB",
    license: e.name,
    softwareVersion: "6.0.0",
    udi: t ? `(01)08050038833196(8012)600(21)${t}(250)${a}` : `(01)08050038833196(8012)600(21)00001(250)${a}`,
    build: n || jA,
    computerId: "003134619",
    certificateNumber: "003/MDR",
    _510kNumber: "K173041",
    ownerNumber: "10059505",
    company: (s == null ? void 0 : s.company) ?? Il,
    manufacturerCompany: Il,
    realGuideLogoCaption: (s == null ? void 0 : s.realGuideLogoCaption) ?? (s == null ? void 0 : s.license) ?? "RealGUIDE®",
    headquarter: {
      name: "ZimVie Switzerland GmbH",
      address: "Grüzefeldstrasse 41",
      city: "8404 Winterthur",
      country: "Switzerland"
    }
  };
}
var ge = /* @__PURE__ */ ((e) => (e.TOP_NAVBAR_ICON = "svg-icon", e.TOP_NAVBAR_MOBILE_ICON = "svg-icon-mobile", e.BUTTON_ICON = "", e.OBJECT_LIST_ICON = "svg-icon-grey-light", e.BUTTON_ICON_NO_LABEL = "no-label", e.TOP_NAVBAR_ICON_LABEL = "topnavbariconlabelclass", e))(ge || {}), Wn = /* @__PURE__ */ ((e) => (e.TOP = "flex-col-reverse", e.BOTTOM = "flex-col", e.RIGHT = "flex-row", e.LEFT = "flex-row-reverse", e))(Wn || {});
function BD() {
  return {
    clicked: !1,
    disabled: !1,
    checkable: !1,
    checked: !1,
    pressable: !1,
    pressed: !1,
    toggleable: !1,
    icon: "",
    iconPos: "flex-row-reverse"
    /* LEFT */
  };
}
const kD = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  IN: "in",
  LESS_THAN: "lessThan",
  LESS_THAN_OR_EQUAL_TO: "lessThanOrEqualTo",
  GREATER_THAN: "greaterThan",
  GREATER_THAN_OR_EQUAL_TO: "greaterThanOrEqualTo",
  BETWEEN: "between",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
};
var KA = /* @__PURE__ */ ((e) => (e[e.MESSAGE = 0] = "MESSAGE", e[e.NOTIFICATION = 1] = "NOTIFICATION", e[e.MEDIA_MESSAGE = 2] = "MEDIA_MESSAGE", e[e.SHIPPING_DATE_CHANGE = 3] = "SHIPPING_DATE_CHANGE", e))(KA || {}), Hs = /* @__PURE__ */ ((e) => (e.ADMIN = "ADMIN", e.OPERATOR = "OPERATOR", e.READONLY_OPERATOR = "READONLY_OPERATOR", e.USER = "USER", e))(Hs || {}), Vs = /* @__PURE__ */ ((e) => (e.EDIT_WORKFLOWS = "EDIT_WORKFLOWS", e.EDIT_MATERIAL_LIB = "EDIT_MATERIAL_LIB", e.EDIT_USERS = "EDIT_USERS", e.ARCHIVE_ORDER = "ARCHIVE_ORDER", e.DELETE_ORDER = "DELETE_ORDER", e))(Vs || {});
function _D() {
  return {
    role: "USER",
    workflowPermissions: Object.keys(Vs),
    isReadOnly: !1
  };
}
var WA = /* @__PURE__ */ ((e) => (e.STATUS_CHANGE = "STATUS_CHANGE", e))(WA || {});
function zA() {
  return {
    value: 0,
    minValue: 0,
    maxValue: 10,
    step: 0.1,
    hideValueInput: !1
  };
}
function SD() {
  return {
    rangeValue: [0, 1],
    minValue: 0,
    maxValue: 10,
    step: 0.1,
    hideValueInput: !1
  };
}
function DD() {
  return {
    clicked: !1,
    state: !1,
    disabled: !1
  };
}
function TD() {
  return {
    id: 0,
    name: "test 1",
    materialType: "Titanium (Ti)",
    gap: {
      cementAreaOffsetRange: [0, 0.1],
      cementAreaOffsetMinMax: [0, 0.1],
      cementAreaOffsetStep: 5e-3,
      cementAreaOffsetDefault: 0.03,
      sealingAreaOffsetRange: [0, 0.1],
      sealingAreaOffsetMinMax: [0, 0.1],
      sealingAreaOffsetStep: 5e-3,
      sealingAreaOffsetDefault: 0
    },
    border: {
      horizontalRange: [0.01, 0.5],
      horizontalMinMax: [0.01, 0.5],
      horizontalRangeStep: 0.01,
      angleRange: [0, 90],
      angleMinMax: [0, 90],
      angleRangeStep: 1,
      angledRange: [0.01, 2],
      angledMinMax: [0.01, 2],
      angledRangeStep: 0.01,
      verticalRange: [0, 2],
      verticalMinMax: [0, 2],
      verticalRangeStep: 0.01,
      angleDefault: 0,
      angledDefault: 0,
      horizontalDefault: 0,
      verticalDefault: 0
    },
    minimalThickness: {
      minimalThicknessRange: [0.01, 1.5],
      minimalThicknessMinMax: [0.01, 1.5],
      minimalThicknessStep: 0.05
    },
    reconstructionDesigns: []
  };
}
function MD(e) {
  return {
    name: e,
    gap: {
      cementAreaOffsetRange: [0, 0.1],
      cementAreaOffsetMinMax: [0, 0.1],
      cementAreaOffsetStep: 5e-3,
      cementAreaOffsetDefault: 0.03,
      sealingAreaOffsetRange: [0, 0.1],
      sealingAreaOffsetMinMax: [0, 0.1],
      sealingAreaOffsetStep: 5e-3,
      sealingAreaOffsetDefault: 0
    },
    border: {
      horizontalRange: [0.01, 0.5],
      horizontalMinMax: [0.01, 0.5],
      horizontalRangeStep: 0.01,
      angleRange: [0, 90],
      angleMinMax: [0, 90],
      angleRangeStep: 1,
      angledRange: [0.01, 2],
      angledMinMax: [0.01, 2],
      angledRangeStep: 0.01,
      verticalRange: [0, 2],
      verticalMinMax: [0, 2],
      verticalRangeStep: 0.01,
      angleDefault: 0,
      angledDefault: 0,
      horizontalDefault: 0,
      verticalDefault: 0
    },
    minimalThickness: {
      minimalThicknessRange: [0.01, 1.5],
      minimalThicknessMinMax: [0.01, 1.5],
      minimalThicknessStep: 0.05
    },
    reconstructionDesigns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  };
}
function LD(e, t) {
  return {
    name: t,
    gap: {
      cementAreaOffsetRange: e.gap.cementAreaOffsetRange,
      cementAreaOffsetMinMax: e.gap.cementAreaOffsetMinMax,
      cementAreaOffsetStep: e.gap.cementAreaOffsetStep,
      cementAreaOffsetDefault: e.gap.cementAreaOffsetDefault,
      sealingAreaOffsetRange: e.gap.sealingAreaOffsetRange,
      sealingAreaOffsetMinMax: e.gap.sealingAreaOffsetMinMax,
      sealingAreaOffsetStep: e.gap.sealingAreaOffsetStep,
      sealingAreaOffsetDefault: e.gap.sealingAreaOffsetDefault
    },
    border: {
      horizontalRange: e.border.horizontalRange,
      horizontalMinMax: e.border.horizontalMinMax,
      horizontalRangeStep: e.border.horizontalRangeStep,
      angleRange: e.border.angleRange,
      angleMinMax: e.border.angleMinMax,
      angleRangeStep: e.border.angleRangeStep,
      angledRange: e.border.angledRange,
      angledMinMax: e.border.angledMinMax,
      angledRangeStep: e.border.angledRangeStep,
      verticalRange: e.border.verticalRange,
      verticalMinMax: e.border.verticalMinMax,
      verticalRangeStep: e.border.verticalRangeStep,
      angleDefault: e.border.angleDefault,
      angledDefault: e.border.angledDefault,
      horizontalDefault: e.border.horizontalDefault,
      verticalDefault: e.border.verticalDefault
    },
    minimalThickness: {
      minimalThicknessRange: e.minimalThickness.minimalThicknessRange,
      minimalThicknessMinMax: e.minimalThickness.minimalThicknessMinMax,
      minimalThicknessStep: e.minimalThickness.minimalThicknessStep,
      minimalThicknessDefault: e.minimalThickness.minimalThicknessDefault
    },
    reconstructionDesigns: e.reconstructionDesigns
  };
}
function OD() {
  return {
    name: "",
    username: "",
    id: 0
  };
}
const Vu = [".zip", ".stl", ".pdf", ".docx", ".xlsx", ".png", ".jpg", ".txt", ".pts", ".xml", ".constructioninfo"];
function ND(e, t, n) {
  return e.id ? {
    id: e.id,
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: e.sortOrder,
    visibleToUser: e.visibleToUser,
    sku: e.sku,
    defaultOperatorId: e.defaultOperatorId,
    defaultStatusId: e.defaultStatusId,
    workflowId: t,
    jsonData: ""
  } : {
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: n + 1,
    visibleToUser: e.visibleToUser,
    sku: e.sku,
    defaultOperatorId: e.defaultOperatorId,
    defaultStatusId: e.defaultStatusId,
    workflowId: t,
    jsonData: ""
  };
}
function RD() {
  return {};
}
function PD(e) {
  return {
    id: 0,
    name: "",
    description: "",
    activated: !0,
    oneOperator: !1,
    prodCenterId: e,
    supportedTypes: [],
    machine: "",
    sortOrder: 0,
    steps: [],
    statusIds: [],
    minProcessingDays: 0,
    multiMachine: !1
  };
}
function FD(e, t) {
  return {
    //id: id ? id : 1,
    name: "",
    displayString: "",
    enabled: !0,
    sortOrder: e || 0,
    visibleToUser: !0,
    sku: "",
    defaultOperatorId: void 0,
    defaultStatusId: void 0,
    //workflowId: 0,
    jsonData: ""
  };
}
function QD() {
  return {
    id: 0,
    sortOrder: 0,
    name: "",
    description: "",
    dataType: [],
    activated: !1,
    oneOperator: !1,
    machine: "",
    steps: [],
    statuses: [],
    types: [],
    minProcessingDays: 0,
    multiMachine: !1
  };
}
function UD(e, t) {
  return {
    //id: id ? id : 1,
    name: "",
    displayString: "",
    enabled: !0,
    sortOrder: e || 0,
    jsonData: "",
    allowUserEdit: !1,
    awaitUserConfirmation: !1,
    moveToNext: !1,
    incoming: !1,
    statusClass: ""
    //workflowId: 0
  };
}
function GD(e, t, n) {
  return e.id ? {
    id: e.id,
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: e.sortOrder,
    allowUserEdit: e.allowUserEdit,
    moveToNext: e.moveToNext,
    incoming: e.incoming,
    workflowId: t,
    jsonData: ""
  } : {
    name: e.name,
    displayString: e.name,
    enabled: !0,
    sortOrder: n + 1,
    allowUserEdit: e.allowUserEdit,
    moveToNext: e.moveToNext,
    incoming: e.incoming,
    workflowId: t
  };
}
function Dr(e) {
  const t = Ht(e);
  if (!t) throw new Error("Module is null!");
  return t;
}
class $A {
  constructor(t) {
    this.assetPath = t, console.log("AssetPlugin", t);
  }
  getAssetUrl(t) {
    return this.assetPath === "" || this.assetPath === "/" ? t : (this.assetPath + t).replaceAll("//", "/");
  }
}
const Ku = {
  symbol: Symbol(),
  plugin: null,
  install(e, t) {
    this.plugin = new $A(t.assetPath), e.config.globalProperties.$asset = this.plugin, e.provide(this.symbol, this.plugin);
  }
};
function sa() {
  return Dr(Ku.symbol);
}
const qA = { layout: "dark", palette: { 0: "#ffffff", 50: "#f4f4f4", 100: "#e8e9e9", 200: "#d2d2d4", 300: "#bbbcbe", 400: "#a5a5a9", 500: "#8e8f93", 600: "#77787d", 700: "#616268", 800: "#4a4b52", 900: "#34343d", 950: "#1d1e27" }, color: { name: "blue", palette: { 50: "#eff6ff", 100: "#dbeafe", 200: "#bfdbfe", 300: "#93c5fd", 400: "#4B7AE7", 500: "#3b82f6", 600: "#2563eb", 700: "#1d4ed8", 800: "#1e40af", 900: "#1e3a8a", 950: "#172554" } } }, wo = {
  theme: qA
}, Ai = {
  "application/andrew-inset": { source: "iana", extensions: ["ez"] },
  "application/appinstaller": { compressible: !1, extensions: ["appinstaller"] },
  "application/applixware": { source: "apache", extensions: ["aw"] },
  "application/appx": { compressible: !1, extensions: ["appx"] },
  "application/appxbundle": { compressible: !1, extensions: ["appxbundle"] },
  "application/atom+xml": { source: "iana", compressible: !0, extensions: ["atom"] },
  "application/atomcat+xml": { source: "iana", compressible: !0, extensions: ["atomcat"] },
  "application/atomdeleted+xml": { source: "iana", compressible: !0, extensions: ["atomdeleted"] },
  "application/atomsvc+xml": { source: "iana", compressible: !0, extensions: ["atomsvc"] },
  "application/atsc-dwd+xml": { source: "iana", compressible: !0, extensions: ["dwd"] },
  "application/atsc-held+xml": { source: "iana", compressible: !0, extensions: ["held"] },
  "application/atsc-rsat+xml": { source: "iana", compressible: !0, extensions: ["rsat"] },
  "application/automationml-aml+xml": { source: "iana", compressible: !0, extensions: ["aml"] },
  "application/automationml-amlx+zip": { source: "iana", compressible: !1, extensions: ["amlx"] },
  "application/bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/calendar+xml": { source: "iana", compressible: !0, extensions: ["xcs"] },
  "application/ccxml+xml": { source: "iana", compressible: !0, extensions: ["ccxml"] },
  "application/cdfx+xml": { source: "iana", compressible: !0, extensions: ["cdfx"] },
  "application/cdmi-capability": { source: "iana", extensions: ["cdmia"] },
  "application/cdmi-container": { source: "iana", extensions: ["cdmic"] },
  "application/cdmi-domain": { source: "iana", extensions: ["cdmid"] },
  "application/cdmi-object": { source: "iana", extensions: ["cdmio"] },
  "application/cdmi-queue": { source: "iana", extensions: ["cdmiq"] },
  "application/cpl+xml": { source: "iana", compressible: !0, extensions: ["cpl"] },
  "application/cu-seeme": { source: "apache", extensions: ["cu"] },
  "application/cwl": { source: "iana", extensions: ["cwl"] },
  "application/dash+xml": { source: "iana", compressible: !0, extensions: ["mpd"] },
  "application/dash-patch+xml": { source: "iana", compressible: !0, extensions: ["mpp"] },
  "application/davmount+xml": { source: "iana", compressible: !0, extensions: ["davmount"] },
  "application/dicom": { source: "iana", extensions: ["dcm"] },
  "application/docbook+xml": { source: "apache", compressible: !0, extensions: ["dbk"] },
  "application/dssc+der": { source: "iana", extensions: ["dssc"] },
  "application/dssc+xml": { source: "iana", compressible: !0, extensions: ["xdssc"] },
  "application/ecmascript": { source: "apache", compressible: !0, extensions: ["ecma"] },
  "application/emma+xml": { source: "iana", compressible: !0, extensions: ["emma"] },
  "application/emotionml+xml": { source: "iana", compressible: !0, extensions: ["emotionml"] },
  "application/epub+zip": { source: "iana", compressible: !1, extensions: ["epub"] },
  "application/exi": { source: "iana", extensions: ["exi"] },
  "application/express": { source: "iana", extensions: ["exp"] },
  "application/fdf": { source: "iana", extensions: ["fdf"] },
  "application/fdt+xml": { source: "iana", compressible: !0, extensions: ["fdt"] },
  "application/font-tdpfr": { source: "iana", extensions: ["pfr"] },
  "application/geo+json": { source: "iana", compressible: !0, extensions: ["geojson"] },
  "application/gml+xml": { source: "iana", compressible: !0, extensions: ["gml"] },
  "application/gpx+xml": { source: "apache", compressible: !0, extensions: ["gpx"] },
  "application/gxf": { source: "apache", extensions: ["gxf"] },
  "application/gzip": { source: "iana", compressible: !1, extensions: ["gz"] },
  "application/hjson": { extensions: ["hjson"] },
  "application/hyperstudio": { source: "iana", extensions: ["stk"] },
  "application/inkml+xml": { source: "iana", compressible: !0, extensions: ["ink", "inkml"] },
  "application/ipfix": { source: "iana", extensions: ["ipfix"] },
  "application/its+xml": { source: "iana", compressible: !0, extensions: ["its"] },
  "application/java-archive": { source: "iana", compressible: !1, extensions: ["jar", "war", "ear"] },
  "application/java-serialized-object": { source: "apache", compressible: !1, extensions: ["ser"] },
  "application/java-vm": { source: "apache", compressible: !1, extensions: ["class"] },
  "application/javascript": { source: "apache", charset: "UTF-8", compressible: !0, extensions: ["js"] },
  "application/json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["json", "map"] },
  "application/json5": { extensions: ["json5"] },
  "application/jsonml+json": { source: "apache", compressible: !0, extensions: ["jsonml"] },
  "application/ld+json": { source: "iana", compressible: !0, extensions: ["jsonld"] },
  "application/lgr+xml": { source: "iana", compressible: !0, extensions: ["lgr"] },
  "application/lost+xml": { source: "iana", compressible: !0, extensions: ["lostxml"] },
  "application/mac-binhex40": { source: "iana", extensions: ["hqx"] },
  "application/mac-compactpro": { source: "apache", extensions: ["cpt"] },
  "application/mads+xml": { source: "iana", compressible: !0, extensions: ["mads"] },
  "application/manifest+json": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["webmanifest"] },
  "application/marc": { source: "iana", extensions: ["mrc"] },
  "application/marcxml+xml": { source: "iana", compressible: !0, extensions: ["mrcx"] },
  "application/mathematica": { source: "iana", extensions: ["ma", "nb", "mb"] },
  "application/mathml+xml": { source: "iana", compressible: !0, extensions: ["mathml"] },
  "application/mbox": { source: "iana", extensions: ["mbox"] },
  "application/media-policy-dataset+xml": { source: "iana", compressible: !0, extensions: ["mpf"] },
  "application/mediaservercontrol+xml": { source: "iana", compressible: !0, extensions: ["mscml"] },
  "application/metalink+xml": { source: "apache", compressible: !0, extensions: ["metalink"] },
  "application/metalink4+xml": { source: "iana", compressible: !0, extensions: ["meta4"] },
  "application/mets+xml": { source: "iana", compressible: !0, extensions: ["mets"] },
  "application/mmt-aei+xml": { source: "iana", compressible: !0, extensions: ["maei"] },
  "application/mmt-usd+xml": { source: "iana", compressible: !0, extensions: ["musd"] },
  "application/mods+xml": { source: "iana", compressible: !0, extensions: ["mods"] },
  "application/mp21": { source: "iana", extensions: ["m21", "mp21"] },
  "application/mp4": { source: "iana", extensions: ["mp4", "mpg4", "mp4s", "m4p"] },
  "application/msix": { compressible: !1, extensions: ["msix"] },
  "application/msixbundle": { compressible: !1, extensions: ["msixbundle"] },
  "application/msword": { source: "iana", compressible: !1, extensions: ["doc", "dot"] },
  "application/mxf": { source: "iana", extensions: ["mxf"] },
  "application/n-quads": { source: "iana", extensions: ["nq"] },
  "application/n-triples": { source: "iana", extensions: ["nt"] },
  "application/node": { source: "iana", extensions: ["cjs"] },
  "application/octet-stream": { source: "iana", compressible: !0, extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"] },
  "application/oda": { source: "iana", extensions: ["oda"] },
  "application/oebps-package+xml": { source: "iana", compressible: !0, extensions: ["opf"] },
  "application/ogg": { source: "iana", compressible: !1, extensions: ["ogx"] },
  "application/omdoc+xml": { source: "apache", compressible: !0, extensions: ["omdoc"] },
  "application/onenote": { source: "apache", extensions: ["onetoc", "onetoc2", "onetmp", "onepkg", "one", "onea"] },
  "application/oxps": { source: "iana", extensions: ["oxps"] },
  "application/p2p-overlay+xml": { source: "iana", compressible: !0, extensions: ["relo"] },
  "application/patch-ops-error+xml": { source: "iana", compressible: !0, extensions: ["xer"] },
  "application/pdf": { source: "iana", compressible: !1, extensions: ["pdf"] },
  "application/pgp-encrypted": { source: "iana", compressible: !1, extensions: ["pgp"] },
  "application/pgp-keys": { source: "iana", extensions: ["asc"] },
  "application/pgp-signature": { source: "iana", extensions: ["sig", "asc"] },
  "application/pics-rules": { source: "apache", extensions: ["prf"] },
  "application/pkcs10": { source: "iana", extensions: ["p10"] },
  "application/pkcs7-mime": { source: "iana", extensions: ["p7m", "p7c"] },
  "application/pkcs7-signature": { source: "iana", extensions: ["p7s"] },
  "application/pkcs8": { source: "iana", extensions: ["p8"] },
  "application/pkix-attr-cert": { source: "iana", extensions: ["ac"] },
  "application/pkix-cert": { source: "iana", extensions: ["cer"] },
  "application/pkix-crl": { source: "iana", extensions: ["crl"] },
  "application/pkix-pkipath": { source: "iana", extensions: ["pkipath"] },
  "application/pkixcmp": { source: "iana", extensions: ["pki"] },
  "application/pls+xml": { source: "iana", compressible: !0, extensions: ["pls"] },
  "application/postscript": { source: "iana", compressible: !0, extensions: ["ai", "eps", "ps"] },
  "application/provenance+xml": { source: "iana", compressible: !0, extensions: ["provx"] },
  "application/prs.cww": { source: "iana", extensions: ["cww"] },
  "application/prs.xsf+xml": { source: "iana", compressible: !0, extensions: ["xsf"] },
  "application/pskc+xml": { source: "iana", compressible: !0, extensions: ["pskcxml"] },
  "application/raml+yaml": { compressible: !0, extensions: ["raml"] },
  "application/rdf+xml": { source: "iana", compressible: !0, extensions: ["rdf", "owl"] },
  "application/reginfo+xml": { source: "iana", compressible: !0, extensions: ["rif"] },
  "application/relax-ng-compact-syntax": { source: "iana", extensions: ["rnc"] },
  "application/resource-lists+xml": { source: "iana", compressible: !0, extensions: ["rl"] },
  "application/resource-lists-diff+xml": { source: "iana", compressible: !0, extensions: ["rld"] },
  "application/rls-services+xml": { source: "iana", compressible: !0, extensions: ["rs"] },
  "application/route-apd+xml": { source: "iana", compressible: !0, extensions: ["rapd"] },
  "application/route-s-tsid+xml": { source: "iana", compressible: !0, extensions: ["sls"] },
  "application/route-usd+xml": { source: "iana", compressible: !0, extensions: ["rusd"] },
  "application/rpki-ghostbusters": { source: "iana", extensions: ["gbr"] },
  "application/rpki-manifest": { source: "iana", extensions: ["mft"] },
  "application/rpki-roa": { source: "iana", extensions: ["roa"] },
  "application/rsd+xml": { source: "apache", compressible: !0, extensions: ["rsd"] },
  "application/rss+xml": { source: "apache", compressible: !0, extensions: ["rss"] },
  "application/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "application/sbml+xml": { source: "iana", compressible: !0, extensions: ["sbml"] },
  "application/scvp-cv-request": { source: "iana", extensions: ["scq"] },
  "application/scvp-cv-response": { source: "iana", extensions: ["scs"] },
  "application/scvp-vp-request": { source: "iana", extensions: ["spq"] },
  "application/scvp-vp-response": { source: "iana", extensions: ["spp"] },
  "application/sdp": { source: "iana", extensions: ["sdp"] },
  "application/senml+xml": { source: "iana", compressible: !0, extensions: ["senmlx"] },
  "application/sensml+xml": { source: "iana", compressible: !0, extensions: ["sensmlx"] },
  "application/set-payment-initiation": { source: "iana", extensions: ["setpay"] },
  "application/set-registration-initiation": { source: "iana", extensions: ["setreg"] },
  "application/shf+xml": { source: "iana", compressible: !0, extensions: ["shf"] },
  "application/sieve": { source: "iana", extensions: ["siv", "sieve"] },
  "application/smil+xml": { source: "iana", compressible: !0, extensions: ["smi", "smil"] },
  "application/sparql-query": { source: "iana", extensions: ["rq"] },
  "application/sparql-results+xml": { source: "iana", compressible: !0, extensions: ["srx"] },
  "application/sql": { source: "iana", extensions: ["sql"] },
  "application/srgs": { source: "iana", extensions: ["gram"] },
  "application/srgs+xml": { source: "iana", compressible: !0, extensions: ["grxml"] },
  "application/sru+xml": { source: "iana", compressible: !0, extensions: ["sru"] },
  "application/ssdl+xml": { source: "apache", compressible: !0, extensions: ["ssdl"] },
  "application/ssml+xml": { source: "iana", compressible: !0, extensions: ["ssml"] },
  "application/swid+xml": { source: "iana", compressible: !0, extensions: ["swidtag"] },
  "application/tei+xml": { source: "iana", compressible: !0, extensions: ["tei", "teicorpus"] },
  "application/thraud+xml": { source: "iana", compressible: !0, extensions: ["tfi"] },
  "application/timestamped-data": { source: "iana", extensions: ["tsd"] },
  "application/toml": { source: "iana", compressible: !0, extensions: ["toml"] },
  "application/trig": { source: "iana", extensions: ["trig"] },
  "application/ttml+xml": { source: "iana", compressible: !0, extensions: ["ttml"] },
  "application/ubjson": { compressible: !1, extensions: ["ubj"] },
  "application/urc-ressheet+xml": { source: "iana", compressible: !0, extensions: ["rsheet"] },
  "application/urc-targetdesc+xml": { source: "iana", compressible: !0, extensions: ["td"] },
  "application/vnd.1000minds.decision-model+xml": { source: "iana", compressible: !0, extensions: ["1km"] },
  "application/vnd.3gpp.pic-bw-large": { source: "iana", extensions: ["plb"] },
  "application/vnd.3gpp.pic-bw-small": { source: "iana", extensions: ["psb"] },
  "application/vnd.3gpp.pic-bw-var": { source: "iana", extensions: ["pvb"] },
  "application/vnd.3gpp2.tcap": { source: "iana", extensions: ["tcap"] },
  "application/vnd.3m.post-it-notes": { source: "iana", extensions: ["pwn"] },
  "application/vnd.accpac.simply.aso": { source: "iana", extensions: ["aso"] },
  "application/vnd.accpac.simply.imp": { source: "iana", extensions: ["imp"] },
  "application/vnd.acucobol": { source: "iana", extensions: ["acu"] },
  "application/vnd.acucorp": { source: "iana", extensions: ["atc", "acutc"] },
  "application/vnd.adobe.air-application-installer-package+zip": { source: "apache", compressible: !1, extensions: ["air"] },
  "application/vnd.adobe.formscentral.fcdt": { source: "iana", extensions: ["fcdt"] },
  "application/vnd.adobe.fxp": { source: "iana", extensions: ["fxp", "fxpl"] },
  "application/vnd.adobe.xdp+xml": { source: "iana", compressible: !0, extensions: ["xdp"] },
  "application/vnd.adobe.xfdf": { source: "apache", extensions: ["xfdf"] },
  "application/vnd.age": { source: "iana", extensions: ["age"] },
  "application/vnd.ahead.space": { source: "iana", extensions: ["ahead"] },
  "application/vnd.airzip.filesecure.azf": { source: "iana", extensions: ["azf"] },
  "application/vnd.airzip.filesecure.azs": { source: "iana", extensions: ["azs"] },
  "application/vnd.amazon.ebook": { source: "apache", extensions: ["azw"] },
  "application/vnd.americandynamics.acc": { source: "iana", extensions: ["acc"] },
  "application/vnd.amiga.ami": { source: "iana", extensions: ["ami"] },
  "application/vnd.android.package-archive": { source: "apache", compressible: !1, extensions: ["apk"] },
  "application/vnd.anser-web-certificate-issue-initiation": { source: "iana", extensions: ["cii"] },
  "application/vnd.anser-web-funds-transfer-initiation": { source: "apache", extensions: ["fti"] },
  "application/vnd.antix.game-component": { source: "iana", extensions: ["atx"] },
  "application/vnd.apple.installer+xml": { source: "iana", compressible: !0, extensions: ["mpkg"] },
  "application/vnd.apple.keynote": { source: "iana", extensions: ["key"] },
  "application/vnd.apple.mpegurl": { source: "iana", extensions: ["m3u8"] },
  "application/vnd.apple.numbers": { source: "iana", extensions: ["numbers"] },
  "application/vnd.apple.pages": { source: "iana", extensions: ["pages"] },
  "application/vnd.apple.pkpass": { compressible: !1, extensions: ["pkpass"] },
  "application/vnd.aristanetworks.swi": { source: "iana", extensions: ["swi"] },
  "application/vnd.astraea-software.iota": { source: "iana", extensions: ["iota"] },
  "application/vnd.audiograph": { source: "iana", extensions: ["aep"] },
  "application/vnd.autodesk.fbx": { extensions: ["fbx"] },
  "application/vnd.balsamiq.bmml+xml": { source: "iana", compressible: !0, extensions: ["bmml"] },
  "application/vnd.blueice.multipass": { source: "iana", extensions: ["mpm"] },
  "application/vnd.bmi": { source: "iana", extensions: ["bmi"] },
  "application/vnd.businessobjects": { source: "iana", extensions: ["rep"] },
  "application/vnd.chemdraw+xml": { source: "iana", compressible: !0, extensions: ["cdxml"] },
  "application/vnd.chipnuts.karaoke-mmd": { source: "iana", extensions: ["mmd"] },
  "application/vnd.cinderella": { source: "iana", extensions: ["cdy"] },
  "application/vnd.citationstyles.style+xml": { source: "iana", compressible: !0, extensions: ["csl"] },
  "application/vnd.claymore": { source: "iana", extensions: ["cla"] },
  "application/vnd.cloanto.rp9": { source: "iana", extensions: ["rp9"] },
  "application/vnd.clonk.c4group": { source: "iana", extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"] },
  "application/vnd.cluetrust.cartomobile-config": { source: "iana", extensions: ["c11amc"] },
  "application/vnd.cluetrust.cartomobile-config-pkg": { source: "iana", extensions: ["c11amz"] },
  "application/vnd.commonspace": { source: "iana", extensions: ["csp"] },
  "application/vnd.contact.cmsg": { source: "iana", extensions: ["cdbcmsg"] },
  "application/vnd.cosmocaller": { source: "iana", extensions: ["cmc"] },
  "application/vnd.crick.clicker": { source: "iana", extensions: ["clkx"] },
  "application/vnd.crick.clicker.keyboard": { source: "iana", extensions: ["clkk"] },
  "application/vnd.crick.clicker.palette": { source: "iana", extensions: ["clkp"] },
  "application/vnd.crick.clicker.template": { source: "iana", extensions: ["clkt"] },
  "application/vnd.crick.clicker.wordbank": { source: "iana", extensions: ["clkw"] },
  "application/vnd.criticaltools.wbs+xml": { source: "iana", compressible: !0, extensions: ["wbs"] },
  "application/vnd.ctc-posml": { source: "iana", extensions: ["pml"] },
  "application/vnd.cups-ppd": { source: "iana", extensions: ["ppd"] },
  "application/vnd.curl.car": { source: "apache", extensions: ["car"] },
  "application/vnd.curl.pcurl": { source: "apache", extensions: ["pcurl"] },
  "application/vnd.dart": { source: "iana", compressible: !0, extensions: ["dart"] },
  "application/vnd.data-vision.rdz": { source: "iana", extensions: ["rdz"] },
  "application/vnd.dbf": { source: "iana", extensions: ["dbf"] },
  "application/vnd.dcmp+xml": { source: "iana", compressible: !0, extensions: ["dcmp"] },
  "application/vnd.dece.data": { source: "iana", extensions: ["uvf", "uvvf", "uvd", "uvvd"] },
  "application/vnd.dece.ttml+xml": { source: "iana", compressible: !0, extensions: ["uvt", "uvvt"] },
  "application/vnd.dece.unspecified": { source: "iana", extensions: ["uvx", "uvvx"] },
  "application/vnd.dece.zip": { source: "iana", extensions: ["uvz", "uvvz"] },
  "application/vnd.denovo.fcselayout-link": { source: "iana", extensions: ["fe_launch"] },
  "application/vnd.dna": { source: "iana", extensions: ["dna"] },
  "application/vnd.dolby.mlp": { source: "apache", extensions: ["mlp"] },
  "application/vnd.dpgraph": { source: "iana", extensions: ["dpg"] },
  "application/vnd.dreamfactory": { source: "iana", extensions: ["dfac"] },
  "application/vnd.ds-keypoint": { source: "apache", extensions: ["kpxx"] },
  "application/vnd.dvb.ait": { source: "iana", extensions: ["ait"] },
  "application/vnd.dvb.service": { source: "iana", extensions: ["svc"] },
  "application/vnd.dynageo": { source: "iana", extensions: ["geo"] },
  "application/vnd.ecowin.chart": { source: "iana", extensions: ["mag"] },
  "application/vnd.enliven": { source: "iana", extensions: ["nml"] },
  "application/vnd.epson.esf": { source: "iana", extensions: ["esf"] },
  "application/vnd.epson.msf": { source: "iana", extensions: ["msf"] },
  "application/vnd.epson.quickanime": { source: "iana", extensions: ["qam"] },
  "application/vnd.epson.salt": { source: "iana", extensions: ["slt"] },
  "application/vnd.epson.ssf": { source: "iana", extensions: ["ssf"] },
  "application/vnd.eszigno3+xml": { source: "iana", compressible: !0, extensions: ["es3", "et3"] },
  "application/vnd.ezpix-album": { source: "iana", extensions: ["ez2"] },
  "application/vnd.ezpix-package": { source: "iana", extensions: ["ez3"] },
  "application/vnd.fdf": { source: "apache", extensions: ["fdf"] },
  "application/vnd.fdsn.mseed": { source: "iana", extensions: ["mseed"] },
  "application/vnd.fdsn.seed": { source: "iana", extensions: ["seed", "dataless"] },
  "application/vnd.flographit": { source: "iana", extensions: ["gph"] },
  "application/vnd.fluxtime.clip": { source: "iana", extensions: ["ftc"] },
  "application/vnd.framemaker": { source: "iana", extensions: ["fm", "frame", "maker", "book"] },
  "application/vnd.frogans.fnc": { source: "apache", extensions: ["fnc"] },
  "application/vnd.frogans.ltf": { source: "apache", extensions: ["ltf"] },
  "application/vnd.fsc.weblaunch": { source: "iana", extensions: ["fsc"] },
  "application/vnd.fujitsu.oasys": { source: "iana", extensions: ["oas"] },
  "application/vnd.fujitsu.oasys2": { source: "iana", extensions: ["oa2"] },
  "application/vnd.fujitsu.oasys3": { source: "iana", extensions: ["oa3"] },
  "application/vnd.fujitsu.oasysgp": { source: "iana", extensions: ["fg5"] },
  "application/vnd.fujitsu.oasysprs": { source: "iana", extensions: ["bh2"] },
  "application/vnd.fujixerox.ddd": { source: "iana", extensions: ["ddd"] },
  "application/vnd.fujixerox.docuworks": { source: "iana", extensions: ["xdw"] },
  "application/vnd.fujixerox.docuworks.binder": { source: "iana", extensions: ["xbd"] },
  "application/vnd.fuzzysheet": { source: "iana", extensions: ["fzs"] },
  "application/vnd.genomatix.tuxedo": { source: "iana", extensions: ["txd"] },
  "application/vnd.geogebra.file": { source: "iana", extensions: ["ggb"] },
  "application/vnd.geogebra.slides": { source: "iana", extensions: ["ggs"] },
  "application/vnd.geogebra.tool": { source: "iana", extensions: ["ggt"] },
  "application/vnd.geometry-explorer": { source: "iana", extensions: ["gex", "gre"] },
  "application/vnd.geonext": { source: "iana", extensions: ["gxt"] },
  "application/vnd.geoplan": { source: "iana", extensions: ["g2w"] },
  "application/vnd.geospace": { source: "iana", extensions: ["g3w"] },
  "application/vnd.gmx": { source: "iana", extensions: ["gmx"] },
  "application/vnd.google-apps.document": { compressible: !1, extensions: ["gdoc"] },
  "application/vnd.google-apps.drawing": { compressible: !1, extensions: ["gdraw"] },
  "application/vnd.google-apps.form": { compressible: !1, extensions: ["gform"] },
  "application/vnd.google-apps.jam": { compressible: !1, extensions: ["gjam"] },
  "application/vnd.google-apps.map": { compressible: !1, extensions: ["gmap"] },
  "application/vnd.google-apps.presentation": { compressible: !1, extensions: ["gslides"] },
  "application/vnd.google-apps.script": { compressible: !1, extensions: ["gscript"] },
  "application/vnd.google-apps.site": { compressible: !1, extensions: ["gsite"] },
  "application/vnd.google-apps.spreadsheet": { compressible: !1, extensions: ["gsheet"] },
  "application/vnd.google-earth.kml+xml": { source: "iana", compressible: !0, extensions: ["kml"] },
  "application/vnd.google-earth.kmz": { source: "iana", compressible: !1, extensions: ["kmz"] },
  "application/vnd.gov.sk.xmldatacontainer+xml": { source: "iana", compressible: !0, extensions: ["xdcf"] },
  "application/vnd.grafeq": { source: "iana", extensions: ["gqf", "gqs"] },
  "application/vnd.groove-account": { source: "iana", extensions: ["gac"] },
  "application/vnd.groove-help": { source: "iana", extensions: ["ghf"] },
  "application/vnd.groove-identity-message": { source: "iana", extensions: ["gim"] },
  "application/vnd.groove-injector": { source: "iana", extensions: ["grv"] },
  "application/vnd.groove-tool-message": { source: "iana", extensions: ["gtm"] },
  "application/vnd.groove-tool-template": { source: "iana", extensions: ["tpl"] },
  "application/vnd.groove-vcard": { source: "iana", extensions: ["vcg"] },
  "application/vnd.hal+xml": { source: "iana", compressible: !0, extensions: ["hal"] },
  "application/vnd.handheld-entertainment+xml": { source: "iana", compressible: !0, extensions: ["zmm"] },
  "application/vnd.hbci": { source: "iana", extensions: ["hbci"] },
  "application/vnd.hhe.lesson-player": { source: "iana", extensions: ["les"] },
  "application/vnd.hp-hpgl": { source: "iana", extensions: ["hpgl"] },
  "application/vnd.hp-hpid": { source: "iana", extensions: ["hpid"] },
  "application/vnd.hp-hps": { source: "iana", extensions: ["hps"] },
  "application/vnd.hp-jlyt": { source: "iana", extensions: ["jlt"] },
  "application/vnd.hp-pcl": { source: "iana", extensions: ["pcl"] },
  "application/vnd.hp-pclxl": { source: "iana", extensions: ["pclxl"] },
  "application/vnd.hydrostatix.sof-data": { source: "iana", extensions: ["sfd-hdstx"] },
  "application/vnd.ibm.minipay": { source: "iana", extensions: ["mpy"] },
  "application/vnd.ibm.modcap": { source: "apache", extensions: ["afp", "listafp", "list3820"] },
  "application/vnd.ibm.rights-management": { source: "iana", extensions: ["irm"] },
  "application/vnd.ibm.secure-container": { source: "iana", extensions: ["sc"] },
  "application/vnd.iccprofile": { source: "iana", extensions: ["icc", "icm"] },
  "application/vnd.igloader": { source: "iana", extensions: ["igl"] },
  "application/vnd.immervision-ivp": { source: "iana", extensions: ["ivp"] },
  "application/vnd.immervision-ivu": { source: "iana", extensions: ["ivu"] },
  "application/vnd.insors.igm": { source: "iana", extensions: ["igm"] },
  "application/vnd.intercon.formnet": { source: "iana", extensions: ["xpw", "xpx"] },
  "application/vnd.intergeo": { source: "iana", extensions: ["i2g"] },
  "application/vnd.intu.qbo": { source: "iana", extensions: ["qbo"] },
  "application/vnd.intu.qfx": { source: "iana", extensions: ["qfx"] },
  "application/vnd.ipunplugged.rcprofile": { source: "iana", extensions: ["rcprofile"] },
  "application/vnd.irepository.package+xml": { source: "iana", compressible: !0, extensions: ["irp"] },
  "application/vnd.is-xpr": { source: "iana", extensions: ["xpr"] },
  "application/vnd.isac.fcs": { source: "iana", extensions: ["fcs"] },
  "application/vnd.jam": { source: "iana", extensions: ["jam"] },
  "application/vnd.jcp.javame.midlet-rms": { source: "iana", extensions: ["rms"] },
  "application/vnd.jisp": { source: "iana", extensions: ["jisp"] },
  "application/vnd.joost.joda-archive": { source: "iana", extensions: ["joda"] },
  "application/vnd.kahootz": { source: "iana", extensions: ["ktz", "ktr"] },
  "application/vnd.kde.karbon": { source: "iana", extensions: ["karbon"] },
  "application/vnd.kde.kchart": { source: "iana", extensions: ["chrt"] },
  "application/vnd.kde.kformula": { source: "iana", extensions: ["kfo"] },
  "application/vnd.kde.kivio": { source: "iana", extensions: ["flw"] },
  "application/vnd.kde.kontour": { source: "iana", extensions: ["kon"] },
  "application/vnd.kde.kpresenter": { source: "iana", extensions: ["kpr", "kpt"] },
  "application/vnd.kde.kspread": { source: "iana", extensions: ["ksp"] },
  "application/vnd.kde.kword": { source: "iana", extensions: ["kwd", "kwt"] },
  "application/vnd.kenameaapp": { source: "iana", extensions: ["htke"] },
  "application/vnd.kidspiration": { source: "iana", extensions: ["kia"] },
  "application/vnd.kinar": { source: "iana", extensions: ["kne", "knp"] },
  "application/vnd.koan": { source: "iana", extensions: ["skp", "skd", "skt", "skm"] },
  "application/vnd.kodak-descriptor": { source: "iana", extensions: ["sse"] },
  "application/vnd.las.las+xml": { source: "iana", compressible: !0, extensions: ["lasxml"] },
  "application/vnd.llamagraphics.life-balance.desktop": { source: "iana", extensions: ["lbd"] },
  "application/vnd.llamagraphics.life-balance.exchange+xml": { source: "iana", compressible: !0, extensions: ["lbe"] },
  "application/vnd.lotus-1-2-3": { source: "iana", extensions: ["123"] },
  "application/vnd.lotus-approach": { source: "iana", extensions: ["apr"] },
  "application/vnd.lotus-freelance": { source: "iana", extensions: ["pre"] },
  "application/vnd.lotus-notes": { source: "iana", extensions: ["nsf"] },
  "application/vnd.lotus-organizer": { source: "iana", extensions: ["org"] },
  "application/vnd.lotus-screencam": { source: "iana", extensions: ["scm"] },
  "application/vnd.lotus-wordpro": { source: "iana", extensions: ["lwp"] },
  "application/vnd.macports.portpkg": { source: "iana", extensions: ["portpkg"] },
  "application/vnd.mapbox-vector-tile": { source: "iana", extensions: ["mvt"] },
  "application/vnd.mcd": { source: "iana", extensions: ["mcd"] },
  "application/vnd.medcalcdata": { source: "iana", extensions: ["mc1"] },
  "application/vnd.mediastation.cdkey": { source: "iana", extensions: ["cdkey"] },
  "application/vnd.mfer": { source: "iana", extensions: ["mwf"] },
  "application/vnd.mfmp": { source: "iana", extensions: ["mfm"] },
  "application/vnd.micrografx.flo": { source: "iana", extensions: ["flo"] },
  "application/vnd.micrografx.igx": { source: "iana", extensions: ["igx"] },
  "application/vnd.mif": { source: "iana", extensions: ["mif"] },
  "application/vnd.mobius.daf": { source: "iana", extensions: ["daf"] },
  "application/vnd.mobius.dis": { source: "iana", extensions: ["dis"] },
  "application/vnd.mobius.mbk": { source: "iana", extensions: ["mbk"] },
  "application/vnd.mobius.mqy": { source: "iana", extensions: ["mqy"] },
  "application/vnd.mobius.msl": { source: "iana", extensions: ["msl"] },
  "application/vnd.mobius.plc": { source: "iana", extensions: ["plc"] },
  "application/vnd.mobius.txf": { source: "iana", extensions: ["txf"] },
  "application/vnd.mophun.application": { source: "iana", extensions: ["mpn"] },
  "application/vnd.mophun.certificate": { source: "iana", extensions: ["mpc"] },
  "application/vnd.mozilla.xul+xml": { source: "iana", compressible: !0, extensions: ["xul"] },
  "application/vnd.ms-artgalry": { source: "iana", extensions: ["cil"] },
  "application/vnd.ms-cab-compressed": { source: "iana", extensions: ["cab"] },
  "application/vnd.ms-excel": { source: "iana", compressible: !1, extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"] },
  "application/vnd.ms-excel.addin.macroenabled.12": { source: "iana", extensions: ["xlam"] },
  "application/vnd.ms-excel.sheet.binary.macroenabled.12": { source: "iana", extensions: ["xlsb"] },
  "application/vnd.ms-excel.sheet.macroenabled.12": { source: "iana", extensions: ["xlsm"] },
  "application/vnd.ms-excel.template.macroenabled.12": { source: "iana", extensions: ["xltm"] },
  "application/vnd.ms-fontobject": { source: "iana", compressible: !0, extensions: ["eot"] },
  "application/vnd.ms-htmlhelp": { source: "iana", extensions: ["chm"] },
  "application/vnd.ms-ims": { source: "iana", extensions: ["ims"] },
  "application/vnd.ms-lrm": { source: "iana", extensions: ["lrm"] },
  "application/vnd.ms-officetheme": { source: "iana", extensions: ["thmx"] },
  "application/vnd.ms-outlook": { compressible: !1, extensions: ["msg"] },
  "application/vnd.ms-pki.seccat": { source: "apache", extensions: ["cat"] },
  "application/vnd.ms-pki.stl": { source: "apache", extensions: ["stl"] },
  "application/vnd.ms-powerpoint": { source: "iana", compressible: !1, extensions: ["ppt", "pps", "pot"] },
  "application/vnd.ms-powerpoint.addin.macroenabled.12": { source: "iana", extensions: ["ppam"] },
  "application/vnd.ms-powerpoint.presentation.macroenabled.12": { source: "iana", extensions: ["pptm"] },
  "application/vnd.ms-powerpoint.slide.macroenabled.12": { source: "iana", extensions: ["sldm"] },
  "application/vnd.ms-powerpoint.slideshow.macroenabled.12": { source: "iana", extensions: ["ppsm"] },
  "application/vnd.ms-powerpoint.template.macroenabled.12": { source: "iana", extensions: ["potm"] },
  "application/vnd.ms-project": { source: "iana", extensions: ["mpp", "mpt"] },
  "application/vnd.ms-visio.viewer": { extensions: ["vdx"] },
  "application/vnd.ms-word.document.macroenabled.12": { source: "iana", extensions: ["docm"] },
  "application/vnd.ms-word.template.macroenabled.12": { source: "iana", extensions: ["dotm"] },
  "application/vnd.ms-works": { source: "iana", extensions: ["wps", "wks", "wcm", "wdb"] },
  "application/vnd.ms-wpl": { source: "iana", extensions: ["wpl"] },
  "application/vnd.ms-xpsdocument": { source: "iana", compressible: !1, extensions: ["xps"] },
  "application/vnd.mseq": { source: "iana", extensions: ["mseq"] },
  "application/vnd.musician": { source: "iana", extensions: ["mus"] },
  "application/vnd.muvee.style": { source: "iana", extensions: ["msty"] },
  "application/vnd.mynfc": { source: "iana", extensions: ["taglet"] },
  "application/vnd.nato.bindingdataobject+xml": { source: "iana", compressible: !0, extensions: ["bdo"] },
  "application/vnd.neurolanguage.nlu": { source: "iana", extensions: ["nlu"] },
  "application/vnd.nitf": { source: "iana", extensions: ["ntf", "nitf"] },
  "application/vnd.noblenet-directory": { source: "iana", extensions: ["nnd"] },
  "application/vnd.noblenet-sealer": { source: "iana", extensions: ["nns"] },
  "application/vnd.noblenet-web": { source: "iana", extensions: ["nnw"] },
  "application/vnd.nokia.n-gage.ac+xml": { source: "iana", compressible: !0, extensions: ["ac"] },
  "application/vnd.nokia.n-gage.data": { source: "iana", extensions: ["ngdat"] },
  "application/vnd.nokia.n-gage.symbian.install": { source: "apache", extensions: ["n-gage"] },
  "application/vnd.nokia.radio-preset": { source: "iana", extensions: ["rpst"] },
  "application/vnd.nokia.radio-presets": { source: "iana", extensions: ["rpss"] },
  "application/vnd.novadigm.edm": { source: "iana", extensions: ["edm"] },
  "application/vnd.novadigm.edx": { source: "iana", extensions: ["edx"] },
  "application/vnd.novadigm.ext": { source: "iana", extensions: ["ext"] },
  "application/vnd.oasis.opendocument.chart": { source: "iana", extensions: ["odc"] },
  "application/vnd.oasis.opendocument.chart-template": { source: "iana", extensions: ["otc"] },
  "application/vnd.oasis.opendocument.database": { source: "apache", extensions: ["odb"] },
  "application/vnd.oasis.opendocument.formula": { source: "iana", extensions: ["odf"] },
  "application/vnd.oasis.opendocument.formula-template": { source: "iana", extensions: ["odft"] },
  "application/vnd.oasis.opendocument.graphics": { source: "iana", compressible: !1, extensions: ["odg"] },
  "application/vnd.oasis.opendocument.graphics-template": { source: "iana", extensions: ["otg"] },
  "application/vnd.oasis.opendocument.image": { source: "iana", extensions: ["odi"] },
  "application/vnd.oasis.opendocument.image-template": { source: "iana", extensions: ["oti"] },
  "application/vnd.oasis.opendocument.presentation": { source: "iana", compressible: !1, extensions: ["odp"] },
  "application/vnd.oasis.opendocument.presentation-template": { source: "iana", extensions: ["otp"] },
  "application/vnd.oasis.opendocument.spreadsheet": { source: "iana", compressible: !1, extensions: ["ods"] },
  "application/vnd.oasis.opendocument.spreadsheet-template": { source: "iana", extensions: ["ots"] },
  "application/vnd.oasis.opendocument.text": { source: "iana", compressible: !1, extensions: ["odt"] },
  "application/vnd.oasis.opendocument.text-master": { source: "iana", extensions: ["odm"] },
  "application/vnd.oasis.opendocument.text-template": { source: "iana", extensions: ["ott"] },
  "application/vnd.oasis.opendocument.text-web": { source: "iana", extensions: ["oth"] },
  "application/vnd.olpc-sugar": { source: "iana", extensions: ["xo"] },
  "application/vnd.oma.dd2+xml": { source: "iana", compressible: !0, extensions: ["dd2"] },
  "application/vnd.openblox.game+xml": { source: "iana", compressible: !0, extensions: ["obgx"] },
  "application/vnd.openofficeorg.extension": { source: "apache", extensions: ["oxt"] },
  "application/vnd.openstreetmap.data+xml": { source: "iana", compressible: !0, extensions: ["osm"] },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { source: "iana", compressible: !1, extensions: ["pptx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slide": { source: "iana", extensions: ["sldx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": { source: "iana", extensions: ["ppsx"] },
  "application/vnd.openxmlformats-officedocument.presentationml.template": { source: "iana", extensions: ["potx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { source: "iana", compressible: !1, extensions: ["xlsx"] },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": { source: "iana", extensions: ["xltx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": { source: "iana", compressible: !1, extensions: ["docx"] },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": { source: "iana", extensions: ["dotx"] },
  "application/vnd.osgeo.mapguide.package": { source: "iana", extensions: ["mgp"] },
  "application/vnd.osgi.dp": { source: "iana", extensions: ["dp"] },
  "application/vnd.osgi.subsystem": { source: "iana", extensions: ["esa"] },
  "application/vnd.palm": { source: "iana", extensions: ["pdb", "pqa", "oprc"] },
  "application/vnd.pawaafile": { source: "iana", extensions: ["paw"] },
  "application/vnd.pg.format": { source: "iana", extensions: ["str"] },
  "application/vnd.pg.osasli": { source: "iana", extensions: ["ei6"] },
  "application/vnd.picsel": { source: "iana", extensions: ["efif"] },
  "application/vnd.pmi.widget": { source: "iana", extensions: ["wg"] },
  "application/vnd.pocketlearn": { source: "iana", extensions: ["plf"] },
  "application/vnd.powerbuilder6": { source: "iana", extensions: ["pbd"] },
  "application/vnd.previewsystems.box": { source: "iana", extensions: ["box"] },
  "application/vnd.procrate.brushset": { extensions: ["brushset"] },
  "application/vnd.procreate.brush": { extensions: ["brush"] },
  "application/vnd.procreate.dream": { extensions: ["drm"] },
  "application/vnd.proteus.magazine": { source: "iana", extensions: ["mgz"] },
  "application/vnd.publishare-delta-tree": { source: "iana", extensions: ["qps"] },
  "application/vnd.pvi.ptid1": { source: "iana", extensions: ["ptid"] },
  "application/vnd.pwg-xhtml-print+xml": { source: "iana", compressible: !0, extensions: ["xhtm"] },
  "application/vnd.quark.quarkxpress": { source: "iana", extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"] },
  "application/vnd.rar": { source: "iana", extensions: ["rar"] },
  "application/vnd.realvnc.bed": { source: "iana", extensions: ["bed"] },
  "application/vnd.recordare.musicxml": { source: "iana", extensions: ["mxl"] },
  "application/vnd.recordare.musicxml+xml": { source: "iana", compressible: !0, extensions: ["musicxml"] },
  "application/vnd.rig.cryptonote": { source: "iana", extensions: ["cryptonote"] },
  "application/vnd.rim.cod": { source: "apache", extensions: ["cod"] },
  "application/vnd.rn-realmedia": { source: "apache", extensions: ["rm"] },
  "application/vnd.rn-realmedia-vbr": { source: "apache", extensions: ["rmvb"] },
  "application/vnd.route66.link66+xml": { source: "iana", compressible: !0, extensions: ["link66"] },
  "application/vnd.sailingtracker.track": { source: "iana", extensions: ["st"] },
  "application/vnd.seemail": { source: "iana", extensions: ["see"] },
  "application/vnd.sema": { source: "iana", extensions: ["sema"] },
  "application/vnd.semd": { source: "iana", extensions: ["semd"] },
  "application/vnd.semf": { source: "iana", extensions: ["semf"] },
  "application/vnd.shana.informed.formdata": { source: "iana", extensions: ["ifm"] },
  "application/vnd.shana.informed.formtemplate": { source: "iana", extensions: ["itp"] },
  "application/vnd.shana.informed.interchange": { source: "iana", extensions: ["iif"] },
  "application/vnd.shana.informed.package": { source: "iana", extensions: ["ipk"] },
  "application/vnd.simtech-mindmapper": { source: "iana", extensions: ["twd", "twds"] },
  "application/vnd.smaf": { source: "iana", extensions: ["mmf"] },
  "application/vnd.smart.teacher": { source: "iana", extensions: ["teacher"] },
  "application/vnd.software602.filler.form+xml": { source: "iana", compressible: !0, extensions: ["fo"] },
  "application/vnd.solent.sdkm+xml": { source: "iana", compressible: !0, extensions: ["sdkm", "sdkd"] },
  "application/vnd.spotfire.dxp": { source: "iana", extensions: ["dxp"] },
  "application/vnd.spotfire.sfs": { source: "iana", extensions: ["sfs"] },
  "application/vnd.stardivision.calc": { source: "apache", extensions: ["sdc"] },
  "application/vnd.stardivision.draw": { source: "apache", extensions: ["sda"] },
  "application/vnd.stardivision.impress": { source: "apache", extensions: ["sdd"] },
  "application/vnd.stardivision.math": { source: "apache", extensions: ["smf"] },
  "application/vnd.stardivision.writer": { source: "apache", extensions: ["sdw", "vor"] },
  "application/vnd.stardivision.writer-global": { source: "apache", extensions: ["sgl"] },
  "application/vnd.stepmania.package": { source: "iana", extensions: ["smzip"] },
  "application/vnd.stepmania.stepchart": { source: "iana", extensions: ["sm"] },
  "application/vnd.sun.wadl+xml": { source: "iana", compressible: !0, extensions: ["wadl"] },
  "application/vnd.sun.xml.calc": { source: "apache", extensions: ["sxc"] },
  "application/vnd.sun.xml.calc.template": { source: "apache", extensions: ["stc"] },
  "application/vnd.sun.xml.draw": { source: "apache", extensions: ["sxd"] },
  "application/vnd.sun.xml.draw.template": { source: "apache", extensions: ["std"] },
  "application/vnd.sun.xml.impress": { source: "apache", extensions: ["sxi"] },
  "application/vnd.sun.xml.impress.template": { source: "apache", extensions: ["sti"] },
  "application/vnd.sun.xml.math": { source: "apache", extensions: ["sxm"] },
  "application/vnd.sun.xml.writer": { source: "apache", extensions: ["sxw"] },
  "application/vnd.sun.xml.writer.global": { source: "apache", extensions: ["sxg"] },
  "application/vnd.sun.xml.writer.template": { source: "apache", extensions: ["stw"] },
  "application/vnd.sus-calendar": { source: "iana", extensions: ["sus", "susp"] },
  "application/vnd.svd": { source: "iana", extensions: ["svd"] },
  "application/vnd.symbian.install": { source: "apache", extensions: ["sis", "sisx"] },
  "application/vnd.syncml+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xsm"] },
  "application/vnd.syncml.dm+wbxml": { source: "iana", charset: "UTF-8", extensions: ["bdm"] },
  "application/vnd.syncml.dm+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["xdm"] },
  "application/vnd.syncml.dmddf+xml": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["ddf"] },
  "application/vnd.tao.intent-module-archive": { source: "iana", extensions: ["tao"] },
  "application/vnd.tcpdump.pcap": { source: "iana", extensions: ["pcap", "cap", "dmp"] },
  "application/vnd.tmobile-livetv": { source: "iana", extensions: ["tmo"] },
  "application/vnd.trid.tpt": { source: "iana", extensions: ["tpt"] },
  "application/vnd.triscape.mxs": { source: "iana", extensions: ["mxs"] },
  "application/vnd.trueapp": { source: "iana", extensions: ["tra"] },
  "application/vnd.ufdl": { source: "iana", extensions: ["ufd", "ufdl"] },
  "application/vnd.uiq.theme": { source: "iana", extensions: ["utz"] },
  "application/vnd.umajin": { source: "iana", extensions: ["umj"] },
  "application/vnd.unity": { source: "iana", extensions: ["unityweb"] },
  "application/vnd.uoml+xml": { source: "iana", compressible: !0, extensions: ["uoml", "uo"] },
  "application/vnd.vcx": { source: "iana", extensions: ["vcx"] },
  "application/vnd.visio": { source: "iana", extensions: ["vsd", "vst", "vss", "vsw", "vsdx", "vtx"] },
  "application/vnd.visionary": { source: "iana", extensions: ["vis"] },
  "application/vnd.vsf": { source: "iana", extensions: ["vsf"] },
  "application/vnd.wap.wbxml": { source: "iana", charset: "UTF-8", extensions: ["wbxml"] },
  "application/vnd.wap.wmlc": { source: "iana", extensions: ["wmlc"] },
  "application/vnd.wap.wmlscriptc": { source: "iana", extensions: ["wmlsc"] },
  "application/vnd.webturbo": { source: "iana", extensions: ["wtb"] },
  "application/vnd.wolfram.player": { source: "iana", extensions: ["nbp"] },
  "application/vnd.wordperfect": { source: "iana", extensions: ["wpd"] },
  "application/vnd.wqd": { source: "iana", extensions: ["wqd"] },
  "application/vnd.wt.stf": { source: "iana", extensions: ["stf"] },
  "application/vnd.xara": { source: "iana", extensions: ["xar"] },
  "application/vnd.xfdl": { source: "iana", extensions: ["xfdl"] },
  "application/vnd.yamaha.hv-dic": { source: "iana", extensions: ["hvd"] },
  "application/vnd.yamaha.hv-script": { source: "iana", extensions: ["hvs"] },
  "application/vnd.yamaha.hv-voice": { source: "iana", extensions: ["hvp"] },
  "application/vnd.yamaha.openscoreformat": { source: "iana", extensions: ["osf"] },
  "application/vnd.yamaha.openscoreformat.osfpvg+xml": { source: "iana", compressible: !0, extensions: ["osfpvg"] },
  "application/vnd.yamaha.smaf-audio": { source: "iana", extensions: ["saf"] },
  "application/vnd.yamaha.smaf-phrase": { source: "iana", extensions: ["spf"] },
  "application/vnd.yellowriver-custom-menu": { source: "iana", extensions: ["cmp"] },
  "application/vnd.zul": { source: "iana", extensions: ["zir", "zirz"] },
  "application/vnd.zzazz.deck+xml": { source: "iana", compressible: !0, extensions: ["zaz"] },
  "application/voicexml+xml": { source: "iana", compressible: !0, extensions: ["vxml"] },
  "application/wasm": { source: "iana", compressible: !0, extensions: ["wasm"] },
  "application/watcherinfo+xml": { source: "iana", compressible: !0, extensions: ["wif"] },
  "application/widget": { source: "iana", extensions: ["wgt"] },
  "application/winhlp": { source: "apache", extensions: ["hlp"] },
  "application/wsdl+xml": { source: "iana", compressible: !0, extensions: ["wsdl"] },
  "application/wspolicy+xml": { source: "iana", compressible: !0, extensions: ["wspolicy"] },
  "application/x-7z-compressed": { source: "apache", compressible: !1, extensions: ["7z"] },
  "application/x-abiword": { source: "apache", extensions: ["abw"] },
  "application/x-ace-compressed": { source: "apache", extensions: ["ace"] },
  "application/x-apple-diskimage": { source: "apache", extensions: ["dmg"] },
  "application/x-arj": { compressible: !1, extensions: ["arj"] },
  "application/x-authorware-bin": { source: "apache", extensions: ["aab", "x32", "u32", "vox"] },
  "application/x-authorware-map": { source: "apache", extensions: ["aam"] },
  "application/x-authorware-seg": { source: "apache", extensions: ["aas"] },
  "application/x-bcpio": { source: "apache", extensions: ["bcpio"] },
  "application/x-bdoc": { compressible: !1, extensions: ["bdoc"] },
  "application/x-bittorrent": { source: "apache", extensions: ["torrent"] },
  "application/x-blender": { extensions: ["blend"] },
  "application/x-blorb": { source: "apache", extensions: ["blb", "blorb"] },
  "application/x-bzip": { source: "apache", compressible: !1, extensions: ["bz"] },
  "application/x-bzip2": { source: "apache", compressible: !1, extensions: ["bz2", "boz"] },
  "application/x-cbr": { source: "apache", extensions: ["cbr", "cba", "cbt", "cbz", "cb7"] },
  "application/x-cdlink": { source: "apache", extensions: ["vcd"] },
  "application/x-cfs-compressed": { source: "apache", extensions: ["cfs"] },
  "application/x-chat": { source: "apache", extensions: ["chat"] },
  "application/x-chess-pgn": { source: "apache", extensions: ["pgn"] },
  "application/x-chrome-extension": { extensions: ["crx"] },
  "application/x-cocoa": { source: "nginx", extensions: ["cco"] },
  "application/x-compressed": { extensions: ["rar"] },
  "application/x-conference": { source: "apache", extensions: ["nsc"] },
  "application/x-cpio": { source: "apache", extensions: ["cpio"] },
  "application/x-csh": { source: "apache", extensions: ["csh"] },
  "application/x-debian-package": { source: "apache", extensions: ["deb", "udeb"] },
  "application/x-dgc-compressed": { source: "apache", extensions: ["dgc"] },
  "application/x-director": { source: "apache", extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"] },
  "application/x-doom": { source: "apache", extensions: ["wad"] },
  "application/x-dtbncx+xml": { source: "apache", compressible: !0, extensions: ["ncx"] },
  "application/x-dtbook+xml": { source: "apache", compressible: !0, extensions: ["dtb"] },
  "application/x-dtbresource+xml": { source: "apache", compressible: !0, extensions: ["res"] },
  "application/x-dvi": { source: "apache", compressible: !1, extensions: ["dvi"] },
  "application/x-envoy": { source: "apache", extensions: ["evy"] },
  "application/x-eva": { source: "apache", extensions: ["eva"] },
  "application/x-font-bdf": { source: "apache", extensions: ["bdf"] },
  "application/x-font-ghostscript": { source: "apache", extensions: ["gsf"] },
  "application/x-font-linux-psf": { source: "apache", extensions: ["psf"] },
  "application/x-font-pcf": { source: "apache", extensions: ["pcf"] },
  "application/x-font-snf": { source: "apache", extensions: ["snf"] },
  "application/x-font-type1": { source: "apache", extensions: ["pfa", "pfb", "pfm", "afm"] },
  "application/x-freearc": { source: "apache", extensions: ["arc"] },
  "application/x-futuresplash": { source: "apache", extensions: ["spl"] },
  "application/x-gca-compressed": { source: "apache", extensions: ["gca"] },
  "application/x-glulx": { source: "apache", extensions: ["ulx"] },
  "application/x-gnumeric": { source: "apache", extensions: ["gnumeric"] },
  "application/x-gramps-xml": { source: "apache", extensions: ["gramps"] },
  "application/x-gtar": { source: "apache", extensions: ["gtar"] },
  "application/x-hdf": { source: "apache", extensions: ["hdf"] },
  "application/x-httpd-php": { compressible: !0, extensions: ["php"] },
  "application/x-install-instructions": { source: "apache", extensions: ["install"] },
  "application/x-ipynb+json": { compressible: !0, extensions: ["ipynb"] },
  "application/x-iso9660-image": { source: "apache", extensions: ["iso"] },
  "application/x-iwork-keynote-sffkey": { extensions: ["key"] },
  "application/x-iwork-numbers-sffnumbers": { extensions: ["numbers"] },
  "application/x-iwork-pages-sffpages": { extensions: ["pages"] },
  "application/x-java-archive-diff": { source: "nginx", extensions: ["jardiff"] },
  "application/x-java-jnlp-file": { source: "apache", compressible: !1, extensions: ["jnlp"] },
  "application/x-keepass2": { extensions: ["kdbx"] },
  "application/x-latex": { source: "apache", compressible: !1, extensions: ["latex"] },
  "application/x-lua-bytecode": { extensions: ["luac"] },
  "application/x-lzh-compressed": { source: "apache", extensions: ["lzh", "lha"] },
  "application/x-makeself": { source: "nginx", extensions: ["run"] },
  "application/x-mie": { source: "apache", extensions: ["mie"] },
  "application/x-mobipocket-ebook": { source: "apache", extensions: ["prc", "mobi"] },
  "application/x-ms-application": { source: "apache", extensions: ["application"] },
  "application/x-ms-shortcut": { source: "apache", extensions: ["lnk"] },
  "application/x-ms-wmd": { source: "apache", extensions: ["wmd"] },
  "application/x-ms-wmz": { source: "apache", extensions: ["wmz"] },
  "application/x-ms-xbap": { source: "apache", extensions: ["xbap"] },
  "application/x-msaccess": { source: "apache", extensions: ["mdb"] },
  "application/x-msbinder": { source: "apache", extensions: ["obd"] },
  "application/x-mscardfile": { source: "apache", extensions: ["crd"] },
  "application/x-msclip": { source: "apache", extensions: ["clp"] },
  "application/x-msdos-program": { extensions: ["exe"] },
  "application/x-msdownload": { source: "apache", extensions: ["exe", "dll", "com", "bat", "msi"] },
  "application/x-msmediaview": { source: "apache", extensions: ["mvb", "m13", "m14"] },
  "application/x-msmetafile": { source: "apache", extensions: ["wmf", "wmz", "emf", "emz"] },
  "application/x-msmoney": { source: "apache", extensions: ["mny"] },
  "application/x-mspublisher": { source: "apache", extensions: ["pub"] },
  "application/x-msschedule": { source: "apache", extensions: ["scd"] },
  "application/x-msterminal": { source: "apache", extensions: ["trm"] },
  "application/x-mswrite": { source: "apache", extensions: ["wri"] },
  "application/x-netcdf": { source: "apache", extensions: ["nc", "cdf"] },
  "application/x-ns-proxy-autoconfig": { compressible: !0, extensions: ["pac"] },
  "application/x-nzb": { source: "apache", extensions: ["nzb"] },
  "application/x-perl": { source: "nginx", extensions: ["pl", "pm"] },
  "application/x-pilot": { source: "nginx", extensions: ["prc", "pdb"] },
  "application/x-pkcs12": { source: "apache", compressible: !1, extensions: ["p12", "pfx"] },
  "application/x-pkcs7-certificates": { source: "apache", extensions: ["p7b", "spc"] },
  "application/x-pkcs7-certreqresp": { source: "apache", extensions: ["p7r"] },
  "application/x-rar-compressed": { source: "apache", compressible: !1, extensions: ["rar"] },
  "application/x-redhat-package-manager": { source: "nginx", extensions: ["rpm"] },
  "application/x-research-info-systems": { source: "apache", extensions: ["ris"] },
  "application/x-sea": { source: "nginx", extensions: ["sea"] },
  "application/x-sh": { source: "apache", compressible: !0, extensions: ["sh"] },
  "application/x-shar": { source: "apache", extensions: ["shar"] },
  "application/x-shockwave-flash": { source: "apache", compressible: !1, extensions: ["swf"] },
  "application/x-silverlight-app": { source: "apache", extensions: ["xap"] },
  "application/x-sql": { source: "apache", extensions: ["sql"] },
  "application/x-stuffit": { source: "apache", compressible: !1, extensions: ["sit"] },
  "application/x-stuffitx": { source: "apache", extensions: ["sitx"] },
  "application/x-subrip": { source: "apache", extensions: ["srt"] },
  "application/x-sv4cpio": { source: "apache", extensions: ["sv4cpio"] },
  "application/x-sv4crc": { source: "apache", extensions: ["sv4crc"] },
  "application/x-t3vm-image": { source: "apache", extensions: ["t3"] },
  "application/x-tads": { source: "apache", extensions: ["gam"] },
  "application/x-tar": { source: "apache", compressible: !0, extensions: ["tar"] },
  "application/x-tcl": { source: "apache", extensions: ["tcl", "tk"] },
  "application/x-tex": { source: "apache", extensions: ["tex"] },
  "application/x-tex-tfm": { source: "apache", extensions: ["tfm"] },
  "application/x-texinfo": { source: "apache", extensions: ["texinfo", "texi"] },
  "application/x-tgif": { source: "apache", extensions: ["obj"] },
  "application/x-ustar": { source: "apache", extensions: ["ustar"] },
  "application/x-virtualbox-hdd": { compressible: !0, extensions: ["hdd"] },
  "application/x-virtualbox-ova": { compressible: !0, extensions: ["ova"] },
  "application/x-virtualbox-ovf": { compressible: !0, extensions: ["ovf"] },
  "application/x-virtualbox-vbox": { compressible: !0, extensions: ["vbox"] },
  "application/x-virtualbox-vbox-extpack": { compressible: !1, extensions: ["vbox-extpack"] },
  "application/x-virtualbox-vdi": { compressible: !0, extensions: ["vdi"] },
  "application/x-virtualbox-vhd": { compressible: !0, extensions: ["vhd"] },
  "application/x-virtualbox-vmdk": { compressible: !0, extensions: ["vmdk"] },
  "application/x-wais-source": { source: "apache", extensions: ["src"] },
  "application/x-web-app-manifest+json": { compressible: !0, extensions: ["webapp"] },
  "application/x-x509-ca-cert": { source: "iana", extensions: ["der", "crt", "pem"] },
  "application/x-xfig": { source: "apache", extensions: ["fig"] },
  "application/x-xliff+xml": { source: "apache", compressible: !0, extensions: ["xlf"] },
  "application/x-xpinstall": { source: "apache", compressible: !1, extensions: ["xpi"] },
  "application/x-xz": { source: "apache", extensions: ["xz"] },
  "application/x-zip-compressed": { extensions: ["zip"] },
  "application/x-zmachine": { source: "apache", extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"] },
  "application/xaml+xml": { source: "apache", compressible: !0, extensions: ["xaml"] },
  "application/xcap-att+xml": { source: "iana", compressible: !0, extensions: ["xav"] },
  "application/xcap-caps+xml": { source: "iana", compressible: !0, extensions: ["xca"] },
  "application/xcap-diff+xml": { source: "iana", compressible: !0, extensions: ["xdf"] },
  "application/xcap-el+xml": { source: "iana", compressible: !0, extensions: ["xel"] },
  "application/xcap-ns+xml": { source: "iana", compressible: !0, extensions: ["xns"] },
  "application/xenc+xml": { source: "iana", compressible: !0, extensions: ["xenc"] },
  "application/xfdf": { source: "iana", extensions: ["xfdf"] },
  "application/xhtml+xml": { source: "iana", compressible: !0, extensions: ["xhtml", "xht"] },
  "application/xliff+xml": { source: "iana", compressible: !0, extensions: ["xlf"] },
  "application/xml": { source: "iana", compressible: !0, extensions: ["xml", "xsl", "xsd", "rng"] },
  "application/xml-dtd": { source: "iana", compressible: !0, extensions: ["dtd"] },
  "application/xop+xml": { source: "iana", compressible: !0, extensions: ["xop"] },
  "application/xproc+xml": { source: "apache", compressible: !0, extensions: ["xpl"] },
  "application/xslt+xml": { source: "iana", compressible: !0, extensions: ["xsl", "xslt"] },
  "application/xspf+xml": { source: "apache", compressible: !0, extensions: ["xspf"] },
  "application/xv+xml": { source: "iana", compressible: !0, extensions: ["mxml", "xhvml", "xvml", "xvm"] },
  "application/yang": { source: "iana", extensions: ["yang"] },
  "application/yin+xml": { source: "iana", compressible: !0, extensions: ["yin"] },
  "application/zip": { source: "iana", compressible: !1, extensions: ["zip"] },
  "application/zip+dotlottie": { extensions: ["lottie"] },
  "audio/3gpp": { source: "iana", compressible: !1, extensions: ["3gpp"] },
  "audio/aac": { source: "iana", extensions: ["adts", "aac"] },
  "audio/adpcm": { source: "apache", extensions: ["adp"] },
  "audio/amr": { source: "iana", extensions: ["amr"] },
  "audio/basic": { source: "iana", compressible: !1, extensions: ["au", "snd"] },
  "audio/midi": { source: "apache", extensions: ["mid", "midi", "kar", "rmi"] },
  "audio/mobile-xmf": { source: "iana", extensions: ["mxmf"] },
  "audio/mp3": { compressible: !1, extensions: ["mp3"] },
  "audio/mp4": { source: "iana", compressible: !1, extensions: ["m4a", "mp4a", "m4b"] },
  "audio/mpeg": { source: "iana", compressible: !1, extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"] },
  "audio/ogg": { source: "iana", compressible: !1, extensions: ["oga", "ogg", "spx", "opus"] },
  "audio/s3m": { source: "apache", extensions: ["s3m"] },
  "audio/silk": { source: "apache", extensions: ["sil"] },
  "audio/vnd.dece.audio": { source: "iana", extensions: ["uva", "uvva"] },
  "audio/vnd.digital-winds": { source: "iana", extensions: ["eol"] },
  "audio/vnd.dra": { source: "iana", extensions: ["dra"] },
  "audio/vnd.dts": { source: "iana", extensions: ["dts"] },
  "audio/vnd.dts.hd": { source: "iana", extensions: ["dtshd"] },
  "audio/vnd.lucent.voice": { source: "iana", extensions: ["lvp"] },
  "audio/vnd.ms-playready.media.pya": { source: "iana", extensions: ["pya"] },
  "audio/vnd.nuera.ecelp4800": { source: "iana", extensions: ["ecelp4800"] },
  "audio/vnd.nuera.ecelp7470": { source: "iana", extensions: ["ecelp7470"] },
  "audio/vnd.nuera.ecelp9600": { source: "iana", extensions: ["ecelp9600"] },
  "audio/vnd.rip": { source: "iana", extensions: ["rip"] },
  "audio/wav": { compressible: !1, extensions: ["wav"] },
  "audio/wave": { compressible: !1, extensions: ["wav"] },
  "audio/webm": { source: "apache", compressible: !1, extensions: ["weba"] },
  "audio/x-aac": { source: "apache", compressible: !1, extensions: ["aac"] },
  "audio/x-aiff": { source: "apache", extensions: ["aif", "aiff", "aifc"] },
  "audio/x-caf": { source: "apache", compressible: !1, extensions: ["caf"] },
  "audio/x-flac": { source: "apache", extensions: ["flac"] },
  "audio/x-m4a": { source: "nginx", extensions: ["m4a"] },
  "audio/x-matroska": { source: "apache", extensions: ["mka"] },
  "audio/x-mpegurl": { source: "apache", extensions: ["m3u"] },
  "audio/x-ms-wax": { source: "apache", extensions: ["wax"] },
  "audio/x-ms-wma": { source: "apache", extensions: ["wma"] },
  "audio/x-pn-realaudio": { source: "apache", extensions: ["ram", "ra"] },
  "audio/x-pn-realaudio-plugin": { source: "apache", extensions: ["rmp"] },
  "audio/x-realaudio": { source: "nginx", extensions: ["ra"] },
  "audio/x-wav": { source: "apache", extensions: ["wav"] },
  "audio/xm": { source: "apache", extensions: ["xm"] },
  "chemical/x-cdx": { source: "apache", extensions: ["cdx"] },
  "chemical/x-cif": { source: "apache", extensions: ["cif"] },
  "chemical/x-cmdf": { source: "apache", extensions: ["cmdf"] },
  "chemical/x-cml": { source: "apache", extensions: ["cml"] },
  "chemical/x-csml": { source: "apache", extensions: ["csml"] },
  "chemical/x-xyz": { source: "apache", extensions: ["xyz"] },
  "font/collection": { source: "iana", extensions: ["ttc"] },
  "font/otf": { source: "iana", compressible: !0, extensions: ["otf"] },
  "font/ttf": { source: "iana", compressible: !0, extensions: ["ttf"] },
  "font/woff": { source: "iana", extensions: ["woff"] },
  "font/woff2": { source: "iana", extensions: ["woff2"] },
  "image/aces": { source: "iana", extensions: ["exr"] },
  "image/apng": { source: "iana", compressible: !1, extensions: ["apng"] },
  "image/avci": { source: "iana", extensions: ["avci"] },
  "image/avcs": { source: "iana", extensions: ["avcs"] },
  "image/avif": { source: "iana", compressible: !1, extensions: ["avif"] },
  "image/bmp": { source: "iana", compressible: !0, extensions: ["bmp", "dib"] },
  "image/cgm": { source: "iana", extensions: ["cgm"] },
  "image/dicom-rle": { source: "iana", extensions: ["drle"] },
  "image/dpx": { source: "iana", extensions: ["dpx"] },
  "image/emf": { source: "iana", extensions: ["emf"] },
  "image/fits": { source: "iana", extensions: ["fits"] },
  "image/g3fax": { source: "iana", extensions: ["g3"] },
  "image/gif": { source: "iana", compressible: !1, extensions: ["gif"] },
  "image/heic": { source: "iana", extensions: ["heic"] },
  "image/heic-sequence": { source: "iana", extensions: ["heics"] },
  "image/heif": { source: "iana", extensions: ["heif"] },
  "image/heif-sequence": { source: "iana", extensions: ["heifs"] },
  "image/hej2k": { source: "iana", extensions: ["hej2"] },
  "image/ief": { source: "iana", extensions: ["ief"] },
  "image/jaii": { source: "iana", extensions: ["jaii"] },
  "image/jais": { source: "iana", extensions: ["jais"] },
  "image/jls": { source: "iana", extensions: ["jls"] },
  "image/jp2": { source: "iana", compressible: !1, extensions: ["jp2", "jpg2"] },
  "image/jpeg": { source: "iana", compressible: !1, extensions: ["jpg", "jpeg", "jpe"] },
  "image/jph": { source: "iana", extensions: ["jph"] },
  "image/jphc": { source: "iana", extensions: ["jhc"] },
  "image/jpm": { source: "iana", compressible: !1, extensions: ["jpm", "jpgm"] },
  "image/jpx": { source: "iana", compressible: !1, extensions: ["jpx", "jpf"] },
  "image/jxl": { source: "iana", extensions: ["jxl"] },
  "image/jxr": { source: "iana", extensions: ["jxr"] },
  "image/jxra": { source: "iana", extensions: ["jxra"] },
  "image/jxrs": { source: "iana", extensions: ["jxrs"] },
  "image/jxs": { source: "iana", extensions: ["jxs"] },
  "image/jxsc": { source: "iana", extensions: ["jxsc"] },
  "image/jxsi": { source: "iana", extensions: ["jxsi"] },
  "image/jxss": { source: "iana", extensions: ["jxss"] },
  "image/ktx": { source: "iana", extensions: ["ktx"] },
  "image/ktx2": { source: "iana", extensions: ["ktx2"] },
  "image/pjpeg": { compressible: !1, extensions: ["jfif"] },
  "image/png": { source: "iana", compressible: !1, extensions: ["png"] },
  "image/prs.btif": { source: "iana", extensions: ["btif", "btf"] },
  "image/prs.pti": { source: "iana", extensions: ["pti"] },
  "image/sgi": { source: "apache", extensions: ["sgi"] },
  "image/svg+xml": { source: "iana", compressible: !0, extensions: ["svg", "svgz"] },
  "image/t38": { source: "iana", extensions: ["t38"] },
  "image/tiff": { source: "iana", compressible: !1, extensions: ["tif", "tiff"] },
  "image/tiff-fx": { source: "iana", extensions: ["tfx"] },
  "image/vnd.adobe.photoshop": { source: "iana", compressible: !0, extensions: ["psd"] },
  "image/vnd.airzip.accelerator.azv": { source: "iana", extensions: ["azv"] },
  "image/vnd.blockfact.facti": { source: "iana", extensions: ["facti"] },
  "image/vnd.dece.graphic": { source: "iana", extensions: ["uvi", "uvvi", "uvg", "uvvg"] },
  "image/vnd.djvu": { source: "iana", extensions: ["djvu", "djv"] },
  "image/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "image/vnd.dwg": { source: "iana", extensions: ["dwg"] },
  "image/vnd.dxf": { source: "iana", extensions: ["dxf"] },
  "image/vnd.fastbidsheet": { source: "iana", extensions: ["fbs"] },
  "image/vnd.fpx": { source: "iana", extensions: ["fpx"] },
  "image/vnd.fst": { source: "iana", extensions: ["fst"] },
  "image/vnd.fujixerox.edmics-mmr": { source: "iana", extensions: ["mmr"] },
  "image/vnd.fujixerox.edmics-rlc": { source: "iana", extensions: ["rlc"] },
  "image/vnd.microsoft.icon": { source: "iana", compressible: !0, extensions: ["ico"] },
  "image/vnd.ms-dds": { compressible: !0, extensions: ["dds"] },
  "image/vnd.ms-modi": { source: "iana", extensions: ["mdi"] },
  "image/vnd.ms-photo": { source: "apache", extensions: ["wdp"] },
  "image/vnd.net-fpx": { source: "iana", extensions: ["npx"] },
  "image/vnd.pco.b16": { source: "iana", extensions: ["b16"] },
  "image/vnd.tencent.tap": { source: "iana", extensions: ["tap"] },
  "image/vnd.valve.source.texture": { source: "iana", extensions: ["vtf"] },
  "image/vnd.wap.wbmp": { source: "iana", extensions: ["wbmp"] },
  "image/vnd.xiff": { source: "iana", extensions: ["xif"] },
  "image/vnd.zbrush.pcx": { source: "iana", extensions: ["pcx"] },
  "image/webp": { source: "iana", extensions: ["webp"] },
  "image/wmf": { source: "iana", extensions: ["wmf"] },
  "image/x-3ds": { source: "apache", extensions: ["3ds"] },
  "image/x-adobe-dng": { extensions: ["dng"] },
  "image/x-cmu-raster": { source: "apache", extensions: ["ras"] },
  "image/x-cmx": { source: "apache", extensions: ["cmx"] },
  "image/x-freehand": { source: "apache", extensions: ["fh", "fhc", "fh4", "fh5", "fh7"] },
  "image/x-icon": { source: "apache", compressible: !0, extensions: ["ico"] },
  "image/x-jng": { source: "nginx", extensions: ["jng"] },
  "image/x-mrsid-image": { source: "apache", extensions: ["sid"] },
  "image/x-ms-bmp": { source: "nginx", compressible: !0, extensions: ["bmp"] },
  "image/x-pcx": { source: "apache", extensions: ["pcx"] },
  "image/x-pict": { source: "apache", extensions: ["pic", "pct"] },
  "image/x-portable-anymap": { source: "apache", extensions: ["pnm"] },
  "image/x-portable-bitmap": { source: "apache", extensions: ["pbm"] },
  "image/x-portable-graymap": { source: "apache", extensions: ["pgm"] },
  "image/x-portable-pixmap": { source: "apache", extensions: ["ppm"] },
  "image/x-rgb": { source: "apache", extensions: ["rgb"] },
  "image/x-tga": { source: "apache", extensions: ["tga"] },
  "image/x-xbitmap": { source: "apache", extensions: ["xbm"] },
  "image/x-xpixmap": { source: "apache", extensions: ["xpm"] },
  "image/x-xwindowdump": { source: "apache", extensions: ["xwd"] },
  "message/disposition-notification": { source: "iana", extensions: ["disposition-notification"] },
  "message/global": { source: "iana", extensions: ["u8msg"] },
  "message/global-delivery-status": { source: "iana", extensions: ["u8dsn"] },
  "message/global-disposition-notification": { source: "iana", extensions: ["u8mdn"] },
  "message/global-headers": { source: "iana", extensions: ["u8hdr"] },
  "message/rfc822": { source: "iana", compressible: !0, extensions: ["eml", "mime", "mht", "mhtml"] },
  "message/vnd.wfa.wsc": { source: "iana", extensions: ["wsc"] },
  "model/3mf": { source: "iana", extensions: ["3mf"] },
  "model/gltf+json": { source: "iana", compressible: !0, extensions: ["gltf"] },
  "model/gltf-binary": { source: "iana", compressible: !0, extensions: ["glb"] },
  "model/iges": { source: "iana", compressible: !1, extensions: ["igs", "iges"] },
  "model/jt": { source: "iana", extensions: ["jt"] },
  "model/mesh": { source: "iana", compressible: !1, extensions: ["msh", "mesh", "silo"] },
  "model/mtl": { source: "iana", extensions: ["mtl"] },
  "model/obj": { source: "iana", extensions: ["obj"] },
  "model/prc": { source: "iana", extensions: ["prc"] },
  "model/step": { source: "iana", extensions: ["step", "stp", "stpnc", "p21", "210"] },
  "model/step+xml": { source: "iana", compressible: !0, extensions: ["stpx"] },
  "model/step+zip": { source: "iana", compressible: !1, extensions: ["stpz"] },
  "model/step-xml+zip": { source: "iana", compressible: !1, extensions: ["stpxz"] },
  "model/stl": { source: "iana", extensions: ["stl"] },
  "model/u3d": { source: "iana", extensions: ["u3d"] },
  "model/vnd.bary": { source: "iana", extensions: ["bary"] },
  "model/vnd.cld": { source: "iana", extensions: ["cld"] },
  "model/vnd.collada+xml": { source: "iana", compressible: !0, extensions: ["dae"] },
  "model/vnd.dwf": { source: "iana", extensions: ["dwf"] },
  "model/vnd.gdl": { source: "iana", extensions: ["gdl"] },
  "model/vnd.gtw": { source: "iana", extensions: ["gtw"] },
  "model/vnd.mts": { source: "iana", extensions: ["mts"] },
  "model/vnd.opengex": { source: "iana", extensions: ["ogex"] },
  "model/vnd.parasolid.transmit.binary": { source: "iana", extensions: ["x_b"] },
  "model/vnd.parasolid.transmit.text": { source: "iana", extensions: ["x_t"] },
  "model/vnd.pytha.pyox": { source: "iana", extensions: ["pyo", "pyox"] },
  "model/vnd.sap.vds": { source: "iana", extensions: ["vds"] },
  "model/vnd.usda": { source: "iana", extensions: ["usda"] },
  "model/vnd.usdz+zip": { source: "iana", compressible: !1, extensions: ["usdz"] },
  "model/vnd.valve.source.compiled-map": { source: "iana", extensions: ["bsp"] },
  "model/vnd.vtu": { source: "iana", extensions: ["vtu"] },
  "model/vrml": { source: "iana", compressible: !1, extensions: ["wrl", "vrml"] },
  "model/x3d+binary": { source: "apache", compressible: !1, extensions: ["x3db", "x3dbz"] },
  "model/x3d+fastinfoset": { source: "iana", extensions: ["x3db"] },
  "model/x3d+vrml": { source: "apache", compressible: !1, extensions: ["x3dv", "x3dvz"] },
  "model/x3d+xml": { source: "iana", compressible: !0, extensions: ["x3d", "x3dz"] },
  "model/x3d-vrml": { source: "iana", extensions: ["x3dv"] },
  "text/cache-manifest": { source: "iana", compressible: !0, extensions: ["appcache", "manifest"] },
  "text/calendar": { source: "iana", extensions: ["ics", "ifb"] },
  "text/coffeescript": { extensions: ["coffee", "litcoffee"] },
  "text/css": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["css"] },
  "text/csv": { source: "iana", compressible: !0, extensions: ["csv"] },
  "text/html": { source: "iana", compressible: !0, extensions: ["html", "htm", "shtml"] },
  "text/jade": { extensions: ["jade"] },
  "text/javascript": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["js", "mjs"] },
  "text/jsx": { compressible: !0, extensions: ["jsx"] },
  "text/less": { compressible: !0, extensions: ["less"] },
  "text/markdown": { source: "iana", compressible: !0, extensions: ["md", "markdown"] },
  "text/mathml": { source: "nginx", extensions: ["mml"] },
  "text/mdx": { compressible: !0, extensions: ["mdx"] },
  "text/n3": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["n3"] },
  "text/plain": { source: "iana", compressible: !0, extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"] },
  "text/prs.lines.tag": { source: "iana", extensions: ["dsc"] },
  "text/richtext": { source: "iana", compressible: !0, extensions: ["rtx"] },
  "text/rtf": { source: "iana", compressible: !0, extensions: ["rtf"] },
  "text/sgml": { source: "iana", extensions: ["sgml", "sgm"] },
  "text/shex": { source: "iana", extensions: ["shex"] },
  "text/slim": { extensions: ["slim", "slm"] },
  "text/spdx": { source: "iana", extensions: ["spdx"] },
  "text/stylus": { extensions: ["stylus", "styl"] },
  "text/tab-separated-values": { source: "iana", compressible: !0, extensions: ["tsv"] },
  "text/troff": { source: "iana", extensions: ["t", "tr", "roff", "man", "me", "ms"] },
  "text/turtle": { source: "iana", charset: "UTF-8", extensions: ["ttl"] },
  "text/uri-list": { source: "iana", compressible: !0, extensions: ["uri", "uris", "urls"] },
  "text/vcard": { source: "iana", compressible: !0, extensions: ["vcard"] },
  "text/vnd.curl": { source: "iana", extensions: ["curl"] },
  "text/vnd.curl.dcurl": { source: "apache", extensions: ["dcurl"] },
  "text/vnd.curl.mcurl": { source: "apache", extensions: ["mcurl"] },
  "text/vnd.curl.scurl": { source: "apache", extensions: ["scurl"] },
  "text/vnd.dvb.subtitle": { source: "iana", extensions: ["sub"] },
  "text/vnd.familysearch.gedcom": { source: "iana", extensions: ["ged"] },
  "text/vnd.fly": { source: "iana", extensions: ["fly"] },
  "text/vnd.fmi.flexstor": { source: "iana", extensions: ["flx"] },
  "text/vnd.graphviz": { source: "iana", extensions: ["gv"] },
  "text/vnd.in3d.3dml": { source: "iana", extensions: ["3dml"] },
  "text/vnd.in3d.spot": { source: "iana", extensions: ["spot"] },
  "text/vnd.sun.j2me.app-descriptor": { source: "iana", charset: "UTF-8", extensions: ["jad"] },
  "text/vnd.wap.wml": { source: "iana", extensions: ["wml"] },
  "text/vnd.wap.wmlscript": { source: "iana", extensions: ["wmls"] },
  "text/vtt": { source: "iana", charset: "UTF-8", compressible: !0, extensions: ["vtt"] },
  "text/wgsl": { source: "iana", extensions: ["wgsl"] },
  "text/x-asm": { source: "apache", extensions: ["s", "asm"] },
  "text/x-c": { source: "apache", extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"] },
  "text/x-component": { source: "nginx", extensions: ["htc"] },
  "text/x-fortran": { source: "apache", extensions: ["f", "for", "f77", "f90"] },
  "text/x-handlebars-template": { extensions: ["hbs"] },
  "text/x-java-source": { source: "apache", extensions: ["java"] },
  "text/x-lua": { extensions: ["lua"] },
  "text/x-markdown": { compressible: !0, extensions: ["mkd"] },
  "text/x-nfo": { source: "apache", extensions: ["nfo"] },
  "text/x-opml": { source: "apache", extensions: ["opml"] },
  "text/x-org": { compressible: !0, extensions: ["org"] },
  "text/x-pascal": { source: "apache", extensions: ["p", "pas"] },
  "text/x-processing": { compressible: !0, extensions: ["pde"] },
  "text/x-sass": { extensions: ["sass"] },
  "text/x-scss": { extensions: ["scss"] },
  "text/x-setext": { source: "apache", extensions: ["etx"] },
  "text/x-sfv": { source: "apache", extensions: ["sfv"] },
  "text/x-suse-ymp": { compressible: !0, extensions: ["ymp"] },
  "text/x-uuencode": { source: "apache", extensions: ["uu"] },
  "text/x-vcalendar": { source: "apache", extensions: ["vcs"] },
  "text/x-vcard": { source: "apache", extensions: ["vcf"] },
  "text/xml": { source: "iana", compressible: !0, extensions: ["xml"] },
  "text/yaml": { compressible: !0, extensions: ["yaml", "yml"] },
  "video/3gpp": { source: "iana", extensions: ["3gp", "3gpp"] },
  "video/3gpp2": { source: "iana", extensions: ["3g2"] },
  "video/h261": { source: "iana", extensions: ["h261"] },
  "video/h263": { source: "iana", extensions: ["h263"] },
  "video/h264": { source: "iana", extensions: ["h264"] },
  "video/iso.segment": { source: "iana", extensions: ["m4s"] },
  "video/jpeg": { source: "iana", extensions: ["jpgv"] },
  "video/jpm": { source: "apache", extensions: ["jpm", "jpgm"] },
  "video/mj2": { source: "iana", extensions: ["mj2", "mjp2"] },
  "video/mp2t": { source: "iana", extensions: ["ts", "m2t", "m2ts", "mts"] },
  "video/mp4": { source: "iana", compressible: !1, extensions: ["mp4", "mp4v", "mpg4"] },
  "video/mpeg": { source: "iana", compressible: !1, extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"] },
  "video/ogg": { source: "iana", compressible: !1, extensions: ["ogv"] },
  "video/quicktime": { source: "iana", compressible: !1, extensions: ["qt", "mov"] },
  "video/vnd.dece.hd": { source: "iana", extensions: ["uvh", "uvvh"] },
  "video/vnd.dece.mobile": { source: "iana", extensions: ["uvm", "uvvm"] },
  "video/vnd.dece.pd": { source: "iana", extensions: ["uvp", "uvvp"] },
  "video/vnd.dece.sd": { source: "iana", extensions: ["uvs", "uvvs"] },
  "video/vnd.dece.video": { source: "iana", extensions: ["uvv", "uvvv"] },
  "video/vnd.dvb.file": { source: "iana", extensions: ["dvb"] },
  "video/vnd.fvt": { source: "iana", extensions: ["fvt"] },
  "video/vnd.mpegurl": { source: "iana", extensions: ["mxu", "m4u"] },
  "video/vnd.ms-playready.media.pyv": { source: "iana", extensions: ["pyv"] },
  "video/vnd.uvvu.mp4": { source: "iana", extensions: ["uvu", "uvvu"] },
  "video/vnd.vivo": { source: "iana", extensions: ["viv"] },
  "video/webm": { source: "apache", compressible: !1, extensions: ["webm"] },
  "video/x-f4v": { source: "apache", extensions: ["f4v"] },
  "video/x-fli": { source: "apache", extensions: ["fli"] },
  "video/x-flv": { source: "apache", compressible: !1, extensions: ["flv"] },
  "video/x-m4v": { source: "apache", extensions: ["m4v"] },
  "video/x-matroska": { source: "apache", compressible: !1, extensions: ["mkv", "mk3d", "mks"] },
  "video/x-mng": { source: "apache", extensions: ["mng"] },
  "video/x-ms-asf": { source: "apache", extensions: ["asf", "asx"] },
  "video/x-ms-vob": { source: "apache", extensions: ["vob"] },
  "video/x-ms-wm": { source: "apache", extensions: ["wm"] },
  "video/x-ms-wmv": { source: "apache", compressible: !1, extensions: ["wmv"] },
  "video/x-ms-wmx": { source: "apache", extensions: ["wmx"] },
  "video/x-ms-wvx": { source: "apache", extensions: ["wvx"] },
  "video/x-msvideo": { source: "apache", extensions: ["avi"] },
  "video/x-sgi-movie": { source: "apache", extensions: ["movie"] },
  "video/x-smv": { source: "apache", extensions: ["smv"] },
  "x-conference/x-cooltalk": { source: "apache", extensions: ["ice"] }
};
function YD(e) {
  const t = /\*\.(\w+)/g, n = [];
  let a;
  for (; (a = t.exec(e)) !== null; )
    n.push("." + a[1]);
  return n;
}
function JA(e) {
  switch (e) {
    case V.EN:
      return "English";
    case V.IT:
      return "Italiano";
    case V.BG:
      return "Български";
    case V.ZH_HANS:
      return "汉语";
    case V.HR:
      return "Hrvatski";
    case V.CS:
      return "Čeština";
    case V.DA:
      return "Dansk";
    case V.NL:
      return "Nederlands";
    case V.FR:
      return "Français";
    case V.DE:
      return "Deutsch";
    case V.HU:
      return "Magyar";
    case V.JA:
      return "日本語";
    case V.KO:
      return "한국어";
    case V.LT:
      return "Lietuvių";
    case V.PL:
      return "Polski";
    case V.PT:
      return "Português";
    case V.RO:
      return "Română";
    case V.SK:
      return "Slovenčina";
    case V.SL:
      return "Slovenščina";
    case V.ES:
      return "Español";
    case V.SV:
      return "Svenska";
    case V.TR:
      return "Türkçe";
    default:
      return e;
  }
}
function jD(e) {
  if (e.toLowerCase().endsWith(".mobile.json"))
    return e.slice(0, -12);
  const t = e.lastIndexOf(".");
  return t === -1 ? e : e.substring(0, t);
}
function Wu(e) {
  if (!e || Math.floor(e) === e) return 0;
  const t = e.toString();
  return t.indexOf(".") !== -1 && t.indexOf("-") !== -1 ? t.split("-")[1] || 0 : t.indexOf(".") !== -1 ? t.split(".")[1].length || 0 : t.split("-")[1] || 0;
}
function Bl(e, t = 2) {
  if (!+e) return "0 Bytes";
  const n = 1024, a = t < 0 ? 0 : t, s = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], o = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, o)).toFixed(a))} ${s[o]}`;
}
function HD() {
  return window.screen.width < 520;
}
function VD() {
  const e = window.screen.width;
  return 520 < e && e < 1e3;
}
function KD(e, t) {
  var n;
  (n = document.getElementById(t)) == null || n.classList.add(e);
}
function WD(e, t) {
  var n;
  (n = document.getElementById(t)) == null || n.classList.remove(e);
}
function zD(e, t) {
  const n = document.getElementsByClassName(t);
  n && n[0].classList.add(e);
}
function $D(e, t) {
  const n = document.getElementsByClassName(t);
  n && n[0].classList.remove(e);
}
function qD(e) {
  const t = document.getElementsByClassName(e);
  t.length > 0 && (t[0].style.height = "100vh");
}
function JD(e) {
  const t = document.getElementsByClassName(e);
  if (t.length > 0) {
    const n = t[0];
    n.style.height = "";
  }
}
function XA() {
  const e = document.getElementById("btn_profile");
  e && (e.style.marginTop = "0.28rem");
}
function XD(e) {
  return e && e.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(t, n) {
    return +t == 0 ? "" : n === 0 ? t.toLowerCase() : t.toUpperCase();
  });
}
function ZD(e, t) {
  const n = t.messages.value;
  for (const a in n)
    for (const s in n[a]) {
      const o = n[a][s];
      if (o[e] !== void 0)
        return o[e];
    }
  return e;
}
function eT(e) {
  let t = "";
  const n = new Uint8Array(e), a = n.byteLength;
  for (let s = 0; s < a; s++)
    t += String.fromCharCode(n[s]);
  return window.btoa(t);
}
function tT(e) {
  return e instanceof Date && !isNaN(Number(e));
}
function ZA(e) {
  const t = /* @__PURE__ */ new Set();
  return e.split(",").map((n) => n.trim()).forEach((n) => {
    if (n.startsWith("."))
      t.add(n);
    else if (n in Ai)
      Ai[n].extensions.forEach((a) => t.add(`.${a}`));
    else if (n.endsWith("/*")) {
      const a = n.slice(0, -2);
      Object.entries(Ai).forEach(([s, o]) => {
        s.startsWith(a) && o.extensions.forEach((i) => t.add(`.${i}`));
      });
    }
  }), Array.from(t);
}
function zu(e, t) {
  if (t) {
    const n = ZA(t);
    return e.some((a) => {
      const s = a.split(".").pop() || "";
      return !n.includes(`.${s.toLowerCase()}`);
    });
  } else
    return e.some((n) => {
      const a = n.split(".").pop() || "";
      return !Vu.includes(`.${a.toLowerCase()}`);
    });
}
function Io(e) {
  return sa().getAssetUrl(`/icons/${e}.svg`);
}
function nT(e) {
  switch ((e ?? "").toLowerCase().replace(/^\./, "")) {
    case "pdf":
      return new URL("/img/pdf_file_icon.png", import.meta.url).href;
    case "zip":
      return new URL("/img/zip_file_icon.png", import.meta.url).href;
    case "docx":
      return new URL("/img/docx_file_icon.png", import.meta.url).href;
    case "xlsx":
      return new URL("/img/xlsx_file_icon.png", import.meta.url).href;
    case "txt":
      return new URL("/img/txt_file_icon.png", import.meta.url).href;
    case "pts":
      return new URL("/img/txt_file_icon.png", import.meta.url).href;
    case "xml":
      return new URL("/img/xml_file_icon.png", import.meta.url).href;
    case "constructioninfo":
      return new URL("/img/xml_file_icon.png", import.meta.url).href;
    case "dcm":
      return new URL("/img/dcm_file_icon.svg", import.meta.url).href;
    case "stl":
      return new URL("/img/stl_file_icon.svg", import.meta.url).href;
    case "erp":
      return new URL("/img/erp_file_icon.svg", import.meta.url).href;
    case "matrix4":
      return new URL("/img/matrix4_file_icon.svg", import.meta.url).href;
    case "mtl":
      return new URL("/img/mtl_file_icon.svg", import.meta.url).href;
    case "dentalproject":
      return new URL("/img/dentalproject_file_icon.svg", import.meta.url).href;
    default:
      return new URL("/img/pdf-icon.png", import.meta.url).href;
  }
}
function aT() {
  return wo.theme.palette;
}
function sT() {
  return {
    name: wo.theme.color.name,
    palette: wo.theme.color.palette
  };
}
function eg(e) {
  document.documentElement.classList.toggle("p-dark", e === "dark"), document.documentElement.classList.toggle("app-dark", e === "dark"), localStorage.setItem("colorScheme", JSON.stringify(e));
}
function oT() {
  const { layout: e } = wo.theme;
  eg(e);
}
function iT() {
  const e = document.getElementById("app");
  e && (e.style.background = "radial-gradient(41.26% 792.78% at 49.97% 506.11%, rgba(20, 48, 94, 0.80) 5.22%, rgba(11, 14, 26, 0.80) 100%)", e.style.height = "100%", e.style.overflowY = "hidden");
}
function rT() {
  const e = document.getElementById("app");
  e && (e.style.background = "linear-gradient(to top, #286AAD 1%, #0b0e1a 105%)");
}
function Oi(e) {
  return sa().getAssetUrl(`/img/${e}.png`);
}
function Xs(e) {
  return sa().getAssetUrl(`/icons/${e}.svg`);
}
function lT(e, t) {
  var n;
  return (n = Object.entries(e).find(([, a]) => a === t)) == null ? void 0 : n[0];
}
function cT(e) {
  const t = JSON.stringify(e), a = new TextEncoder().encode(t);
  let s = "";
  return a.forEach((o) => s += String.fromCharCode(o)), btoa(s);
}
function uT(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let o = 0; o < t.length; o++)
    n[o] = t.charCodeAt(o);
  const s = new TextDecoder().decode(n);
  return JSON.parse(s);
}
let Ni = null;
function dT(e) {
  Ni = e.global;
}
function tg() {
  return Ni || (console.warn("[lib] i18n not initialized. Returning fallback composer."), {
    t: (e) => e
    // just echoes the key back
    // you can add other methods as needed (d, n, locale, etc.)
  });
}
function ke(e, t) {
  const n = tg();
  return t === void 0 ? n.t(e) : n.t(e, t);
}
const ms = "default-blue", Bo = [
  {
    name: "default-blue",
    palette: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#4B7AE7",
      500: "#4B7AE7",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    }
  },
  { name: "noir", palette: {} },
  {
    name: "emerald",
    palette: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    }
  },
  {
    name: "green",
    palette: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    }
  },
  {
    name: "lime",
    palette: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    }
  },
  {
    name: "orange",
    palette: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    }
  },
  {
    name: "amber",
    palette: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    }
  },
  {
    name: "yellow",
    palette: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    }
  },
  {
    name: "teal",
    palette: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    }
  },
  {
    name: "cyan",
    palette: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    }
  },
  {
    name: "sky",
    palette: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    }
  },
  {
    name: "indigo",
    palette: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    }
  },
  {
    name: "violet",
    palette: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    }
  },
  {
    name: "purple",
    palette: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    }
  },
  {
    name: "fuchsia",
    palette: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    }
  },
  {
    name: "pink",
    palette: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    }
  },
  {
    name: "rose",
    palette: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    }
  }
];
function Ho(e) {
  if (typeof e != "string" || e === "blue")
    return ms;
  if (Bo.some((t) => t.name === e))
    return e;
  try {
    const t = JSON.parse(e);
    return typeof t == "string" && t !== e ? Ho(t) : ms;
  } catch {
    return ms;
  }
}
function ng(e) {
  const t = Ho(e);
  return Bo.find((n) => n.name === t) ?? Bo.find((n) => n.name === ms);
}
function $u(e) {
  var n;
  const t = Ho(e);
  return (n = globalThis.localStorage) == null || n.setItem("colorTheme", JSON.stringify(t)), t;
}
function qu(e) {
  const t = ng(e);
  return t.name === "noir" ? {
    semantic: {
      primary: {
        50: "{surface.50}",
        100: "{surface.100}",
        200: "{surface.200}",
        300: "{surface.300}",
        400: "{surface.400}",
        500: "{surface.500}",
        600: "{surface.600}",
        700: "{surface.700}",
        800: "{surface.800}",
        900: "{surface.900}",
        950: "{surface.950}"
      },
      colorScheme: {
        light: {
          primary: {
            color: "{primary.950}",
            contrastColor: "#ffffff",
            hoverColor: "{primary.800}",
            activeColor: "{primary.700}"
          },
          highlight: {
            background: "{primary.950}",
            focusBackground: "{primary.700}",
            color: "#ffffff",
            focusColor: "#ffffff"
          }
        },
        dark: {
          primary: {
            color: "{primary.50}",
            contrastColor: "{primary.950}",
            hoverColor: "{primary.200}",
            activeColor: "{primary.300}"
          },
          highlight: {
            background: "{primary.50}",
            focusBackground: "{primary.300}",
            color: "{primary.950}",
            focusColor: "{primary.950}"
          }
        }
      }
    }
  } : {
    semantic: {
      primary: t.palette,
      colorScheme: {
        light: {
          primary: {
            color: "{primary.500}",
            contrastColor: "#ffffff",
            hoverColor: "{primary.600}",
            activeColor: "{primary.700}"
          },
          highlight: {
            background: "{primary.50}",
            focusBackground: "{primary.100}",
            color: "{primary.700}",
            focusColor: "{primary.800}"
          }
        },
        dark: {
          primary: {
            color: "{primary.400}",
            contrastColor: "{surface.900}",
            hoverColor: "{primary.300}",
            activeColor: "{primary.200}"
          },
          highlight: {
            background: "color-mix(in srgb, {primary.400}, transparent 84%)",
            focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)",
            color: "rgba(255,255,255,.87)",
            focusColor: "rgba(255,255,255,.87)"
          }
        }
      }
    }
  };
}
function Ju(e) {
  const t = Ho(e);
  return Gp(qu(t)), t;
}
function ag(e, t) {
  const n = t.startsWith(".") ? t : `.${t}`;
  return e.replace(/\.[^/.]+$/, "") + n;
}
function fT(e, t) {
  const n = new URL(e), a = n.searchParams.get("file_name");
  if (a) {
    const s = ag(a, t);
    n.searchParams.set("file_name", s);
  }
  return n.toString();
}
function pT(e) {
  const n = new URL(e).searchParams.get("file_name");
  if (!n) return null;
  const a = n.match(/\.[^/.]+$/);
  return a ? a[0] : null;
}
const sg = ".pdf,.zip,.doc,.docx,.doc,.txt", og = ".png,.jpg,.jpeg,.bmp", mT = ".png,.jpg,.jpeg,.bmp,.svg,.heic,.heif", ig = ".mhd,.nii,.nii.gz,.nrrd", Xu = ".stl,.ply,.obj", AT = ".mtl,.png,.jpg,.jpeg", gT = ".zip,.nii.gz,.nii,.dcm", rg = Xu.split(","), hT = ".off,.x3d,.cam5zip";
function vT(e) {
  var n;
  if (!e)
    return !1;
  const t = (n = e.split(".").pop()) == null ? void 0 : n.toLowerCase();
  return rg.includes(`.${t}`);
}
function yT(e) {
  const t = e.indexOf("/");
  return t !== -1 ? e.substring(0, t) : e;
}
function bT(e, t) {
  let n = 0;
  for (const a of e)
    (a.label === t || a.parent === t) && n++;
  return n;
}
function xT(e, t) {
  for (const n of e)
    if (n.label === t)
      return !0;
  return !1;
}
function ET(e, t) {
  let n = "";
  for (const a of e)
    if (a.label === t)
      return a.key;
  return n;
}
function CT(e) {
  const t = {}, n = [];
  return e.forEach((a) => {
    if (t[a.key] = {
      // Store nodes by key
      key: a.key,
      label: a.label,
      icon: a.icon,
      data: {}
    }, a.parent !== "root") {
      const s = t[a.parentKey];
      s && (s.children || (s.children = []), s.children.push(t[a.key]));
    } else
      n.push(t[a.key]);
  }), n;
}
function wT(e) {
  const n = e / 1048576;
  return n < 1 ? (n * 1024).toFixed(2) + " KB" : n >= 1024 ? (n / 1024).toFixed(2) + " GB" : n.toFixed(2) + " MB";
}
const lg = [...sg.split(","), ...og.split(","), ...ig.split(","), ...Xu.split(",")].map((e) => e.trim().replace(".", "\\.")).sort((e, t) => t.length - e.length), cg = new RegExp(
  `(${lg.join("|")})\\b`,
  // match extension followed by word boundary
  "gi"
);
function IT(e) {
  return e.replace(cg, "").replace(/\s+$/, "");
}
function BT(e, t) {
  if (t > e)
    return "step-done";
  if (t === e)
    return "current-step";
  if (t < e)
    return "next-step";
}
function kT(e, t) {
  return t === e ? "text-selected-step" : "text-default-step";
}
function _T(e) {
  try {
    if (!e || typeof e != "string")
      throw new Error("Invalid JSON input");
    const t = JSON.parse(e), n = t == null ? void 0 : t.color;
    return {
      "red-status": n === "red",
      "orange-status": n === "orange",
      "green-status": n === "green"
    };
  } catch {
    return {
      "red-status": !1,
      "orange-status": !1,
      "green-status": !1
    };
  }
}
function ST(e) {
  try {
    const t = JSON.parse(e).color;
    switch (t) {
      case "red":
        return "#FF0000";
      case "green":
        return "#43C261";
      case "orange":
        return "#FFA500";
      case "white":
        return "#FFFFFF";
      default:
        return `${t}`;
    }
  } catch {
    return "#FFFFFF";
  }
}
function DT(e) {
  try {
    return JSON.parse(e).append_message;
  } catch {
    return "";
  }
}
function TT(e) {
  return e.startsWith("base64, ") ? atob(e.slice(8)) : e.slice(8);
}
function MT(e) {
  return e.startsWith("base64, ") ? e.slice(8) : btoa(e.slice(8));
}
const Zu = "https://www.3diemme.it/en/tutorial-videos/", ug = "https://realguide.com/en/video/", ed = "https://get.teamviewer.com/jrunq9w";
function LT() {
  window.location.host.startsWith("localhost:5") ? window.open("http://localhost:8080/admin", "_blank") : window.open("/admin", "_blank");
}
function OT() {
  window.location.host.startsWith("localhost:5") ? window.open("http://localhost:8080/auth/forgot-password", "_blank") : window.open("/auth/forgot-password", "_blank");
}
function dg(e) {
  return (e == null ? void 0 : e.trim().toLowerCase()) === "zimvie";
}
function fg(e) {
  return dg(e) ? ug : Zu;
}
function NT(e, t) {
  const n = t ?? fg(e);
  window.open(n, "_blank");
}
function RT(e = ed) {
  window.open(e, "_blank");
}
function PT() {
  window.open("/planner/patients", "_blank");
}
function FT(e) {
  window.location.host.startsWith("localhost") ? window.open(`https://gama-cloud.medicteam.io/weblink/prod-center-selection?loginToken=${e}`, "_blank") : window.open(`/weblink/prod-center-selection?loginToken=${e}`, "_blank");
}
function QT(e, t, n) {
  window.open(`https://helpdesk.3diemme.it/Tickets/New?cf10=${e}&cf9=${t}&cf11=${n}`, "_blank");
}
function UT() {
  return !1;
}
function GT() {
  return !0;
}
const pg = "sessionId";
function YT(e) {
  if (typeof document > "u")
    return;
  const n = typeof window < "u" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${pg}=${encodeURIComponent(e)}; Path=/; SameSite=Lax${n}`;
}
var mg = /* @__PURE__ */ ((e) => (e[e.DEFAULT_APP = 0] = "DEFAULT_APP", e[e.BELLATEK = 1] = "BELLATEK", e))(mg || {}), Tr = /* @__PURE__ */ ((e) => (e.IMPLANT_PLANNER = "ImplantPlannerApp", e.WEBLINK = "WeblinkViewerApp", e))(Tr || {});
function Ag(e) {
  e.config.globalProperties.$appState = un({ colorScheme: "dark" });
  const t = localStorage.getItem("colorScheme");
  t && JSON.parse(t) === $a.DARK && document.documentElement.classList.toggle("p-dark"), e._component.__name !== Tr.IMPLANT_PLANNER && (e.use(im), e.use(qm)), e.directive("tooltip", Xm), e.directive("badge", $p), e.directive("ripple", Tm), e.component("Accordion", Hp), e.component("AccordionTab", Vp), e.component("AutoComplete", jp), e.component("Avatar", Kp), e.component("AvatarGroup", Wp), e.component("Badge", zp), e.component("Breadcrumb", qp), e.component("Button", Vn), e.component("Calendar", Jp), e.component("Card", Xp), e.component("Carousel", em), e.component("CascadeSelect", Zp), e.component("Checkbox", tm), e.component("Chip", Ou), e.component("Chips", nm), e.component("ColorPicker", kr), e.component("Column", am), e.component("ConfirmDialog", sm), e.component("ConfirmPopup", om), e.component("ContextMenu", Nu), e.component("DataTable", rm), e.component("Dialog", Ru), e.component("Divider", Pu), e.component("Dropdown", lm), e.component("Fieldset", cm), e.component("FileUpload", um), e.component("Galleria", dm), e.component("Image", Fu), e.component("InlineMessage", fm), e.component("Inplace", pm), e.component("InputMask", mm), e.component("InputNumber", Go), e.component("InputSwitch", Qu), e.component("InputText", _r), e.component("Knob", Am), e.component("Listbox", Uu), e.component("MegaMenu", gm), e.component("Menu", hm), e.component("Menubar", vm), e.component("Message", ym), e.component("MultiSelect", bm), e.component("OrderList", xm), e.component("OrganizationChart", Em), e.component("Popover", Bs), e.component("Paginator", Cm), e.component("Panel", wm), e.component("PanelMenu", Im), e.component("Password", Bm), e.component("PickList", km), e.component("ProgressBar", _m), e.component("RadioButton", Dm), e.component("Rating", Sm), e.component("SelectButton", Mm), e.component("ScrollPanel", Lm), e.component("ScrollTop", Om), e.component("Slider", Sr), e.component("Sidebar", Rm), e.component("Skeleton", Nm), e.component("SplitButton", Pm), e.component("Splitter", Fm), e.component("SplitterPanel", Qm), e.component("Steps", Um), e.component("TabMenu", Gm), e.component("TabView", Km), e.component("TabPanel", Wm), e.component("Tag", zm), e.component("Textarea", jm), e.component("TieredMenu", Ym), e.component("Timeline", $m), e.component("Toast", Hm), e.component("Toolbar", Vm), e.component("ToggleButton", Jm), e.component("Tree", Zm), e.component("TreeSelect", eA), e.component("TreeTable", tA);
}
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function gg(e, t, n) {
  return (t = vg(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function kl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function F(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kl(Object(n), !0).forEach(function(a) {
      gg(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kl(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function hg(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function vg(e) {
  var t = hg(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const _l = () => {
};
let Mr = {}, td = {}, nd = null, ad = {
  mark: _l,
  measure: _l
};
try {
  typeof window < "u" && (Mr = window), typeof document < "u" && (td = document), typeof MutationObserver < "u" && (nd = MutationObserver), typeof performance < "u" && (ad = performance);
} catch {
}
const {
  userAgent: Sl = ""
} = Mr.navigator || {}, Jn = Mr, Me = td, Dl = nd, Zs = ad;
Jn.document;
const Ln = !!Me.documentElement && !!Me.head && typeof Me.addEventListener == "function" && typeof Me.createElement == "function", sd = ~Sl.indexOf("MSIE") || ~Sl.indexOf("Trident/");
var yg = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, bg = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, od = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, xg = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, id = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], lt = "classic", Vo = "duotone", Eg = "sharp", Cg = "sharp-duotone", rd = [lt, Vo, Eg, Cg], wg = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, Ig = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, Bg = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), kg = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, _g = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Tl = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, Sg = ["kit"], Dg = {
  kit: {
    "fa-kit": "fak"
  }
}, Tg = ["fak", "fakd"], Mg = {
  kit: {
    fak: "fa-kit"
  }
}, Ml = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, eo = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Lg = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], Og = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Ng = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Rg = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, Pg = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Ri = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, Fg = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Pi = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...Lg, ...Fg], Qg = ["solid", "regular", "light", "thin", "duotone", "brands"], ld = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ug = ld.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Gg = [...Object.keys(Pg), ...Qg, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", eo.GROUP, eo.SWAP_OPACITY, eo.PRIMARY, eo.SECONDARY].concat(ld.map((e) => "".concat(e, "x"))).concat(Ug.map((e) => "w-".concat(e))), Yg = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Bn = "___FONT_AWESOME___", Fi = 16, cd = "fa", ud = "svg-inline--fa", xa = "data-fa-i2svg", Qi = "data-fa-pseudo-element", jg = "data-fa-pseudo-element-pending", Lr = "data-prefix", Or = "data-icon", Ll = "fontawesome-i2svg", Hg = "async", Vg = ["HTML", "HEAD", "STYLE", "SCRIPT"], dd = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function Ks(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[lt];
    }
  });
}
const fd = F({}, od);
fd[lt] = F(F(F(F({}, {
  "fa-duotone": "duotone"
}), od[lt]), Tl.kit), Tl["kit-duotone"]);
const Kg = Ks(fd), Ui = F({}, kg);
Ui[lt] = F(F(F(F({}, {
  duotone: "fad"
}), Ui[lt]), Ml.kit), Ml["kit-duotone"]);
const Ol = Ks(Ui), Gi = F({}, Ri);
Gi[lt] = F(F({}, Gi[lt]), Mg.kit);
const Nr = Ks(Gi), Yi = F({}, Rg);
Yi[lt] = F(F({}, Yi[lt]), Dg.kit);
Ks(Yi);
const Wg = yg, pd = "fa-layers-text", zg = bg, $g = F({}, wg);
Ks($g);
const qg = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], gi = xg, Jg = [...Sg, ...Gg], hs = Jn.FontAwesomeConfig || {};
function Xg(e) {
  var t = Me.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Zg(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Me && typeof Me.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, a] = t;
  const s = Zg(Xg(n));
  s != null && (hs[a] = s);
});
const md = {
  styleDefault: "solid",
  familyDefault: lt,
  cssPrefix: cd,
  replacementClass: ud,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
hs.familyPrefix && (hs.cssPrefix = hs.familyPrefix);
const qa = F(F({}, md), hs);
qa.autoReplaceSvg || (qa.observeMutations = !1);
const q = {};
Object.keys(md).forEach((e) => {
  Object.defineProperty(q, e, {
    enumerable: !0,
    set: function(t) {
      qa[e] = t, vs.forEach((n) => n(q));
    },
    get: function() {
      return qa[e];
    }
  });
});
Object.defineProperty(q, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    qa.cssPrefix = e, vs.forEach((t) => t(q));
  },
  get: function() {
    return qa.cssPrefix;
  }
});
Jn.FontAwesomeConfig = q;
const vs = [];
function eh(e) {
  return vs.push(e), () => {
    vs.splice(vs.indexOf(e), 1);
  };
}
const Rn = Fi, on = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function th(e) {
  if (!e || !Ln)
    return;
  const t = Me.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Me.head.childNodes;
  let a = null;
  for (let s = n.length - 1; s > -1; s--) {
    const o = n[s], i = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(i) > -1 && (a = o);
  }
  return Me.head.insertBefore(t, a), e;
}
const nh = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function ks() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += nh[Math.random() * 62 | 0];
  return t;
}
function ss(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Rr(e) {
  return e.classList ? ss(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function Ad(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ah(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(Ad(e[n]), '" '), "").trim();
}
function Ko(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Pr(e) {
  return e.size !== on.size || e.x !== on.x || e.y !== on.y || e.rotate !== on.rotate || e.flipX || e.flipY;
}
function sh(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: a
  } = e;
  const s = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), r = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(i, " ").concat(r)
  }, c = {
    transform: "translate(".concat(a / 2 * -1, " -256)")
  };
  return {
    outer: s,
    inner: l,
    path: c
  };
}
function oh(e) {
  let {
    transform: t,
    width: n = Fi,
    height: a = Fi,
    startCentered: s = !1
  } = e, o = "";
  return s && sd ? o += "translate(".concat(t.x / Rn - n / 2, "em, ").concat(t.y / Rn - a / 2, "em) ") : s ? o += "translate(calc(-50% + ".concat(t.x / Rn, "em), calc(-50% + ").concat(t.y / Rn, "em)) ") : o += "translate(".concat(t.x / Rn, "em, ").concat(t.y / Rn, "em) "), o += "scale(".concat(t.size / Rn * (t.flipX ? -1 : 1), ", ").concat(t.size / Rn * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var ih = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function gd() {
  const e = cd, t = ud, n = q.cssPrefix, a = q.replacementClass;
  let s = ih;
  if (n !== e || a !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), i = new RegExp("\\--".concat(e, "\\-"), "g"), r = new RegExp("\\.".concat(t), "g");
    s = s.replace(o, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(r, ".".concat(a));
  }
  return s;
}
let Nl = !1;
function hi() {
  q.autoAddCss && !Nl && (th(gd()), Nl = !0);
}
var rh = {
  mixout() {
    return {
      dom: {
        css: gd,
        insertCss: hi
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        hi();
      },
      beforeI2svg() {
        hi();
      }
    };
  }
};
const kn = Jn || {};
kn[Bn] || (kn[Bn] = {});
kn[Bn].styles || (kn[Bn].styles = {});
kn[Bn].hooks || (kn[Bn].hooks = {});
kn[Bn].shims || (kn[Bn].shims = []);
var rn = kn[Bn];
const hd = [], vd = function() {
  Me.removeEventListener("DOMContentLoaded", vd), ko = 1, hd.map((e) => e());
};
let ko = !1;
Ln && (ko = (Me.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Me.readyState), ko || Me.addEventListener("DOMContentLoaded", vd));
function lh(e) {
  Ln && (ko ? setTimeout(e, 0) : hd.push(e));
}
function Ws(e) {
  const {
    tag: t,
    attributes: n = {},
    children: a = []
  } = e;
  return typeof e == "string" ? Ad(e) : "<".concat(t, " ").concat(ah(n), ">").concat(a.map(Ws).join(""), "</").concat(t, ">");
}
function Rl(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var vi = function(t, n, a, s) {
  var o = Object.keys(t), i = o.length, r = n, l, c, u;
  for (a === void 0 ? (l = 1, u = t[o[0]]) : (l = 0, u = a); l < i; l++)
    c = o[l], u = r(u, t[c], c, t);
  return u;
};
function ch(e) {
  const t = [];
  let n = 0;
  const a = e.length;
  for (; n < a; ) {
    const s = e.charCodeAt(n++);
    if (s >= 55296 && s <= 56319 && n < a) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((s & 1023) << 10) + (o & 1023) + 65536) : (t.push(s), n--);
    } else
      t.push(s);
  }
  return t;
}
function ji(e) {
  const t = ch(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function uh(e, t) {
  const n = e.length;
  let a = e.charCodeAt(t), s;
  return a >= 55296 && a <= 56319 && n > t + 1 && (s = e.charCodeAt(t + 1), s >= 56320 && s <= 57343) ? (a - 55296) * 1024 + s - 56320 + 65536 : a;
}
function Pl(e) {
  return Object.keys(e).reduce((t, n) => {
    const a = e[n];
    return !!a.icon ? t[a.iconName] = a.icon : t[n] = a, t;
  }, {});
}
function Hi(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: a = !1
  } = n, s = Pl(t);
  typeof rn.hooks.addPack == "function" && !a ? rn.hooks.addPack(e, Pl(t)) : rn.styles[e] = F(F({}, rn.styles[e] || {}), s), e === "fas" && Hi("fa", t);
}
const {
  styles: _s,
  shims: dh
} = rn, yd = Object.keys(Nr), fh = yd.reduce((e, t) => (e[t] = Object.keys(Nr[t]), e), {});
let Fr = null, bd = {}, xd = {}, Ed = {}, Cd = {}, wd = {};
function ph(e) {
  return ~Jg.indexOf(e);
}
function mh(e, t) {
  const n = t.split("-"), a = n[0], s = n.slice(1).join("-");
  return a === e && s !== "" && !ph(s) ? s : null;
}
const Id = () => {
  const e = (a) => vi(_s, (s, o, i) => (s[i] = vi(o, a, {}), s), {});
  bd = e((a, s, o) => (s[3] && (a[s[3]] = o), s[2] && s[2].filter((r) => typeof r == "number").forEach((r) => {
    a[r.toString(16)] = o;
  }), a)), xd = e((a, s, o) => (a[o] = o, s[2] && s[2].filter((r) => typeof r == "string").forEach((r) => {
    a[r] = o;
  }), a)), wd = e((a, s, o) => {
    const i = s[2];
    return a[o] = o, i.forEach((r) => {
      a[r] = o;
    }), a;
  });
  const t = "far" in _s || q.autoFetchSvg, n = vi(dh, (a, s) => {
    const o = s[0];
    let i = s[1];
    const r = s[2];
    return i === "far" && !t && (i = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: i,
      iconName: r
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: i,
      iconName: r
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  Ed = n.names, Cd = n.unicodes, Fr = Wo(q.styleDefault, {
    family: q.familyDefault
  });
};
eh((e) => {
  Fr = Wo(e.styleDefault, {
    family: q.familyDefault
  });
});
Id();
function Qr(e, t) {
  return (bd[e] || {})[t];
}
function Ah(e, t) {
  return (xd[e] || {})[t];
}
function ua(e, t) {
  return (wd[e] || {})[t];
}
function Bd(e) {
  return Ed[e] || {
    prefix: null,
    iconName: null
  };
}
function gh(e) {
  const t = Cd[e], n = Qr("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Xn() {
  return Fr;
}
const kd = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function hh(e) {
  let t = lt;
  const n = yd.reduce((a, s) => (a[s] = "".concat(q.cssPrefix, "-").concat(s), a), {});
  return rd.forEach((a) => {
    (e.includes(n[a]) || e.some((s) => fh[a].includes(s))) && (t = a);
  }), t;
}
function Wo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = lt
  } = t, a = Kg[n][e];
  if (n === Vo && !e)
    return "fad";
  const s = Ol[n][e] || Ol[n][a], o = e in rn.styles ? e : null;
  return s || o || null;
}
function vh(e) {
  let t = [], n = null;
  return e.forEach((a) => {
    const s = mh(q.cssPrefix, a);
    s ? n = s : a && t.push(a);
  }), {
    iconName: n,
    rest: t
  };
}
function Fl(e) {
  return e.sort().filter((t, n, a) => a.indexOf(t) === n);
}
function zo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let a = null;
  const s = Pi.concat(Og), o = Fl(e.filter((d) => s.includes(d))), i = Fl(e.filter((d) => !Pi.includes(d))), r = o.filter((d) => (a = d, !id.includes(d))), [l = null] = r, c = hh(o), u = F(F({}, vh(i)), {}, {
    prefix: Wo(l, {
      family: c
    })
  });
  return F(F(F({}, u), Eh({
    values: e,
    family: c,
    styles: _s,
    config: q,
    canonical: u,
    givenPrefix: a
  })), yh(n, a, u));
}
function yh(e, t, n) {
  let {
    prefix: a,
    iconName: s
  } = n;
  if (e || !a || !s)
    return {
      prefix: a,
      iconName: s
    };
  const o = t === "fa" ? Bd(s) : {}, i = ua(a, s);
  return s = o.iconName || i || s, a = o.prefix || a, a === "far" && !_s.far && _s.fas && !q.autoFetchSvg && (a = "fas"), {
    prefix: a,
    iconName: s
  };
}
const bh = rd.filter((e) => e !== lt || e !== Vo), xh = Object.keys(Ri).filter((e) => e !== lt).map((e) => Object.keys(Ri[e])).flat();
function Eh(e) {
  const {
    values: t,
    family: n,
    canonical: a,
    givenPrefix: s = "",
    styles: o = {},
    config: i = {}
  } = e, r = n === Vo, l = t.includes("fa-duotone") || t.includes("fad"), c = i.familyDefault === "duotone", u = a.prefix === "fad" || a.prefix === "fa-duotone";
  if (!r && (l || c || u) && (a.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (a.prefix = "fab"), !a.prefix && bh.includes(n) && (Object.keys(o).find((m) => xh.includes(m)) || i.autoFetchSvg)) {
    const m = Bg.get(n).defaultShortPrefixId;
    a.prefix = m, a.iconName = ua(a.prefix, a.iconName) || a.iconName;
  }
  return (a.prefix === "fa" || s === "fa") && (a.prefix = Xn() || "fas"), a;
}
class Ch {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    const s = n.reduce(this._pullDefinitions, {});
    Object.keys(s).forEach((o) => {
      this.definitions[o] = F(F({}, this.definitions[o] || {}), s[o]), Hi(o, s[o]);
      const i = Nr[lt][o];
      i && Hi(i, s[o]), Id();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const a = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(a).map((s) => {
      const {
        prefix: o,
        iconName: i,
        icon: r
      } = a[s], l = r[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((c) => {
        typeof c == "string" && (t[o][c] = r);
      }), t[o][i] = r;
    }), t;
  }
}
let Ql = [], Oa = {};
const Pa = {}, wh = Object.keys(Pa);
function Ih(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return Ql = e, Oa = {}, Object.keys(Pa).forEach((a) => {
    wh.indexOf(a) === -1 && delete Pa[a];
  }), Ql.forEach((a) => {
    const s = a.mixout ? a.mixout() : {};
    if (Object.keys(s).forEach((o) => {
      typeof s[o] == "function" && (n[o] = s[o]), typeof s[o] == "object" && Object.keys(s[o]).forEach((i) => {
        n[o] || (n[o] = {}), n[o][i] = s[o][i];
      });
    }), a.hooks) {
      const o = a.hooks();
      Object.keys(o).forEach((i) => {
        Oa[i] || (Oa[i] = []), Oa[i].push(o[i]);
      });
    }
    a.provides && a.provides(Pa);
  }), n;
}
function Vi(e, t) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    a[s - 2] = arguments[s];
  return (Oa[e] || []).forEach((i) => {
    t = i.apply(null, [t, ...a]);
  }), t;
}
function Ea(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  (Oa[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function Zn() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return Pa[e] ? Pa[e].apply(null, t) : void 0;
}
function Ki(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || Xn();
  if (t)
    return t = ua(n, t) || t, Rl(_d.definitions, n, t) || Rl(rn.styles, n, t);
}
const _d = new Ch(), Bh = () => {
  q.autoReplaceSvg = !1, q.observeMutations = !1, Ea("noAuto");
}, kh = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Ln ? (Ea("beforeI2svg", e), Zn("pseudoElements2svg", e), Zn("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    q.autoReplaceSvg === !1 && (q.autoReplaceSvg = !0), q.observeMutations = !0, lh(() => {
      Sh({
        autoReplaceSvgRoot: t
      }), Ea("watch", e);
    });
  }
}, _h = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: ua(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Wo(e[0]);
      return {
        prefix: n,
        iconName: ua(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(q.cssPrefix, "-")) > -1 || e.match(Wg))) {
      const t = zo(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || Xn(),
        iconName: ua(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = Xn();
      return {
        prefix: t,
        iconName: ua(t, e) || e
      };
    }
  }
}, kt = {
  noAuto: Bh,
  config: q,
  dom: kh,
  parse: _h,
  library: _d,
  findIconDefinition: Ki,
  toHtml: Ws
}, Sh = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Me
  } = e;
  (Object.keys(rn.styles).length > 0 || q.autoFetchSvg) && Ln && q.autoReplaceSvg && kt.dom.i2svg({
    node: t
  });
};
function $o(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => Ws(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!Ln) return;
      const n = Me.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function Dh(e) {
  let {
    children: t,
    main: n,
    mask: a,
    attributes: s,
    styles: o,
    transform: i
  } = e;
  if (Pr(i) && n.found && !a.found) {
    const {
      width: r,
      height: l
    } = n, c = {
      x: r / l / 2,
      y: 0.5
    };
    s.style = Ko(F(F({}, o), {}, {
      "transform-origin": "".concat(c.x + i.x / 16, "em ").concat(c.y + i.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: s,
    children: t
  }];
}
function Th(e) {
  let {
    prefix: t,
    iconName: n,
    children: a,
    attributes: s,
    symbol: o
  } = e;
  const i = o === !0 ? "".concat(t, "-").concat(q.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: F(F({}, s), {}, {
        id: i
      }),
      children: a
    }]
  }];
}
function Ur(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: a,
    iconName: s,
    transform: o,
    symbol: i,
    title: r,
    maskId: l,
    titleId: c,
    extra: u,
    watchable: d = !1
  } = e, {
    width: m,
    height: g
  } = n.found ? n : t, h = Tg.includes(a), A = [q.replacementClass, s ? "".concat(q.cssPrefix, "-").concat(s) : ""].filter((_) => u.classes.indexOf(_) === -1).filter((_) => _ !== "" || !!_).concat(u.classes).join(" ");
  let f = {
    children: [],
    attributes: F(F({}, u.attributes), {}, {
      "data-prefix": a,
      "data-icon": s,
      class: A,
      role: u.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(m, " ").concat(g)
    })
  };
  const p = h && !~u.classes.indexOf("fa-fw") ? {
    width: "".concat(m / g * 16 * 0.0625, "em")
  } : {};
  d && (f.attributes[xa] = ""), r && (f.children.push({
    tag: "title",
    attributes: {
      id: f.attributes["aria-labelledby"] || "title-".concat(c || ks())
    },
    children: [r]
  }), delete f.attributes.title);
  const v = F(F({}, f), {}, {
    prefix: a,
    iconName: s,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: i,
    styles: F(F({}, p), u.styles)
  }), {
    children: b,
    attributes: y
  } = n.found && t.found ? Zn("generateAbstractMask", v) || {
    children: [],
    attributes: {}
  } : Zn("generateAbstractIcon", v) || {
    children: [],
    attributes: {}
  };
  return v.children = b, v.attributes = y, i ? Th(v) : Dh(v);
}
function Ul(e) {
  const {
    content: t,
    width: n,
    height: a,
    transform: s,
    title: o,
    extra: i,
    watchable: r = !1
  } = e, l = F(F(F({}, i.attributes), o ? {
    title: o
  } : {}), {}, {
    class: i.classes.join(" ")
  });
  r && (l[xa] = "");
  const c = F({}, i.styles);
  Pr(s) && (c.transform = oh({
    transform: s,
    startCentered: !0,
    width: n,
    height: a
  }), c["-webkit-transform"] = c.transform);
  const u = Ko(c);
  u.length > 0 && (l.style = u);
  const d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), d;
}
function Mh(e) {
  const {
    content: t,
    title: n,
    extra: a
  } = e, s = F(F(F({}, a.attributes), n ? {
    title: n
  } : {}), {}, {
    class: a.classes.join(" ")
  }), o = Ko(a.styles);
  o.length > 0 && (s.style = o);
  const i = [];
  return i.push({
    tag: "span",
    attributes: s,
    children: [t]
  }), n && i.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), i;
}
const {
  styles: yi
} = rn;
function Wi(e) {
  const t = e[0], n = e[1], [a] = e.slice(4);
  let s = null;
  return Array.isArray(a) ? s = {
    tag: "g",
    attributes: {
      class: "".concat(q.cssPrefix, "-").concat(gi.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(q.cssPrefix, "-").concat(gi.SECONDARY),
        fill: "currentColor",
        d: a[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(q.cssPrefix, "-").concat(gi.PRIMARY),
        fill: "currentColor",
        d: a[1]
      }
    }]
  } : s = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: a
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: s
  };
}
const Lh = {
  found: !1,
  width: 512,
  height: 512
};
function Oh(e, t) {
  !dd && !q.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function zi(e, t) {
  let n = t;
  return t === "fa" && q.styleDefault !== null && (t = Xn()), new Promise((a, s) => {
    if (n === "fa") {
      const o = Bd(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && yi[t] && yi[t][e]) {
      const o = yi[t][e];
      return a(Wi(o));
    }
    Oh(e, t), a(F(F({}, Lh), {}, {
      icon: q.showMissingIcons && e ? Zn("missingIconAbstract") || {} : {}
    }));
  });
}
const Gl = () => {
}, $i = q.measurePerformance && Zs && Zs.mark && Zs.measure ? Zs : {
  mark: Gl,
  measure: Gl
}, As = 'FA "6.7.2"', Nh = (e) => ($i.mark("".concat(As, " ").concat(e, " begins")), () => Sd(e)), Sd = (e) => {
  $i.mark("".concat(As, " ").concat(e, " ends")), $i.measure("".concat(As, " ").concat(e), "".concat(As, " ").concat(e, " begins"), "".concat(As, " ").concat(e, " ends"));
};
var Gr = {
  begin: Nh,
  end: Sd
};
const Ao = () => {
};
function Yl(e) {
  return typeof (e.getAttribute ? e.getAttribute(xa) : null) == "string";
}
function Rh(e) {
  const t = e.getAttribute ? e.getAttribute(Lr) : null, n = e.getAttribute ? e.getAttribute(Or) : null;
  return t && n;
}
function Ph(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(q.replacementClass);
}
function Fh() {
  return q.autoReplaceSvg === !0 ? go.replace : go[q.autoReplaceSvg] || go.replace;
}
function Qh(e) {
  return Me.createElementNS("http://www.w3.org/2000/svg", e);
}
function Uh(e) {
  return Me.createElement(e);
}
function Dd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? Qh : Uh
  } = t;
  if (typeof e == "string")
    return Me.createTextNode(e);
  const a = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    a.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    a.appendChild(Dd(o, {
      ceFn: n
    }));
  }), a;
}
function Gh(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const go = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(Dd(n), t);
      }), t.getAttribute(xa) === null && q.keepOriginalSource) {
        let n = Me.createComment(Gh(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Rr(t).indexOf(q.replacementClass))
      return go.replace(e);
    const a = new RegExp("".concat(q.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((i, r) => (r === q.replacementClass || r.match(a) ? i.toSvg.push(r) : i.toNode.push(r), i), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const s = n.map((o) => Ws(o)).join(`
`);
    t.setAttribute(xa, ""), t.innerHTML = s;
  }
};
function jl(e) {
  e();
}
function Td(e, t) {
  const n = typeof t == "function" ? t : Ao;
  if (e.length === 0)
    n();
  else {
    let a = jl;
    q.mutateApproach === Hg && (a = Jn.requestAnimationFrame || jl), a(() => {
      const s = Fh(), o = Gr.begin("mutate");
      e.map(s), o(), n();
    });
  }
}
let Yr = !1;
function Md() {
  Yr = !0;
}
function qi() {
  Yr = !1;
}
let _o = null;
function Hl(e) {
  if (!Dl || !q.observeMutations)
    return;
  const {
    treeCallback: t = Ao,
    nodeCallback: n = Ao,
    pseudoElementsCallback: a = Ao,
    observeMutationsRoot: s = Me
  } = e;
  _o = new Dl((o) => {
    if (Yr) return;
    const i = Xn();
    ss(o).forEach((r) => {
      if (r.type === "childList" && r.addedNodes.length > 0 && !Yl(r.addedNodes[0]) && (q.searchPseudoElements && a(r.target), t(r.target)), r.type === "attributes" && r.target.parentNode && q.searchPseudoElements && a(r.target.parentNode), r.type === "attributes" && Yl(r.target) && ~qg.indexOf(r.attributeName))
        if (r.attributeName === "class" && Rh(r.target)) {
          const {
            prefix: l,
            iconName: c
          } = zo(Rr(r.target));
          r.target.setAttribute(Lr, l || i), c && r.target.setAttribute(Or, c);
        } else Ph(r.target) && n(r.target);
    });
  }), Ln && _o.observe(s, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Yh() {
  _o && _o.disconnect();
}
function jh(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((a, s) => {
    const o = s.split(":"), i = o[0], r = o.slice(1);
    return i && r.length > 0 && (a[i] = r.join(":").trim()), a;
  }, {})), n;
}
function Hh(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), a = e.innerText !== void 0 ? e.innerText.trim() : "";
  let s = zo(Rr(e));
  return s.prefix || (s.prefix = Xn()), t && n && (s.prefix = t, s.iconName = n), s.iconName && s.prefix || (s.prefix && a.length > 0 && (s.iconName = Ah(s.prefix, e.innerText) || Qr(s.prefix, ji(e.innerText))), !s.iconName && q.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (s.iconName = e.firstChild.data)), s;
}
function Vh(e) {
  const t = ss(e.attributes).reduce((s, o) => (s.name !== "class" && s.name !== "style" && (s[o.name] = o.value), s), {}), n = e.getAttribute("title"), a = e.getAttribute("data-fa-title-id");
  return q.autoA11y && (n ? t["aria-labelledby"] = "".concat(q.replacementClass, "-title-").concat(a || ks()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Kh() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: on,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function Vl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: a,
    rest: s
  } = Hh(e), o = Vh(e), i = Vi("parseNodeAttributes", {}, e);
  let r = t.styleParser ? jh(e) : [];
  return F({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: on,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: s,
      styles: r,
      attributes: o
    }
  }, i);
}
const {
  styles: Wh
} = rn;
function Ld(e) {
  const t = q.autoReplaceSvg === "nest" ? Vl(e, {
    styleParser: !1
  }) : Vl(e);
  return ~t.extra.classes.indexOf(pd) ? Zn("generateLayersText", e, t) : Zn("generateSvgReplacementMutation", e, t);
}
function zh() {
  return [..._g, ...Pi];
}
function Kl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Ln) return Promise.resolve();
  const n = Me.documentElement.classList, a = (u) => n.add("".concat(Ll, "-").concat(u)), s = (u) => n.remove("".concat(Ll, "-").concat(u)), o = q.autoFetchSvg ? zh() : id.concat(Object.keys(Wh));
  o.includes("fa") || o.push("fa");
  const i = [".".concat(pd, ":not([").concat(xa, "])")].concat(o.map((u) => ".".concat(u, ":not([").concat(xa, "])"))).join(", ");
  if (i.length === 0)
    return Promise.resolve();
  let r = [];
  try {
    r = ss(e.querySelectorAll(i));
  } catch {
  }
  if (r.length > 0)
    a("pending"), s("complete");
  else
    return Promise.resolve();
  const l = Gr.begin("onTree"), c = r.reduce((u, d) => {
    try {
      const m = Ld(d);
      m && u.push(m);
    } catch (m) {
      dd || m.name === "MissingIcon" && console.error(m);
    }
    return u;
  }, []);
  return new Promise((u, d) => {
    Promise.all(c).then((m) => {
      Td(m, () => {
        a("active"), a("complete"), s("pending"), typeof t == "function" && t(), l(), u();
      });
    }).catch((m) => {
      l(), d(m);
    });
  });
}
function $h(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Ld(e).then((n) => {
    n && Td([n], t);
  });
}
function qh(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = (t || {}).icon ? t : Ki(t || {});
    let {
      mask: s
    } = n;
    return s && (s = (s || {}).icon ? s : Ki(s || {})), e(a, F(F({}, n), {}, {
      mask: s
    }));
  };
}
const Jh = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = on,
    symbol: a = !1,
    mask: s = null,
    maskId: o = null,
    title: i = null,
    titleId: r = null,
    classes: l = [],
    attributes: c = {},
    styles: u = {}
  } = t;
  if (!e) return;
  const {
    prefix: d,
    iconName: m,
    icon: g
  } = e;
  return $o(F({
    type: "icon"
  }, e), () => (Ea("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), q.autoA11y && (i ? c["aria-labelledby"] = "".concat(q.replacementClass, "-title-").concat(r || ks()) : (c["aria-hidden"] = "true", c.focusable = "false")), Ur({
    icons: {
      main: Wi(g),
      mask: s ? Wi(s.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: d,
    iconName: m,
    transform: F(F({}, on), n),
    symbol: a,
    title: i,
    maskId: o,
    titleId: r,
    extra: {
      attributes: c,
      styles: u,
      classes: l
    }
  })));
};
var Xh = {
  mixout() {
    return {
      icon: qh(Jh)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = Kl, e.nodeCallback = $h, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Me,
        callback: a = () => {
        }
      } = t;
      return Kl(n, a);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: a,
        title: s,
        titleId: o,
        prefix: i,
        transform: r,
        symbol: l,
        mask: c,
        maskId: u,
        extra: d
      } = n;
      return new Promise((m, g) => {
        Promise.all([zi(a, i), c.iconName ? zi(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [A, f] = h;
          m([t, Ur({
            icons: {
              main: A,
              mask: f
            },
            prefix: i,
            iconName: a,
            transform: r,
            symbol: l,
            maskId: u,
            title: s,
            titleId: o,
            extra: d,
            watchable: !0
          })]);
        }).catch(g);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: a,
        main: s,
        transform: o,
        styles: i
      } = t;
      const r = Ko(i);
      r.length > 0 && (a.style = r);
      let l;
      return Pr(o) && (l = Zn("generateAbstractTransformGrouping", {
        main: s,
        transform: o,
        containerWidth: s.width,
        iconWidth: s.width
      })), n.push(l || s.icon), {
        children: n,
        attributes: a
      };
    };
  }
}, Zh = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return $o({
          type: "layer"
        }, () => {
          Ea("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let a = [];
          return e((s) => {
            Array.isArray(s) ? s.map((o) => {
              a = a.concat(o.abstract);
            }) : a = a.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(q.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: a
          }];
        });
      }
    };
  }
}, e0 = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: a = [],
          attributes: s = {},
          styles: o = {}
        } = t;
        return $o({
          type: "counter",
          content: e
        }, () => (Ea("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Mh({
          content: e.toString(),
          title: n,
          extra: {
            attributes: s,
            styles: o,
            classes: ["".concat(q.cssPrefix, "-layers-counter"), ...a]
          }
        })));
      }
    };
  }
}, t0 = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = on,
          title: a = null,
          classes: s = [],
          attributes: o = {},
          styles: i = {}
        } = t;
        return $o({
          type: "text",
          content: e
        }, () => (Ea("beforeDOMElementCreation", {
          content: e,
          params: t
        }), Ul({
          content: e,
          transform: F(F({}, on), n),
          title: a,
          extra: {
            attributes: o,
            styles: i,
            classes: ["".concat(q.cssPrefix, "-layers-text"), ...s]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: a,
        transform: s,
        extra: o
      } = n;
      let i = null, r = null;
      if (sd) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        i = c.width / l, r = c.height / l;
      }
      return q.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, Ul({
        content: t.innerHTML,
        width: i,
        height: r,
        transform: s,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const n0 = new RegExp('"', "ug"), Wl = [1105920, 1112319], zl = F(F(F(F({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), Ig), Yg), Ng), Ji = Object.keys(zl).reduce((e, t) => (e[t.toLowerCase()] = zl[t], e), {}), a0 = Object.keys(Ji).reduce((e, t) => {
  const n = Ji[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function s0(e) {
  const t = e.replace(n0, ""), n = uh(t, 0), a = n >= Wl[0] && n <= Wl[1], s = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: ji(s ? t[0] : t),
    isSecondary: a || s
  };
}
function o0(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), a = parseInt(t), s = isNaN(a) ? "normal" : a;
  return (Ji[n] || {})[s] || a0[n];
}
function $l(e, t) {
  const n = "".concat(jg).concat(t.replace(":", "-"));
  return new Promise((a, s) => {
    if (e.getAttribute(n) !== null)
      return a();
    const i = ss(e.children).filter((m) => m.getAttribute(Qi) === t)[0], r = Jn.getComputedStyle(e, t), l = r.getPropertyValue("font-family"), c = l.match(zg), u = r.getPropertyValue("font-weight"), d = r.getPropertyValue("content");
    if (i && !c)
      return e.removeChild(i), a();
    if (c && d !== "none" && d !== "") {
      const m = r.getPropertyValue("content");
      let g = o0(l, u);
      const {
        value: h,
        isSecondary: A
      } = s0(m), f = c[0].startsWith("FontAwesome");
      let p = Qr(g, h), v = p;
      if (f) {
        const b = gh(h);
        b.iconName && b.prefix && (p = b.iconName, g = b.prefix);
      }
      if (p && !A && (!i || i.getAttribute(Lr) !== g || i.getAttribute(Or) !== v)) {
        e.setAttribute(n, v), i && e.removeChild(i);
        const b = Kh(), {
          extra: y
        } = b;
        y.attributes[Qi] = t, zi(p, g).then((_) => {
          const M = Ur(F(F({}, b), {}, {
            icons: {
              main: _,
              mask: kd()
            },
            prefix: g,
            iconName: v,
            extra: y,
            watchable: !0
          })), S = Me.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(S, e.firstChild) : e.appendChild(S), S.outerHTML = M.map((Y) => Ws(Y)).join(`
`), e.removeAttribute(n), a();
        }).catch(s);
      } else
        a();
    } else
      a();
  });
}
function i0(e) {
  return Promise.all([$l(e, "::before"), $l(e, "::after")]);
}
function r0(e) {
  return e.parentNode !== document.head && !~Vg.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Qi) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function ql(e) {
  if (Ln)
    return new Promise((t, n) => {
      const a = ss(e.querySelectorAll("*")).filter(r0).map(i0), s = Gr.begin("searchPseudoElements");
      Md(), Promise.all(a).then(() => {
        s(), qi(), t();
      }).catch(() => {
        s(), qi(), n();
      });
    });
}
var l0 = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = ql, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Me
      } = t;
      q.searchPseudoElements && ql(n);
    };
  }
};
let Jl = !1;
var c0 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          Md(), Jl = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        Hl(Vi("mutationObserverCallbacks", {}));
      },
      noAuto() {
        Yh();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        Jl ? qi() : Hl(Vi("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const Xl = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, a) => {
    const s = a.toLowerCase().split("-"), o = s[0];
    let i = s.slice(1).join("-");
    if (o && i === "h")
      return n.flipX = !0, n;
    if (o && i === "v")
      return n.flipY = !0, n;
    if (i = parseFloat(i), isNaN(i))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + i;
        break;
      case "shrink":
        n.size = n.size - i;
        break;
      case "left":
        n.x = n.x - i;
        break;
      case "right":
        n.x = n.x + i;
        break;
      case "up":
        n.y = n.y - i;
        break;
      case "down":
        n.y = n.y + i;
        break;
      case "rotate":
        n.rotate = n.rotate + i;
        break;
    }
    return n;
  }, t);
};
var u0 = {
  mixout() {
    return {
      parse: {
        transform: (e) => Xl(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = Xl(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: a,
        containerWidth: s,
        iconWidth: o
      } = t;
      const i = {
        transform: "translate(".concat(s / 2, " 256)")
      }, r = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), l = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), c = "rotate(".concat(a.rotate, " 0 0)"), u = {
        transform: "".concat(r, " ").concat(l, " ").concat(c)
      }, d = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, m = {
        outer: i,
        inner: u,
        path: d
      };
      return {
        tag: "g",
        attributes: F({}, m.outer),
        children: [{
          tag: "g",
          attributes: F({}, m.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: F(F({}, n.icon.attributes), m.path)
          }]
        }]
      };
    };
  }
};
const bi = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function Zl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function d0(e) {
  return e.tag === "g" ? e.children : [e];
}
var f0 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), a = n ? zo(n.split(" ").map((s) => s.trim())) : kd();
        return a.prefix || (a.prefix = Xn()), e.mask = a, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: a,
        main: s,
        mask: o,
        maskId: i,
        transform: r
      } = t;
      const {
        width: l,
        icon: c
      } = s, {
        width: u,
        icon: d
      } = o, m = sh({
        transform: r,
        containerWidth: u,
        iconWidth: l
      }), g = {
        tag: "rect",
        attributes: F(F({}, bi), {}, {
          fill: "white"
        })
      }, h = c.children ? {
        children: c.children.map(Zl)
      } : {}, A = {
        tag: "g",
        attributes: F({}, m.inner),
        children: [Zl(F({
          tag: c.tag,
          attributes: F(F({}, c.attributes), m.path)
        }, h))]
      }, f = {
        tag: "g",
        attributes: F({}, m.outer),
        children: [A]
      }, p = "mask-".concat(i || ks()), v = "clip-".concat(i || ks()), b = {
        tag: "mask",
        attributes: F(F({}, bi), {}, {
          id: p,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [g, f]
      }, y = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: v
          },
          children: d0(d)
        }, b]
      };
      return n.push(y, {
        tag: "rect",
        attributes: F({
          fill: "currentColor",
          "clip-path": "url(#".concat(v, ")"),
          mask: "url(#".concat(p, ")")
        }, bi)
      }), {
        children: n,
        attributes: a
      };
    };
  }
}, p0 = {
  provides(e) {
    let t = !1;
    Jn.matchMedia && (t = Jn.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], a = {
        fill: "currentColor"
      }, s = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: F(F({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = F(F({}, s), {}, {
        attributeName: "opacity"
      }), i = {
        tag: "circle",
        attributes: F(F({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || i.children.push({
        tag: "animate",
        attributes: F(F({}, s), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: F(F({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(i), n.push({
        tag: "path",
        attributes: F(F({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: F(F({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: F(F({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: F(F({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, m0 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), a = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = a, e;
      }
    };
  }
}, A0 = [rh, Xh, Zh, e0, t0, l0, c0, u0, f0, p0, m0];
Ih(A0, {
  mixoutsTo: kt
});
kt.noAuto;
const Od = kt.config, g0 = kt.library;
kt.dom;
const So = kt.parse;
kt.findIconDefinition;
kt.toHtml;
const h0 = kt.icon;
kt.layer;
const v0 = kt.text;
kt.counter;
function Xi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function y0(e) {
  if (Array.isArray(e)) return Xi(e);
}
function st(e, t, n) {
  return (t = I0(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function b0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function x0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ec(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ec(Object(n), !0).forEach(function(a) {
      st(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ec(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function E0(e, t) {
  if (e == null) return {};
  var n, a, s = C0(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) n = o[a], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
  }
  return s;
}
function C0(e, t) {
  if (e == null) return {};
  var n = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (t.indexOf(a) !== -1) continue;
    n[a] = e[a];
  }
  return n;
}
function Zi(e) {
  return y0(e) || b0(e) || B0(e) || x0();
}
function w0(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function I0(e) {
  var t = w0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Do(e) {
  "@babel/helpers - typeof";
  return Do = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Do(e);
}
function B0(e, t) {
  if (e) {
    if (typeof e == "string") return Xi(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xi(e, t) : void 0;
  }
}
function ys(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? st({}, e, t) : {};
}
function k0(e) {
  var t, n = (t = {
    "fa-spin": e.spin,
    "fa-pulse": e.pulse,
    // the fixedWidth property has been deprecated as of version 7.0.0
    "fa-fw": e.fixedWidth,
    "fa-border": e.border,
    "fa-li": e.listItem,
    "fa-inverse": e.inverse,
    "fa-flip": e.flip === !0,
    "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
    "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
  }, st(st(st(st(st(st(st(st(st(st(t, "fa-".concat(e.size), e.size !== null), "fa-rotate-".concat(e.rotation), e.rotation !== null), "fa-rotate-by", e.rotateBy), "fa-pull-".concat(e.pull), e.pull !== null), "fa-swap-opacity", e.swapOpacity), "fa-bounce", e.bounce), "fa-shake", e.shake), "fa-beat", e.beat), "fa-fade", e.fade), "fa-beat-fade", e.beatFade), st(st(st(st(t, "fa-flash", e.flash), "fa-spin-pulse", e.spinPulse), "fa-spin-reverse", e.spinReverse), "fa-width-auto", e.widthAuto));
  return Object.keys(n).map(function(a) {
    return n[a] ? a : null;
  }).filter(function(a) {
    return a;
  });
}
var _0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Nd = { exports: {} };
(function(e) {
  (function(t) {
    var n = function(p, v, b) {
      if (!c(v) || d(v) || m(v) || g(v) || l(v))
        return v;
      var y, _ = 0, M = 0;
      if (u(v))
        for (y = [], M = v.length; _ < M; _++)
          y.push(n(p, v[_], b));
      else {
        y = {};
        for (var S in v)
          Object.prototype.hasOwnProperty.call(v, S) && (y[p(S, b)] = n(p, v[S], b));
      }
      return y;
    }, a = function(p, v) {
      v = v || {};
      var b = v.separator || "_", y = v.split || /(?=[A-Z])/;
      return p.split(y).join(b);
    }, s = function(p) {
      return h(p) ? p : (p = p.replace(/[\-_\s]+(.)?/g, function(v, b) {
        return b ? b.toUpperCase() : "";
      }), p.substr(0, 1).toLowerCase() + p.substr(1));
    }, o = function(p) {
      var v = s(p);
      return v.substr(0, 1).toUpperCase() + v.substr(1);
    }, i = function(p, v) {
      return a(p, v).toLowerCase();
    }, r = Object.prototype.toString, l = function(p) {
      return typeof p == "function";
    }, c = function(p) {
      return p === Object(p);
    }, u = function(p) {
      return r.call(p) == "[object Array]";
    }, d = function(p) {
      return r.call(p) == "[object Date]";
    }, m = function(p) {
      return r.call(p) == "[object RegExp]";
    }, g = function(p) {
      return r.call(p) == "[object Boolean]";
    }, h = function(p) {
      return p = p - 0, p === p;
    }, A = function(p, v) {
      var b = v && "process" in v ? v.process : v;
      return typeof b != "function" ? p : function(y, _) {
        return b(y, p, _);
      };
    }, f = {
      camelize: s,
      decamelize: i,
      pascalize: o,
      depascalize: i,
      camelizeKeys: function(p, v) {
        return n(A(s, v), p);
      },
      decamelizeKeys: function(p, v) {
        return n(A(i, v), p, v);
      },
      pascalizeKeys: function(p, v) {
        return n(A(o, v), p);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = f : t.humps = f;
  })(_0);
})(Nd);
var S0 = Nd.exports, D0 = ["class", "style"];
function T0(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var a = n.indexOf(":"), s = S0.camelize(n.slice(0, a)), o = n.slice(a + 1).trim();
    return t[s] = o, t;
  }, {});
}
function M0(e) {
  return e.split(/\s+/).reduce(function(t, n) {
    return t[n] = !0, t;
  }, {});
}
function jr(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var a = (e.children || []).map(function(l) {
    return jr(l);
  }), s = Object.keys(e.attributes || {}).reduce(function(l, c) {
    var u = e.attributes[c];
    switch (c) {
      case "class":
        l.class = M0(u);
        break;
      case "style":
        l.style = T0(u);
        break;
      default:
        l.attrs[c] = u;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var o = n.style, i = o === void 0 ? {} : o, r = E0(n, D0);
  return Qo(e.tag, Ut(Ut(Ut({}, t), {}, {
    class: s.class,
    style: Ut(Ut({}, s.style), i)
  }, s.attrs), r), a);
}
var Rd = !1;
try {
  Rd = process.env.NODE_ENV === "production";
} catch {
}
function L0() {
  if (!Rd && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function tc(e) {
  if (e && Do(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (So.icon)
    return So.icon(e);
  if (e === null)
    return null;
  if (Do(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
var O0 = j({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    // the fixedWidth property has been deprecated as of version 7
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(t) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(t) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(t) {
        return ["right", "left"].indexOf(t) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(t) {
        return [90, 180, 270].indexOf(Number.parseInt(t, 10)) > -1;
      }
    },
    // the rotateBy property is only supported in version 7.0.0 and later
    rotateBy: {
      type: Boolean,
      default: !1
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(t) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    },
    // the widthAuto property is only supported in version 7.0.0 and later
    widthAuto: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var a = n.attrs, s = U(function() {
      return tc(t.icon);
    }), o = U(function() {
      return ys("classes", k0(t));
    }), i = U(function() {
      return ys("transform", typeof t.transform == "string" ? So.transform(t.transform) : t.transform);
    }), r = U(function() {
      return ys("mask", tc(t.mask));
    }), l = U(function() {
      var u = Ut(Ut(Ut(Ut({}, o.value), i.value), r.value), {}, {
        symbol: t.symbol,
        maskId: t.maskId
      });
      return u.title = t.title, u.titleId = t.titleId, h0(s.value, u);
    });
    ye(l, function(u) {
      if (!u)
        return L0("Could not find one or more icon(s)", s.value, r.value);
    }, {
      immediate: !0
    });
    var c = U(function() {
      return l.value ? jr(l.value.abstract[0], {}, a) : null;
    });
    return function() {
      return c.value;
    };
  }
});
j({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var a = n.slots, s = Od.familyPrefix, o = U(function() {
      return ["".concat(s, "-layers")].concat(Zi(t.fixedWidth ? ["".concat(s, "-fw")] : []));
    });
    return function() {
      return Qo("div", {
        class: o.value
      }, a.default ? a.default() : []);
    };
  }
});
j({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(t) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(t) > -1;
      }
    }
  },
  setup: function(t, n) {
    var a = n.attrs, s = Od.familyPrefix, o = U(function() {
      return ys("classes", [].concat(Zi(t.counter ? ["".concat(s, "-layers-counter")] : []), Zi(t.position ? ["".concat(s, "-layers-").concat(t.position)] : [])));
    }), i = U(function() {
      return ys("transform", typeof t.transform == "string" ? So.transform(t.transform) : t.transform);
    }), r = U(function() {
      var c = v0(t.value.toString(), Ut(Ut({}, i.value), o.value)), u = c.abstract;
      return t.counter && (u[0].attributes.class = u[0].attributes.class.replace("fa-layers-text", "")), u[0];
    }), l = U(function() {
      return jr(r.value, {}, a);
    });
    return function() {
      return l.value;
    };
  }
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const N0 = {
  prefix: "fas",
  iconName: "circle-notch",
  icon: [512, 512, [], "f1ce", "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"]
}, R0 = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, P0 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, F0 = P0, Q0 = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
function U0() {
  return {
    colorScheme: {
      light: {
        header: {
          active: {
            background: "rgba(68, 72, 109, 0.12)"
          }
        },
        panel: {
          border: {
            width: "1px"
          }
        },
        content: {
          border: {
            width: "1px"
          }
        }
      },
      dark: {
        header: {
          active: {
            background: "rgba(255, 255, 255, 0.15)"
          }
        },
        panel: {
          border: {
            width: "1px"
          }
        },
        content: {
          border: {
            width: "1px"
          }
        }
      }
    }
  };
}
function G0() {
  return {
    colorScheme: {
      light: {
        background: "transparent",
        checked: {
          background: "var(--p-primary-color)"
        },
        icon: {
          checked: {
            color: "#34343d"
          }
        }
      },
      dark: {
        background: "transparent",
        checked: {
          background: "var(--p-primary-color)"
        },
        icon: {
          checked: {
            color: "#FFFFFF"
          }
        }
      }
    }
  };
}
function Y0() {
  return {
    colorScheme: {
      light: {
        background: "#ECECF9"
      },
      dark: {
        background: "#535763"
      }
    }
  };
}
function j0() {
  return {
    header: {
      background: "transparent !important",
      cell: {
        border: {
          color: "#bfbfbf !important"
        }
      }
    },
    body: {
      cell: {
        background: "transparent !important",
        border: {
          color: "#bfbfbf !important"
        }
      }
    },
    footer: {
      cell: {
        background: "transparent !important"
      }
    },
    dialog: {
      title: {
        font: {
          size: "2.143rem !important"
        }
      }
    },
    row: {
      background: "transparent !important"
    },
    sort: {
      icon: {
        color: "var(--p-primary-color)"
      }
    },
    colorScheme: {
      light: {
        header: {
          background: "#E2E2E2 !important"
        },
        footer: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        header: {
          background: "#32343A!important"
        },
        footer: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function H0() {
  return {
    colorScheme: {
      light: {
        background: "#FFFFFF !important"
      },
      dark: {
        background: "#3C3E46 !important"
      }
    }
  };
}
function V0() {
  return {
    option: {
      selected: {
        background: "var(--p-primary-color)"
      }
    },
    colorScheme: {
      light: {
        background: "transparent",
        border: {
          color: "var(--p-primary-color)"
        }
      },
      dark: {
        background: "#3C3E44"
      }
    }
  };
}
function K0() {
  return {
    colorScheme: {
      light: {
        modal: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        modal: {
          background: "#3E3E3E !important"
        }
      }
    }
  };
}
function W0() {
  return {
    background: "transparent !important",
    border: {
      color: "var(--p-text-color) !important"
    }
  };
}
function z0() {
  return {
    track: {
      size: "6px"
    },
    border: {
      radius: "8px"
    }
  };
}
function $0() {
  return {
    tab: {
      padding: "0.5rem 1.55rem 0.4rem 0",
      margin: "0px 0px -2px 0px",
      border: {
        width: "0px 0px 2px 0px"
      }
    },
    tablist: {
      border: {
        width: 0
      }
    },
    tabpanel: {
      padding: 0
    },
    colorScheme: {
      light: {
        tablist: {
          background: "#E2E2E2 !important"
        },
        tabpanel: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        tablist: {
          background: "#32343A!important"
        },
        tabpanel: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function q0() {
  return {
    colorScheme: {
      light: {
        background: "#FFFFFF"
      },
      dark: {
        background: "#3C3E46"
      }
    }
  };
}
function J0() {
  return {
    padding: "0",
    node: {
      padding: "0"
    },
    colorScheme: {
      light: {
        background: "#FFFFFF"
      },
      dark: {
        background: "#707070"
      }
    }
  };
}
function X0() {
  return {
    primary: {
      color: "#FFFFFF !important"
    },
    success: {
      color: "#FFFFFF !important"
    },
    danger: {
      color: "#FFFFFF !important"
    },
    warning: {
      color: "#FFFFFF !important"
    }
  };
}
function Z0() {
  return {
    title: {
      font: {
        size: "2.1rem !important",
        weight: "500 !important"
      }
    },
    colorScheme: {
      light: {
        background: "#E2E2E2 !important"
      },
      dark: {
        background: "#3E3E3E !important"
      }
    }
  };
}
function ev() {
  return {
    colorScheme: {
      light: {
        content: {
          background: "#E2E2E2 !important"
        }
      },
      dark: {
        content: {
          background: "#32343A!important"
        }
      }
    }
  };
}
function tv() {
  return {
    content: {
      background: "transparent"
    }
  };
}
function nv() {
  return {
    border: {
      color: "rgba(255, 255, 255, 0.05)"
    },
    background: "transparent"
  };
}
function av() {
  return {
    border: {
      color: "transparent !important"
    }
  };
}
function Pd() {
  return Co(Co(sA, qu("default-blue")), {
    semantic: {
      primary: {
        gray: "#54515f",
        blue: "#1c80cf",
        bluegray: "#526a76",
        username: {
          color: "#808080"
        },
        datatable: {
          line: {
            color: "#bfbfbf"
          }
        },
        progress: {
          bar: {
            next: {
              step: "#505259"
            }
          }
        }
      },
      colorScheme: {
        light: {
          body: {
            background: "#ffffff"
          },
          text: {
            color: "#000000"
          },
          textInverse: {
            color: "#FFFFFF"
          },
          navbarIcon: {
            filter: "invert(0%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(100%) contrast(101%)"
          },
          navbarText: {
            color: "#000000"
          },
          patientItem: {
            color: "#EEEEEE"
          },
          cardHome: {
            background: "#E2E2E2 !important"
          },
          image: {
            container: {
              background: "#C6C6C6"
            }
          },
          objectList: {
            background: "#FFFFFF !important"
          },
          inputTextCard: {
            background: "#C6C6C6"
          },
          inputTextSmall: {
            background: "#808080 !important"
          },
          wizObjectListText: {
            color: "#000000"
          },
          clippingPlanesBtn: {
            background: "#F0F0F0"
          },
          sidebar: {
            wiz: {
              background: "#E2E2E2"
            },
            wizItem: {
              background: "#EEEEEE"
            }
          },
          test2BorderColor: "rgba(255, 255, 255, 0.10)"
        },
        dark: {
          body: {
            background: "#28292C"
          },
          text: {
            color: "#FFFFFF"
          },
          textInverse: {
            color: "#000000"
          },
          navbarIcon: {
            filter: "invert(100%) sepia(0%) saturate(1%) hue-rotate(313deg) brightness(107%) contrast(101%)"
          },
          navbarText: {
            color: "#FFFFFF"
          },
          patientItem: {
            color: "#3c3e46"
          },
          cardHome: {
            background: "linear-gradient(180deg, #182B4B 0%, #161924 100%) !important"
          },
          image: {
            container: {
              background: "#535763"
            }
          },
          objectList: {
            background: "#707070 !important"
          },
          inputTextCard: {
            background: "#464646"
          },
          inputTextSmall: {
            background: "#808080 !important"
          },
          wizObjectListText: {
            color: "#B7B7B7"
          },
          clippingPlanesBtn: {
            background: "#FFFFFF"
          },
          sidebar: {
            wiz: {
              background: "#28292C"
            },
            wizItem: {
              background: "#32343A"
            }
          },
          test2BorderColor: "rgba(255, 255, 255, 0.10)"
        }
      }
    },
    components: {
      accordion: U0(),
      button: X0(),
      checkbox: G0(),
      contextmenu: Y0(),
      dialog: Z0(),
      datatable: j0(),
      dataview: ev(),
      divider: tv(),
      fileupload: nv(),
      inputtext: H0(),
      listbox: V0(),
      overlay: K0(),
      select: W0(),
      slider: z0(),
      tabs: $0(),
      textarea: q0(),
      toolbar: av(),
      tree: J0()
    }
  });
}
function sv() {
  return Co(Pd(), {
    semantic: {
      primary: {},
      colorScheme: {
        light: {
          body: {
            background: "#ffffff"
          },
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgTableHeaderBackgroundColor: "#1a3053"
        },
        dark: {
          body: {
            background: "#14305E"
          },
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgTableHeaderBackgroundColor: "#1a3053"
        }
      }
    },
    components: {
      progressbar: {
        colorScheme: {
          light: {
            background: "rgba(255, 255, 255, 0.06)"
          },
          dark: {
            background: "rgba(255, 255, 255, 0.06)"
          }
        }
      }
    }
  });
}
function ov() {
  return Co(Pd(), {
    semantic: {
      primary: {},
      colorScheme: {
        light: {
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgTableHeaderBackgroundColor: "#1a3053"
        },
        dark: {
          rgBorderColor: "rgba(255, 255, 255, 0.10)",
          rgOutlinedButtonBorderColor: "rgba(41, 51, 72, 0.68)",
          rgComponentTextColor: "rgba(255, 255, 255, 0.50)",
          rgComponentBackgroundColor: "rgba(255, 255, 255, 0.06)",
          rgTableHeaderBackgroundColor: "#1a3053"
        }
      }
    },
    components: {}
  });
}
var qo = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, pa, Un, Qa, Cu, iv = (Cu = class extends qo {
  constructor() {
    super();
    de(this, pa);
    de(this, Un);
    de(this, Qa);
    ee(this, Qa, (t) => {
      if (typeof window < "u" && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    L(this, Un) || this.setEventListener(L(this, Qa));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = L(this, Un)) == null || t.call(this), ee(this, Un, void 0));
  }
  setEventListener(t) {
    var n;
    ee(this, Qa, t), (n = L(this, Un)) == null || n.call(this), ee(this, Un, t((a) => {
      typeof a == "boolean" ? this.setFocused(a) : this.onFocus();
    }));
  }
  setFocused(t) {
    L(this, pa) !== t && (ee(this, pa, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof L(this, pa) == "boolean" ? L(this, pa) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, pa = new WeakMap(), Un = new WeakMap(), Qa = new WeakMap(), Cu), Fd = new iv(), rv = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, Xt, ma, wu, lv = (wu = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support the default provider's concrete timer ID, which is
    // infeasible across environments.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    de(this, Xt, rv);
    de(this, ma, !1);
  }
  setTimeoutProvider(e) {
    process.env.NODE_ENV !== "production" && L(this, ma) && e !== L(this, Xt) && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: L(this, Xt), provider: e }
    ), ee(this, Xt, e), process.env.NODE_ENV !== "production" && ee(this, ma, !1);
  }
  setTimeout(e, t) {
    return process.env.NODE_ENV !== "production" && ee(this, ma, !0), L(this, Xt).setTimeout(e, t);
  }
  clearTimeout(e) {
    L(this, Xt).clearTimeout(e);
  }
  setInterval(e, t) {
    return process.env.NODE_ENV !== "production" && ee(this, ma, !0), L(this, Xt).setInterval(e, t);
  }
  clearInterval(e) {
    L(this, Xt).clearInterval(e);
  }
}, Xt = new WeakMap(), ma = new WeakMap(), wu), er = new lv();
function cv(e) {
  setTimeout(e, 0);
}
var Qd = typeof window > "u" || "Deno" in globalThis;
function Ft() {
}
function uv(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function dv(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function fv(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function tr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pv(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nc(e, t) {
  const {
    type: n = "all",
    exact: a,
    fetchStatus: s,
    predicate: o,
    queryKey: i,
    stale: r
  } = e;
  if (i) {
    if (a) {
      if (t.queryHash !== Hr(i, t.options))
        return !1;
    } else if (!Ds(t.queryKey, i))
      return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof r == "boolean" && t.isStale() !== r || s && s !== t.state.fetchStatus || o && !o(t));
}
function ac(e, t) {
  const { exact: n, status: a, predicate: s, mutationKey: o } = e;
  if (o) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ss(t.options.mutationKey) !== Ss(o))
        return !1;
    } else if (!Ds(t.options.mutationKey, o))
      return !1;
  }
  return !(a && t.state.status !== a || s && !s(t));
}
function Hr(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ss)(e);
}
function Ss(e) {
  return JSON.stringify(
    e,
    (t, n) => ar(n) ? Object.keys(n).sort().reduce((a, s) => (a[s] = n[s], a), {}) : n
  );
}
function Ds(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((n) => Ds(e[n], t[n])) : !1;
}
var mv = Object.prototype.hasOwnProperty;
function nr(e, t, n = 0) {
  if (e === t)
    return e;
  if (n > 500) return t;
  const a = sc(e) && sc(t);
  if (!a && !(ar(e) && ar(t))) return t;
  const o = (a ? e : Object.keys(e)).length, i = a ? t : Object.keys(t), r = i.length, l = a ? new Array(r) : {};
  let c = 0;
  for (let u = 0; u < r; u++) {
    const d = a ? u : i[u], m = e[d], g = t[d];
    if (m === g) {
      l[d] = m, (a ? u < o : mv.call(e, d)) && c++;
      continue;
    }
    if (m === null || g === null || typeof m != "object" || typeof g != "object") {
      l[d] = g;
      continue;
    }
    const h = nr(m, g, n + 1);
    l[d] = h, h === m && c++;
  }
  return o === r && c === o ? e : l;
}
function sc(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function ar(e) {
  if (!oc(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!oc(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function oc(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Av(e) {
  return new Promise((t) => {
    er.setTimeout(t, e);
  });
}
function gv(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return nr(e, t);
      } catch (a) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${a}`
        ), a;
      }
    return nr(e, t);
  }
  return t;
}
function hv(e, t, n = 0) {
  const a = [...e, t];
  return n && a.length > n ? a.slice(1) : a;
}
function vv(e, t, n = 0) {
  const a = [t, ...e];
  return n && a.length > n ? a.slice(0, -1) : a;
}
var To = /* @__PURE__ */ Symbol();
function Ud(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === To && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === To ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function yv(e, t, n) {
  let a = !1, s;
  return Object.defineProperty(e, "signal", {
    enumerable: !0,
    get: () => (s ?? (s = t()), a || (a = !0, s.aborted ? n() : s.addEventListener("abort", n, { once: !0 })), s)
  }), e;
}
var Gd = /* @__PURE__ */ (() => {
  let e = () => Qd;
  return {
    /**
     * Returns whether the current runtime should be treated as a server environment.
     */
    isServer() {
      return e();
    },
    /**
     * Overrides the server check globally.
     */
    setIsServer(t) {
      e = t;
    }
  };
})();
function bv() {
  let e, t;
  const n = new Promise((s, o) => {
    e = s, t = o;
  });
  n.status = "pending", n.catch(() => {
  });
  function a(s) {
    Object.assign(n, s), delete n.resolve, delete n.reject;
  }
  return n.resolve = (s) => {
    a({
      status: "fulfilled",
      value: s
    }), e(s);
  }, n.reject = (s) => {
    a({
      status: "rejected",
      reason: s
    }), t(s);
  }, n;
}
var xv = cv;
function Ev() {
  let e = [], t = 0, n = (r) => {
    r();
  }, a = (r) => {
    r();
  }, s = xv;
  const o = (r) => {
    t ? e.push(r) : s(() => {
      n(r);
    });
  }, i = () => {
    const r = e;
    e = [], r.length && s(() => {
      a(() => {
        r.forEach((l) => {
          n(l);
        });
      });
    });
  };
  return {
    batch: (r) => {
      let l;
      t++;
      try {
        l = r();
      } finally {
        t--, t || i();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (r) => (...l) => {
      o(() => {
        r(...l);
      });
    },
    schedule: o,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (r) => {
      n = r;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (r) => {
      a = r;
    },
    setScheduler: (r) => {
      s = r;
    }
  };
}
var ut = Ev(), Ua, Gn, Ga, Iu, Cv = (Iu = class extends qo {
  constructor() {
    super();
    de(this, Ua, !0);
    de(this, Gn);
    de(this, Ga);
    ee(this, Ga, (t) => {
      if (typeof window < "u" && window.addEventListener) {
        const n = () => t(!0), a = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", a, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", a);
        };
      }
    });
  }
  onSubscribe() {
    L(this, Gn) || this.setEventListener(L(this, Ga));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = L(this, Gn)) == null || t.call(this), ee(this, Gn, void 0));
  }
  setEventListener(t) {
    var n;
    ee(this, Ga, t), (n = L(this, Gn)) == null || n.call(this), ee(this, Gn, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    L(this, Ua) !== t && (ee(this, Ua, t), this.listeners.forEach((a) => {
      a(t);
    }));
  }
  isOnline() {
    return L(this, Ua);
  }
}, Ua = new WeakMap(), Gn = new WeakMap(), Ga = new WeakMap(), Iu), Ja = new Cv();
function wv(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Yd(e) {
  return (e ?? "online") === "online" ? Ja.isOnline() : !0;
}
var sr = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function jd(e) {
  let t = !1, n = 0, a;
  const s = bv(), o = () => s.status !== "pending", i = (A) => {
    var f;
    if (!o()) {
      const p = new sr(A);
      m(p), (f = e.onCancel) == null || f.call(e, p);
    }
  }, r = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, c = () => Fd.isFocused() && (e.networkMode === "always" || Ja.isOnline()) && e.canRun(), u = () => Yd(e.networkMode) && e.canRun(), d = (A) => {
    o() || (a == null || a(), s.resolve(A));
  }, m = (A) => {
    o() || (a == null || a(), s.reject(A));
  }, g = () => new Promise((A) => {
    var f;
    a = (p) => {
      (o() || c()) && A(p);
    }, (f = e.onPause) == null || f.call(e);
  }).then(() => {
    var A;
    a = void 0, o() || (A = e.onContinue) == null || A.call(e);
  }), h = () => {
    if (o())
      return;
    let A;
    const f = n === 0 ? e.initialPromise : void 0;
    try {
      A = f ?? e.fn();
    } catch (p) {
      A = Promise.reject(p);
    }
    Promise.resolve(A).then(d).catch((p) => {
      var M;
      if (o())
        return;
      const v = e.retry ?? (Gd.isServer() ? 0 : 3), b = e.retryDelay ?? wv, y = typeof b == "function" ? b(n, p) : b, _ = v === !0 || typeof v == "number" && n < v || typeof v == "function" && v(n, p);
      if (t || !_) {
        m(p);
        return;
      }
      n++, (M = e.onFail) == null || M.call(e, n, p), Av(y).then(() => c() ? void 0 : g()).then(() => {
        t ? m(p) : h();
      });
    });
  };
  return {
    promise: s,
    status: () => s.status,
    cancel: i,
    continue: () => (a == null || a(), s),
    cancelRetry: r,
    continueRetry: l,
    canStart: u,
    start: () => (u() ? h() : g().then(h), s)
  };
}
var Aa, Bu, Hd = (Bu = class {
  constructor() {
    de(this, Aa);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), dv(this.gcTime) && ee(this, Aa, er.setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (Gd.isServer() ? 1 / 0 : 300 * 1e3)
    );
  }
  clearGcTimeout() {
    L(this, Aa) !== void 0 && (er.clearTimeout(L(this, Aa)), ee(this, Aa, void 0));
  }
}, Aa = new WeakMap(), Bu);
function Iv(e) {
  return {
    onFetch: (t, n) => {
      var u, d, m, g, h;
      const a = t.options, s = (m = (d = (u = t.fetchOptions) == null ? void 0 : u.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : m.direction, o = ((g = t.state.data) == null ? void 0 : g.pages) || [], i = ((h = t.state.data) == null ? void 0 : h.pageParams) || [];
      let r = { pages: [], pageParams: [] }, l = 0;
      const c = async () => {
        let A = !1;
        const f = (b) => {
          yv(
            b,
            () => t.signal,
            () => A = !0
          );
        }, p = Ud(t.options, t.fetchOptions), v = async (b, y, _) => {
          if (A)
            return Promise.reject(t.signal.reason);
          if (y == null && b.pages.length)
            return Promise.resolve(b);
          const S = (() => {
            const le = {
              client: t.client,
              queryKey: t.queryKey,
              pageParam: y,
              direction: _ ? "backward" : "forward",
              meta: t.options.meta
            };
            return f(le), le;
          })(), Y = await p(S), { maxPages: K } = t.options, Z = _ ? vv : hv;
          return {
            pages: Z(b.pages, Y, K),
            pageParams: Z(b.pageParams, y, K)
          };
        };
        if (s && o.length) {
          const b = s === "backward", y = b ? Bv : ic, _ = {
            pages: o,
            pageParams: i
          }, M = y(a, _);
          r = await v(_, M, b);
        } else {
          const b = e ?? o.length;
          do {
            const y = l === 0 ? i[0] ?? a.initialPageParam : ic(a, r);
            if (l > 0 && y == null)
              break;
            r = await v(r, y), l++;
          } while (l < b);
        }
        return r;
      };
      t.options.persister ? t.fetchFn = () => {
        var A, f;
        return (f = (A = t.options).persister) == null ? void 0 : f.call(
          A,
          c,
          {
            client: t.client,
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = c;
    }
  };
}
function ic(e, { pages: t, pageParams: n }) {
  const a = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[a],
    t,
    n[a],
    n
  ) : void 0;
}
function Bv(e, { pages: t, pageParams: n }) {
  var a;
  return t.length > 0 ? (a = e.getPreviousPageParam) == null ? void 0 : a.call(e, t[0], t, n[0], n) : void 0;
}
var Ya, ga, ja, Dt, ha, ze, Gs, va, bt, Vd, bn, ku, kv = (ku = class extends Hd {
  constructor(t) {
    super();
    de(this, bt);
    de(this, Ya);
    de(this, ga);
    de(this, ja);
    de(this, Dt);
    de(this, ha);
    de(this, ze);
    de(this, Gs);
    de(this, va);
    ee(this, va, !1), ee(this, Gs, t.defaultOptions), this.setOptions(t.options), this.observers = [], ee(this, ha, t.client), ee(this, Dt, L(this, ha).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, ee(this, ga, lc(this.options)), this.state = t.state ?? L(this, ga), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get queryType() {
    return L(this, Ya);
  }
  get promise() {
    var t;
    return (t = L(this, ze)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    if (this.options = { ...L(this, Gs), ...t }, t != null && t._type && ee(this, Ya, t._type), this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
      const n = lc(this.options);
      n.data !== void 0 && (this.setState(
        rc(n.data, n.dataUpdatedAt)
      ), ee(this, ga, n));
    }
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && L(this, Dt).remove(this);
  }
  setData(t, n) {
    const a = gv(this.state.data, t, this.options);
    return et(this, bt, bn).call(this, {
      data: a,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), a;
  }
  setState(t) {
    et(this, bt, bn).call(this, { type: "setState", state: t });
  }
  cancel(t) {
    var a, s;
    const n = (a = L(this, ze)) == null ? void 0 : a.promise;
    return (s = L(this, ze)) == null || s.cancel(t), n ? n.then(Ft).catch(Ft) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  get resetState() {
    return L(this, ga);
  }
  reset() {
    this.destroy(), this.setState(this.resetState);
  }
  isActive() {
    return this.observers.some(
      (t) => pv(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === To || !this.isFetched();
  }
  isFetched() {
    return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => tr(t.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(t = 0) {
    return this.state.data === void 0 ? !0 : t === "static" ? !1 : this.state.isInvalidated ? !0 : !fv(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((a) => a.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = L(this, ze)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((a) => a.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = L(this, ze)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), L(this, Dt).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (L(this, ze) && (L(this, va) || et(this, bt, Vd).call(this) ? L(this, ze).cancel({ revert: !0 }) : L(this, ze).cancelRetry()), this.scheduleGc()), L(this, Dt).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || et(this, bt, bn).call(this, { type: "invalidate" });
  }
  async fetch(t, n) {
    var c, u, d, m, g, h, A, f, p, v, b;
    if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
    // re-start the fetch; there is a chance that the query is still in a
    // pending state when that happens
    ((c = L(this, ze)) == null ? void 0 : c.status()) !== "rejected") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (L(this, ze))
        return L(this, ze).continueRetry(), L(this, ze).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const y = this.observers.find((_) => _.options.queryFn);
      y && this.setOptions(y.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const a = new AbortController(), s = (y) => {
      Object.defineProperty(y, "signal", {
        enumerable: !0,
        get: () => (ee(this, va, !0), a.signal)
      });
    }, o = () => {
      const y = Ud(this.options, n), M = (() => {
        const S = {
          client: L(this, ha),
          queryKey: this.queryKey,
          meta: this.meta
        };
        return s(S), S;
      })();
      return ee(this, va, !1), this.options.persister ? this.options.persister(
        y,
        M,
        this
      ) : y(M);
    }, r = (() => {
      const y = {
        fetchOptions: n,
        options: this.options,
        queryKey: this.queryKey,
        client: L(this, ha),
        state: this.state,
        fetchFn: o
      };
      return s(y), y;
    })(), l = L(this, Ya) === "infinite" ? Iv(
      this.options.pages
    ) : this.options.behavior;
    l == null || l.onFetch(r, this), ee(this, ja, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = r.fetchOptions) == null ? void 0 : u.meta)) && et(this, bt, bn).call(this, { type: "fetch", meta: (d = r.fetchOptions) == null ? void 0 : d.meta }), ee(this, ze, jd({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: r.fetchFn,
      onCancel: (y) => {
        y instanceof sr && y.revert && this.setState({
          ...L(this, ja),
          fetchStatus: "idle"
        }), a.abort();
      },
      onFail: (y, _) => {
        et(this, bt, bn).call(this, { type: "failed", failureCount: y, error: _ });
      },
      onPause: () => {
        et(this, bt, bn).call(this, { type: "pause" });
      },
      onContinue: () => {
        et(this, bt, bn).call(this, { type: "continue" });
      },
      retry: r.options.retry,
      retryDelay: r.options.retryDelay,
      networkMode: r.options.networkMode,
      canRun: () => !0
    }));
    try {
      const y = await L(this, ze).start();
      if (y === void 0)
        throw process.env.NODE_ENV !== "production" && console.error(
          `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
        ), new Error(`${this.queryHash} data is undefined`);
      return this.setData(y), (g = (m = L(this, Dt).config).onSuccess) == null || g.call(m, y, this), (A = (h = L(this, Dt).config).onSettled) == null || A.call(
        h,
        y,
        this.state.error,
        this
      ), y;
    } catch (y) {
      if (y instanceof sr) {
        if (y.silent)
          return L(this, ze).promise;
        if (y.revert) {
          if (this.state.data === void 0)
            throw y;
          return this.state.data;
        }
      }
      throw et(this, bt, bn).call(this, {
        type: "error",
        error: y
      }), (p = (f = L(this, Dt).config).onError) == null || p.call(
        f,
        y,
        this
      ), (b = (v = L(this, Dt).config).onSettled) == null || b.call(
        v,
        this.state.data,
        y,
        this
      ), y;
    } finally {
      this.scheduleGc();
    }
  }
}, Ya = new WeakMap(), ga = new WeakMap(), ja = new WeakMap(), Dt = new WeakMap(), ha = new WeakMap(), ze = new WeakMap(), Gs = new WeakMap(), va = new WeakMap(), bt = new WeakSet(), Vd = function() {
  return this.state.fetchStatus === "paused" && this.state.status === "pending";
}, bn = function(t) {
  const n = (a) => {
    switch (t.type) {
      case "failed":
        return {
          ...a,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...a,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...a,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...a,
          ..._v(a.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        const s = {
          ...a,
          ...rc(t.data, t.dataUpdatedAt),
          dataUpdateCount: a.dataUpdateCount + 1,
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
        return ee(this, ja, t.manual ? s : void 0), s;
      case "error":
        const o = t.error;
        return {
          ...a,
          error: o,
          errorUpdateCount: a.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: a.fetchFailureCount + 1,
          fetchFailureReason: o,
          fetchStatus: "idle",
          status: "error",
          // flag existing data as invalidated if we get a background error
          // note that "no data" always means stale so we can set unconditionally here
          isInvalidated: !0
        };
      case "invalidate":
        return {
          ...a,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...a,
          ...t.state
        };
    }
  };
  this.state = n(this.state), ut.batch(() => {
    this.observers.forEach((a) => {
      a.onQueryUpdate();
    }), L(this, Dt).notify({ query: this, type: "updated", action: t });
  });
}, ku);
function _v(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Yd(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function rc(e, t) {
  return {
    data: e,
    dataUpdatedAt: t ?? Date.now(),
    error: null,
    isInvalidated: !1,
    status: "success"
  };
}
function lc(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, a = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? a ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Ys, Zt, it, ya, en, Fn, _u, Sv = (_u = class extends Hd {
  constructor(t) {
    super();
    de(this, en);
    de(this, Ys);
    de(this, Zt);
    de(this, it);
    de(this, ya);
    ee(this, Ys, t.client), this.mutationId = t.mutationId, ee(this, it, t.mutationCache), ee(this, Zt, []), this.state = t.state || Dv(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    L(this, Zt).includes(t) || (L(this, Zt).push(t), this.clearGcTimeout(), L(this, it).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    ee(this, Zt, L(this, Zt).filter((n) => n !== t)), this.scheduleGc(), L(this, it).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    L(this, Zt).length || (this.state.status === "pending" ? this.scheduleGc() : L(this, it).remove(this));
  }
  continue() {
    var t;
    return ((t = L(this, ya)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var i, r, l, c, u, d, m, g, h, A, f, p, v, b, y, _, M, S;
    const n = () => {
      et(this, en, Fn).call(this, { type: "continue" });
    }, a = {
      client: L(this, Ys),
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    ee(this, ya, jd({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t, a) : Promise.reject(new Error("No mutationFn found")),
      onFail: (Y, K) => {
        et(this, en, Fn).call(this, { type: "failed", failureCount: Y, error: K });
      },
      onPause: () => {
        et(this, en, Fn).call(this, { type: "pause" });
      },
      onContinue: n,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => L(this, it).canRun(this)
    }));
    const s = this.state.status === "pending", o = !L(this, ya).canStart();
    try {
      if (s)
        n();
      else {
        et(this, en, Fn).call(this, { type: "pending", variables: t, isPaused: o }), L(this, it).config.onMutate && await L(this, it).config.onMutate(
          t,
          this,
          a
        );
        const K = await ((r = (i = this.options).onMutate) == null ? void 0 : r.call(
          i,
          t,
          a
        ));
        K !== this.state.context && et(this, en, Fn).call(this, {
          type: "pending",
          context: K,
          variables: t,
          isPaused: o
        });
      }
      const Y = await L(this, ya).start();
      return await ((c = (l = L(this, it).config).onSuccess) == null ? void 0 : c.call(
        l,
        Y,
        t,
        this.state.context,
        this,
        a
      )), await ((d = (u = this.options).onSuccess) == null ? void 0 : d.call(
        u,
        Y,
        t,
        this.state.context,
        a
      )), await ((g = (m = L(this, it).config).onSettled) == null ? void 0 : g.call(
        m,
        Y,
        null,
        this.state.variables,
        this.state.context,
        this,
        a
      )), await ((A = (h = this.options).onSettled) == null ? void 0 : A.call(
        h,
        Y,
        null,
        t,
        this.state.context,
        a
      )), et(this, en, Fn).call(this, { type: "success", data: Y }), Y;
    } catch (Y) {
      try {
        await ((p = (f = L(this, it).config).onError) == null ? void 0 : p.call(
          f,
          Y,
          t,
          this.state.context,
          this,
          a
        ));
      } catch (K) {
        Promise.reject(K);
      }
      try {
        await ((b = (v = this.options).onError) == null ? void 0 : b.call(
          v,
          Y,
          t,
          this.state.context,
          a
        ));
      } catch (K) {
        Promise.reject(K);
      }
      try {
        await ((_ = (y = L(this, it).config).onSettled) == null ? void 0 : _.call(
          y,
          void 0,
          Y,
          this.state.variables,
          this.state.context,
          this,
          a
        ));
      } catch (K) {
        Promise.reject(K);
      }
      try {
        await ((S = (M = this.options).onSettled) == null ? void 0 : S.call(
          M,
          void 0,
          Y,
          t,
          this.state.context,
          a
        ));
      } catch (K) {
        Promise.reject(K);
      }
      throw et(this, en, Fn).call(this, { type: "error", error: Y }), Y;
    } finally {
      L(this, it).runNext(this);
    }
  }
}, Ys = new WeakMap(), Zt = new WeakMap(), it = new WeakMap(), ya = new WeakMap(), en = new WeakSet(), Fn = function(t) {
  const n = (a) => {
    switch (t.type) {
      case "failed":
        return {
          ...a,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...a,
          isPaused: !0
        };
      case "continue":
        return {
          ...a,
          isPaused: !1
        };
      case "pending":
        return {
          ...a,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...a,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...a,
          data: void 0,
          error: t.error,
          failureCount: a.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), ut.batch(() => {
    L(this, Zt).forEach((a) => {
      a.onMutationUpdate(t);
    }), L(this, it).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, _u);
function Dv() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var En, Qt, js, Su, Kd = (Su = class extends qo {
  constructor(n = {}) {
    super();
    de(this, En);
    de(this, Qt);
    de(this, js);
    this.config = n, ee(this, En, /* @__PURE__ */ new Set()), ee(this, Qt, /* @__PURE__ */ new Map()), ee(this, js, 0);
  }
  build(n, a, s) {
    const o = new Sv({
      client: n,
      mutationCache: this,
      mutationId: ++Js(this, js)._,
      options: n.defaultMutationOptions(a),
      state: s
    });
    return this.add(o), o;
  }
  add(n) {
    L(this, En).add(n);
    const a = to(n);
    if (typeof a == "string") {
      const s = L(this, Qt).get(a);
      s ? s.push(n) : L(this, Qt).set(a, [n]);
    }
    this.notify({ type: "added", mutation: n });
  }
  remove(n) {
    if (L(this, En).delete(n)) {
      const a = to(n);
      if (typeof a == "string") {
        const s = L(this, Qt).get(a);
        if (s)
          if (s.length > 1) {
            const o = s.indexOf(n);
            o !== -1 && s.splice(o, 1);
          } else s[0] === n && L(this, Qt).delete(a);
      }
    }
    this.notify({ type: "removed", mutation: n });
  }
  canRun(n) {
    const a = to(n);
    if (typeof a == "string") {
      const s = L(this, Qt).get(a), o = s == null ? void 0 : s.find(
        (i) => i.state.status === "pending"
      );
      return !o || o === n;
    } else
      return !0;
  }
  runNext(n) {
    var s;
    const a = to(n);
    if (typeof a == "string") {
      const o = (s = L(this, Qt).get(a)) == null ? void 0 : s.find((i) => i !== n && i.state.isPaused);
      return (o == null ? void 0 : o.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    ut.batch(() => {
      L(this, En).forEach((n) => {
        this.notify({ type: "removed", mutation: n });
      }), L(this, En).clear(), L(this, Qt).clear();
    });
  }
  getAll() {
    return Array.from(L(this, En));
  }
  find(n) {
    const a = { exact: !0, ...n };
    return this.getAll().find(
      (s) => ac(a, s)
    );
  }
  findAll(n = {}) {
    return this.getAll().filter((a) => ac(n, a));
  }
  notify(n) {
    ut.batch(() => {
      this.listeners.forEach((a) => {
        a(n);
      });
    });
  }
  resumePausedMutations() {
    const n = this.getAll().filter((a) => a.state.isPaused);
    return ut.batch(
      () => Promise.all(
        n.map((a) => a.continue().catch(Ft))
      )
    );
  }
}, En = new WeakMap(), Qt = new WeakMap(), js = new WeakMap(), Su);
function to(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
var tn, Du, Wd = (Du = class extends qo {
  constructor(n = {}) {
    super();
    de(this, tn);
    this.config = n, ee(this, tn, /* @__PURE__ */ new Map());
  }
  build(n, a, s) {
    const o = a.queryKey, i = a.queryHash ?? Hr(o, a);
    let r = this.get(i);
    return r || (r = new kv({
      client: n,
      queryKey: o,
      queryHash: i,
      options: n.defaultQueryOptions(a),
      state: s,
      defaultOptions: n.getQueryDefaults(o)
    }), this.add(r)), r;
  }
  add(n) {
    L(this, tn).has(n.queryHash) || (L(this, tn).set(n.queryHash, n), this.notify({
      type: "added",
      query: n
    }));
  }
  remove(n) {
    const a = L(this, tn).get(n.queryHash);
    a && (n.destroy(), a === n && L(this, tn).delete(n.queryHash), this.notify({ type: "removed", query: n }));
  }
  clear() {
    ut.batch(() => {
      this.getAll().forEach((n) => {
        this.remove(n);
      });
    });
  }
  get(n) {
    return L(this, tn).get(n);
  }
  getAll() {
    return [...L(this, tn).values()];
  }
  find(n) {
    const a = { exact: !0, ...n };
    return this.getAll().find(
      (s) => nc(a, s)
    );
  }
  findAll(n = {}) {
    const a = this.getAll();
    return Object.keys(n).length > 0 ? a.filter((s) => nc(n, s)) : a;
  }
  notify(n) {
    ut.batch(() => {
      this.listeners.forEach((a) => {
        a(n);
      });
    });
  }
  onFocus() {
    ut.batch(() => {
      this.getAll().forEach((n) => {
        n.onFocus();
      });
    });
  }
  onOnline() {
    ut.batch(() => {
      this.getAll().forEach((n) => {
        n.onOnline();
      });
    });
  }
}, tn = new WeakMap(), Du), Fe, Yn, jn, Ha, Va, Hn, Ka, Wa, Tu, Tv = (Tu = class {
  constructor(t = {}) {
    de(this, Fe);
    de(this, Yn);
    de(this, jn);
    de(this, Ha);
    de(this, Va);
    de(this, Hn);
    de(this, Ka);
    de(this, Wa);
    ee(this, Fe, t.queryCache || new Wd()), ee(this, Yn, t.mutationCache || new Kd()), ee(this, jn, t.defaultOptions || {}), ee(this, Ha, /* @__PURE__ */ new Map()), ee(this, Va, /* @__PURE__ */ new Map()), ee(this, Hn, 0);
  }
  mount() {
    Js(this, Hn)._++, L(this, Hn) === 1 && (ee(this, Ka, Fd.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), L(this, Fe).onFocus());
    })), ee(this, Wa, Ja.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), L(this, Fe).onOnline());
    })));
  }
  unmount() {
    var t, n;
    Js(this, Hn)._--, L(this, Hn) === 0 && ((t = L(this, Ka)) == null || t.call(this), ee(this, Ka, void 0), (n = L(this, Wa)) == null || n.call(this), ee(this, Wa, void 0));
  }
  isFetching(t) {
    return L(this, Fe).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return L(this, Yn).findAll({ ...t, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(t) {
    var a;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (a = L(this, Fe).get(n.queryHash)) == null ? void 0 : a.state.data;
  }
  ensureQueryData(t) {
    const n = this.defaultQueryOptions(t), a = L(this, Fe).build(this, n), s = a.state.data;
    return s === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && a.isStaleByTime(tr(n.staleTime, a)) && this.prefetchQuery(n), Promise.resolve(s));
  }
  getQueriesData(t) {
    return L(this, Fe).findAll(t).map(({ queryKey: n, state: a }) => {
      const s = a.data;
      return [n, s];
    });
  }
  setQueryData(t, n, a) {
    const s = this.defaultQueryOptions({ queryKey: t }), o = L(this, Fe).get(
      s.queryHash
    ), i = o == null ? void 0 : o.state.data, r = uv(n, i);
    if (r !== void 0)
      return L(this, Fe).build(this, s).setData(r, { ...a, manual: !0 });
  }
  setQueriesData(t, n, a) {
    return ut.batch(
      () => L(this, Fe).findAll(t).map(({ queryKey: s }) => [
        s,
        this.setQueryData(s, n, a)
      ])
    );
  }
  getQueryState(t) {
    var a;
    const n = this.defaultQueryOptions({ queryKey: t });
    return (a = L(this, Fe).get(
      n.queryHash
    )) == null ? void 0 : a.state;
  }
  removeQueries(t) {
    const n = L(this, Fe);
    ut.batch(() => {
      n.findAll(t).forEach((a) => {
        n.remove(a);
      });
    });
  }
  resetQueries(t, n) {
    const a = L(this, Fe);
    return ut.batch(() => (a.findAll(t).forEach((s) => {
      s.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...t
      },
      n
    )));
  }
  cancelQueries(t, n = {}) {
    const a = { revert: !0, ...n }, s = ut.batch(
      () => L(this, Fe).findAll(t).map((o) => o.cancel(a))
    );
    return Promise.all(s).then(Ft).catch(Ft);
  }
  invalidateQueries(t, n = {}) {
    return ut.batch(() => (L(this, Fe).findAll(t).forEach((a) => {
      a.invalidate();
    }), (t == null ? void 0 : t.refetchType) === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...t,
        type: (t == null ? void 0 : t.refetchType) ?? (t == null ? void 0 : t.type) ?? "active"
      },
      n
    )));
  }
  refetchQueries(t, n = {}) {
    const a = {
      ...n,
      cancelRefetch: n.cancelRefetch ?? !0
    }, s = ut.batch(
      () => L(this, Fe).findAll(t).filter((o) => !o.isDisabled() && !o.isStatic()).map((o) => {
        let i = o.fetch(void 0, a);
        return a.throwOnError || (i = i.catch(Ft)), o.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(s).then(Ft);
  }
  fetchQuery(t) {
    const n = this.defaultQueryOptions(t);
    n.retry === void 0 && (n.retry = !1);
    const a = L(this, Fe).build(this, n);
    return a.isStaleByTime(
      tr(n.staleTime, a)
    ) ? a.fetch(n) : Promise.resolve(a.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(Ft).catch(Ft);
  }
  fetchInfiniteQuery(t) {
    return t._type = "infinite", this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(Ft).catch(Ft);
  }
  ensureInfiniteQueryData(t) {
    return t._type = "infinite", this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Ja.isOnline() ? L(this, Yn).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return L(this, Fe);
  }
  getMutationCache() {
    return L(this, Yn);
  }
  getDefaultOptions() {
    return L(this, jn);
  }
  setDefaultOptions(t) {
    ee(this, jn, t);
  }
  setQueryDefaults(t, n) {
    L(this, Ha).set(Ss(t), {
      queryKey: t,
      defaultOptions: n
    });
  }
  getQueryDefaults(t) {
    const n = [...L(this, Ha).values()], a = {};
    return n.forEach((s) => {
      Ds(t, s.queryKey) && Object.assign(a, s.defaultOptions);
    }), a;
  }
  setMutationDefaults(t, n) {
    L(this, Va).set(Ss(t), {
      mutationKey: t,
      defaultOptions: n
    });
  }
  getMutationDefaults(t) {
    const n = [...L(this, Va).values()], a = {};
    return n.forEach((s) => {
      Ds(t, s.mutationKey) && Object.assign(a, s.defaultOptions);
    }), a;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const n = {
      ...L(this, jn).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return n.queryHash || (n.queryHash = Hr(
      n.queryKey,
      n
    )), n.refetchOnReconnect === void 0 && (n.refetchOnReconnect = n.networkMode !== "always"), n.throwOnError === void 0 && (n.throwOnError = !!n.suspense), !n.networkMode && n.persister && (n.networkMode = "offlineFirst"), n.queryFn === To && (n.enabled = !1), n;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...L(this, jn).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    L(this, Fe).clear(), L(this, Yn).clear();
  }
}, Fe = new WeakMap(), Yn = new WeakMap(), jn = new WeakMap(), Ha = new WeakMap(), Va = new WeakMap(), Hn = new WeakMap(), Ka = new WeakMap(), Wa = new WeakMap(), Tu), Mv = "VUE_QUERY_CLIENT";
function Lv(e) {
  const t = e ? `:${e}` : "";
  return `${Mv}${t}`;
}
function or(e, t, n = "", a = 0) {
  if (t) {
    const s = t(e, n, a);
    if (s === void 0 && Mu(e) || s !== void 0)
      return s;
  }
  if (Array.isArray(e))
    return e.map(
      (s, o) => or(s, t, String(o), a + 1)
    );
  if (typeof e == "object" && Nv(e)) {
    const s = Object.entries(e).map(([o, i]) => [
      o,
      or(i, t, o, a + 1)
    ]);
    return Object.fromEntries(s);
  }
  return e;
}
function Ov(e, t) {
  return or(e, t);
}
function ue(e, t = !1) {
  return Ov(e, (n, a, s) => {
    if (s === 1 && a === "queryKey")
      return ue(n, !0);
    if (t && Rv(n))
      return ue(n(), t);
    if (Mu(n))
      return ue(k(n), t);
  });
}
function Nv(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function Rv(e) {
  return typeof e == "function";
}
var Pv = class extends Wd {
  find(e) {
    return super.find(ue(e));
  }
  findAll(e = {}) {
    return super.findAll(ue(e));
  }
}, Fv = class extends Kd {
  find(e) {
    return super.find(ue(e));
  }
  findAll(e = {}) {
    return super.findAll(ue(e));
  }
}, zd = class extends Tv {
  constructor(e = {}) {
    const t = {
      defaultOptions: e.defaultOptions,
      queryCache: e.queryCache || new Pv(),
      mutationCache: e.mutationCache || new Fv()
    };
    super(t), this.isRestoring = T(!1);
  }
  isFetching(e = {}) {
    return super.isFetching(ue(e));
  }
  isMutating(e = {}) {
    return super.isMutating(ue(e));
  }
  getQueryData(e) {
    return super.getQueryData(ue(e));
  }
  ensureQueryData(e) {
    return super.ensureQueryData(ue(e));
  }
  getQueriesData(e) {
    return super.getQueriesData(ue(e));
  }
  setQueryData(e, t, n = {}) {
    return super.setQueryData(
      ue(e),
      t,
      ue(n)
    );
  }
  setQueriesData(e, t, n = {}) {
    return super.setQueriesData(
      ue(e),
      t,
      ue(n)
    );
  }
  getQueryState(e) {
    return super.getQueryState(ue(e));
  }
  removeQueries(e = {}) {
    return super.removeQueries(ue(e));
  }
  resetQueries(e = {}, t = {}) {
    return super.resetQueries(ue(e), ue(t));
  }
  cancelQueries(e = {}, t = {}) {
    return super.cancelQueries(ue(e), ue(t));
  }
  invalidateQueries(e = {}, t = {}) {
    const n = ue(
      e
    ), a = ue(
      t
    );
    if (super.invalidateQueries(
      { ...n, refetchType: "none" },
      a
    ), n.refetchType === "none")
      return Promise.resolve();
    const s = {
      ...n,
      type: n.refetchType ?? n.type ?? "active"
    };
    return Tn().then(() => super.refetchQueries(s, a));
  }
  refetchQueries(e = {}, t = {}) {
    return super.refetchQueries(
      ue(e),
      ue(t)
    );
  }
  fetchQuery(e) {
    return super.fetchQuery(ue(e));
  }
  prefetchQuery(e) {
    return super.prefetchQuery(ue(e));
  }
  fetchInfiniteQuery(e) {
    return super.fetchInfiniteQuery(ue(e));
  }
  prefetchInfiniteQuery(e) {
    return super.prefetchInfiniteQuery(ue(e));
  }
  setDefaultOptions(e) {
    super.setDefaultOptions(ue(e));
  }
  setQueryDefaults(e, t) {
    super.setQueryDefaults(ue(e), ue(t));
  }
  getQueryDefaults(e) {
    return super.getQueryDefaults(ue(e));
  }
  setMutationDefaults(e, t) {
    super.setMutationDefaults(
      ue(e),
      ue(t)
    );
  }
  getMutationDefaults(e) {
    return super.getMutationDefaults(ue(e));
  }
};
function Qv() {
  return $d().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $d() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Uv = typeof Proxy == "function", Gv = "devtools-plugin:setup", Yv = "plugin:settings:set";
let Da, ir;
function jv() {
  var e;
  return Da !== void 0 || (typeof window < "u" && window.performance ? (Da = !0, ir = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Da = !0, ir = globalThis.perf_hooks.performance) : Da = !1), Da;
}
function Hv() {
  return jv() ? ir.now() : Date.now();
}
class Vv {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const a = {};
    if (t.settings)
      for (const i in t.settings) {
        const r = t.settings[i];
        a[i] = r.defaultValue;
      }
    const s = `__vue-devtools-plugin-settings__${t.id}`;
    let o = Object.assign({}, a);
    try {
      const i = localStorage.getItem(s), r = JSON.parse(i);
      Object.assign(o, r);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return o;
      },
      setSettings(i) {
        try {
          localStorage.setItem(s, JSON.stringify(i));
        } catch {
        }
        o = i;
      },
      now() {
        return Hv();
      }
    }, n && n.on(Yv, (i, r) => {
      i === this.plugin.id && this.fallbacks.setSettings(r);
    }), this.proxiedOn = new Proxy({}, {
      get: (i, r) => this.target ? this.target.on[r] : (...l) => {
        this.onQueue.push({
          method: r,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (i, r) => this.target ? this.target[r] : r === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(r) ? (...l) => (this.targetQueue.push({
        method: r,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[r](...l)) : (...l) => new Promise((c) => {
        this.targetQueue.push({
          method: r,
          args: l,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function Kv(e, t) {
  const n = e, a = $d(), s = Qv(), o = Uv && n.enableEarlyProxy;
  if (s && (a.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !o))
    s.emit(Gv, e, t);
  else {
    const i = o ? new Vv(n, s) : null;
    (a.__VUE_DEVTOOLS_PLUGINS__ = a.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: i
    }), i && t(i.proxiedTarget);
  }
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const qd = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, Wv = Object.keys(qd).join("|"), zv = new RegExp(Wv, "g");
function $v(e) {
  return e.replace(zv, (t) => qd[t]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const gt = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function qv(e, t, n) {
  var a;
  if (n = n || {}, n.threshold = (a = n.threshold) != null ? a : gt.MATCHES, !n.accessors) {
    const i = cc(e, t, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: e,
      rank: i,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: i >= n.threshold
    };
  }
  const s = ey(e, n.accessors), o = {
    rankedValue: e,
    rank: gt.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let i = 0; i < s.length; i++) {
    const r = s[i];
    let l = cc(r.itemValue, t, n);
    const {
      minRanking: c,
      maxRanking: u,
      threshold: d = n.threshold
    } = r.attributes;
    l < c && l >= gt.MATCHES ? l = c : l > u && (l = u), l = Math.min(l, u), l >= d && l > o.rank && (o.rank = l, o.passed = !0, o.accessorIndex = i, o.accessorThreshold = d, o.rankedValue = r.itemValue);
  }
  return o;
}
function cc(e, t, n) {
  return e = uc(e, n), t = uc(t, n), t.length > e.length ? gt.NO_MATCH : e === t ? gt.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? gt.EQUAL : e.startsWith(t) ? gt.STARTS_WITH : e.includes(` ${t}`) ? gt.WORD_STARTS_WITH : e.includes(t) ? gt.CONTAINS : t.length === 1 ? gt.NO_MATCH : Jv(e).includes(t) ? gt.ACRONYM : Xv(e, t));
}
function Jv(e) {
  let t = "";
  return e.split(" ").forEach((a) => {
    a.split("-").forEach((o) => {
      t += o.substr(0, 1);
    });
  }), t;
}
function Xv(e, t) {
  let n = 0, a = 0;
  function s(l, c, u) {
    for (let d = u, m = c.length; d < m; d++)
      if (c[d] === l)
        return n += 1, d + 1;
    return -1;
  }
  function o(l) {
    const c = 1 / l, u = n / t.length;
    return gt.MATCHES + u * c;
  }
  const i = s(t[0], e, 0);
  if (i < 0)
    return gt.NO_MATCH;
  a = i;
  for (let l = 1, c = t.length; l < c; l++) {
    const u = t[l];
    if (a = s(u, e, a), !(a > -1))
      return gt.NO_MATCH;
  }
  const r = a - i;
  return o(r);
}
function uc(e, t) {
  let {
    keepDiacritics: n
  } = t;
  return e = `${e}`, n || (e = $v(e)), e;
}
function Zv(e, t) {
  let n = t;
  typeof t == "object" && (n = t.accessor);
  const a = n(e);
  return a == null ? [] : Array.isArray(a) ? a : [String(a)];
}
function ey(e, t) {
  const n = [];
  for (let a = 0, s = t.length; a < s; a++) {
    const o = t[a], i = ty(o), r = Zv(e, o);
    for (let l = 0, c = r.length; l < c; l++)
      n.push({
        itemValue: r[l],
        attributes: i
      });
  }
  return n;
}
const dc = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function ty(e) {
  return typeof e == "function" ? dc : {
    ...dc,
    ...e
  };
}
function da(e) {
  return e.state.fetchStatus === "fetching" ? 0 : e.state.fetchStatus === "paused" ? 4 : e.getObserversCount() ? e.isStale() ? 2 : 1 : 3;
}
function fc(e) {
  const t = da(e);
  return t === 0 ? "fetching" : t === 4 ? "paused" : t === 2 ? "stale" : t === 3 ? "inactive" : "fresh";
}
function ny(e) {
  return da(e) === 2 ? 0 : 16777215;
}
function ay(e) {
  const t = da(e);
  return t === 0 ? 27647 : t === 4 ? 9193963 : t === 2 ? 16757248 : t === 3 ? 4148832 : 33575;
}
var sy = (e, t) => e.queryHash.localeCompare(t.queryHash), Jd = (e, t) => e.state.dataUpdatedAt < t.state.dataUpdatedAt ? 1 : -1, oy = (e, t) => da(e) === da(t) ? Jd(e, t) : da(e) > da(t) ? 1 : -1, xi = {
  "Status > Last Updated": oy,
  "Query Hash": sy,
  "Last Updated": Jd
}, Pn = "vue-query", Ei = "Vue Query";
function iy(e, t) {
  Kv(
    {
      id: Pn,
      label: Ei,
      packageName: "vue-query",
      homepage: "https://tanstack.com/query/latest",
      logo: "https://raw.githubusercontent.com/TanStack/query/main/packages/vue-query/media/vue-query.svg",
      app: e,
      settings: {
        baseSort: {
          type: "choice",
          component: "button-group",
          label: "Sort Cache Entries",
          options: [
            {
              label: "ASC",
              value: 1
            },
            {
              label: "DESC",
              value: -1
            }
          ],
          defaultValue: 1
        },
        sortFn: {
          type: "choice",
          label: "Sort Function",
          options: Object.keys(xi).map((n) => ({
            label: n,
            value: n
          })),
          defaultValue: Object.keys(xi)[0]
        },
        onlineMode: {
          type: "choice",
          component: "button-group",
          label: "Online mode",
          options: [
            {
              label: "Online",
              value: 1
            },
            {
              label: "Offline",
              value: 0
            }
          ],
          defaultValue: 1
        }
      }
    },
    (n) => {
      const a = n.getSettings();
      Ja.setOnline(!!a.onlineMode.valueOf());
      const s = t.getQueryCache();
      n.addInspector({
        id: Pn,
        label: Ei,
        icon: "api",
        nodeActions: [
          {
            icon: "file_download",
            tooltip: "Refetch",
            action: (o) => {
              var i;
              (i = s.get(o)) == null || i.fetch();
            }
          },
          {
            icon: "alarm",
            tooltip: "Invalidate",
            action: (o) => {
              const i = s.get(o);
              t.invalidateQueries({
                queryKey: i.queryKey,
                exact: !0
              });
            }
          },
          {
            icon: "settings_backup_restore",
            tooltip: "Reset",
            action: (o) => {
              var i;
              (i = s.get(o)) == null || i.reset();
            }
          },
          {
            icon: "delete",
            tooltip: "Remove",
            action: (o) => {
              const i = s.get(o);
              s.remove(i);
            }
          },
          {
            icon: "hourglass_empty",
            tooltip: "Force loading",
            action: (o) => {
              s.get(o).setState({
                data: void 0,
                status: "pending"
              });
            }
          },
          {
            icon: "error_outline",
            tooltip: "Force error",
            action: (o) => {
              s.get(o).setState({
                data: void 0,
                status: "error",
                error: new Error("Unknown error from devtools")
              });
            }
          }
        ]
      }), n.addTimelineLayer({
        id: Pn,
        label: Ei,
        color: 16767308
      }), s.subscribe((o) => {
        n.sendInspectorTree(Pn), n.sendInspectorState(Pn), [
          "added",
          "removed",
          "updated"
        ].includes(o.type) && n.addTimelineEvent({
          layerId: Pn,
          event: {
            title: o.type,
            subtitle: o.query.queryHash,
            time: n.now(),
            data: {
              queryHash: o.query.queryHash,
              ...o
            }
          }
        });
      }), n.on.setPluginSettings((o) => {
        o.key === "onlineMode" && Ja.setOnline(!!o.newValue);
      }), n.on.getInspectorTree((o) => {
        if (o.inspectorId === Pn) {
          const i = s.getAll(), r = n.getSettings(), u = (o.filter ? i.filter(
            (d) => qv(d.queryHash, o.filter).passed
          ) : [...i]).sort(
            (d, m) => xi[r.sortFn](d, m) * r.baseSort
          ).map((d) => {
            const m = fc(d);
            return {
              id: d.queryHash,
              label: d.queryHash,
              tags: [
                {
                  label: `${m} [${d.getObserversCount()}]`,
                  textColor: ny(d),
                  backgroundColor: ay(d)
                }
              ]
            };
          });
          o.rootNodes = u;
        }
      }), n.on.getInspectorState((o) => {
        if (o.inspectorId === Pn) {
          const i = s.get(o.nodeId);
          if (!i)
            return;
          o.state = {
            " Query Details": [
              {
                key: "Query key",
                value: i.queryHash
              },
              {
                key: "Query status",
                value: fc(i)
              },
              {
                key: "Observers",
                value: i.getObserversCount()
              },
              {
                key: "Last Updated",
                value: new Date(i.state.dataUpdatedAt).toLocaleTimeString()
              }
            ],
            "Data Explorer": [
              {
                key: "Data",
                value: i.state.data
              }
            ],
            "Query Explorer": [
              {
                key: "Query",
                value: i
              }
            ]
          };
        }
      });
    }
  );
}
var ry = {
  install: (e, t = {}) => {
    const n = Lv(t.queryClientKey);
    let a;
    if ("queryClient" in t && t.queryClient)
      a = t.queryClient;
    else {
      const i = "queryClientConfig" in t ? t.queryClientConfig : void 0;
      a = new zd(i);
    }
    Qd || a.mount();
    let s = () => {
    };
    if (t.clientPersister) {
      a.isRestoring && (a.isRestoring.value = !0);
      const [i, r] = t.clientPersister(a);
      s = i, r.then(() => {
        var l;
        a.isRestoring && (a.isRestoring.value = !1), (l = t.clientPersisterOnSuccess) == null || l.call(t, a);
      });
    }
    const o = () => {
      a.unmount(), s();
    };
    if (e.onUnmount)
      e.onUnmount(o);
    else {
      const i = e.unmount;
      e.unmount = function() {
        o(), i();
      };
    }
    e.provide(n, a), process.env.NODE_ENV === "development" && t.enableDevtoolsV6Plugin && iy(e, a);
  }
}, Xd = /* @__PURE__ */ ((e) => (e[e.SHIPPING = 0] = "SHIPPING", e[e.BILLING = 1] = "BILLING", e))(Xd || {});
const Jt = new zd(), ly = {
  install(e) {
    e.use(ry, { queryClient: Jt });
  }
};
function Ts(e) {
  return ["user-addresses", e];
}
function Na(e, t) {
  return [...Ts(e), t];
}
function cy(e, t, n) {
  return {
    queryKey: Na(t, n),
    queryFn: async () => {
      const { data: a } = await e.getUserAddressesById(t, n);
      return a;
    },
    staleTime: 1 / 0,
    retry: !1
  };
}
function uy(e, t, n, a = Jt) {
  const s = a.getQueriesData({ queryKey: Ts(e) }), o = /* @__PURE__ */ new Set();
  for (const [i, r] of s) {
    if (!r || !Array.isArray(i) || i.length < 3)
      continue;
    const l = Number(i[2]);
    if (!Number.isFinite(l))
      continue;
    (n === Xd.SHIPPING ? r.shippingList : r.billingList).some((u) => Number(u.id) === Number(t)) && o.add(l);
  }
  return Array.from(o);
}
async function KT(e, t, n, a = Jt) {
  const s = uy(e, t, n, a);
  return s.length > 0 ? (await Promise.all(s.map((o) => a.invalidateQueries({ queryKey: Na(e, o), exact: !0 }))), s) : (await a.invalidateQueries({ queryKey: Ts(e) }), []);
}
function WT(e, t, n) {
  g0.add(N0, Q0, F0, R0), e.component("font-awesome-icon", O0), e.use(Yp, {
    theme: {
      preset: e._component.__name === "RgApp" ? sv() : ov(),
      options: {
        darkModeSelector: ".p-dark"
      }
    }
  }), e.use(El), e._component.__name !== Tr.IMPLANT_PLANNER && e.use(El), e.use(ly), e.use(Ku, { assetPath: (n == null ? void 0 : n.assetPath) ?? "" }), Ag(e), t && Rp(t);
}
function dy(e) {
  return (t) => t.id === e;
}
const no = new Intl.Collator(void 0, { sensitivity: "base" });
function pc(e) {
  const t = [];
  if (!e)
    return t;
  const n = /(\d+(?:\.\d+)?)/g;
  let a = 0, s = null;
  for (; (s = n.exec(e)) !== null; ) {
    s.index > a && t.push({ type: "text", value: e.slice(a, s.index) });
    const o = s[1];
    t.push({ type: "number", value: Number(o), raw: o }), a = s.index + o.length;
  }
  return a < e.length && t.push({ type: "text", value: e.slice(a) }), t;
}
function rr(e, t) {
  if (e === t)
    return 0;
  const n = pc(e), a = pc(t), s = Math.max(n.length, a.length);
  for (let o = 0; o < s; o += 1) {
    const i = n[o], r = a[o];
    if (!i)
      return -1;
    if (!r)
      return 1;
    if (i.type === "number" && r.type === "number") {
      if (i.value !== r.value)
        return i.value - r.value;
      const d = no.compare(i.raw, r.raw);
      if (d !== 0)
        return d;
      continue;
    }
    if (i.type === "text" && r.type === "text") {
      const d = no.compare(i.value, r.value);
      if (d !== 0)
        return d;
      continue;
    }
    const l = i.type === "number" ? i.raw : i.value, c = r.type === "number" ? r.raw : r.value, u = no.compare(l, c);
    if (u !== 0)
      return u;
  }
  return no.compare(e, t);
}
function zt(e) {
  return [...e].sort((t, n) => rr(t.name ?? "", n.name ?? ""));
}
function Ci(e) {
  return [...e].sort((t, n) => {
    const a = rr(t.manufacturer ?? "", n.manufacturer ?? "");
    return a !== 0 ? a : rr(t.name ?? "", n.name ?? "");
  });
}
async function fy(e, t, n) {
  if (!t.has(e)) {
    const s = await n();
    t.set(e, s.data);
  }
  const a = t.get(e);
  if (a === void 0)
    throw new Error(`Value for key "${e}" not found in cache.`);
  return a;
}
function py(e, t, n) {
  if (!t.has(e)) {
    const s = n();
    t.set(e, s);
  }
  const a = t.get(e);
  if (a === void 0)
    throw new Error(`Value for key "${e}" not found in cache.`);
  return a;
}
function mc(e, t) {
  return `${e}__${t}`;
}
class zT {
  constructor(t, n) {
    ie(this, "api");
    ie(this, "cachedResponse");
    ie(this, "objectCache", /* @__PURE__ */ new Map());
    ie(this, "objectDepsCache", /* @__PURE__ */ new Map());
    ie(this, "manufacturerNameCache");
    this.api = n, this.cachedResponse = t;
  }
  getManufacturerName(t) {
    return t ? (this.manufacturerNameCache || (this.manufacturerNameCache = new Map(this.cachedResponse.manufacturers.map((n) => [n.id, n.name]))), this.manufacturerNameCache.get(t) ?? "") : "";
  }
  filterByIds(t, n, a) {
    return a ? t : !n || n.length === 0 ? [] : t.filter((s) => n.includes(s.id));
  }
  withManufacturerName(t) {
    return {
      ...t,
      manufacturerName: this.getManufacturerName(t.pId)
    };
  }
  formatNameWithSellingCode(t) {
    const n = t.name ?? "", a = typeof t.sellingCode == "string" ? t.sellingCode.trim() : "";
    return a.length > 0 ? `${n} / ${a}` : n;
  }
  buildListModelByManufacturer(t, n = !0, a = !1) {
    const s = t.map((i) => {
      const r = this.getManufacturerName(i.pId), l = a ? this.formatNameWithSellingCode(i) : i.name ?? "";
      return {
        manufacturer: r,
        name: l,
        item: {
          ...i,
          manufacturerName: r
        }
      };
    });
    return Ci(s).map((i) => ({
      name: n && i.manufacturer ? `${i.manufacturer} / ${i.name}` : i.name,
      value: i.item
    }));
  }
  manufacturers() {
    const { manufacturers: t } = this.cachedResponse;
    return zt(t);
  }
  implantManufacturers() {
    const { manufacturers: t, implantModels: n } = this.cachedResponse;
    return zt(t.filter((a) => n.some((s) => s.pId === a.id)));
  }
  abutmentManufacturers() {
    const { manufacturers: t, abutmentModels: n } = this.cachedResponse;
    return zt(t.filter((a) => n.some((s) => s.pId === a.id)));
  }
  implantModels() {
    const { implantModels: t } = this.cachedResponse;
    return zt(t);
  }
  sleeves() {
    const { sleeves: t } = this.cachedResponse;
    return zt(t);
  }
  extrusions() {
    const { extrusions: t } = this.cachedResponse;
    return t;
  }
  getExtrusionElements() {
    const { extrusions: t } = this.cachedResponse;
    return t.map((n) => {
      const a = n.jsonData ? JSON.parse(n.jsonData) : {}, s = ["d1model", "d2model", "l1model", "l2model", "cutsizemodel", "supportrmodel", "rotation_cutmodel", "bottomextrusionrmodel"];
      for (const o of s)
        o in a && typeof a[o] == "string" && (a[o] = Number(a[o]));
      return a.doublecutmodel = a.doublecutmodel === "true", {
        ...n,
        ...a
      };
    });
  }
  implants() {
    const { implants: t } = this.cachedResponse;
    return t.map((n) => ({ ...n, ...JSON.parse(n.jsonData ?? "") }));
  }
  pins() {
    const { pins: t, manufacturers: n } = this.cachedResponse;
    return Ci(
      t.map((a) => {
        var o;
        return { manufacturer: ((o = n == null ? void 0 : n.find((i) => i.id === a.pId)) == null ? void 0 : o.name) || "", ...a, ...JSON.parse(a.jsonData ?? "") };
      })
    );
  }
  abutments() {
    const { abutments: t } = this.cachedResponse;
    return zt(
      t.map((n) => {
        const a = n.jsonData ? JSON.parse(n.jsonData) : {}, s = ["angle", "color", "diameter", "rotation_z", "collar_height", "connector_height"];
        for (const o of s)
          o in a && typeof a[o] == "string" && (a[o] = Number(a[o]));
        return {
          ...n,
          ...a
        };
      })
    );
  }
  getScanAbutmentListModels(t, n) {
    const a = this.filterByIds(this.cachedResponse.scanAbuts ?? [], n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getSecondaryAbutmentListModels(t) {
    const n = this.filterByIds(this.cachedResponse.secAbuts ?? [], t, !1);
    return this.buildListModelByManufacturer(n, !1, !0);
  }
  getSecondaryScanAbutmentListModels(t) {
    const n = this.filterByIds(this.cachedResponse.secScanAbuts ?? [], t, !1);
    return this.buildListModelByManufacturer(n, !1, !0);
  }
  getAnalogExtrusionListModels(t, n) {
    const a = this.filterByIds(this.getExtrusionElements(), n, t);
    return this.buildListModelByManufacturer(a, !1);
  }
  getScanAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.scanAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getSecondaryAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.secAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getSecondaryScanAbutmentByGuid(t) {
    var a;
    const n = (a = this.cachedResponse.secScanAbuts) == null ? void 0 : a.find((s) => s.uuid === t);
    if (n)
      return this.withManufacturerName(n);
  }
  getExtrusionByStlGuid(t) {
    const n = this.getExtrusionElements(), a = n.find((s) => s.stl_file_guid === t) ?? n.find((s) => s.uuid === t);
    if (a)
      return this.withManufacturerName(a);
  }
  abutmentModels() {
    const { abutmentModels: t } = this.cachedResponse;
    return zt(t);
  }
  implantSleeveManufacturers() {
    const { sleeves: t, manufacturers: n } = this.cachedResponse;
    return zt(n.filter((a) => t.filter((s) => s.type == po.SleeveType.IMPLANT && s.pId == a.id).length > 0));
  }
  getImplantSleeves() {
    let t = [];
    const { sleeves: n, manufacturers: a } = this.cachedResponse;
    for (const s of a) {
      const o = n.filter((i) => i.type == po.SleeveType.IMPLANT && i.pId == s.id).map((i) => ({
        ...i,
        ...JSON.parse(i.jsonData ?? ""),
        original_name: mc(s.name, i.name)
      }));
      t = t.concat(o);
    }
    return zt(t);
  }
  getImplantSleeveListModels(t, n) {
    const a = this.filterByIds(this.getImplantSleeves(), n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getPinSleevesById(t) {
    return this.getPinSleeves().find((a) => a.id === t);
  }
  getPinSleevesFiltered(t, n) {
    const a = this.filterByIds(this.getPinSleeves(), n, t);
    return this.buildListModelByManufacturer(a, t, !0);
  }
  getPinSleeves() {
    let t = [];
    const { sleeves: n, manufacturers: a } = this.cachedResponse;
    for (const s of a) {
      const o = n.filter((i) => i.type == po.SleeveType.PIN && i.pId == s.id).map((i) => ({
        ...i,
        ...JSON.parse(i.jsonData ?? ""),
        manufacturer: s.name,
        original_name: mc(s.name, i.name)
      }));
      t = t.concat(o);
    }
    return Ci(t);
  }
  getImplantModelsForManufacturer(t) {
    return this.implantModels().filter((n) => n.pId === t);
  }
  getImplantsForModel(t) {
    const n = this.implants();
    return zt(n.filter((a) => a.pId === t));
  }
  async getFile(t) {
    return fy(t, this.objectCache, () => this.api.getSTLFile(t));
  }
  getImplantTreeById(t) {
    return this.getObjectTreeById(t, {
      l3: this.implants(),
      l2: this.implantModels(),
      l1: this.implantManufacturers()
    });
  }
  getAbutmentTreeById(t) {
    return this.getObjectTreeById(t, {
      l3: this.abutments(),
      l2: this.abutmentModels(),
      l1: this.abutmentManufacturers()
    });
  }
  getSleeveTreeByName(t) {
    let n = this.getImplantSleeves().find((a) => a.original_name === t);
    if (n || (n = this.getImplantSleeves().find((a) => a.original_name.toLowerCase() === t.toLowerCase())), n) {
      const a = this.manufacturers().find((s) => s.id === n.pId);
      if (a)
        return {
          manufacturer: a,
          object: n
        };
    }
  }
  getSleeveTreeById(t) {
    let n = this.getImplantSleeves().find((a) => a.id === t);
    if (n) {
      const a = this.manufacturers().find((s) => s.id === n.pId);
      if (a)
        return {
          manufacturer: a,
          object: n
        };
    }
  }
  getObjectTreeById(t, n) {
    const a = n.l3.find((s) => s.uuid === t);
    if (a) {
      const s = n.l2.find((o) => o.id === a.pId);
      if (s) {
        const o = n.l1.find((i) => i.id === s.pId);
        if (o)
          return {
            manufacturer: o,
            model: s,
            object: a
          };
      }
    }
  }
  getDependantObjectsForImplant(t) {
    return py(t, this.objectDepsCache, () => this.buildDependantForImplant(t));
  }
  buildDependantForImplant(t) {
    const n = this.implants().find(dy(t));
    let a = [], s = [], o = [], i = [];
    if (n && n.abutmentIds && n.abutmentIds.length > 0) {
      const r = this.abutmentManufacturers();
      o = this.abutments().filter((l) => {
        var c;
        return (c = n.abutmentIds) == null ? void 0 : c.some((u) => u === l.id);
      }), s = this.abutmentModels().filter((l) => o.some((c) => c.pId === l.id)), a = r.filter((l) => s.some((c) => c.pId === l.id));
    }
    return n && n.extrusionIds && n.extrusionIds.length > 0 && (i = this.getExtrusionElements().filter((r) => {
      var l;
      return (l = n.extrusionIds) == null ? void 0 : l.some((c) => c === r.id);
    })), {
      abManufacturers: a,
      abAbutments: o,
      abModels: s,
      extrusions: i
    };
  }
}
const os = aa("notificationStore", {
  state: () => ({
    message: {}
  }),
  actions: {
    add(e) {
      this.message = e;
    }
  }
});
function $T() {
  const e = os();
  Ge(() => {
    const t = nA();
    e.$subscribe((n, a) => {
      const { severity: s, summary: o, detail: i, life: r, closable: l } = a.message;
      t.add({ severity: s, summary: o, detail: i, life: r, closable: l });
    });
  });
}
function We(e, t = ke("shared.success")) {
  os().add({
    closable: !0,
    severity: "success",
    life: 3e3,
    summary: t,
    detail: e
  });
}
function qT(e, t, n = ke("shared.error")) {
  var r;
  const a = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data, o = (typeof a == "string" ? a : a == null ? void 0 : a.message) || (t == null ? void 0 : t.message);
  os().add({
    closable: !0,
    severity: "error",
    life: 3e3,
    summary: n,
    detail: o ? `${e}: ${o}` : e
  });
}
function Oe(e, t = ke("shared.error")) {
  os().add({
    closable: !0,
    severity: "error",
    life: 3e3,
    summary: t,
    detail: e
  });
}
function JT(e, t = ke("shared.info")) {
  os().add({
    closable: !0,
    severity: "info",
    life: 3e3,
    summary: t,
    detail: `${e}`
  });
}
function XT(e, t = ke("implant-planner.warning")) {
  os().add({
    closable: !0,
    severity: "warn",
    life: 3e3,
    summary: t,
    detail: `${e}`
  });
}
function zs(e) {
  return e.weblinkRole === Hs.ADMIN;
}
function Jo(e) {
  return zs(e) || e.weblinkRole === Hs.OPERATOR;
}
function Xo(e) {
  return e.weblinkRole === Hs.READONLY_OPERATOR;
}
function ZT(e) {
  return e.weblinkRole === Hs.USER;
}
function my(e) {
  if (zs(e))
    return !0;
  const t = Jo(e) || Xo(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Vs.EDIT_WORKFLOWS) : !1;
  return t && n;
}
function Ay(e) {
  if (zs(e))
    return !0;
  const t = Jo(e) || Xo(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Vs.EDIT_USERS) : !1;
  return t && n;
}
function Ac(e) {
  if (zs(e))
    return !0;
  const t = Jo(e) || Xo(e), n = e.weblinkPermissions ? e.weblinkPermissions.includes(Vs.EDIT_MATERIAL_LIB) : !1;
  return t && n;
}
function gy(e) {
  let t = "empty name";
  if (e.data) {
    const { firstName: n, lastName: a } = e.data;
    (n || a) && (t = `${n || ""} ${a || ""}`.trim());
  }
  return t;
}
function eM(e) {
  return zs(e) || Jo(e) || Xo(e) || Ac(e) ? my(e) || Ay(e) || Ac(e) : !1;
}
function tM(e) {
  return e.username == "test_admin_1";
}
function ao(e) {
  return e.data.organization ? e.data.organization : gy(e);
}
const Vr = void 0, Ca = "undefined", Kr = "function";
let Zd = 2;
try {
  typeof navigator != Ca && navigator.hardwareConcurrency && (Zd = navigator.hardwareConcurrency);
} catch {
}
const hy = {
  workerURI: "./core/web-worker-wasm.js",
  wasmURI: "./core/streams/zlib-wasm/zlib-streams.wasm",
  chunkSize: 64 * 1024,
  maxWorkers: Zd,
  terminateWorkerTimeout: 5e3,
  useWebWorkers: !0,
  useCompressionStream: !0,
  CompressionStream: typeof CompressionStream != Ca && CompressionStream,
  DecompressionStream: typeof DecompressionStream != Ca && DecompressionStream
}, vy = Object.assign({}, hy);
function Zo(e) {
  const {
    baseURI: t,
    chunkSize: n,
    maxWorkers: a,
    terminateWorkerTimeout: s,
    useCompressionStream: o,
    useWebWorkers: i,
    CompressionStream: r,
    DecompressionStream: l,
    CompressionStreamZlib: c,
    DecompressionStreamZlib: u,
    workerURI: d,
    wasmURI: m
  } = e;
  St("baseURI", t), St("wasmURI", m), St("workerURI", d), St("chunkSize", n), St("maxWorkers", a), St("terminateWorkerTimeout", s), St("useCompressionStream", o), St("useWebWorkers", i), St("CompressionStream", r), St("DecompressionStream", l), St("CompressionStreamZlib", c), St("DecompressionStreamZlib", u);
}
function St(e, t) {
  t !== Vr && (vy[e] = t);
}
function yy(e) {
  let t;
  e({ workerURI: () => (t || (t = "data:text/javascript," + encodeURIComponent(`(t=>{"function"==typeof define&&define.amd?define(t):t()})(function(){"use strict";const{Array:t,Object:e,Number:n,Math:s,Error:r,Uint8Array:o,Uint16Array:i,Uint32Array:c,Int32Array:a,Map:h,DataView:f,Promise:l,TextEncoder:u,crypto:w,postMessage:p,TransformStream:d,ReadableStream:y,WritableStream:m,CompressionStream:g,DecompressionStream:S}=self,b=void 0,v="undefined",k="function",z=[];for(let t=0;256>t;t++){let e=t;for(let t=0;8>t;t++)1&e?e=e>>>1^3988292384:e>>>=1;z[t]=e}class C{constructor(t){this.t=t||-1}append(t){let e=0|this.t;for(let n=0,s=0|t.length;s>n;n++)e=e>>>8^z[255&(e^t[n])];this.t=e}get(){return~this.t}}class A extends d{constructor(){let t;const e=new C;super({transform(t,n){e.append(t),n.enqueue(t)},flush(){const n=new o(4);new f(n.buffer).setUint32(0,e.get()),t.value=n}}),t=this}}const x={concat(t,e){if(0===t.length||0===e.length)return t.concat(e);const n=t[t.length-1],s=x.o(n);return 32===s?t.concat(e):x.i(e,s,0|n,t.slice(0,t.length-1))},h(t){const e=t.length;if(0===e)return 0;const n=t[e-1];return 32*(e-1)+x.o(n)},l(t,e){if(32*t.length<e)return t;const n=(t=t.slice(0,s.ceil(e/32))).length;return e&=31,n>0&&e&&(t[n-1]=x.u(e,t[n-1]&2147483648>>e-1,1)),t},u:(t,e,n)=>32===t?e:(n?0|e:e<<32-t)+1099511627776*t,o:t=>s.round(t/1099511627776)||32,i(t,e,n,s){for(void 0===s&&(s=[]);e>=32;e-=32)s.push(n),n=0;if(0===e)return s.concat(t);for(let r=0;r<t.length;r++)s.push(n|t[r]>>>e),n=t[r]<<32-e;const r=t.length?t[t.length-1]:0,o=x.o(r);return s.push(x.u(e+o&31,e+o>32?n:s.pop(),1)),s}},I={bytes:{p(t){const e=x.h(t)/8,n=new o(e);let s;for(let r=0;e>r;r++)3&r||(s=t[r/4]),n[r]=s>>>24,s<<=8;return n},m(t){const e=[];let n,s=0;for(n=0;n<t.length;n++)s=s<<8|t[n],3&~n||(e.push(s),s=0);return 3&n&&e.push(x.u(8*(3&n),s)),e}}},R=class{constructor(t){const e=this;e.blockSize=512,e.S=[1732584193,4023233417,2562383102,271733878,3285377520],e.v=[1518500249,1859775393,2400959708,3395469782],t?(e.k=t.k.slice(0),e.C=t.C.slice(0),e.A=t.A):e.reset()}reset(){const t=this;return t.k=t.S.slice(0),t.C=[],t.A=0,t}update(t){const e=this;"string"==typeof t&&(t=I.I.m(t));const n=e.C=x.concat(e.C,t),s=e.A,o=e.A=s+x.h(t);if(o>9007199254740991)throw new r("Cannot hash more than 2^53 - 1 bits");const i=new c(n);let a=0;for(let t=e.blockSize+s-(e.blockSize+s&e.blockSize-1);o>=t;t+=e.blockSize)e.R(i.subarray(16*a,16*(a+1))),a+=1;return n.splice(0,16*a),e}P(){const t=this;let e=t.C;const n=t.k;e=x.concat(e,[x.u(1,1)]);for(let t=e.length+2;15&t;t++)e.push(0);for(e.push(s.floor(t.A/4294967296)),e.push(0|t.A);e.length;)t.R(e.splice(0,16));return t.reset(),n}U(t,e,n,s){return t>19?t>39?t>59?t>79?void 0:e^n^s:e&n|e&s|n&s:e^n^s:e&n|~e&s}V(t,e){return e<<t|e>>>32-t}R(e){const n=this,r=n.k,o=t(80);for(let t=0;16>t;t++)o[t]=e[t];let i=r[0],c=r[1],a=r[2],h=r[3],f=r[4];for(let t=0;79>=t;t++){16>t||(o[t]=n.V(1,o[t-3]^o[t-8]^o[t-14]^o[t-16]));const e=n.V(5,i)+n.U(t,c,a,h)+f+o[t]+n.v[s.floor(t/20)]|0;f=h,h=a,a=n.V(30,c),c=i,i=e}r[0]=r[0]+i|0,r[1]=r[1]+c|0,r[2]=r[2]+a|0,r[3]=r[3]+h|0,r[4]=r[4]+f|0}},P={getRandomValues(t){const e=new c(t.buffer),n=t=>{let e=987654321;const n=4294967295;return()=>(e=36969*(65535&e)+(e>>16)&n,(((e<<16)+(t=18e3*(65535&t)+(t>>16)&n)&n)/4294967296+.5)*(s.random()>.5?1:-1))};for(let r,o=0;o<t.length;o+=4){const t=n(4294967296*(r||s.random()));r=987654071*t(),e[o/4]=4294967296*t()|0}return t}},U={importKey:t=>new U.M(I.bytes.m(t)),_(t,e,n,s){if(n=n||1e4,0>s||0>n)throw new r("invalid params to pbkdf2");const o=1+(s>>5)<<2;let i,c,a,h,l;const u=new ArrayBuffer(o),w=new f(u);let p=0;const d=x;for(e=I.bytes.m(e),l=1;(o||1)>p;l++){for(i=c=t.encrypt(d.concat(e,[l])),a=1;n>a;a++)for(c=t.encrypt(c),h=0;h<c.length;h++)i[h]^=c[h];for(a=0;(o||1)>p&&a<i.length;a++)w.setInt32(p,i[a]),p+=4}return u.slice(0,s/8)},M:class{constructor(t){const e=this,n=e.B=R,s=[[],[]];e.D=[new n,new n];const r=e.D[0].blockSize/32;t.length>r&&(t=(new n).update(t).P());for(let e=0;r>e;e++)s[0][e]=909522486^t[e],s[1][e]=1549556828^t[e];e.D[0].update(s[0]),e.D[1].update(s[1]),e.W=new n(e.D[0])}reset(){const t=this;t.W=new t.B(t.D[0]),t.K=!1}update(t){this.K=!0,this.W.update(t)}digest(){const t=this,e=t.W.P(),n=new t.B(t.D[1]).update(e).P();return t.reset(),n}encrypt(t){if(this.K)throw new r("encrypt on already updated hmac called!");return this.update(t),this.digest(t)}}},V=typeof w!=v&&typeof w.getRandomValues==k,M="Invalid password",_="Invalid signature",B="zipjs-abort-check-password";function D(t){return V?w.getRandomValues(t):P.getRandomValues(t)}const W=16,K={name:"PBKDF2"},E=e.assign({hash:{name:"HMAC"}},K),L=e.assign({iterations:1e3,hash:{name:"SHA-1"}},K),O=["deriveBits"],T=[8,12,16],j=[16,24,32],H=10,Z=[0,0,0,0],F=typeof w!=v,N=F&&w.subtle,q=F&&typeof N!=v,G=I.bytes,J=class{constructor(t){const e=this;e.L=[[[],[],[],[],[]],[[],[],[],[],[]]],e.L[0][0][0]||e.O();const n=e.L[0][4],s=e.L[1],o=t.length;let i,c,a,h=1;if(4!==o&&6!==o&&8!==o)throw new r("invalid aes key size");for(e.v=[c=t.slice(0),a=[]],i=o;4*o+28>i;i++){let t=c[i-1];(i%o===0||8===o&&i%o===4)&&(t=n[t>>>24]<<24^n[t>>16&255]<<16^n[t>>8&255]<<8^n[255&t],i%o===0&&(t=t<<8^t>>>24^h<<24,h=h<<1^283*(h>>7))),c[i]=c[i-o]^t}for(let t=0;i;t++,i--){const e=c[3&t?i:i-4];a[t]=4>=i||4>t?e:s[0][n[e>>>24]]^s[1][n[e>>16&255]]^s[2][n[e>>8&255]]^s[3][n[255&e]]}}encrypt(t){return this.T(t,0)}decrypt(t){return this.T(t,1)}O(){const t=this.L[0],e=this.L[1],n=t[4],s=e[4],r=[],o=[];let i,c,a,h;for(let t=0;256>t;t++)o[(r[t]=t<<1^283*(t>>7))^t]=t;for(let f=i=0;!n[f];f^=c||1,i=o[i]||1){let o=i^i<<1^i<<2^i<<3^i<<4;o=o>>8^255&o^99,n[f]=o,s[o]=f,h=r[a=r[c=r[f]]];let l=16843009*h^65537*a^257*c^16843008*f,u=257*r[o]^16843008*o;for(let n=0;4>n;n++)t[n][f]=u=u<<24^u>>>8,e[n][o]=l=l<<24^l>>>8}for(let n=0;5>n;n++)t[n]=t[n].slice(0),e[n]=e[n].slice(0)}T(t,e){if(4!==t.length)throw new r("invalid aes block size");const n=this.v[e],s=n.length/4-2,o=[0,0,0,0],i=this.L[e],c=i[0],a=i[1],h=i[2],f=i[3],l=i[4];let u,w,p,d=t[0]^n[0],y=t[e?3:1]^n[1],m=t[2]^n[2],g=t[e?1:3]^n[3],S=4;for(let t=0;s>t;t++)u=c[d>>>24]^a[y>>16&255]^h[m>>8&255]^f[255&g]^n[S],w=c[y>>>24]^a[m>>16&255]^h[g>>8&255]^f[255&d]^n[S+1],p=c[m>>>24]^a[g>>16&255]^h[d>>8&255]^f[255&y]^n[S+2],g=c[g>>>24]^a[d>>16&255]^h[y>>8&255]^f[255&m]^n[S+3],S+=4,d=u,y=w,m=p;for(let t=0;4>t;t++)o[e?3&-t:t]=l[d>>>24]<<24^l[y>>16&255]<<16^l[m>>8&255]<<8^l[255&g]^n[S++],u=d,d=y,y=m,m=g,g=u;return o}},Q=class{constructor(t,e){this.j=t,this.H=e,this.Z=e}reset(){this.Z=this.H}update(t){return this.F(this.j,t,this.Z)}N(t){if(255&~(t>>24))t+=1<<24;else{let e=t>>16&255,n=t>>8&255,s=255&t;255===e?(e=0,255===n?(n=0,255===s?s=0:++s):++n):++e,t=0,t+=e<<16,t+=n<<8,t+=s}return t}q(t){0===(t[0]=this.N(t[0]))&&(t[1]=this.N(t[1]))}F(t,e,n){let s;if(!(s=e.length))return[];const r=x.h(e);for(let r=0;s>r;r+=4){this.q(n);const s=t.encrypt(n);e[r]^=s[0],e[r+1]^=s[1],e[r+2]^=s[2],e[r+3]^=s[3]}return x.l(e,r)}},X=U.M;let Y=F&&q&&typeof N.importKey==k,$=F&&q&&typeof N.deriveBits==k;class tt extends d{constructor({password:t,rawPassword:n,signed:s,encryptionStrength:i,checkPasswordOnly:c}){super({start(){e.assign(this,{ready:new l(t=>this.G=t),password:rt(t,n),signed:s,J:i-1,pending:new o})},async transform(t,e){const n=this,{password:s,J:i,G:a,ready:h}=n;s?(await(async(t,e,n,s)=>{const o=await st(t,e,n,it(s,0,T[e])),i=it(s,T[e]);if(o[0]!=i[0]||o[1]!=i[1])throw new r(M)})(n,i,s,it(t,0,T[i]+2)),t=it(t,T[i]+2),c?e.error(new r(B)):a()):await h;const f=new o(t.length-H-(t.length-H)%W);e.enqueue(nt(n,t,f,0,H,!0))},async flush(t){const{signed:e,X:n,Y:s,pending:i,ready:c}=this;if(s&&n){await c;const a=it(i,0,i.length-H),h=it(i,i.length-H);let f=new o;if(a.length){const t=at(G,a);s.update(t);const e=n.update(t);f=ct(G,e)}if(e){const t=it(ct(G,s.digest()),0,H);for(let e=0;H>e;e++)if(t[e]!=h[e])throw new r(_)}t.enqueue(f)}}})}}class et extends d{constructor({password:t,rawPassword:n,encryptionStrength:s}){let r;super({start(){e.assign(this,{ready:new l(t=>this.G=t),password:rt(t,n),J:s-1,pending:new o})},async transform(t,e){const n=this,{password:s,J:r,G:i,ready:c}=n;let a=new o;s?(a=await(async(t,e,n)=>{const s=D(new o(T[e]));return ot(s,await st(t,e,n,s))})(n,r,s),i()):await c;const h=new o(a.length+t.length-t.length%W);h.set(a,0),e.enqueue(nt(n,t,h,a.length,0))},async flush(t){const{X:e,Y:n,pending:s,ready:i}=this;if(n&&e){await i;let c=new o;if(s.length){const t=e.update(at(G,s));n.update(t),c=ct(G,t)}r.signature=ct(G,n.digest()).slice(0,H),t.enqueue(ot(c,r.signature))}}}),r=this}}function nt(t,e,n,s,r,i){const{X:c,Y:a,pending:h}=t,f=e.length-r;let l;for(h.length&&(e=ot(h,e),n=((t,e)=>{if(e&&e>t.length){const n=t;(t=new o(e)).set(n,0)}return t})(n,f-f%W)),l=0;f-W>=l;l+=W){const t=at(G,it(e,l,l+W));i&&a.update(t);const r=c.update(t);i||a.update(r),n.set(ct(G,r),l+s)}return t.pending=it(e,l),n}async function st(n,s,r,i){n.password=null;const c=await(async(t,e,n,s,r)=>{if(!Y)return U.importKey(e);try{return await N.importKey("raw",e,n,!1,r)}catch{return Y=!1,U.importKey(e)}})(0,r,E,0,O),a=await(async(t,e,n)=>{if(!$)return U._(e,t.salt,L.iterations,n);try{return await N.deriveBits(t,e,n)}catch{return $=!1,U._(e,t.salt,L.iterations,n)}})(e.assign({salt:i},L),c,8*(2*j[s]+2)),h=new o(a),f=at(G,it(h,0,j[s])),l=at(G,it(h,j[s],2*j[s])),u=it(h,2*j[s]);return e.assign(n,{keys:{key:f,$:l,passwordVerification:u},X:new Q(new J(f),t.from(Z)),Y:new X(l)}),u}function rt(t,e){return e===b?(t=>{if(typeof u==v){const e=new o((t=unescape(encodeURIComponent(t))).length);for(let n=0;n<e.length;n++)e[n]=t.charCodeAt(n);return e}return(new u).encode(t)})(t):e}function ot(t,e){let n=t;return t.length+e.length&&(n=new o(t.length+e.length),n.set(t,0),n.set(e,t.length)),n}function it(t,e,n){return t.subarray(e,n)}function ct(t,e){return t.p(e)}function at(t,e){return t.m(e)}class ht extends d{constructor({password:t,passwordVerification:n,checkPasswordOnly:s}){super({start(){e.assign(this,{password:t,passwordVerification:n}),wt(this,t)},transform(t,e){const n=this;if(n.password){const e=lt(n,t.subarray(0,12));if(n.password=null,e.at(-1)!=n.passwordVerification)throw new r(M);t=t.subarray(12)}s?e.error(new r(B)):e.enqueue(lt(n,t))}})}}class ft extends d{constructor({password:t,passwordVerification:n}){super({start(){e.assign(this,{password:t,passwordVerification:n}),wt(this,t)},transform(t,e){const n=this;let s,r;if(n.password){n.password=null;const e=D(new o(12));e[11]=n.passwordVerification,s=new o(t.length+e.length),s.set(ut(n,e),0),r=12}else s=new o(t.length),r=0;s.set(ut(n,t),r),e.enqueue(s)}})}}function lt(t,e){const n=new o(e.length);for(let s=0;s<e.length;s++)n[s]=dt(t)^e[s],pt(t,n[s]);return n}function ut(t,e){const n=new o(e.length);for(let s=0;s<e.length;s++)n[s]=dt(t)^e[s],pt(t,e[s]);return n}function wt(t,n){const s=[305419896,591751049,878082192];e.assign(t,{keys:s,tt:new C(s[0]),et:new C(s[2])});for(let e=0;e<n.length;e++)pt(t,n.charCodeAt(e))}function pt(t,e){let[n,r,o]=t.keys;t.tt.append([e]),n=~t.tt.get(),r=mt(s.imul(mt(r+yt(n)),134775813)+1),t.et.append([r>>>24]),o=~t.et.get(),t.keys=[n,r,o]}function dt(t){const e=2|t.keys[2];return yt(s.imul(e,1^e)>>>8)}function yt(t){return 255&t}function mt(t){return 4294967295&t}class gt extends d{constructor(t,{chunkSize:e,nt:n,CompressionStream:s}){super({});const{compressed:r,encrypted:o,useCompressionStream:i,zipCrypto:c,signed:a,level:h}=t,l=this;let u,w,p=super.readable;o&&!c||!a||(u=new A,p=kt(p,u)),r&&(p=vt(p,i,{level:h,chunkSize:e},s,n,s)),o&&(c?p=kt(p,new ft(t)):(w=new et(t),p=kt(p,w))),bt(l,p,()=>{let t;o&&!c&&(t=w.signature),o&&!c||!a||(t=new f(u.value.buffer).getUint32(0)),l.signature=t})}}class St extends d{constructor(t,{chunkSize:e,st:n,DecompressionStream:s}){super({});const{zipCrypto:o,encrypted:i,signed:c,signature:a,compressed:h,useCompressionStream:l,rt:u}=t;let w,p,d=super.readable;i&&(o?d=kt(d,new ht(t)):(p=new tt(t),d=kt(d,p))),h&&(d=vt(d,l,{chunkSize:e,rt:u},s,n,s)),i&&!o||!c||(w=new A,d=kt(d,w)),bt(this,d,()=>{if((!i||o)&&c){const t=new f(w.value.buffer);if(a!=t.getUint32(0,!1))throw new r(_)}})}}function bt(t,n,s){n=kt(n,new d({flush:s})),e.defineProperty(t,"readable",{get:()=>n})}function vt(t,e,n,s,r,o){const i=e&&s?s:r||o,c=n.rt?"deflate64-raw":"deflate-raw";try{t=kt(t,new i(c,n))}catch(s){if(!e)throw s;if(r)t=kt(t,new r(c,n));else{if(!o)throw s;t=kt(t,new o(c,n))}}return t}function kt(t,e){return t.pipeThrough(e)}const zt="data",Ct="close";class At extends d{constructor(t,n){super({});const s=this,{codecType:o}=t;let i;o.startsWith("deflate")?i=gt:o.startsWith("inflate")&&(i=St),s.outputSize=0;let c=0;const a=new i(t,n),h=super.readable,f=new d({transform(t,e){t&&t.length&&(c+=t.length,e.enqueue(t))},flush(){e.assign(s,{inputSize:c})}}),l=new d({transform(e,n){if(e&&e.length&&(n.enqueue(e),s.outputSize+=e.length,t.outputSize!==b&&s.outputSize>t.outputSize))throw new r("Invalid uncompressed size")},flush(){const{signature:t}=a;e.assign(s,{signature:t,inputSize:c})}});e.defineProperty(s,"readable",{get:()=>h.pipeThrough(f).pipeThrough(a).pipeThrough(l)})}}class xt extends d{constructor(t){let e;super({transform:function n(s,r){if(e){const t=new o(e.length+s.length);t.set(e),t.set(s,e.length),s=t,e=null}s.length>t?(r.enqueue(s.slice(0,t)),n(s.slice(t),r)):e=s},flush(t){e&&e.length&&t.enqueue(e)}})}}const It=new h,Rt=new h;let Pt,Ut,Vt,Mt,_t,Bt=0;async function Dt(t){try{const{options:e,config:s}=t;if(!e.useCompressionStream)try{await self.initModule(t.config)}catch{e.useCompressionStream=!0}s.CompressionStream=self.CompressionStream,s.DecompressionStream=self.DecompressionStream;const r={highWaterMark:1},o=t.readable||new y({async pull(t){const e=new l(t=>It.set(Bt,t));Wt({type:"pull",messageId:Bt}),Bt=(Bt+1)%n.MAX_SAFE_INTEGER;const{value:s,done:r}=await e;t.enqueue(s),r&&t.close()}},r),i=t.writable||new m({async write(t){let e;const s=new l(t=>e=t);Rt.set(Bt,e),Wt({type:zt,value:t,messageId:Bt}),Bt=(Bt+1)%n.MAX_SAFE_INTEGER,await s}},r),c=new At(e,s);Pt=new AbortController;const{signal:a}=Pt;await o.pipeThrough(c).pipeThrough(new xt(s.chunkSize)).pipeTo(i,{signal:a,preventClose:!0,preventAbort:!0}),await i.getWriter().close();const{signature:h,inputSize:f,outputSize:u}=c;Wt({type:Ct,result:{signature:h,inputSize:f,outputSize:u}})}catch(t){t.outputSize=0,Kt(t)}}function Wt(t){let{value:e}=t;if(e)if(e.length)try{e=new o(e),t.value=e.buffer,p(t,[t.value])}catch{p(t)}else p(t);else p(t)}function Kt(t=new r("Unknown error")){const{message:e,stack:n,code:s,name:o,outputSize:i}=t;p({error:{message:e,stack:n,code:s,name:o,outputSize:i}})}function Et(t,e,n={}){const i="number"==typeof n.level?n.level:-1,c="number"==typeof n.ot?n.ot:65536,a="number"==typeof n.it?n.it:65536;return new d({start(){let n;if(this.ct=Vt(c),this.in=Vt(a),this.it=a,this.ht=new o(c),t?(this.ft=Ut.deflate_process,this.lt=Ut.deflate_last_consumed,this.ut=Ut.deflate_end,this.wt=Ut.deflate_new(),n="gzip"===e?Ut.deflate_init_gzip(this.wt,i):"deflate-raw"===e?Ut.deflate_init_raw(this.wt,i):Ut.deflate_init(this.wt,i)):"deflate64-raw"===e?(this.ft=Ut.inflate9_process,this.lt=Ut.inflate9_last_consumed,this.ut=Ut.inflate9_end,this.wt=Ut.inflate9_new(),n=Ut.inflate9_init_raw(this.wt)):(this.ft=Ut.inflate_process,this.lt=Ut.inflate_last_consumed,this.ut=Ut.inflate_end,this.wt=Ut.inflate_new(),n="deflate-raw"===e?Ut.inflate_init_raw(this.wt):"gzip"===e?Ut.inflate_init_gzip(this.wt):Ut.inflate_init(this.wt)),0!==n)throw new r("init failed:"+n)},transform(e,n){try{const i=e,a=new o(_t.buffer),h=this.ft,f=this.lt,l=this.ct,u=this.ht;let w=0;for(;w<i.length;){const e=s.min(i.length-w,32768);this.in&&this.it>=e||(this.in&&Mt&&Mt(this.in),this.in=Vt(e),this.it=e),a.set(i.subarray(w,w+e),this.in);const o=h(this.wt,this.in,e,l,c,0);if(!t&&0>o)throw new r("process error:"+o);const p=16777215&o;p&&(u.set(a.subarray(l,l+p),0),n.enqueue(u.slice(0,p)));const d=f(this.wt);if(0===d)break;w+=d}}catch(t){this.ut&&this.wt&&this.ut(this.wt),this.in&&Mt&&Mt(this.in),this.ct&&Mt&&Mt(this.ct),n.error(t)}},flush(e){try{const n=new o(_t.buffer),s=this.ft,i=this.ct,a=this.ht;for(;;){const o=s(this.wt,0,0,i,c,4);if(!t&&0>o)throw new r("process error:"+o);const h=16777215&o,f=o>>24&255;if(h&&(a.set(n.subarray(i,i+h),0),e.enqueue(a.slice(0,h))),1===f||0===h)break}}catch(t){e.error(t)}finally{if(this.ut&&this.wt){const t=this.ut(this.wt);0!==t&&e.error(new r("end error:"+t))}this.in&&Mt&&Mt(this.in),this.ct&&Mt&&Mt(this.ct)}}})}addEventListener("message",({data:t})=>{const{type:e,messageId:n,value:s,done:r}=t;try{if("start"==e&&Dt(t),e==zt){const t=It.get(n);It.delete(n),t({value:new o(s),done:r})}if("ack"==e){const t=Rt.get(n);Rt.delete(n),t()}e==Ct&&Pt.abort()}catch(t){Kt(t)}});class Lt{constructor(t="deflate",e){return Et(!0,t,e)}}class Ot{constructor(t="deflate",e){return Et(!1,t,e)}}let Tt=!1;self.initModule=async t=>{try{const e=await(async(t,{baseURI:e})=>{if(!Tt){let n,s;try{try{s=new URL(t,e)}catch{}const r=await fetch(s);n=await r.arrayBuffer()}catch(e){if(!t.startsWith("data:application/wasm;base64,"))throw e;n=(t=>{const e=t.split(",")[1],n=atob(e),s=n.length,r=new o(s);for(let t=0;s>t;++t)r[t]=n.charCodeAt(t);return r.buffer})(t)}(t=>{if(Ut=t,({malloc:Vt,free:Mt,memory:_t}=Ut),"function"!=typeof Vt||"function"!=typeof Mt||!_t)throw Ut=Vt=Mt=_t=null,new r("Invalid WASM module")})((await WebAssembly.instantiate(n)).instance.exports),Tt=!0}})(t.wasmURI,t);return t.nt=Lt,t.st=Ot,e}catch{}}});
`)), t) });
}
const ef = [];
for (let e = 0; e < 256; e++) {
  let t = e;
  for (let n = 0; n < 8; n++)
    t & 1 ? t = t >>> 1 ^ 3988292384 : t = t >>> 1;
  ef[e] = t;
}
class lr {
  constructor(t) {
    this.crc = t || -1;
  }
  append(t) {
    let n = this.crc | 0;
    for (let a = 0, s = t.length | 0; a < s; a++)
      n = n >>> 8 ^ ef[(n ^ t[a]) & 255];
    this.crc = n;
  }
  get() {
    return ~this.crc;
  }
}
class tf extends TransformStream {
  constructor() {
    let t;
    const n = new lr();
    super({
      transform(a, s) {
        n.append(a), s.enqueue(a);
      },
      flush() {
        const a = new Uint8Array(4);
        new DataView(a.buffer).setUint32(0, n.get()), t.value = a;
      }
    }), t = this;
  }
}
function by(e) {
  if (typeof TextEncoder == Ca) {
    e = unescape(encodeURIComponent(e));
    const t = new Uint8Array(e.length);
    for (let n = 0; n < t.length; n++)
      t[n] = e.charCodeAt(n);
    return t;
  } else
    return new TextEncoder().encode(e);
}
const dt = {
  /**
   * Concatenate two bit arrays.
   * @param {bitArray} a1 The first array.
   * @param {bitArray} a2 The second array.
   * @return {bitArray} The concatenation of a1 and a2.
   */
  concat(e, t) {
    if (e.length === 0 || t.length === 0)
      return e.concat(t);
    const n = e[e.length - 1], a = dt.getPartial(n);
    return a === 32 ? e.concat(t) : dt._shiftRight(t, a, n | 0, e.slice(0, e.length - 1));
  },
  /**
   * Find the length of an array of bits.
   * @param {bitArray} a The array.
   * @return {Number} The length of a, in bits.
   */
  bitLength(e) {
    const t = e.length;
    if (t === 0)
      return 0;
    const n = e[t - 1];
    return (t - 1) * 32 + dt.getPartial(n);
  },
  /**
   * Truncate an array.
   * @param {bitArray} a The array.
   * @param {Number} len The length to truncate to, in bits.
   * @return {bitArray} A new array, truncated to len bits.
   */
  clamp(e, t) {
    if (e.length * 32 < t)
      return e;
    e = e.slice(0, Math.ceil(t / 32));
    const n = e.length;
    return t = t & 31, n > 0 && t && (e[n - 1] = dt.partial(t, e[n - 1] & 2147483648 >> t - 1, 1)), e;
  },
  /**
   * Make a partial word for a bit array.
   * @param {Number} len The number of bits in the word.
   * @param {Number} x The bits.
   * @param {Number} [_end=0] Pass 1 if x has already been shifted to the high side.
   * @return {Number} The partial word.
   */
  partial(e, t, n) {
    return e === 32 ? t : (n ? t | 0 : t << 32 - e) + e * 1099511627776;
  },
  /**
   * Get the number of bits used by a partial word.
   * @param {Number} x The partial word.
   * @return {Number} The number of bits used by the partial word.
   */
  getPartial(e) {
    return Math.round(e / 1099511627776) || 32;
  },
  /** Shift an array right.
   * @param {bitArray} a The array to shift.
   * @param {Number} shift The number of bits to shift.
   * @param {Number} [carry=0] A byte to carry in
   * @param {bitArray} [out=[]] An array to prepend to the output.
   * @private
   */
  _shiftRight(e, t, n, a) {
    for (a === void 0 && (a = []); t >= 32; t -= 32)
      a.push(n), n = 0;
    if (t === 0)
      return a.concat(e);
    for (let i = 0; i < e.length; i++)
      a.push(n | e[i] >>> t), n = e[i] << 32 - t;
    const s = e.length ? e[e.length - 1] : 0, o = dt.getPartial(s);
    return a.push(dt.partial(t + o & 31, t + o > 32 ? n : a.pop(), 1)), a;
  }
}, Mo = {
  bytes: {
    /** Convert from a bitArray to an array of bytes. */
    fromBits(e) {
      const n = dt.bitLength(e) / 8, a = new Uint8Array(n);
      let s;
      for (let o = 0; o < n; o++)
        (o & 3) === 0 && (s = e[o / 4]), a[o] = s >>> 24, s <<= 8;
      return a;
    },
    /** Convert from an array of bytes to a bitArray. */
    toBits(e) {
      const t = [];
      let n, a = 0;
      for (n = 0; n < e.length; n++)
        a = a << 8 | e[n], (n & 3) === 3 && (t.push(a), a = 0);
      return n & 3 && t.push(dt.partial(8 * (n & 3), a)), t;
    }
  }
}, nf = {};
nf.sha1 = class {
  constructor(e) {
    const t = this;
    t.blockSize = 512, t._init = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], t._key = [1518500249, 1859775393, 2400959708, 3395469782], e ? (t._h = e._h.slice(0), t._buffer = e._buffer.slice(0), t._length = e._length) : t.reset();
  }
  /**
   * Reset the hash state.
   * @return this
   */
  reset() {
    const e = this;
    return e._h = e._init.slice(0), e._buffer = [], e._length = 0, e;
  }
  /**
   * Input several words to the hash.
   * @param {bitArray|String} data the data to hash.
   * @return this
   */
  update(e) {
    const t = this;
    typeof e == "string" && (e = Mo.utf8String.toBits(e));
    const n = t._buffer = dt.concat(t._buffer, e), a = t._length, s = t._length = a + dt.bitLength(e);
    if (s > 9007199254740991)
      throw new Error("Cannot hash more than 2^53 - 1 bits");
    const o = new Uint32Array(n);
    let i = 0;
    for (let r = t.blockSize + a - (t.blockSize + a & t.blockSize - 1); r <= s; r += t.blockSize)
      t._block(o.subarray(16 * i, 16 * (i + 1))), i += 1;
    return n.splice(0, 16 * i), t;
  }
  /**
   * Complete hashing and output the hash value.
   * @return {bitArray} The hash value, an array of 5 big-endian words. TODO
   */
  finalize() {
    const e = this;
    let t = e._buffer;
    const n = e._h;
    t = dt.concat(t, [dt.partial(1, 1)]);
    for (let a = t.length + 2; a & 15; a++)
      t.push(0);
    for (t.push(Math.floor(e._length / 4294967296)), t.push(e._length | 0); t.length; )
      e._block(t.splice(0, 16));
    return e.reset(), n;
  }
  /**
   * The SHA-1 logical functions f(0), f(1), ..., f(79).
   * @private
   */
  _f(e, t, n, a) {
    if (e <= 19)
      return t & n | ~t & a;
    if (e <= 39)
      return t ^ n ^ a;
    if (e <= 59)
      return t & n | t & a | n & a;
    if (e <= 79)
      return t ^ n ^ a;
  }
  /**
   * Circular left-shift operator.
   * @private
   */
  _S(e, t) {
    return t << e | t >>> 32 - e;
  }
  /**
   * Perform one cycle of SHA-1.
   * @param {Uint32Array|bitArray} words one block of words.
   * @private
   */
  _block(e) {
    const t = this, n = t._h, a = Array(80);
    for (let c = 0; c < 16; c++)
      a[c] = e[c];
    let s = n[0], o = n[1], i = n[2], r = n[3], l = n[4];
    for (let c = 0; c <= 79; c++) {
      c >= 16 && (a[c] = t._S(1, a[c - 3] ^ a[c - 8] ^ a[c - 14] ^ a[c - 16]));
      const u = t._S(5, s) + t._f(c, o, i, r) + l + a[c] + t._key[Math.floor(c / 20)] | 0;
      l = r, r = i, i = t._S(30, o), o = s, s = u;
    }
    n[0] = n[0] + s | 0, n[1] = n[1] + o | 0, n[2] = n[2] + i | 0, n[3] = n[3] + r | 0, n[4] = n[4] + l | 0;
  }
};
const af = {};
af.aes = class {
  constructor(e) {
    const t = this;
    t._tables = [[[], [], [], [], []], [[], [], [], [], []]], t._tables[0][0][0] || t._precompute();
    const n = t._tables[0][4], a = t._tables[1], s = e.length;
    let o, i, r, l = 1;
    if (s !== 4 && s !== 6 && s !== 8)
      throw new Error("invalid aes key size");
    for (t._key = [i = e.slice(0), r = []], o = s; o < 4 * s + 28; o++) {
      let c = i[o - 1];
      (o % s === 0 || s === 8 && o % s === 4) && (c = n[c >>> 24] << 24 ^ n[c >> 16 & 255] << 16 ^ n[c >> 8 & 255] << 8 ^ n[c & 255], o % s === 0 && (c = c << 8 ^ c >>> 24 ^ l << 24, l = l << 1 ^ (l >> 7) * 283)), i[o] = i[o - s] ^ c;
    }
    for (let c = 0; o; c++, o--) {
      const u = i[c & 3 ? o : o - 4];
      o <= 4 || c < 4 ? r[c] = u : r[c] = a[0][n[u >>> 24]] ^ a[1][n[u >> 16 & 255]] ^ a[2][n[u >> 8 & 255]] ^ a[3][n[u & 255]];
    }
  }
  // public
  /* Something like this might appear here eventually
  name: "AES",
  blockSize: 4,
  keySizes: [4,6,8],
  */
  /**
   * Encrypt an array of 4 big-endian words.
   * @param {Array} data The plaintext.
   * @return {Array} The ciphertext.
   */
  encrypt(e) {
    return this._crypt(e, 0);
  }
  /**
   * Decrypt an array of 4 big-endian words.
   * @param {Array} data The ciphertext.
   * @return {Array} The plaintext.
   */
  decrypt(e) {
    return this._crypt(e, 1);
  }
  /**
   * Expand the S-box tables.
   *
   * @private
   */
  _precompute() {
    const e = this._tables[0], t = this._tables[1], n = e[4], a = t[4], s = [], o = [];
    let i, r, l, c;
    for (let u = 0; u < 256; u++)
      o[(s[u] = u << 1 ^ (u >> 7) * 283) ^ u] = u;
    for (let u = i = 0; !n[u]; u ^= r || 1, i = o[i] || 1) {
      let d = i ^ i << 1 ^ i << 2 ^ i << 3 ^ i << 4;
      d = d >> 8 ^ d & 255 ^ 99, n[u] = d, a[d] = u, c = s[l = s[r = s[u]]];
      let m = c * 16843009 ^ l * 65537 ^ r * 257 ^ u * 16843008, g = s[d] * 257 ^ d * 16843008;
      for (let h = 0; h < 4; h++)
        e[h][u] = g = g << 24 ^ g >>> 8, t[h][d] = m = m << 24 ^ m >>> 8;
    }
    for (let u = 0; u < 5; u++)
      e[u] = e[u].slice(0), t[u] = t[u].slice(0);
  }
  /**
   * Encryption and decryption core.
   * @param {Array} input Four words to be encrypted or decrypted.
   * @param dir The direction, 0 for encrypt and 1 for decrypt.
   * @return {Array} The four encrypted or decrypted words.
   * @private
   */
  _crypt(e, t) {
    if (e.length !== 4)
      throw new Error("invalid aes block size");
    const n = this._key[t], a = n.length / 4 - 2, s = [0, 0, 0, 0], o = this._tables[t], i = o[0], r = o[1], l = o[2], c = o[3], u = o[4];
    let d = e[0] ^ n[0], m = e[t ? 3 : 1] ^ n[1], g = e[2] ^ n[2], h = e[t ? 1 : 3] ^ n[3], A = 4, f, p, v;
    for (let b = 0; b < a; b++)
      f = i[d >>> 24] ^ r[m >> 16 & 255] ^ l[g >> 8 & 255] ^ c[h & 255] ^ n[A], p = i[m >>> 24] ^ r[g >> 16 & 255] ^ l[h >> 8 & 255] ^ c[d & 255] ^ n[A + 1], v = i[g >>> 24] ^ r[h >> 16 & 255] ^ l[d >> 8 & 255] ^ c[m & 255] ^ n[A + 2], h = i[h >>> 24] ^ r[d >> 16 & 255] ^ l[m >> 8 & 255] ^ c[g & 255] ^ n[A + 3], A += 4, d = f, m = p, g = v;
    for (let b = 0; b < 4; b++)
      s[t ? 3 & -b : b] = u[d >>> 24] << 24 ^ u[m >> 16 & 255] << 16 ^ u[g >> 8 & 255] << 8 ^ u[h & 255] ^ n[A++], f = d, d = m, m = g, g = h, h = f;
    return s;
  }
};
const xy = {
  /** 
   * Generate random words with pure js, cryptographically not as strong & safe as native implementation.
   * @param {TypedArray} typedArray The array to fill.
   * @return {TypedArray} The random values.
   */
  getRandomValues(e) {
    const t = new Uint32Array(e.buffer), n = (a) => {
      let s = 987654321;
      const o = 4294967295;
      return function() {
        return s = 36969 * (s & 65535) + (s >> 16) & o, a = 18e3 * (a & 65535) + (a >> 16) & o, (((s << 16) + a & o) / 4294967296 + 0.5) * (Math.random() > 0.5 ? 1 : -1);
      };
    };
    for (let a = 0, s; a < e.length; a += 4) {
      const o = n((s || Math.random()) * 4294967296);
      s = o() * 987654071, t[a / 4] = o() * 4294967296 | 0;
    }
    return e;
  }
}, sf = {};
sf.ctrGladman = class {
  constructor(e, t) {
    this._prf = e, this._initIv = t, this._iv = t;
  }
  reset() {
    this._iv = this._initIv;
  }
  /** Input some data to calculate.
   * @param {bitArray} data the data to process, it must be intergral multiple of 128 bits unless it's the last.
   */
  update(e) {
    return this.calculate(this._prf, e, this._iv);
  }
  incWord(e) {
    if ((e >> 24 & 255) === 255) {
      let t = e >> 16 & 255, n = e >> 8 & 255, a = e & 255;
      t === 255 ? (t = 0, n === 255 ? (n = 0, a === 255 ? a = 0 : ++a) : ++n) : ++t, e = 0, e += t << 16, e += n << 8, e += a;
    } else
      e += 1 << 24;
    return e;
  }
  incCounter(e) {
    (e[0] = this.incWord(e[0])) === 0 && (e[1] = this.incWord(e[1]));
  }
  calculate(e, t, n) {
    let a;
    if (!(a = t.length))
      return [];
    const s = dt.bitLength(t);
    for (let o = 0; o < a; o += 4) {
      this.incCounter(n);
      const i = e.encrypt(n);
      t[o] ^= i[0], t[o + 1] ^= i[1], t[o + 2] ^= i[2], t[o + 3] ^= i[3];
    }
    return dt.clamp(t, s);
  }
};
const wa = {
  importKey(e) {
    return new wa.hmacSha1(Mo.bytes.toBits(e));
  },
  pbkdf2(e, t, n, a) {
    if (n = n || 1e4, a < 0 || n < 0)
      throw new Error("invalid params to pbkdf2");
    const s = (a >> 5) + 1 << 2;
    let o, i, r, l, c;
    const u = new ArrayBuffer(s), d = new DataView(u);
    let m = 0;
    const g = dt;
    for (t = Mo.bytes.toBits(t), c = 1; m < (s || 1); c++) {
      for (o = i = e.encrypt(g.concat(t, [c])), r = 1; r < n; r++)
        for (i = e.encrypt(i), l = 0; l < i.length; l++)
          o[l] ^= i[l];
      for (r = 0; m < (s || 1) && r < o.length; r++)
        d.setInt32(m, o[r]), m += 4;
    }
    return u.slice(0, a / 8);
  }
};
wa.hmacSha1 = class {
  constructor(e) {
    const t = this, n = t._hash = nf.sha1, a = [[], []];
    t._baseHash = [new n(), new n()];
    const s = t._baseHash[0].blockSize / 32;
    e.length > s && (e = new n().update(e).finalize());
    for (let o = 0; o < s; o++)
      a[0][o] = e[o] ^ 909522486, a[1][o] = e[o] ^ 1549556828;
    t._baseHash[0].update(a[0]), t._baseHash[1].update(a[1]), t._resultHash = new n(t._baseHash[0]);
  }
  reset() {
    const e = this;
    e._resultHash = new e._hash(e._baseHash[0]), e._updated = !1;
  }
  update(e) {
    const t = this;
    t._updated = !0, t._resultHash.update(e);
  }
  digest() {
    const e = this, t = e._resultHash.finalize(), n = new e._hash(e._baseHash[1]).update(t).finalize();
    return e.reset(), n;
  }
  encrypt(e) {
    if (this._updated)
      throw new Error("encrypt on already updated hmac called!");
    return this.update(e), this.digest(e);
  }
};
const Ey = typeof crypto != Ca && typeof crypto.getRandomValues == Kr, of = "Invalid password", rf = "Invalid signature", lf = "zipjs-abort-check-password";
function cf(e) {
  return Ey ? crypto.getRandomValues(e) : xy.getRandomValues(e);
}
const Ra = 16, Cy = "raw", uf = { name: "PBKDF2" }, wy = { name: "HMAC" }, Iy = "SHA-1", By = Object.assign({ hash: wy }, uf), cr = Object.assign({ iterations: 1e3, hash: { name: Iy } }, uf), ky = ["deriveBits"], Ms = [8, 12, 16], us = [16, 24, 32], Qn = 10, _y = [0, 0, 0, 0], ei = typeof crypto != Ca, $s = ei && crypto.subtle, df = ei && typeof $s != Ca, ln = Mo.bytes, Sy = af.aes, Dy = sf.ctrGladman, Ty = wa.hmacSha1;
let gc = ei && df && typeof $s.importKey == Kr, hc = ei && df && typeof $s.deriveBits == Kr;
class My extends TransformStream {
  constructor({ password: t, rawPassword: n, signed: a, encryptionStrength: s, checkPasswordOnly: o }) {
    super({
      start() {
        Object.assign(this, {
          ready: new Promise((i) => this.resolveReady = i),
          password: mf(t, n),
          signed: a,
          strength: s - 1,
          pending: new Uint8Array()
        });
      },
      async transform(i, r) {
        const l = this, {
          password: c,
          strength: u,
          resolveReady: d,
          ready: m
        } = l;
        c ? (await Oy(l, u, c, Mt(i, 0, Ms[u] + 2)), i = Mt(i, Ms[u] + 2), o ? r.error(new Error(lf)) : d()) : await m;
        const g = new Uint8Array(i.length - Qn - (i.length - Qn) % Ra);
        r.enqueue(ff(l, i, g, 0, Qn, !0));
      },
      async flush(i) {
        const {
          signed: r,
          ctr: l,
          hmac: c,
          pending: u,
          ready: d
        } = this;
        if (c && l) {
          await d;
          const m = Mt(u, 0, u.length - Qn), g = Mt(u, u.length - Qn);
          let h = new Uint8Array();
          if (m.length) {
            const A = Os(ln, m);
            c.update(A);
            const f = l.update(A);
            h = Ls(ln, f);
          }
          if (r) {
            const A = Mt(Ls(ln, c.digest()), 0, Qn);
            for (let f = 0; f < Qn; f++)
              if (A[f] != g[f])
                throw new Error(rf);
          }
          i.enqueue(h);
        }
      }
    });
  }
}
class Ly extends TransformStream {
  constructor({ password: t, rawPassword: n, encryptionStrength: a }) {
    let s;
    super({
      start() {
        Object.assign(this, {
          ready: new Promise((o) => this.resolveReady = o),
          password: mf(t, n),
          strength: a - 1,
          pending: new Uint8Array()
        });
      },
      async transform(o, i) {
        const r = this, {
          password: l,
          strength: c,
          resolveReady: u,
          ready: d
        } = r;
        let m = new Uint8Array();
        l ? (m = await Ny(r, c, l), u()) : await d;
        const g = new Uint8Array(m.length + o.length - o.length % Ra);
        g.set(m, 0), i.enqueue(ff(r, o, g, m.length, 0));
      },
      async flush(o) {
        const {
          ctr: i,
          hmac: r,
          pending: l,
          ready: c
        } = this;
        if (r && i) {
          await c;
          let u = new Uint8Array();
          if (l.length) {
            const d = i.update(Os(ln, l));
            r.update(d), u = Ls(ln, d);
          }
          s.signature = Ls(ln, r.digest()).slice(0, Qn), o.enqueue(Wr(u, s.signature));
        }
      }
    }), s = this;
  }
}
function ff(e, t, n, a, s, o) {
  const {
    ctr: i,
    hmac: r,
    pending: l
  } = e, c = t.length - s;
  l.length && (t = Wr(l, t), n = Fy(n, c - c % Ra));
  let u;
  for (u = 0; u <= c - Ra; u += Ra) {
    const d = Os(ln, Mt(t, u, u + Ra));
    o && r.update(d);
    const m = i.update(d);
    o || r.update(m), n.set(Ls(ln, m), u + a);
  }
  return e.pending = Mt(t, u), n;
}
async function Oy(e, t, n, a) {
  const s = await pf(e, t, n, Mt(a, 0, Ms[t])), o = Mt(a, Ms[t]);
  if (s[0] != o[0] || s[1] != o[1])
    throw new Error(of);
}
async function Ny(e, t, n) {
  const a = cf(new Uint8Array(Ms[t])), s = await pf(e, t, n, a);
  return Wr(a, s);
}
async function pf(e, t, n, a) {
  e.password = null;
  const s = await Ry(Cy, n, By, !1, ky), o = await Py(Object.assign({ salt: a }, cr), s, 8 * (us[t] * 2 + 2)), i = new Uint8Array(o), r = Os(ln, Mt(i, 0, us[t])), l = Os(ln, Mt(i, us[t], us[t] * 2)), c = Mt(i, us[t] * 2);
  return Object.assign(e, {
    keys: {
      key: r,
      authentication: l,
      passwordVerification: c
    },
    ctr: new Dy(new Sy(r), Array.from(_y)),
    hmac: new Ty(l)
  }), c;
}
async function Ry(e, t, n, a, s) {
  if (gc)
    try {
      return await $s.importKey(e, t, n, a, s);
    } catch {
      return gc = !1, wa.importKey(t);
    }
  else
    return wa.importKey(t);
}
async function Py(e, t, n) {
  if (hc)
    try {
      return await $s.deriveBits(e, t, n);
    } catch {
      return hc = !1, wa.pbkdf2(t, e.salt, cr.iterations, n);
    }
  else
    return wa.pbkdf2(t, e.salt, cr.iterations, n);
}
function mf(e, t) {
  return t === Vr ? by(e) : t;
}
function Wr(e, t) {
  let n = e;
  return e.length + t.length && (n = new Uint8Array(e.length + t.length), n.set(e, 0), n.set(t, e.length)), n;
}
function Fy(e, t) {
  if (t && t > e.length) {
    const n = e;
    e = new Uint8Array(t), e.set(n, 0);
  }
  return e;
}
function Mt(e, t, n) {
  return e.subarray(t, n);
}
function Ls(e, t) {
  return e.fromBits(t);
}
function Os(e, t) {
  return e.toBits(t);
}
const bs = 12;
class Qy extends TransformStream {
  constructor({ password: t, passwordVerification: n, checkPasswordOnly: a }) {
    super({
      start() {
        Object.assign(this, {
          password: t,
          passwordVerification: n
        }), Af(this, t);
      },
      transform(s, o) {
        const i = this;
        if (i.password) {
          const r = vc(i, s.subarray(0, bs));
          if (i.password = null, r.at(-1) != i.passwordVerification)
            throw new Error(of);
          s = s.subarray(bs);
        }
        a ? o.error(new Error(lf)) : o.enqueue(vc(i, s));
      }
    });
  }
}
class Uy extends TransformStream {
  constructor({ password: t, passwordVerification: n }) {
    super({
      start() {
        Object.assign(this, {
          password: t,
          passwordVerification: n
        }), Af(this, t);
      },
      transform(a, s) {
        const o = this;
        let i, r;
        if (o.password) {
          o.password = null;
          const l = cf(new Uint8Array(bs));
          l[bs - 1] = o.passwordVerification, i = new Uint8Array(a.length + l.length), i.set(yc(o, l), 0), r = bs;
        } else
          i = new Uint8Array(a.length), r = 0;
        i.set(yc(o, a), r), s.enqueue(i);
      }
    });
  }
}
function vc(e, t) {
  const n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++)
    n[a] = gf(e) ^ t[a], zr(e, n[a]);
  return n;
}
function yc(e, t) {
  const n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++)
    n[a] = gf(e) ^ t[a], zr(e, t[a]);
  return n;
}
function Af(e, t) {
  const n = [305419896, 591751049, 878082192];
  Object.assign(e, {
    keys: n,
    crcKey0: new lr(n[0]),
    crcKey2: new lr(n[2])
  });
  for (let a = 0; a < t.length; a++)
    zr(e, t.charCodeAt(a));
}
function zr(e, t) {
  let [n, a, s] = e.keys;
  e.crcKey0.append([t]), n = ~e.crcKey0.get(), a = bc(Math.imul(bc(a + hf(n)), 134775813) + 1), e.crcKey2.append([a >>> 24]), s = ~e.crcKey2.get(), e.keys = [n, a, s];
}
function gf(e) {
  const t = e.keys[2] | 2;
  return hf(Math.imul(t, t ^ 1) >>> 8);
}
function hf(e) {
  return e & 255;
}
function bc(e) {
  return e & 4294967295;
}
const Gy = "Invalid uncompressed size", Yy = "deflate-raw", jy = "deflate64-raw";
class Hy extends TransformStream {
  constructor(t, { chunkSize: n, CompressionStreamZlib: a, CompressionStream: s }) {
    super({});
    const { compressed: o, encrypted: i, useCompressionStream: r, zipCrypto: l, signed: c, level: u } = t, d = this;
    let m, g, h = super.readable;
    (!i || l) && c && (m = new tf(), h = cn(h, m)), o && (h = yf(h, r, { level: u, chunkSize: n }, s, a, s)), i && (l ? h = cn(h, new Uy(t)) : (g = new Ly(t), h = cn(h, g))), vf(d, h, () => {
      let A;
      i && !l && (A = g.signature), (!i || l) && c && (A = new DataView(m.value.buffer).getUint32(0)), d.signature = A;
    });
  }
}
class Vy extends TransformStream {
  constructor(t, { chunkSize: n, DecompressionStreamZlib: a, DecompressionStream: s }) {
    super({});
    const { zipCrypto: o, encrypted: i, signed: r, signature: l, compressed: c, useCompressionStream: u, deflate64: d } = t;
    let m, g, h = super.readable;
    i && (o ? h = cn(h, new Qy(t)) : (g = new My(t), h = cn(h, g))), c && (h = yf(h, u, { chunkSize: n, deflate64: d }, s, a, s)), (!i || o) && r && (m = new tf(), h = cn(h, m)), vf(this, h, () => {
      if ((!i || o) && r) {
        const A = new DataView(m.value.buffer);
        if (l != A.getUint32(0, !1))
          throw new Error(rf);
      }
    });
  }
}
function vf(e, t, n) {
  t = cn(t, new TransformStream({ flush: n })), Object.defineProperty(e, "readable", {
    get() {
      return t;
    }
  });
}
function yf(e, t, n, a, s, o) {
  const i = t && a ? a : s || o, r = n.deflate64 ? jy : Yy;
  try {
    e = cn(e, new i(r, n));
  } catch (l) {
    if (t)
      if (s)
        e = cn(e, new s(r, n));
      else if (o)
        e = cn(e, new o(r, n));
      else
        throw l;
    else
      throw l;
  }
  return e;
}
function cn(e, t) {
  return e.pipeThrough(t);
}
const Ky = "deflate", Wy = "inflate";
class nM extends TransformStream {
  constructor(t, n) {
    super({});
    const a = this, { codecType: s } = t;
    let o;
    s.startsWith(Ky) ? o = Hy : s.startsWith(Wy) && (o = Vy), a.outputSize = 0;
    let i = 0;
    const r = new o(t, n), l = super.readable, c = new TransformStream({
      transform(d, m) {
        d && d.length && (i += d.length, m.enqueue(d));
      },
      flush() {
        Object.assign(a, {
          inputSize: i
        });
      }
    }), u = new TransformStream({
      transform(d, m) {
        if (d && d.length && (m.enqueue(d), a.outputSize += d.length, t.outputSize !== Vr && a.outputSize > t.outputSize))
          throw new Error(Gy);
      },
      flush() {
        const { signature: d } = r;
        Object.assign(a, {
          signature: d,
          inputSize: i
        });
      }
    });
    Object.defineProperty(a, "readable", {
      get() {
        return l.pipeThrough(c).pipeThrough(r).pipeThrough(u);
      }
    });
  }
}
class aM extends TransformStream {
  constructor(t) {
    let n;
    super({
      transform: a,
      flush(s) {
        n && n.length && s.enqueue(n);
      }
    });
    function a(s, o) {
      if (n) {
        const i = new Uint8Array(n.length + s.length);
        i.set(n), i.set(s, n.length), s = i, n = null;
      }
      s.length > t ? (o.enqueue(s.slice(0, t)), a(s.slice(t), o)) : n = s;
    }
  }
}
class sM extends TransformStream {
  constructor({ onstart: t, onprogress: n, size: a, onend: s }) {
    let o = 0;
    super({
      async start() {
        t && await wi(t, a);
      },
      async transform(i, r) {
        o += i.length, n && await wi(n, o, a), r.enqueue(i);
      },
      async flush() {
        s && await wi(s, o);
      }
    });
  }
}
async function wi(e, ...t) {
  try {
    await e(...t);
  } catch {
  }
}
const zy = "Writer not initialized", $y = "writable";
class qy {
  constructor() {
    this.size = 0;
  }
  init() {
    this.initialized = !0;
  }
}
class Jy extends qy {
  constructor() {
    super();
    const t = this, n = new WritableStream({
      write(a) {
        if (!t.initialized)
          throw new Error(zy);
        return t.writeUint8Array(a);
      }
    });
    Object.defineProperty(t, $y, {
      get() {
        return n;
      }
    });
  }
  writeUint8Array() {
  }
}
class Xy extends Jy {
  init(t = 0) {
    Object.assign(this, {
      offset: 0,
      array: new Uint8Array(t)
    }), super.init();
  }
  writeUint8Array(t) {
    const n = this;
    if (n.offset + t.length > n.array.length) {
      const a = n.array;
      n.array = new Uint8Array(a.length + t.length), n.array.set(a);
    }
    n.array.set(t, n.offset), n.offset += t.length;
  }
  getData() {
    return this.array;
  }
}
const Zy = "\0☺☻♥♦♣♠•◘○◙♂♀♪♫☼►◄↕‼¶§▬↨↑↓→←∟↔▲▼ !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~⌂ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ".split("");
Zy.length == 256;
try {
  Zo({ baseURI: import.meta.url });
} catch {
}
const vt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function eb(e) {
  let t;
  e({ wasmURI: () => (t || (t = "data:application/wasm;base64," + ((n) => {
    n = ((i) => {
      const r = (i = (i + "").replace(/[^A-Za-z0-9+/=]/g, "")).length, l = [];
      for (let c = 0; r > c; c += 4) {
        const u = vt.indexOf(i[c]) << 18 | vt.indexOf(i[c + 1]) << 12 | (63 & vt.indexOf(i[c + 2])) << 6 | 63 & vt.indexOf(i[c + 3]);
        l.push(u >> 16 & 255), i[c + 2] !== "=" && l.push(u >> 8 & 255), i[c + 3] !== "=" && l.push(255 & u);
      }
      return new Uint8Array(l);
    })(n);
    let a = new Uint8Array(1024), s = 0;
    for (let i = 0; i < n.length; ) {
      const r = n[i++];
      if (128 & r) {
        const l = 3 + (127 & r), c = n[i++] << 8 | n[i++], u = s - c;
        o(s + l);
        for (let d = 0; l > d; d++) a[s++] = a[u + d];
      } else {
        const l = r;
        o(s + l);
        for (let c = 0; l > c && i < n.length; c++) a[s++] = n[i++];
      }
    }
    return ((i) => {
      let r = "";
      const l = i.length;
      let c = 0;
      for (; l > c + 2; c += 3) {
        const d = i[c] << 16 | i[c + 1] << 8 | i[c + 2];
        r += vt[d >> 18 & 63] + vt[d >> 12 & 63] + vt[d >> 6 & 63] + vt[63 & d];
      }
      const u = l - c;
      if (u === 1) {
        const d = i[c] << 16;
        r += vt[d >> 18 & 63] + vt[d >> 12 & 63] + "==";
      } else if (u === 2) {
        const d = i[c] << 16 | i[c + 1] << 8;
        r += vt[d >> 18 & 63] + vt[d >> 12 & 63] + vt[d >> 6 & 63] + "=";
      }
      return r;
    })(new Uint8Array(a.buffer.slice(0, s)));
    function o(i) {
      if (a.length < i) {
        let r = 2 * a.length;
        for (; i > r; ) r *= 2;
        const l = new Uint8Array(r);
        l.set(a.subarray(0, s)), a = l;
      }
    }
  })("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")), t) });
}
let He, Ii, ds, xc;
function bf(e, t, n = {}) {
  const a = typeof n.level == "number" ? n.level : -1, s = typeof n.outBuffer == "number" ? n.outBuffer : 64 * 1024, o = typeof n.inBufferSize == "number" ? n.inBufferSize : 64 * 1024;
  return new TransformStream({
    start() {
      let i;
      if (this.out = Ii(s), this.in = Ii(o), this.inBufferSize = o, this._scratch = new Uint8Array(s), e ? (this._process = He.deflate_process, this._last_consumed = He.deflate_last_consumed, this._end = He.deflate_end, this.streamHandle = He.deflate_new(), t === "gzip" ? i = He.deflate_init_gzip(this.streamHandle, a) : t === "deflate-raw" ? i = He.deflate_init_raw(this.streamHandle, a) : i = He.deflate_init(this.streamHandle, a)) : t === "deflate64-raw" ? (this._process = He.inflate9_process, this._last_consumed = He.inflate9_last_consumed, this._end = He.inflate9_end, this.streamHandle = He.inflate9_new(), i = He.inflate9_init_raw(this.streamHandle)) : (this._process = He.inflate_process, this._last_consumed = He.inflate_last_consumed, this._end = He.inflate_end, this.streamHandle = He.inflate_new(), t === "deflate-raw" ? i = He.inflate_init_raw(this.streamHandle) : t === "gzip" ? i = He.inflate_init_gzip(this.streamHandle) : i = He.inflate_init(this.streamHandle)), i !== 0)
        throw new Error("init failed:" + i);
    },
    transform(i, r) {
      try {
        const l = i, c = new Uint8Array(xc.buffer), u = this._process, d = this._last_consumed, m = this.out, g = this._scratch;
        let h = 0;
        for (; h < l.length; ) {
          const A = Math.min(l.length - h, 32768);
          (!this.in || this.inBufferSize < A) && (this.in, this.in = Ii(A), this.inBufferSize = A), c.set(l.subarray(h, h + A), this.in);
          const f = u(this.streamHandle, this.in, A, m, s, 0);
          if (!e && f < 0)
            throw new Error("process error:" + f);
          const p = f & 16777215;
          p && (g.set(c.subarray(m, m + p), 0), r.enqueue(g.slice(0, p)));
          const v = d(this.streamHandle);
          if (v === 0)
            break;
          h += v;
        }
      } catch (l) {
        this._end && this.streamHandle && this._end(this.streamHandle), this.in, this.out, r.error(l);
      }
    },
    flush(i) {
      try {
        const r = new Uint8Array(xc.buffer), l = this._process, c = this.out, u = this._scratch;
        for (; ; ) {
          const d = l(this.streamHandle, 0, 0, c, s, 4);
          if (!e && d < 0)
            throw new Error("process error:" + d);
          const m = d & 16777215, g = d >> 24 & 255;
          if (m && (u.set(r.subarray(c, c + m), 0), i.enqueue(u.slice(0, m))), g === 1 || m === 0)
            break;
        }
      } catch (r) {
        i.error(r);
      } finally {
        if (this._end && this.streamHandle) {
          const r = this._end(this.streamHandle);
          r !== 0 && i.error(new Error("end error:" + r));
        }
        this.in, this.out;
      }
    }
  });
}
class tb {
  constructor(t = "deflate", n) {
    return bf(!0, t, n);
  }
}
class nb {
  constructor(t = "deflate", n) {
    return bf(!1, t, n);
  }
}
eb(Zo);
Zo({
  CompressionStreamZlib: tb,
  DecompressionStreamZlib: nb
});
const Bi = {
  application: {
    "andrew-inset": "ez",
    annodex: "anx",
    "atom+xml": "atom",
    "atomcat+xml": "atomcat",
    "atomserv+xml": "atomsrv",
    bbolin: "lin",
    "cu-seeme": "cu",
    "davmount+xml": "davmount",
    dsptype: "tsp",
    ecmascript: [
      "es",
      "ecma"
    ],
    futuresplash: "spl",
    hta: "hta",
    "java-archive": "jar",
    "java-serialized-object": "ser",
    "java-vm": "class",
    m3g: "m3g",
    "mac-binhex40": "hqx",
    mathematica: [
      "nb",
      "ma",
      "mb"
    ],
    msaccess: "mdb",
    msword: [
      "doc",
      "dot",
      "wiz"
    ],
    mxf: "mxf",
    oda: "oda",
    ogg: "ogx",
    pdf: "pdf",
    "pgp-keys": "key",
    "pgp-signature": [
      "asc",
      "sig"
    ],
    "pics-rules": "prf",
    postscript: [
      "ps",
      "ai",
      "eps",
      "epsi",
      "epsf",
      "eps2",
      "eps3"
    ],
    rar: "rar",
    "rdf+xml": "rdf",
    "rss+xml": "rss",
    rtf: "rtf",
    "xhtml+xml": [
      "xhtml",
      "xht"
    ],
    xml: [
      "xml",
      "xsl",
      "xsd",
      "xpdl"
    ],
    "xspf+xml": "xspf",
    zip: "zip",
    "vnd.android.package-archive": "apk",
    "vnd.cinderella": "cdy",
    "vnd.google-earth.kml+xml": "kml",
    "vnd.google-earth.kmz": "kmz",
    "vnd.mozilla.xul+xml": "xul",
    "vnd.ms-excel": [
      "xls",
      "xlb",
      "xlt",
      "xlm",
      "xla",
      "xlc",
      "xlw"
    ],
    "vnd.ms-pki.seccat": "cat",
    "vnd.ms-pki.stl": "stl",
    "vnd.ms-powerpoint": [
      "ppt",
      "pps",
      "pot",
      "ppa",
      "pwz"
    ],
    "vnd.oasis.opendocument.chart": "odc",
    "vnd.oasis.opendocument.database": "odb",
    "vnd.oasis.opendocument.formula": "odf",
    "vnd.oasis.opendocument.graphics": "odg",
    "vnd.oasis.opendocument.graphics-template": "otg",
    "vnd.oasis.opendocument.image": "odi",
    "vnd.oasis.opendocument.presentation": "odp",
    "vnd.oasis.opendocument.presentation-template": "otp",
    "vnd.oasis.opendocument.spreadsheet": "ods",
    "vnd.oasis.opendocument.spreadsheet-template": "ots",
    "vnd.oasis.opendocument.text": "odt",
    "vnd.oasis.opendocument.text-master": [
      "odm",
      "otm"
    ],
    "vnd.oasis.opendocument.text-template": "ott",
    "vnd.oasis.opendocument.text-web": "oth",
    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
    "vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
    "vnd.openxmlformats-officedocument.presentationml.template": "potx",
    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
    "vnd.smaf": "mmf",
    "vnd.stardivision.calc": "sdc",
    "vnd.stardivision.chart": "sds",
    "vnd.stardivision.draw": "sda",
    "vnd.stardivision.impress": "sdd",
    "vnd.stardivision.math": [
      "sdf",
      "smf"
    ],
    "vnd.stardivision.writer": [
      "sdw",
      "vor"
    ],
    "vnd.stardivision.writer-global": "sgl",
    "vnd.sun.xml.calc": "sxc",
    "vnd.sun.xml.calc.template": "stc",
    "vnd.sun.xml.draw": "sxd",
    "vnd.sun.xml.draw.template": "std",
    "vnd.sun.xml.impress": "sxi",
    "vnd.sun.xml.impress.template": "sti",
    "vnd.sun.xml.math": "sxm",
    "vnd.sun.xml.writer": "sxw",
    "vnd.sun.xml.writer.global": "sxg",
    "vnd.sun.xml.writer.template": "stw",
    "vnd.symbian.install": [
      "sis",
      "sisx"
    ],
    "vnd.visio": [
      "vsd",
      "vst",
      "vss",
      "vsw",
      "vsdx",
      "vssx",
      "vstx",
      "vssm",
      "vstm"
    ],
    "vnd.wap.wbxml": "wbxml",
    "vnd.wap.wmlc": "wmlc",
    "vnd.wap.wmlscriptc": "wmlsc",
    "vnd.wordperfect": "wpd",
    "vnd.wordperfect5.1": "wp5",
    "x-123": "wk",
    "x-7z-compressed": "7z",
    "x-abiword": "abw",
    "x-apple-diskimage": "dmg",
    "x-bcpio": "bcpio",
    "x-bittorrent": "torrent",
    "x-cbr": [
      "cbr",
      "cba",
      "cbt",
      "cb7"
    ],
    "x-cbz": "cbz",
    "x-cdf": [
      "cdf",
      "cda"
    ],
    "x-cdlink": "vcd",
    "x-chess-pgn": "pgn",
    "x-cpio": "cpio",
    "x-csh": "csh",
    "x-director": [
      "dir",
      "dxr",
      "cst",
      "cct",
      "cxt",
      "w3d",
      "fgd",
      "swa"
    ],
    "x-dms": "dms",
    "x-doom": "wad",
    "x-dvi": "dvi",
    "x-httpd-eruby": "rhtml",
    "x-font": "pcf.Z",
    "x-freemind": "mm",
    "x-gnumeric": "gnumeric",
    "x-go-sgf": "sgf",
    "x-graphing-calculator": "gcf",
    "x-gtar": [
      "gtar",
      "taz"
    ],
    "x-hdf": "hdf",
    "x-httpd-php": [
      "phtml",
      "pht",
      "php"
    ],
    "x-httpd-php-source": "phps",
    "x-httpd-php3": "php3",
    "x-httpd-php3-preprocessed": "php3p",
    "x-httpd-php4": "php4",
    "x-httpd-php5": "php5",
    "x-ica": "ica",
    "x-info": "info",
    "x-internet-signup": [
      "ins",
      "isp"
    ],
    "x-iphone": "iii",
    "x-iso9660-image": "iso",
    "x-java-jnlp-file": "jnlp",
    "x-jmol": "jmz",
    "x-killustrator": "kil",
    "x-latex": "latex",
    "x-lyx": "lyx",
    "x-lzx": "lzx",
    "x-maker": [
      "frm",
      "fb",
      "fbdoc"
    ],
    "x-ms-wmd": "wmd",
    "x-msdos-program": [
      "com",
      "exe",
      "bat",
      "dll"
    ],
    "x-netcdf": [
      "nc"
    ],
    "x-ns-proxy-autoconfig": [
      "pac",
      "dat"
    ],
    "x-nwc": "nwc",
    "x-object": "o",
    "x-oz-application": "oza",
    "x-pkcs7-certreqresp": "p7r",
    "x-python-code": [
      "pyc",
      "pyo"
    ],
    "x-qgis": [
      "qgs",
      "shp",
      "shx"
    ],
    "x-quicktimeplayer": "qtl",
    "x-redhat-package-manager": [
      "rpm",
      "rpa"
    ],
    "x-ruby": "rb",
    "x-sh": "sh",
    "x-shar": "shar",
    "x-shockwave-flash": [
      "swf",
      "swfl"
    ],
    "x-silverlight": "scr",
    "x-stuffit": "sit",
    "x-sv4cpio": "sv4cpio",
    "x-sv4crc": "sv4crc",
    "x-tar": "tar",
    "x-tex-gf": "gf",
    "x-tex-pk": "pk",
    "x-texinfo": [
      "texinfo",
      "texi"
    ],
    "x-trash": [
      "~",
      "%",
      "bak",
      "old",
      "sik"
    ],
    "x-ustar": "ustar",
    "x-wais-source": "src",
    "x-wingz": "wz",
    "x-x509-ca-cert": [
      "crt",
      "der",
      "cer"
    ],
    "x-xcf": "xcf",
    "x-xfig": "fig",
    "x-xpinstall": "xpi",
    applixware: "aw",
    "atomsvc+xml": "atomsvc",
    "ccxml+xml": "ccxml",
    "cdmi-capability": "cdmia",
    "cdmi-container": "cdmic",
    "cdmi-domain": "cdmid",
    "cdmi-object": "cdmio",
    "cdmi-queue": "cdmiq",
    "docbook+xml": "dbk",
    "dssc+der": "dssc",
    "dssc+xml": "xdssc",
    "emma+xml": "emma",
    "epub+zip": "epub",
    exi: "exi",
    "font-tdpfr": "pfr",
    "gml+xml": "gml",
    "gpx+xml": "gpx",
    gxf: "gxf",
    hyperstudio: "stk",
    "inkml+xml": [
      "ink",
      "inkml"
    ],
    ipfix: "ipfix",
    "jsonml+json": "jsonml",
    "lost+xml": "lostxml",
    "mads+xml": "mads",
    marc: "mrc",
    "marcxml+xml": "mrcx",
    "mathml+xml": [
      "mathml",
      "mml"
    ],
    mbox: "mbox",
    "mediaservercontrol+xml": "mscml",
    "metalink+xml": "metalink",
    "metalink4+xml": "meta4",
    "mets+xml": "mets",
    "mods+xml": "mods",
    mp21: [
      "m21",
      "mp21"
    ],
    mp4: "mp4s",
    "oebps-package+xml": "opf",
    "omdoc+xml": "omdoc",
    onenote: [
      "onetoc",
      "onetoc2",
      "onetmp",
      "onepkg"
    ],
    oxps: "oxps",
    "patch-ops-error+xml": "xer",
    "pgp-encrypted": "pgp",
    pkcs10: "p10",
    "pkcs7-mime": [
      "p7m",
      "p7c"
    ],
    "pkcs7-signature": "p7s",
    pkcs8: "p8",
    "pkix-attr-cert": "ac",
    "pkix-crl": "crl",
    "pkix-pkipath": "pkipath",
    pkixcmp: "pki",
    "pls+xml": "pls",
    "prs.cww": "cww",
    "pskc+xml": "pskcxml",
    "reginfo+xml": "rif",
    "relax-ng-compact-syntax": "rnc",
    "resource-lists+xml": "rl",
    "resource-lists-diff+xml": "rld",
    "rls-services+xml": "rs",
    "rpki-ghostbusters": "gbr",
    "rpki-manifest": "mft",
    "rpki-roa": "roa",
    "rsd+xml": "rsd",
    "sbml+xml": "sbml",
    "scvp-cv-request": "scq",
    "scvp-cv-response": "scs",
    "scvp-vp-request": "spq",
    "scvp-vp-response": "spp",
    sdp: "sdp",
    "set-payment-initiation": "setpay",
    "set-registration-initiation": "setreg",
    "shf+xml": "shf",
    "sparql-query": "rq",
    "sparql-results+xml": "srx",
    srgs: "gram",
    "srgs+xml": "grxml",
    "sru+xml": "sru",
    "ssdl+xml": "ssdl",
    "ssml+xml": "ssml",
    "tei+xml": [
      "tei",
      "teicorpus"
    ],
    "thraud+xml": "tfi",
    "timestamped-data": "tsd",
    "vnd.3gpp.pic-bw-large": "plb",
    "vnd.3gpp.pic-bw-small": "psb",
    "vnd.3gpp.pic-bw-var": "pvb",
    "vnd.3gpp2.tcap": "tcap",
    "vnd.3m.post-it-notes": "pwn",
    "vnd.accpac.simply.aso": "aso",
    "vnd.accpac.simply.imp": "imp",
    "vnd.acucobol": "acu",
    "vnd.acucorp": [
      "atc",
      "acutc"
    ],
    "vnd.adobe.air-application-installer-package+zip": "air",
    "vnd.adobe.formscentral.fcdt": "fcdt",
    "vnd.adobe.fxp": [
      "fxp",
      "fxpl"
    ],
    "vnd.adobe.xdp+xml": "xdp",
    "vnd.adobe.xfdf": "xfdf",
    "vnd.ahead.space": "ahead",
    "vnd.airzip.filesecure.azf": "azf",
    "vnd.airzip.filesecure.azs": "azs",
    "vnd.amazon.ebook": "azw",
    "vnd.americandynamics.acc": "acc",
    "vnd.amiga.ami": "ami",
    "vnd.anser-web-certificate-issue-initiation": "cii",
    "vnd.anser-web-funds-transfer-initiation": "fti",
    "vnd.antix.game-component": "atx",
    "vnd.apple.installer+xml": "mpkg",
    "vnd.apple.mpegurl": "m3u8",
    "vnd.aristanetworks.swi": "swi",
    "vnd.astraea-software.iota": "iota",
    "vnd.audiograph": "aep",
    "vnd.blueice.multipass": "mpm",
    "vnd.bmi": "bmi",
    "vnd.businessobjects": "rep",
    "vnd.chemdraw+xml": "cdxml",
    "vnd.chipnuts.karaoke-mmd": "mmd",
    "vnd.claymore": "cla",
    "vnd.cloanto.rp9": "rp9",
    "vnd.clonk.c4group": [
      "c4g",
      "c4d",
      "c4f",
      "c4p",
      "c4u"
    ],
    "vnd.cluetrust.cartomobile-config": "c11amc",
    "vnd.cluetrust.cartomobile-config-pkg": "c11amz",
    "vnd.commonspace": "csp",
    "vnd.contact.cmsg": "cdbcmsg",
    "vnd.cosmocaller": "cmc",
    "vnd.crick.clicker": "clkx",
    "vnd.crick.clicker.keyboard": "clkk",
    "vnd.crick.clicker.palette": "clkp",
    "vnd.crick.clicker.template": "clkt",
    "vnd.crick.clicker.wordbank": "clkw",
    "vnd.criticaltools.wbs+xml": "wbs",
    "vnd.ctc-posml": "pml",
    "vnd.cups-ppd": "ppd",
    "vnd.curl.car": "car",
    "vnd.curl.pcurl": "pcurl",
    "vnd.dart": "dart",
    "vnd.data-vision.rdz": "rdz",
    "vnd.dece.data": [
      "uvf",
      "uvvf",
      "uvd",
      "uvvd"
    ],
    "vnd.dece.ttml+xml": [
      "uvt",
      "uvvt"
    ],
    "vnd.dece.unspecified": [
      "uvx",
      "uvvx"
    ],
    "vnd.dece.zip": [
      "uvz",
      "uvvz"
    ],
    "vnd.denovo.fcselayout-link": "fe_launch",
    "vnd.dna": "dna",
    "vnd.dolby.mlp": "mlp",
    "vnd.dpgraph": "dpg",
    "vnd.dreamfactory": "dfac",
    "vnd.ds-keypoint": "kpxx",
    "vnd.dvb.ait": "ait",
    "vnd.dvb.service": "svc",
    "vnd.dynageo": "geo",
    "vnd.ecowin.chart": "mag",
    "vnd.enliven": "nml",
    "vnd.epson.esf": "esf",
    "vnd.epson.msf": "msf",
    "vnd.epson.quickanime": "qam",
    "vnd.epson.salt": "slt",
    "vnd.epson.ssf": "ssf",
    "vnd.eszigno3+xml": [
      "es3",
      "et3"
    ],
    "vnd.ezpix-album": "ez2",
    "vnd.ezpix-package": "ez3",
    "vnd.fdf": "fdf",
    "vnd.fdsn.mseed": "mseed",
    "vnd.fdsn.seed": [
      "seed",
      "dataless"
    ],
    "vnd.flographit": "gph",
    "vnd.fluxtime.clip": "ftc",
    "vnd.framemaker": [
      "fm",
      "frame",
      "maker",
      "book"
    ],
    "vnd.frogans.fnc": "fnc",
    "vnd.frogans.ltf": "ltf",
    "vnd.fsc.weblaunch": "fsc",
    "vnd.fujitsu.oasys": "oas",
    "vnd.fujitsu.oasys2": "oa2",
    "vnd.fujitsu.oasys3": "oa3",
    "vnd.fujitsu.oasysgp": "fg5",
    "vnd.fujitsu.oasysprs": "bh2",
    "vnd.fujixerox.ddd": "ddd",
    "vnd.fujixerox.docuworks": "xdw",
    "vnd.fujixerox.docuworks.binder": "xbd",
    "vnd.fuzzysheet": "fzs",
    "vnd.genomatix.tuxedo": "txd",
    "vnd.geogebra.file": "ggb",
    "vnd.geogebra.tool": "ggt",
    "vnd.geometry-explorer": [
      "gex",
      "gre"
    ],
    "vnd.geonext": "gxt",
    "vnd.geoplan": "g2w",
    "vnd.geospace": "g3w",
    "vnd.gmx": "gmx",
    "vnd.grafeq": [
      "gqf",
      "gqs"
    ],
    "vnd.groove-account": "gac",
    "vnd.groove-help": "ghf",
    "vnd.groove-identity-message": "gim",
    "vnd.groove-injector": "grv",
    "vnd.groove-tool-message": "gtm",
    "vnd.groove-tool-template": "tpl",
    "vnd.groove-vcard": "vcg",
    "vnd.hal+xml": "hal",
    "vnd.handheld-entertainment+xml": "zmm",
    "vnd.hbci": "hbci",
    "vnd.hhe.lesson-player": "les",
    "vnd.hp-hpgl": "hpgl",
    "vnd.hp-hpid": "hpid",
    "vnd.hp-hps": "hps",
    "vnd.hp-jlyt": "jlt",
    "vnd.hp-pcl": "pcl",
    "vnd.hp-pclxl": "pclxl",
    "vnd.hydrostatix.sof-data": "sfd-hdstx",
    "vnd.ibm.minipay": "mpy",
    "vnd.ibm.modcap": [
      "afp",
      "listafp",
      "list3820"
    ],
    "vnd.ibm.rights-management": "irm",
    "vnd.ibm.secure-container": "sc",
    "vnd.iccprofile": [
      "icc",
      "icm"
    ],
    "vnd.igloader": "igl",
    "vnd.immervision-ivp": "ivp",
    "vnd.immervision-ivu": "ivu",
    "vnd.insors.igm": "igm",
    "vnd.intercon.formnet": [
      "xpw",
      "xpx"
    ],
    "vnd.intergeo": "i2g",
    "vnd.intu.qbo": "qbo",
    "vnd.intu.qfx": "qfx",
    "vnd.ipunplugged.rcprofile": "rcprofile",
    "vnd.irepository.package+xml": "irp",
    "vnd.is-xpr": "xpr",
    "vnd.isac.fcs": "fcs",
    "vnd.jam": "jam",
    "vnd.jcp.javame.midlet-rms": "rms",
    "vnd.jisp": "jisp",
    "vnd.joost.joda-archive": "joda",
    "vnd.kahootz": [
      "ktz",
      "ktr"
    ],
    "vnd.kde.karbon": "karbon",
    "vnd.kde.kchart": "chrt",
    "vnd.kde.kformula": "kfo",
    "vnd.kde.kivio": "flw",
    "vnd.kde.kontour": "kon",
    "vnd.kde.kpresenter": [
      "kpr",
      "kpt"
    ],
    "vnd.kde.kspread": "ksp",
    "vnd.kde.kword": [
      "kwd",
      "kwt"
    ],
    "vnd.kenameaapp": "htke",
    "vnd.kidspiration": "kia",
    "vnd.kinar": [
      "kne",
      "knp"
    ],
    "vnd.koan": [
      "skp",
      "skd",
      "skt",
      "skm"
    ],
    "vnd.kodak-descriptor": "sse",
    "vnd.las.las+xml": "lasxml",
    "vnd.llamagraphics.life-balance.desktop": "lbd",
    "vnd.llamagraphics.life-balance.exchange+xml": "lbe",
    "vnd.lotus-1-2-3": "123",
    "vnd.lotus-approach": "apr",
    "vnd.lotus-freelance": "pre",
    "vnd.lotus-notes": "nsf",
    "vnd.lotus-organizer": "org",
    "vnd.lotus-screencam": "scm",
    "vnd.lotus-wordpro": "lwp",
    "vnd.macports.portpkg": "portpkg",
    "vnd.mcd": "mcd",
    "vnd.medcalcdata": "mc1",
    "vnd.mediastation.cdkey": "cdkey",
    "vnd.mfer": "mwf",
    "vnd.mfmp": "mfm",
    "vnd.micrografx.flo": "flo",
    "vnd.micrografx.igx": "igx",
    "vnd.mif": "mif",
    "vnd.mobius.daf": "daf",
    "vnd.mobius.dis": "dis",
    "vnd.mobius.mbk": "mbk",
    "vnd.mobius.mqy": "mqy",
    "vnd.mobius.msl": "msl",
    "vnd.mobius.plc": "plc",
    "vnd.mobius.txf": "txf",
    "vnd.mophun.application": "mpn",
    "vnd.mophun.certificate": "mpc",
    "vnd.ms-artgalry": "cil",
    "vnd.ms-cab-compressed": "cab",
    "vnd.ms-excel.addin.macroenabled.12": "xlam",
    "vnd.ms-excel.sheet.binary.macroenabled.12": "xlsb",
    "vnd.ms-excel.sheet.macroenabled.12": "xlsm",
    "vnd.ms-excel.template.macroenabled.12": "xltm",
    "vnd.ms-fontobject": "eot",
    "vnd.ms-htmlhelp": "chm",
    "vnd.ms-ims": "ims",
    "vnd.ms-lrm": "lrm",
    "vnd.ms-officetheme": "thmx",
    "vnd.ms-powerpoint.addin.macroenabled.12": "ppam",
    "vnd.ms-powerpoint.presentation.macroenabled.12": "pptm",
    "vnd.ms-powerpoint.slide.macroenabled.12": "sldm",
    "vnd.ms-powerpoint.slideshow.macroenabled.12": "ppsm",
    "vnd.ms-powerpoint.template.macroenabled.12": "potm",
    "vnd.ms-project": [
      "mpp",
      "mpt"
    ],
    "vnd.ms-word.document.macroenabled.12": "docm",
    "vnd.ms-word.template.macroenabled.12": "dotm",
    "vnd.ms-works": [
      "wps",
      "wks",
      "wcm",
      "wdb"
    ],
    "vnd.ms-wpl": "wpl",
    "vnd.ms-xpsdocument": "xps",
    "vnd.mseq": "mseq",
    "vnd.musician": "mus",
    "vnd.muvee.style": "msty",
    "vnd.mynfc": "taglet",
    "vnd.neurolanguage.nlu": "nlu",
    "vnd.nitf": [
      "ntf",
      "nitf"
    ],
    "vnd.noblenet-directory": "nnd",
    "vnd.noblenet-sealer": "nns",
    "vnd.noblenet-web": "nnw",
    "vnd.nokia.n-gage.data": "ngdat",
    "vnd.nokia.n-gage.symbian.install": "n-gage",
    "vnd.nokia.radio-preset": "rpst",
    "vnd.nokia.radio-presets": "rpss",
    "vnd.novadigm.edm": "edm",
    "vnd.novadigm.edx": "edx",
    "vnd.novadigm.ext": "ext",
    "vnd.oasis.opendocument.chart-template": "otc",
    "vnd.oasis.opendocument.formula-template": "odft",
    "vnd.oasis.opendocument.image-template": "oti",
    "vnd.olpc-sugar": "xo",
    "vnd.oma.dd2+xml": "dd2",
    "vnd.openofficeorg.extension": "oxt",
    "vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
    "vnd.osgeo.mapguide.package": "mgp",
    "vnd.osgi.dp": "dp",
    "vnd.osgi.subsystem": "esa",
    "vnd.palm": [
      "pdb",
      "pqa",
      "oprc"
    ],
    "vnd.pawaafile": "paw",
    "vnd.pg.format": "str",
    "vnd.pg.osasli": "ei6",
    "vnd.picsel": "efif",
    "vnd.pmi.widget": "wg",
    "vnd.pocketlearn": "plf",
    "vnd.powerbuilder6": "pbd",
    "vnd.previewsystems.box": "box",
    "vnd.proteus.magazine": "mgz",
    "vnd.publishare-delta-tree": "qps",
    "vnd.pvi.ptid1": "ptid",
    "vnd.quark.quarkxpress": [
      "qxd",
      "qxt",
      "qwd",
      "qwt",
      "qxl",
      "qxb"
    ],
    "vnd.realvnc.bed": "bed",
    "vnd.recordare.musicxml": "mxl",
    "vnd.recordare.musicxml+xml": "musicxml",
    "vnd.rig.cryptonote": "cryptonote",
    "vnd.rn-realmedia": "rm",
    "vnd.rn-realmedia-vbr": "rmvb",
    "vnd.route66.link66+xml": "link66",
    "vnd.sailingtracker.track": "st",
    "vnd.seemail": "see",
    "vnd.sema": "sema",
    "vnd.semd": "semd",
    "vnd.semf": "semf",
    "vnd.shana.informed.formdata": "ifm",
    "vnd.shana.informed.formtemplate": "itp",
    "vnd.shana.informed.interchange": "iif",
    "vnd.shana.informed.package": "ipk",
    "vnd.simtech-mindmapper": [
      "twd",
      "twds"
    ],
    "vnd.smart.teacher": "teacher",
    "vnd.solent.sdkm+xml": [
      "sdkm",
      "sdkd"
    ],
    "vnd.spotfire.dxp": "dxp",
    "vnd.spotfire.sfs": "sfs",
    "vnd.stepmania.package": "smzip",
    "vnd.stepmania.stepchart": "sm",
    "vnd.sus-calendar": [
      "sus",
      "susp"
    ],
    "vnd.svd": "svd",
    "vnd.syncml+xml": "xsm",
    "vnd.syncml.dm+wbxml": "bdm",
    "vnd.syncml.dm+xml": "xdm",
    "vnd.tao.intent-module-archive": "tao",
    "vnd.tcpdump.pcap": [
      "pcap",
      "cap",
      "dmp"
    ],
    "vnd.tmobile-livetv": "tmo",
    "vnd.trid.tpt": "tpt",
    "vnd.triscape.mxs": "mxs",
    "vnd.trueapp": "tra",
    "vnd.ufdl": [
      "ufd",
      "ufdl"
    ],
    "vnd.uiq.theme": "utz",
    "vnd.umajin": "umj",
    "vnd.unity": "unityweb",
    "vnd.uoml+xml": "uoml",
    "vnd.vcx": "vcx",
    "vnd.visionary": "vis",
    "vnd.vsf": "vsf",
    "vnd.webturbo": "wtb",
    "vnd.wolfram.player": "nbp",
    "vnd.wqd": "wqd",
    "vnd.wt.stf": "stf",
    "vnd.xara": "xar",
    "vnd.xfdl": "xfdl",
    "vnd.yamaha.hv-dic": "hvd",
    "vnd.yamaha.hv-script": "hvs",
    "vnd.yamaha.hv-voice": "hvp",
    "vnd.yamaha.openscoreformat": "osf",
    "vnd.yamaha.openscoreformat.osfpvg+xml": "osfpvg",
    "vnd.yamaha.smaf-audio": "saf",
    "vnd.yamaha.smaf-phrase": "spf",
    "vnd.yellowriver-custom-menu": "cmp",
    "vnd.zul": [
      "zir",
      "zirz"
    ],
    "vnd.zzazz.deck+xml": "zaz",
    "voicexml+xml": "vxml",
    widget: "wgt",
    winhlp: "hlp",
    "wsdl+xml": "wsdl",
    "wspolicy+xml": "wspolicy",
    "x-ace-compressed": "ace",
    "x-authorware-bin": [
      "aab",
      "x32",
      "u32",
      "vox"
    ],
    "x-authorware-map": "aam",
    "x-authorware-seg": "aas",
    "x-blorb": [
      "blb",
      "blorb"
    ],
    "x-bzip": "bz",
    "x-bzip2": [
      "bz2",
      "boz"
    ],
    "x-cfs-compressed": "cfs",
    "x-chat": "chat",
    "x-conference": "nsc",
    "x-dgc-compressed": "dgc",
    "x-dtbncx+xml": "ncx",
    "x-dtbook+xml": "dtb",
    "x-dtbresource+xml": "res",
    "x-eva": "eva",
    "x-font-bdf": "bdf",
    "x-font-ghostscript": "gsf",
    "x-font-linux-psf": "psf",
    "x-font-pcf": "pcf",
    "x-font-snf": "snf",
    "x-font-ttf": [
      "ttf",
      "ttc"
    ],
    "x-font-type1": [
      "pfa",
      "pfb",
      "pfm",
      "afm"
    ],
    "x-freearc": "arc",
    "x-gca-compressed": "gca",
    "x-glulx": "ulx",
    "x-gramps-xml": "gramps",
    "x-install-instructions": "install",
    "x-lzh-compressed": [
      "lzh",
      "lha"
    ],
    "x-mie": "mie",
    "x-mobipocket-ebook": [
      "prc",
      "mobi"
    ],
    "x-ms-application": "application",
    "x-ms-shortcut": "lnk",
    "x-ms-xbap": "xbap",
    "x-msbinder": "obd",
    "x-mscardfile": "crd",
    "x-msclip": "clp",
    "application/x-ms-installer": "msi",
    "x-msmediaview": [
      "mvb",
      "m13",
      "m14"
    ],
    "x-msmetafile": [
      "wmf",
      "wmz",
      "emf",
      "emz"
    ],
    "x-msmoney": "mny",
    "x-mspublisher": "pub",
    "x-msschedule": "scd",
    "x-msterminal": "trm",
    "x-mswrite": "wri",
    "x-nzb": "nzb",
    "x-pkcs12": [
      "p12",
      "pfx"
    ],
    "x-pkcs7-certificates": [
      "p7b",
      "spc"
    ],
    "x-research-info-systems": "ris",
    "x-silverlight-app": "xap",
    "x-sql": "sql",
    "x-stuffitx": "sitx",
    "x-subrip": "srt",
    "x-t3vm-image": "t3",
    "x-tex-tfm": "tfm",
    "x-tgif": "obj",
    "x-xliff+xml": "xlf",
    "x-xz": "xz",
    "x-zmachine": [
      "z1",
      "z2",
      "z3",
      "z4",
      "z5",
      "z6",
      "z7",
      "z8"
    ],
    "xaml+xml": "xaml",
    "xcap-diff+xml": "xdf",
    "xenc+xml": "xenc",
    "xml-dtd": "dtd",
    "xop+xml": "xop",
    "xproc+xml": "xpl",
    "xslt+xml": "xslt",
    "xv+xml": [
      "mxml",
      "xhvml",
      "xvml",
      "xvm"
    ],
    yang: "yang",
    "yin+xml": "yin",
    envoy: "evy",
    fractals: "fif",
    "internet-property-stream": "acx",
    olescript: "axs",
    "vnd.ms-outlook": "msg",
    "vnd.ms-pkicertstore": "sst",
    "x-compress": "z",
    "x-perfmon": [
      "pma",
      "pmc",
      "pmr",
      "pmw"
    ],
    "ynd.ms-pkipko": "pko",
    gzip: [
      "gz",
      "tgz"
    ],
    "smil+xml": [
      "smi",
      "smil"
    ],
    "vnd.debian.binary-package": [
      "deb",
      "udeb"
    ],
    "vnd.hzn-3d-crossword": "x3d",
    "vnd.sqlite3": [
      "db",
      "sqlite",
      "sqlite3",
      "db-wal",
      "sqlite-wal",
      "db-shm",
      "sqlite-shm"
    ],
    "vnd.wap.sic": "sic",
    "vnd.wap.slc": "slc",
    "x-krita": [
      "kra",
      "krz"
    ],
    "x-perl": [
      "pm",
      "pl"
    ],
    yaml: [
      "yaml",
      "yml"
    ]
  },
  audio: {
    amr: "amr",
    "amr-wb": "awb",
    annodex: "axa",
    basic: [
      "au",
      "snd"
    ],
    flac: "flac",
    midi: [
      "mid",
      "midi",
      "kar",
      "rmi"
    ],
    mpeg: [
      "mpga",
      "mpega",
      "mp3",
      "m4a",
      "mp2a",
      "m2a",
      "m3a"
    ],
    mpegurl: "m3u",
    ogg: [
      "oga",
      "ogg",
      "spx"
    ],
    "prs.sid": "sid",
    "x-aiff": "aifc",
    "x-gsm": "gsm",
    "x-ms-wma": "wma",
    "x-ms-wax": "wax",
    "x-pn-realaudio": "ram",
    "x-realaudio": "ra",
    "x-sd2": "sd2",
    adpcm: "adp",
    mp4: "mp4a",
    s3m: "s3m",
    silk: "sil",
    "vnd.dece.audio": [
      "uva",
      "uvva"
    ],
    "vnd.digital-winds": "eol",
    "vnd.dra": "dra",
    "vnd.dts": "dts",
    "vnd.dts.hd": "dtshd",
    "vnd.lucent.voice": "lvp",
    "vnd.ms-playready.media.pya": "pya",
    "vnd.nuera.ecelp4800": "ecelp4800",
    "vnd.nuera.ecelp7470": "ecelp7470",
    "vnd.nuera.ecelp9600": "ecelp9600",
    "vnd.rip": "rip",
    webm: "weba",
    "x-caf": "caf",
    "x-matroska": "mka",
    "x-pn-realaudio-plugin": "rmp",
    xm: "xm",
    aac: "aac",
    aiff: [
      "aiff",
      "aif",
      "aff"
    ],
    opus: "opus",
    wav: "wav"
  },
  chemical: {
    "x-alchemy": "alc",
    "x-cache": [
      "cac",
      "cache"
    ],
    "x-cache-csf": "csf",
    "x-cactvs-binary": [
      "cbin",
      "cascii",
      "ctab"
    ],
    "x-cdx": "cdx",
    "x-chem3d": "c3d",
    "x-cif": "cif",
    "x-cmdf": "cmdf",
    "x-cml": "cml",
    "x-compass": "cpa",
    "x-crossfire": "bsd",
    "x-csml": [
      "csml",
      "csm"
    ],
    "x-ctx": "ctx",
    "x-cxf": [
      "cxf",
      "cef"
    ],
    "x-embl-dl-nucleotide": [
      "emb",
      "embl"
    ],
    "x-gamess-input": [
      "inp",
      "gam",
      "gamin"
    ],
    "x-gaussian-checkpoint": [
      "fch",
      "fchk"
    ],
    "x-gaussian-cube": "cub",
    "x-gaussian-input": [
      "gau",
      "gjc",
      "gjf"
    ],
    "x-gaussian-log": "gal",
    "x-gcg8-sequence": "gcg",
    "x-genbank": "gen",
    "x-hin": "hin",
    "x-isostar": [
      "istr",
      "ist"
    ],
    "x-jcamp-dx": [
      "jdx",
      "dx"
    ],
    "x-kinemage": "kin",
    "x-macmolecule": "mcm",
    "x-macromodel-input": "mmod",
    "x-mdl-molfile": "mol",
    "x-mdl-rdfile": "rd",
    "x-mdl-rxnfile": "rxn",
    "x-mdl-sdfile": "sd",
    "x-mdl-tgf": "tgf",
    "x-mmcif": "mcif",
    "x-mol2": "mol2",
    "x-molconn-Z": "b",
    "x-mopac-graph": "gpt",
    "x-mopac-input": [
      "mop",
      "mopcrt",
      "zmt"
    ],
    "x-mopac-out": "moo",
    "x-ncbi-asn1": "asn",
    "x-ncbi-asn1-ascii": [
      "prt",
      "ent"
    ],
    "x-ncbi-asn1-binary": "val",
    "x-rosdal": "ros",
    "x-swissprot": "sw",
    "x-vamas-iso14976": "vms",
    "x-vmd": "vmd",
    "x-xtel": "xtel",
    "x-xyz": "xyz"
  },
  font: {
    otf: "otf",
    woff: "woff",
    woff2: "woff2"
  },
  image: {
    gif: "gif",
    ief: "ief",
    jpeg: [
      "jpeg",
      "jpg",
      "jpe",
      "jfif",
      "jfif-tbnl",
      "jif"
    ],
    pcx: "pcx",
    png: "png",
    "svg+xml": [
      "svg",
      "svgz"
    ],
    tiff: [
      "tiff",
      "tif"
    ],
    "vnd.djvu": [
      "djvu",
      "djv"
    ],
    "vnd.wap.wbmp": "wbmp",
    "x-canon-cr2": "cr2",
    "x-canon-crw": "crw",
    "x-cmu-raster": "ras",
    "x-coreldraw": "cdr",
    "x-coreldrawpattern": "pat",
    "x-coreldrawtemplate": "cdt",
    "x-corelphotopaint": "cpt",
    "x-epson-erf": "erf",
    "x-icon": "ico",
    "x-jg": "art",
    "x-jng": "jng",
    "x-nikon-nef": "nef",
    "x-olympus-orf": "orf",
    "x-portable-anymap": "pnm",
    "x-portable-bitmap": "pbm",
    "x-portable-graymap": "pgm",
    "x-portable-pixmap": "ppm",
    "x-rgb": "rgb",
    "x-xbitmap": "xbm",
    "x-xpixmap": "xpm",
    "x-xwindowdump": "xwd",
    bmp: "bmp",
    cgm: "cgm",
    g3fax: "g3",
    ktx: "ktx",
    "prs.btif": "btif",
    sgi: "sgi",
    "vnd.dece.graphic": [
      "uvi",
      "uvvi",
      "uvg",
      "uvvg"
    ],
    "vnd.dwg": "dwg",
    "vnd.dxf": "dxf",
    "vnd.fastbidsheet": "fbs",
    "vnd.fpx": "fpx",
    "vnd.fst": "fst",
    "vnd.fujixerox.edmics-mmr": "mmr",
    "vnd.fujixerox.edmics-rlc": "rlc",
    "vnd.ms-modi": "mdi",
    "vnd.ms-photo": "wdp",
    "vnd.net-fpx": "npx",
    "vnd.xiff": "xif",
    webp: "webp",
    "x-3ds": "3ds",
    "x-cmx": "cmx",
    "x-freehand": [
      "fh",
      "fhc",
      "fh4",
      "fh5",
      "fh7"
    ],
    "x-pict": [
      "pic",
      "pct"
    ],
    "x-tga": "tga",
    "cis-cod": "cod",
    avif: "avifs",
    heic: [
      "heif",
      "heic"
    ],
    pjpeg: [
      "pjpg"
    ],
    "vnd.adobe.photoshop": "psd",
    "x-adobe-dng": "dng",
    "x-fuji-raf": "raf",
    "x-icns": "icns",
    "x-kodak-dcr": "dcr",
    "x-kodak-k25": "k25",
    "x-kodak-kdc": "kdc",
    "x-minolta-mrw": "mrw",
    "x-panasonic-raw": [
      "raw",
      "rw2",
      "rwl"
    ],
    "x-pentax-pef": [
      "pef",
      "ptx"
    ],
    "x-sigma-x3f": "x3f",
    "x-sony-arw": "arw",
    "x-sony-sr2": "sr2",
    "x-sony-srf": "srf"
  },
  message: {
    rfc822: [
      "eml",
      "mime",
      "mht",
      "mhtml",
      "nws"
    ]
  },
  model: {
    iges: [
      "igs",
      "iges"
    ],
    mesh: [
      "msh",
      "mesh",
      "silo"
    ],
    vrml: [
      "wrl",
      "vrml"
    ],
    "x3d+vrml": [
      "x3dv",
      "x3dvz"
    ],
    "x3d+xml": "x3dz",
    "x3d+binary": [
      "x3db",
      "x3dbz"
    ],
    "vnd.collada+xml": "dae",
    "vnd.dwf": "dwf",
    "vnd.gdl": "gdl",
    "vnd.gtw": "gtw",
    "vnd.mts": "mts",
    "vnd.usdz+zip": "usdz",
    "vnd.vtu": "vtu"
  },
  text: {
    "cache-manifest": [
      "manifest",
      "appcache"
    ],
    calendar: [
      "ics",
      "icz",
      "ifb"
    ],
    css: "css",
    csv: "csv",
    h323: "323",
    html: [
      "html",
      "htm",
      "shtml",
      "stm"
    ],
    iuls: "uls",
    plain: [
      "txt",
      "text",
      "brf",
      "conf",
      "def",
      "list",
      "log",
      "in",
      "bas",
      "diff",
      "ksh"
    ],
    richtext: "rtx",
    scriptlet: [
      "sct",
      "wsc"
    ],
    texmacs: "tm",
    "tab-separated-values": "tsv",
    "vnd.sun.j2me.app-descriptor": "jad",
    "vnd.wap.wml": "wml",
    "vnd.wap.wmlscript": "wmls",
    "x-bibtex": "bib",
    "x-boo": "boo",
    "x-c++hdr": [
      "h++",
      "hpp",
      "hxx",
      "hh"
    ],
    "x-c++src": [
      "c++",
      "cpp",
      "cxx",
      "cc"
    ],
    "x-component": "htc",
    "x-dsrc": "d",
    "x-diff": "patch",
    "x-haskell": "hs",
    "x-java": "java",
    "x-literate-haskell": "lhs",
    "x-moc": "moc",
    "x-pascal": [
      "p",
      "pas",
      "pp",
      "inc"
    ],
    "x-pcs-gcd": "gcd",
    "x-python": "py",
    "x-scala": "scala",
    "x-setext": "etx",
    "x-tcl": [
      "tcl",
      "tk"
    ],
    "x-tex": [
      "tex",
      "ltx",
      "sty",
      "cls"
    ],
    "x-vcalendar": "vcs",
    "x-vcard": "vcf",
    n3: "n3",
    "prs.lines.tag": "dsc",
    sgml: [
      "sgml",
      "sgm"
    ],
    troff: [
      "t",
      "tr",
      "roff",
      "man",
      "me",
      "ms"
    ],
    turtle: "ttl",
    "uri-list": [
      "uri",
      "uris",
      "urls"
    ],
    vcard: "vcard",
    "vnd.curl": "curl",
    "vnd.curl.dcurl": "dcurl",
    "vnd.curl.scurl": "scurl",
    "vnd.curl.mcurl": "mcurl",
    "vnd.dvb.subtitle": "sub",
    "vnd.fly": "fly",
    "vnd.fmi.flexstor": "flx",
    "vnd.graphviz": "gv",
    "vnd.in3d.3dml": "3dml",
    "vnd.in3d.spot": "spot",
    "x-asm": [
      "s",
      "asm"
    ],
    "x-c": [
      "c",
      "h",
      "dic"
    ],
    "x-fortran": [
      "f",
      "for",
      "f77",
      "f90"
    ],
    "x-opml": "opml",
    "x-nfo": "nfo",
    "x-sfv": "sfv",
    "x-uuencode": "uu",
    webviewhtml: "htt",
    javascript: "js",
    json: "json",
    markdown: [
      "md",
      "markdown",
      "mdown",
      "markdn"
    ],
    "vnd.wap.si": "si",
    "vnd.wap.sl": "sl"
  },
  video: {
    avif: "avif",
    "3gpp": "3gp",
    annodex: "axv",
    dl: "dl",
    dv: [
      "dif",
      "dv"
    ],
    fli: "fli",
    gl: "gl",
    mpeg: [
      "mpeg",
      "mpg",
      "mpe",
      "m1v",
      "m2v",
      "mp2",
      "mpa",
      "mpv2"
    ],
    mp4: [
      "mp4",
      "mp4v",
      "mpg4"
    ],
    quicktime: [
      "qt",
      "mov"
    ],
    ogg: "ogv",
    "vnd.mpegurl": [
      "mxu",
      "m4u"
    ],
    "x-flv": "flv",
    "x-la-asf": [
      "lsf",
      "lsx"
    ],
    "x-mng": "mng",
    "x-ms-asf": [
      "asf",
      "asx",
      "asr"
    ],
    "x-ms-wm": "wm",
    "x-ms-wmv": "wmv",
    "x-ms-wmx": "wmx",
    "x-ms-wvx": "wvx",
    "x-msvideo": "avi",
    "x-sgi-movie": "movie",
    "x-matroska": [
      "mpv",
      "mkv",
      "mk3d",
      "mks"
    ],
    "3gpp2": "3g2",
    h261: "h261",
    h263: "h263",
    h264: "h264",
    jpeg: "jpgv",
    jpm: [
      "jpm",
      "jpgm"
    ],
    mj2: [
      "mj2",
      "mjp2"
    ],
    "vnd.dece.hd": [
      "uvh",
      "uvvh"
    ],
    "vnd.dece.mobile": [
      "uvm",
      "uvvm"
    ],
    "vnd.dece.pd": [
      "uvp",
      "uvvp"
    ],
    "vnd.dece.sd": [
      "uvs",
      "uvvs"
    ],
    "vnd.dece.video": [
      "uvv",
      "uvvv"
    ],
    "vnd.dvb.file": "dvb",
    "vnd.fvt": "fvt",
    "vnd.ms-playready.media.pyv": "pyv",
    "vnd.uvvu.mp4": [
      "uvu",
      "uvvu"
    ],
    "vnd.vivo": "viv",
    webm: "webm",
    "x-f4v": "f4v",
    "x-m4v": "m4v",
    "x-ms-vob": "vob",
    "x-smv": "smv",
    mp2t: "ts"
  },
  "x-conference": {
    "x-cooltalk": "ice"
  },
  "x-world": {
    "x-vrml": [
      "vrm",
      "flr",
      "wrz",
      "xaf",
      "xof"
    ]
  }
};
(() => {
  const e = {};
  for (const t of Object.keys(Bi))
    for (const n of Object.keys(Bi[t])) {
      const a = Bi[t][n];
      if (typeof a == "string")
        e[a] = t + "/" + n;
      else
        for (let s = 0; s < a.length; s++)
          e[a[s]] = t + "/" + n;
    }
  return e;
})();
yy(Zo);
async function oM(e, t) {
  return e == null ? void 0 : e.getData(new Xy(), {
    onprogress: t
  });
}
const ab = ["src"], sb = ["src"], iM = /* @__PURE__ */ j({
  __name: "MButtonMenu",
  props: {
    tabMenuItems: { required: !0 },
    tabMenuItemsModifiers: {},
    tabIndex: { required: !0 },
    tabIndexModifiers: {},
    selectedTab: { required: !1 },
    selectedTabModifiers: {},
    disabled: { type: Boolean, required: !1, default: !1 },
    disabledModifiers: {},
    showArrows: { type: Boolean, required: !1, default: !1 },
    showArrowsModifiers: {},
    isVertical: { type: Boolean, required: !1, default: !1 },
    isVerticalModifiers: {}
  },
  emits: ["update:tabMenuItems", "update:tabIndex", "update:selectedTab", "update:disabled", "update:showArrows", "update:isVertical"],
  setup(e) {
    const t = Ie(e, "tabMenuItems"), n = Ie(e, "tabIndex"), a = Ie(e, "selectedTab"), s = Ie(e, "disabled"), o = Ie(e, "showArrows"), i = Ie(e, "isVertical"), r = (m) => n.value === m.index ? "project-item-menu-btn-selected" : "p-button-outlined", l = U(() => o.value ? "gap-4 w-full" : "gap-2 w-full"), c = U(() => o.value ? "gap-4 grow" : "grow"), u = (m) => {
      n.value = m.index, a.value = m.label;
    }, d = (m) => s.value || !!m;
    return (m, g) => {
      const h = se("Button");
      return i.value ? (C(), H(k(ls), {
        key: 0,
        class: "gap-4"
      }, {
        default: D(() => [
          (C(!0), O(me, null, qe(t.value, (A, f) => (C(), H(ae, {
            class: J([c.value]),
            key: A.label
          }, {
            default: D(() => {
              var p;
              return [
                (C(), H(h, {
                  id: `btnMenu${A.id ?? A.label.replaceAll(" ", "")}`,
                  class: J(["project-item-menu-btn w-full", r(A)]),
                  badge: (p = A.badge) == null ? void 0 : p.toString(),
                  key: f,
                  label: A.label,
                  disabled: d(A.disabled),
                  onClick: (v) => u(A)
                }, null, 8, ["id", "badge", "class", "label", "disabled", "onClick"])),
                o.value && f !== t.value.length - 1 ? (C(), O("img", {
                  key: 0,
                  src: k(Io)("rg_chevron_right")
                }, null, 8, ab)) : $("", !0)
              ];
            }),
            _: 2
          }, 1032, ["class"]))), 128))
        ]),
        _: 1
      })) : (C(), H(ae, {
        key: 1,
        class: J([l.value])
      }, {
        default: D(() => [
          (C(!0), O(me, null, qe(t.value, (A, f) => (C(), H(ae, {
            class: J([c.value]),
            key: A.label
          }, {
            default: D(() => {
              var p;
              return [
                (C(), H(h, {
                  id: `btnMenu${A.id ?? A.label.replaceAll(" ", "")}`,
                  class: J(["project-item-menu-btn w-full", r(A)]),
                  badge: (p = A.badge) == null ? void 0 : p.toString(),
                  key: f,
                  label: A.label,
                  disabled: d(A.disabled),
                  onClick: (v) => u(A)
                }, null, 8, ["id", "badge", "class", "label", "disabled", "onClick"])),
                o.value && f !== t.value.length - 1 ? (C(), O("img", {
                  key: 0,
                  src: k(Io)("rg_chevron_right")
                }, null, 8, sb)) : $("", !0)
              ];
            }),
            _: 2
          }, 1032, ["class"]))), 128))
        ]),
        _: 1
      }, 8, ["class"]));
    };
  }
}), ob = {}, ib = { class: "flex justify-center items-center select-none w-10/12 h-10 rounded-lg border-2 border-gray-700 text-2xl text-gray-500 hover:border-gray-500 hover:text-gray-400" };
function rb(e, t) {
  return C(), O("button", ib, " ✕ ");
}
const rM = /* @__PURE__ */ fe(ob, [["render", rb]]), lb = ["src", "height", "alt"], cb = /* @__PURE__ */ j({
  __name: "MIconButton",
  props: {
    iconType: { default: ge.TOP_NAVBAR_ICON },
    iconPos: { default: Wn.LEFT },
    icon: { default: "icon_export" },
    label: {},
    disabled: { type: Boolean },
    tooltipBottom: {}
  },
  setup(e) {
    const t = e, n = sa(), a = U(() => n.getAssetUrl(`/icons/${t.icon}.svg`)), s = U(() => t.iconType === ge.TOP_NAVBAR_ICON || t.iconType === ge.BUTTON_ICON || t.iconType === ge.TOP_NAVBAR_MOBILE_ICON || t.iconType === ge.TOP_NAVBAR_ICON_LABEL ? "order: 1" : "order: 1; margin-top: 0.3rem;"), o = U(() => t.iconType === ge.TOP_NAVBAR_ICON || t.iconType === ge.TOP_NAVBAR_MOBILE_ICON || t.iconType === ge.TOP_NAVBAR_ICON_LABEL ? "web-rg-navbar-btn" : ""), i = U(() => {
      if (t.label)
        if (t.iconType === ge.TOP_NAVBAR_ICON || t.iconType === ge.TOP_NAVBAR_MOBILE_ICON || t.iconType === ge.TOP_NAVBAR_ICON_LABEL) {
          const d = "top-navbar-hide-sm top-navbar-text-color whitespace-nowrap";
          return t.iconPos == Wn.LEFT ? d + " ml-2" : t.iconPos == Wn.TOP ? d + " mt-2" : d;
        } else return t.iconType === ge.BUTTON_ICON_NO_LABEL ? "" : "btn-text-14 whitespace-nowrap";
      else return "";
    }), r = U(() => {
      if (t.iconType !== ge.TOP_NAVBAR_MOBILE_ICON)
        return t.iconType === ge.TOP_NAVBAR_ICON || t.iconType === ge.TOP_NAVBAR_ICON_LABEL ? "top-nav-height" : "px-2";
    }), l = U(() => {
      if (t.iconType === ge.TOP_NAVBAR_MOBILE_ICON)
        return (t.icon ?? "").includes("logout"), 22;
    }), c = U(() => {
      switch (t.iconType) {
        case ge.BUTTON_ICON:
        case ge.BUTTON_ICON_NO_LABEL:
          return "h-2-5rem";
        case ge.TOP_NAVBAR_ICON_LABEL:
          return typeof window < "u" && window.innerWidth < 1200 ? "ipad-top-nav-btn-padding" : "top-nav-height";
        default:
          return "";
      }
    }), u = U(() => {
      switch (t.iconType) {
        case ge.TOP_NAVBAR_ICON:
          return "svg-icon-color";
        case ge.TOP_NAVBAR_MOBILE_ICON:
          return "svg-icon-color;";
        case ge.BUTTON_ICON:
          return "width: 1.5rem; height: 2.2rem !important;";
        case ge.BUTTON_ICON_NO_LABEL:
          return "width: 1.5rem; height: 2.2rem !important;";
        case ge.TOP_NAVBAR_ICON_LABEL:
          return "";
        default:
          return "width: 4.5rem; max-height: 20px;";
      }
    });
    return (d, m) => {
      const g = ws("tooltip");
      return an((C(), O("button", {
        class: J(["m-u-button", [{ "m-u-button-disabled": e.disabled }, t.iconPos, o.value, r.value, c.value]]),
        style: Le({ pointerEvents: t.disabled ? "none" : "auto" }),
        type: "button"
      }, [
        x("span", {
          style: Le(s.value),
          class: J([t.iconType === k(ge).TOP_NAVBAR_ICON ? "navbar-icon-wrapper" : ""])
        }, [
          x("img", {
            class: J(t.iconType),
            src: a.value,
            height: l.value,
            style: Le([u.value]),
            alt: t.label,
            draggable: "false"
          }, null, 14, lb)
        ], 6),
        x("span", {
          class: J([i.value]),
          style: { "min-width": "0", overflow: "hidden", "text-overflow": "ellipsis" }
        }, [
          X(d.$slots, "default", {}, void 0, !0),
          Te(" " + P(t.label), 1)
        ], 2)
      ], 6)), [
        [
          g,
          t.label ?? t.tooltipBottom,
          void 0,
          { bottom: !0 }
        ]
      ]);
    };
  }
}), ho = /* @__PURE__ */ fe(cb, [["__scopeId", "data-v-164b54a6"]]), ub = j({
  props: {
    src: String,
    // <img :src="src" ... >
    faIcon: String,
    // fontawesome icon name, has to be added to library in main.ts
    cIcon: String,
    // custom icons located in assets/icons/
    scale: {
      type: Boolean,
      default: !1
    },
    colorClass: {
      type: String,
      default: "svg-icon-color"
    },
    width: {
      type: Number,
      default: 19
    },
    height: {
      type: Number,
      default: 19
    },
    label: {
      type: String
    },
    isMenuIcon: {
      type: Boolean,
      default: !1
    },
    iconType: {
      type: String,
      default: ge.TOP_NAVBAR_ICON
    }
  },
  setup(e) {
    const t = U(() => {
      switch (e.iconType) {
        case ge.OBJECT_LIST_ICON:
          return ge.OBJECT_LIST_ICON.toString();
        case ge.BUTTON_ICON:
          return "";
      }
      return e.colorClass;
    }), n = sa();
    return {
      cIconSrc: T(n.getAssetUrl(`/icons/${e.cIcon}.svg`)),
      colClass: t
    };
  }
}), db = { style: { display: "inline-flex", "margin-top": "2%" } }, fb = ["src"], pb = ["height", "src", "width"], mb = {
  key: 2,
  class: "flex w-full h-full justify-center items-center pointer-events-none"
}, Ab = { style: { display: "contents" } }, gb = { style: { "margin-top": "2px", "margin-left": "2px" } };
function hb(e, t, n, a, s, o) {
  const i = se("font-awesome-icon");
  return C(), O("span", db, [
    e.src ? (C(), O("img", {
      key: 0,
      class: J([[e.scale ? "object-contain" : "object-scale-down"], "w-full h-full object-contain pointer-events-none"]),
      src: e.src,
      draggable: "false"
    }, null, 10, fb)) : e.cIcon ? (C(), O("img", {
      key: 1,
      class: J([e.scale ? "object-scale-down" : "object-contain", e.colClass]),
      height: e.height,
      src: e.cIconSrc,
      style: Le([e.isMenuIcon ? "max-width:19px; max-height:19px; border-style: none" : "border-style: none"]),
      width: e.width,
      draggable: "false"
    }, null, 14, pb)) : e.faIcon ? (C(), O("div", mb, [
      B(i, {
        icon: e.faIcon,
        style: Le([e.scale ? "width: 100%" : ""]),
        class: "w-full h-full pointer-events-none"
      }, null, 8, ["icon", "style"])
    ])) : $("", !0),
    x("span", Ab, [
      x("span", gb, P(e.label), 1)
    ])
  ]);
}
const $r = /* @__PURE__ */ fe(ub, [["render", hb]]), vb = ["disabled"], yb = { class: "flex flex-col items-center" }, bb = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, lM = /* @__PURE__ */ j({
  __name: "MLargeIconButton",
  props: {
    icon: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { disabled: n, icon: a } = ft(t);
    return (s, o) => (C(), O("button", {
      class: J([{ "text-gray-500 cursor-default": k(n) }, "w-24 h-16 p-1 text-xs"]),
      disabled: k(n)
    }, [
      x("div", yb, [
        B($r, {
          src: k(a),
          class: "w-8/12 h-8"
        }, null, 8, ["src"]),
        x("div", bb, [
          X(s.$slots, "default")
        ])
      ])
    ], 10, vb));
  }
}), xb = {}, Eb = { class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-12 rounded" };
function Cb(e, t) {
  return C(), O("button", Eb, [
    X(e.$slots, "default")
  ]);
}
const cM = /* @__PURE__ */ fe(xb, [["render", Cb]]), wb = /* @__PURE__ */ j({
  __name: "MToggleButton",
  props: {
    checked: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = T(e.checked);
    return (a, s) => {
      const o = se("ToggleButton");
      return C(), H(o, {
        modelValue: n.value,
        "onUpdate:modelValue": s[0] || (s[0] = (i) => n.value = i),
        "off-icon": "pi pi-times",
        "on-icon": "pi pi-check"
      }, null, 8, ["modelValue"]);
    };
  }
}), Ib = ["disabled"], Bb = { class: "flex items-center" }, kb = { class: "whitespace-nowrap overflow-hidden overflow-ellipsis" }, uM = /* @__PURE__ */ j({
  __name: "MToolbarButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    icon: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (C(), O("button", {
      class: J([{ "text-gray-500": e.disabled }, "h-6 text-xs bg-inactive-tabs"]),
      disabled: e.disabled
    }, [
      x("div", Bb, [
        B($r, {
          src: t.icon,
          class: "w-6/12 h-6"
        }, null, 8, ["src"]),
        x("div", kb, [
          X(n.$slots, "default")
        ])
      ])
    ], 10, Ib));
  }
});
function _b(e, t) {
  return !(t.value === e.target || t.value && t.value.contains(e.target));
}
function ti(e, t, n) {
  const a = (s) => {
    _b(s, e) && t();
  };
  n ? (ye(n, () => {
    n.value ? document.addEventListener("click", a) : document.removeEventListener("click", a);
  }), n.value && document.addEventListener("click", a)) : Uo(() => document.addEventListener("click", a)), Mn(() => document.removeEventListener("click", a));
}
const Sb = ["src"], Db = /* @__PURE__ */ j({
  __name: "MUButton",
  props: /* @__PURE__ */ It({
    label: {},
    icon: {},
    iconSrc: {},
    iconRight: { type: Boolean },
    iconAbove: { type: Boolean },
    previewSrc: {},
    outlined: { type: Boolean },
    disabled: { type: Boolean },
    background: { type: Boolean, default: !0 },
    iconFont: {},
    labelFont: {},
    iconSrcHeight: {},
    iconSrcWidth: {},
    iconSrcMaxWidth: {},
    iconSrcPadding: {},
    iconSrcObjectFit: {},
    customInput: { type: Boolean },
    dropdown: { type: Boolean },
    dropdownLocationTop: { type: Boolean },
    dropdownLocationTopLeft: { type: Boolean },
    togglable: { type: Boolean },
    isToolbarButton: { type: Boolean, default: !1 },
    ignoreSvgFilter: { type: Boolean, default: !1 },
    tooltip: {},
    dynamicButton: { type: Boolean },
    addEnterListener: { type: Boolean, default: !1 }
  }, {
    dropdownState: { type: Boolean, default: !1, required: !1 },
    dropdownStateModifiers: {},
    toggled: { type: Boolean, default: !1, required: !1 },
    toggledModifiers: {}
  }),
  emits: /* @__PURE__ */ It(["click", "toggledChange", "closedByClickOutside"], ["update:dropdownState", "update:toggled"]),
  setup(e, { emit: t }) {
    const n = Ie(e, "dropdownState"), a = Ie(e, "toggled"), s = e, o = t, i = sa(), r = U(() => s.iconSrc ? i.getAssetUrl(`${s.iconSrc}`) : s.previewSrc ? s.previewSrc : ""), l = () => {
      if (!s.disabled)
        if ((s.dropdown || s.customInput) && !s.dynamicButton) {
          n.value = !n.value;
          return;
        } else s.togglable && !s.dynamicButton ? (a.value = !a.value, o("toggledChange", a.value)) : o("click");
    }, c = T();
    return ti(c, () => {
      n.value && (n.value = !1, o("closedByClickOutside"));
    }), (u, d) => {
      const m = ws("tooltip");
      return an((C(), O("button", {
        class: J(["m-u-button", {
          "m-u-button-outlined": s.outlined,
          "flex-row": !s.iconAbove,
          "flex-col": s.iconAbove,
          "m-u-button-disabled": e.disabled,
          "m-u-button-background": s.background,
          "m-u-button-no-background": !s.background,
          "m-u-button-toggled": a.value && s.background,
          "m-u-button-ignore-svg-filter": s.ignoreSvgFilter,
          "m-u-no-button-toolbar": !s.isToolbarButton,
          "m-u-button-toolbar": s.isToolbarButton,
          "m-u-cursor-default": !s.togglable
        }]),
        ref_key: "menuButton",
        ref: c,
        type: "button",
        onClick: l,
        onKeydown: d[0] || (d[0] = Is((g) => s.addEnterListener && o("click"), ["enter"]))
      }, [
        s.icon ? (C(), O("i", {
          key: 0,
          class: J(["h-full flex justify-center", [s.icon, s.label && !s.iconAbove ? "ml-2" : ""]]),
          style: Le([{ "align-items": "center" }, {
            fontSize: s.iconFont,
            order: s.iconAbove ? 0 : s.iconRight ? 2 : 0
          }])
        }, null, 6)) : $("", !0),
        s.iconSrc || s.previewSrc ? (C(), O("img", {
          key: 1,
          draggable: "false",
          src: r.value,
          alt: "icon",
          class: J(["svg-filter h-full flex justify-content-center"]),
          style: Le([{ "align-items": "center" }, {
            order: s.iconAbove ? 0 : s.iconRight ? 2 : 0,
            height: s.iconSrcHeight + " !important",
            width: s.iconSrcWidth + " !important",
            maxWidth: s.iconSrcMaxWidth + " !important",
            padding: s.iconSrcPadding,
            objectFit: s.iconSrcObjectFit
          }])
        }, null, 12, Sb)) : $("", !0),
        s.label ? (C(), O("span", {
          key: 2,
          class: J([["flex justify-content-center", !s.isToolbarButton && !s.iconAbove ? "mr-2 ml-2" : "", s.iconAbove ? "mt-2" : ""], "h-full"]),
          style: Le({
            whiteSpace: "nowrap",
            alignItems: "center",
            order: "1",
            fontSize: s.labelFont
          })
        }, P(s.label), 7)) : $("", !0),
        n.value ? (C(), O("div", {
          key: 3,
          class: J({
            "dropdown-container": !0,
            "dropdown-menu-bottom": s.dropdown && !s.dropdownLocationTop && !s.dropdownLocationTopLeft,
            "dropdown-menu-top": s.dropdown && s.dropdownLocationTop,
            "dropdown-menu-top-left": s.dropdown && s.dropdownLocationTopLeft,
            "custom-input-menu": s.customInput
          })
        }, [
          X(u.$slots, "default", {}, void 0, !0)
        ], 2)) : $("", !0)
      ], 34)), [
        [
          m,
          { value: s.tooltip, showDelay: 500, hideDelay: 200 },
          void 0,
          { bottom: !0 }
        ]
      ]);
    };
  }
}), wt = /* @__PURE__ */ fe(Db, [["__scopeId", "data-v-72965138"]]), Tb = ["type", "min", "max", "step", "placeholder"], Mb = /* @__PURE__ */ j({
  __name: "MUInput",
  props: {
    type: { default: "number" },
    min: { default: "0" },
    max: { default: "999999" },
    step: { default: "0.01" },
    placeholder: { default: "Custom (mm)" },
    focused: { type: Boolean, default: !1 }
  },
  emits: ["customSelected", "onBlur", "update:focused"],
  setup(e, { emit: t }) {
    const n = e, a = t, { focused: s } = ft(n), o = T(), i = T();
    ye(s, () => {
      var d;
      s.value && ((d = i.value) == null || d.focus());
    }), s.value && setTimeout(() => {
      var d;
      (d = i.value) == null || d.focus();
    }, 0);
    let r = !1;
    const l = () => {
      r = !0, i.value && i.value.blur();
    }, c = () => {
      o.value != null && a("customSelected", o.value);
    }, u = () => {
      o.value != null ? a("onBlur", o.value, r) : a("onBlur", 0, !0), r = !1;
    };
    return (d, m) => an((C(), O("input", {
      "onUpdate:modelValue": m[0] || (m[0] = (g) => o.value = g),
      ref_key: "customInputEl",
      ref: i,
      type: e.type,
      min: e.min,
      max: e.max,
      step: e.step,
      placeholder: e.placeholder,
      class: "custom-input",
      onBlur: u,
      onClick: m[1] || (m[1] = xt(() => {
      }, ["stop"])),
      onKeydown: [
        Is(l, ["esc"]),
        m[2] || (m[2] = xt(() => {
        }, ["stop"]))
      ],
      onKeyup: m[3] || (m[3] = xt(() => {
      }, ["stop"])),
      onKeypress: [
        Is(c, ["enter"]),
        m[4] || (m[4] = xt(() => {
        }, ["stop"]))
      ]
    }, null, 40, Tb)), [
      [
        _p,
        o.value,
        void 0,
        { number: !0 }
      ]
    ]);
  }
}), Lb = ["onClick"], Ob = {
  key: 0,
  class: "menu-item"
}, dM = /* @__PURE__ */ j({
  __name: "MUDropdown",
  props: {
    dropdownItems: {},
    customInput: { type: Boolean }
  },
  emits: ["selected", "customSelected"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = (i) => {
      a("selected", i);
    }, o = (i) => {
      i != null && a("customSelected", i);
    };
    return (i, r) => (C(), O(me, null, [
      (C(!0), O(me, null, qe(e.dropdownItems, (l, c) => (C(), O("div", {
        key: c,
        class: "menu-item",
        onClick: (u) => s(l)
      }, P(l.label), 9, Lb))), 128)),
      n.customInput ? (C(), O("div", Ob, [
        B(Mb, { onCustomSelected: o })
      ])) : $("", !0)
    ], 64));
  }
}), Nb = /* @__PURE__ */ j({
  __name: "MDialogCancelButton",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = se("Button");
      return C(), H(o, {
        class: "p-button-outlined",
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "border-radius": "16px", "min-width": "114px !important", background: "rgba(255, 255, 255, 0.06)", border: "1px var(--p-rg-border-color) solid !important", color: "var(--p-rg-component-text-color) !important" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), Lo = /* @__PURE__ */ j({
  __name: "MDialogCancelButtonRedesign",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = se("Button");
      return C(), H(o, {
        class: "p-button-outlined",
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "border-radius": "16px", "min-width": "114px !important", background: "rgba(255, 255, 255, 0.06)", border: "1px var(--p-rg-border-color) solid !important", color: "var(--p-rg-component-text-color) !important" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), Rb = /* @__PURE__ */ j({
  __name: "MDialogConfirmButton",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = se("Button");
      return C(), H(o, {
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "min-width": "114px !important", "border-radius": "16px" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), ni = /* @__PURE__ */ j({
  __name: "MDialogConfirmButtonRedesign",
  props: ["label", "icon"],
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, s) => {
      const o = se("Button");
      return C(), H(o, {
        label: e.label,
        icon: e.icon,
        onClick: s[0] || (s[0] = (i) => n("click")),
        style: { height: "49px !important", "min-width": "114px !important", "border-radius": "16px" }
      }, null, 8, ["label", "icon"]);
    };
  }
}), Pb = () => ({
  order: {
    caseIdIncludesUser: !1,
    requireStatusStepConfirmation: !1,
    defaultOrdersPageSize: 30,
    ignoreMinimalDeliveryDays: !0
  },
  enabledFunctionality: {
    materialLibrary: !0,
    openTicket: !1,
    remoteSupport: !1,
    eLearning: !1
  },
  ui: {
    dialogButtons: {
      okCancelLayout: "win"
    }
  }
}), yt = Pb(), is = wr({
  ...yt,
  order: { ...yt.order },
  enabledFunctionality: { ...yt.enabledFunctionality }
}), Fb = U(() => {
  var e, t;
  return (((t = (e = is.value.ui) == null ? void 0 : e.dialogButtons) == null ? void 0 : t.okCancelLayout) ?? "win") === "win";
}), Qb = U(() => {
  var e;
  return ((e = is.value.enabledFunctionality) == null ? void 0 : e.openTicket) ?? !1;
}), Ub = U(() => {
  var e;
  return ((e = is.value.enabledFunctionality) == null ? void 0 : e.remoteSupport) ?? !1;
}), Gb = U(() => {
  var e;
  return ((e = is.value.enabledFunctionality) == null ? void 0 : e.eLearning) ?? !1;
});
let ki = null;
function Yb(e) {
  var t;
  return e ? {
    ...yt,
    ...e,
    order: {
      ...yt.order,
      ...e.order ?? {}
    },
    enabledFunctionality: {
      ...yt.enabledFunctionality,
      ...e.enabledFunctionality ?? {}
    },
    ui: {
      ...yt.ui,
      ...e.ui ?? {},
      dialogButtons: {
        ...yt.ui.dialogButtons,
        ...((t = e.ui) == null ? void 0 : t.dialogButtons) ?? {}
      }
    }
  } : {
    ...yt,
    order: { ...yt.order },
    enabledFunctionality: { ...yt.enabledFunctionality },
    ui: {
      ...yt.ui,
      dialogButtons: { ...yt.ui.dialogButtons }
    }
  };
}
async function jb() {
  try {
    const e = globalThis.__APP_SETTINGS_URL ?? (typeof document < "u" ? new URL("resources/app-settings.json", document.baseURI).toString() : "/resources/app-settings.json"), t = await fetch(e, {
      cache: "no-store"
    });
    return t.ok ? await t.json() : (console.warn(`Failed to load app-settings.json. Status: ${t.status}`), null);
  } catch (e) {
    return console.warn("Failed to load app-settings.json", e), null;
  }
}
async function Hb() {
  return ki || (ki = (async () => {
    const e = await jb(), t = Yb(e);
    return is.value = t, t;
  })()), ki;
}
function Ec() {
  return {
    appSettings: is,
    isWinLayout: Fb,
    hasOpenTicket: Qb,
    hasRemoteSupport: Ub,
    hasELearning: Gb,
    loadAppSettings: Hb
  };
}
const xf = /* @__PURE__ */ j({
  __name: "MDialogFooter",
  props: {
    acceptLabel: { default: "OK" },
    rejectLabel: { default: void 0 },
    acceptIcon: { default: "pi pi-check" },
    rejectIcon: { default: "pi pi-times" },
    gap: { default: "gap-2" },
    align: { default: "center" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["accept", "reject"],
  setup(e, { emit: t }) {
    const { appSettings: n } = Ec(), a = e, { acceptLabel: s, rejectLabel: o, acceptIcon: i, rejectIcon: r, gap: l, align: c, disabled: u } = ft(a), d = t, { isWinLayout: m } = Ec(), g = {
      height: "49px",
      minWidth: "114px",
      borderRadius: "16px"
    }, h = U(() => ({ ...g })), A = U(() => ({
      ...g,
      background: "rgba(255, 255, 255, 0.06)",
      border: "1px var(--p-rg-border-color) solid !important",
      color: "var(--p-rg-component-text-color)"
    })), f = U(() => `justify-${c.value}`), p = U(() => o.value ?? ke("shared.cancel"));
    return (v, b) => (C(), H(k(Sn), {
      class: J(["action-row", [k(l), f.value, { "action-row--reverse": !k(m) }]])
    }, {
      default: D(() => [
        B(k(Rb), {
          label: k(s),
          icon: k(i),
          disabled: k(u),
          onClick: b[0] || (b[0] = (y) => d("accept")),
          class: "action-btn action-btn--accept",
          style: Le(h.value)
        }, null, 8, ["label", "icon", "disabled", "style"]),
        B(k(Nb), {
          label: p.value,
          icon: k(r),
          onClick: b[1] || (b[1] = (y) => d("reject")),
          class: "action-btn action-btn--reject p-button-outlined",
          style: Le(A.value)
        }, null, 8, ["label", "icon", "style"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
var Pt = /* @__PURE__ */ ((e) => (e.SHOW_ONLY_LOGO = "showOnlyLogo", e.SHOW_ONLY_PC_NAME = "showOnlyPCName", e.SHOW_NAVBAR = "showNavbar", e.HIDE_NAVBAR = "hideNavbar", e.ENABLE_NAVBAR_BUTTONS = "enableNavbarButtons", e.DISABLE_NAVBAR_BUTTONS = "disableNavbarButtons", e.ADD_TOOLTIPS = "addTooltips", e.UPDATE_NAVBAR = "updateNavbar", e.SHOW_PROJECT_NAME = "showProjectName", e.TOGGLE_CAD_MODE = "toggleCadMode", e.SHOW_UNVERIFIED_ADDRESS = "showUnverifiedAddress", e))(Pt || {}), Ma = /* @__PURE__ */ ((e) => (e.NAVBAR_BUTTON_CLICKED = "onNavbarButtonClicked", e.USER_EMAIL_NOTIFICATION_CLICKED = "onUserEmailNotificationClicked", e.USER_CHAT_EMAIL_NOTIFICATION_CLICKED = "onUserChatEmailNotificationClicked", e.PROJECT_UNVERIFIED_ADDRESS_CLICKED = "onProjectUnverifiedAddressClicked", e))(Ma || {});
const De = jo();
class Vb {
  showOnlyLogo() {
    De.emit(
      "showOnlyLogo"
      /* SHOW_ONLY_LOGO */
    );
  }
  showOnlyPCName(t) {
    De.emit("showOnlyPCName", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showNavbar(t) {
    De.emit("showNavbar", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  hideNavbar() {
    De.emit("hideNavbar", {
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  enableNavbarButtons(t) {
    De.emit("enableNavbarButtons", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  disableNavbarButtons(t) {
    De.emit("disableNavbarButtons", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  addTooltips(t) {
    De.emit("addTooltips", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  updateNavbar(t) {
    De.emit("updateNavbar", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showProjectOnNavbar(t) {
    De.emit("showProjectName", {
      options: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  setCadMode(t) {
    De.emit("toggleCadMode", {
      flag: t,
      resolve: () => {
        console.log("resolve");
      }
    });
  }
  showUnverifiedAddress(t) {
    De.emit("showUnverifiedAddress", {
      flag: t,
      resolve: () => {
      }
    });
  }
}
var G = /* @__PURE__ */ ((e) => (e[e.RG_LOGO_ONLY = 100] = "RG_LOGO_ONLY", e[e.SETTINGS = 0] = "SETTINGS", e[e.MATERIAL_LIBRARY = 1] = "MATERIAL_LIBRARY", e[e.ADD_PATIENT = 2] = "ADD_PATIENT", e[e.NOTIFICATIONS = 3] = "NOTIFICATIONS", e[e.SUPPORT = 4] = "SUPPORT", e[e.EXIT = 5] = "EXIT", e[e.LOGOUT = 6] = "LOGOUT", e[e.SCREENSHOT = 7] = "SCREENSHOT", e[e.RULER = 8] = "RULER", e[e.INSPECT = 9] = "INSPECT", e[e.RESET = 10] = "RESET", e[e.LAYOUT = 11] = "LAYOUT", e[e.SAVE = 12] = "SAVE", e[e.SAVE_AS = 13] = "SAVE_AS", e[e.W_L = 14] = "W_L", e[e.HELP = 15] = "HELP", e[e.UNDO = 16] = "UNDO", e[e.REDO = 17] = "REDO", e[e.INFO = 19] = "INFO", e[e.PROFILE = 20] = "PROFILE", e[e.PC_SETTINGS = 21] = "PC_SETTINGS", e[e.USER_SETTINGS = 22] = "USER_SETTINGS", e[e.RULER_DISTANCE = 23] = "RULER_DISTANCE", e[e.RULER_ANGLE = 24] = "RULER_ANGLE", e[e.RULER_ANNOTATION = 25] = "RULER_ANNOTATION", e[e.RULER_ROI = 26] = "RULER_ROI", e[e.RULER_CLEAR = 27] = "RULER_CLEAR", e[e.RG_LOGO = 28] = "RG_LOGO", e[e.ZIMVIE_LOGO = 29] = "ZIMVIE_LOGO", e[e.DISTANCE_UNIT_MM = 30] = "DISTANCE_UNIT_MM", e[e.DISTANCE_UNIT_INCH = 31] = "DISTANCE_UNIT_INCH", e[e.ADD_DOCTOR = 31] = "ADD_DOCTOR", e[e.SHOW_DOCTOR_PATIENT_LIST = 32] = "SHOW_DOCTOR_PATIENT_LIST", e[e.TESTING_VIEW = 33] = "TESTING_VIEW", e[e.RULER_SPHERE = 34] = "RULER_SPHERE", e[e.RULER_PLANE = 35] = "RULER_PLANE", e[e.RULER_TETRAHEDRON = 36] = "RULER_TETRAHEDRON", e[e.RULER_LANDMARK = 37] = "RULER_LANDMARK", e[e.RULER_CLEAR_EXCEPT = 38] = "RULER_CLEAR_EXCEPT", e[e.PC_SELECTION = 39] = "PC_SELECTION", e[e.PROFILE_INFO = 40] = "PROFILE_INFO", e[e.PC_LIST = 41] = "PC_LIST", e[e.RG_WEB = 42] = "RG_WEB", e[e.RESET_PASSWORD = 43] = "RESET_PASSWORD", e[e.VIDEO_TUTORIAL = 44] = "VIDEO_TUTORIAL", e[e.E_LEARNING = 45] = "E_LEARNING", e[e.OPEN_TICKET = 46] = "OPEN_TICKET", e[e.REMOTE_SUPPORT = 47] = "REMOTE_SUPPORT", e))(G || {}), gs = /* @__PURE__ */ ((e) => (e[e.Mm = 0] = "Mm", e[e.Inch = 1] = "Inch", e))(gs || {});
const Ef = aa("userStore", {
  state: () => ({
    user: {},
    userAddressId: 0,
    billingData: [],
    shippingData: [],
    users: [],
    userAddressMap: /* @__PURE__ */ new Map(),
    usersBillingData: [],
    usersShippingData: [],
    hasUnverifiedAddressInfo: !1,
    translationMessages: {},
    weblinkMessages: {}
  }),
  actions: {
    async updateUsers(e, t) {
      if (t)
        try {
          const { data: n } = await this.api.getUserByKeyword(t, e);
          this.users = n.filter((a) => a.username !== "prodcenteruser");
        } catch {
          Oe(this.weblinkMessages.thereWasAProblemWithLoadingUsers || "There was a problem with loading users");
        }
      else
        try {
          const { data: n } = await this.api.getUsers(e);
          this.users = n.filter((a) => a.username !== "prodcenteruser");
        } catch {
          Oe(this.weblinkMessages.thereWasAProblemWithLoadingUsers || "There was a problem with loading users");
        }
    },
    async getUserAddresses(e, t, n = !1) {
      try {
        n && await Jt.invalidateQueries({ queryKey: Na(e, t), exact: !0 });
        const a = await Jt.fetchQuery(cy(this.api, e, t));
        this.userAddressMap.set(t, a), this.usersBillingData = a.billingList, this.usersShippingData = a.shippingList, this.userAddressId = t;
        const s = e === 1 || e === 29;
        return this.hasUnverifiedAddressInfo = s && (this.usersBillingData.some((o) => !o.verified) || this.usersShippingData.some((o) => !o.verified)), a;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithLoadingUserAddresses || "There was a problem with loading user addresses");
      }
      return null;
    },
    async updateData() {
      try {
        const { data: e } = await this.api.getUserAddresses();
        return this.billingData = e.billingList.map((t) => ({
          ...t,
          data: { ...t.data, optionLabel: ao(t) }
        })), this.shippingData = e.shippingList.map((t) => ({
          ...t,
          data: { ...t.data, optionLabel: ao(t) }
        })), !0;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithLoadingUserAddressesUpdateData || "There was a problem with loading user addresses (update data)");
      }
    },
    async updateBellatekAddress(e) {
      try {
        const { data: t } = await this.api.getUserAddresses();
        this.billingData = t.billingList.filter((n) => n.bellatekAddressType == (e ? 2 : 1)).map((n) => ({
          ...n,
          data: { ...n.data, optionLabel: ao(n) }
        })), this.shippingData = t.shippingList.filter((n) => n.bellatekAddressType == (e ? 2 : 1)).map((n) => ({
          ...n,
          data: { ...n.data, optionLabel: ao(n) }
        }));
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithLoadingUserAddresses || "There was a problem with loading user addresses");
      }
    },
    async upsertShippingAddress(e) {
      try {
        (await this.api.upsertUserShippingAddress(e)).status === 200 && We("User data address updated!");
        const n = this.shippingData.findIndex((a) => a.id === e.id);
        n != -1 ? this.shippingData[n] = e : this.shippingData.push(e), await this.updateData();
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating billing address");
      }
    },
    async upsertBillingAddress(e) {
      try {
        (await this.api.upsertUserBillingAddress(e)).status === 200 && We("User billing address updated!");
        const n = this.billingData.findIndex((a) => a.id === e.id);
        n != -1 ? this.billingData[n] = e : this.billingData.push(e), await this.updateData();
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating billing address");
      }
    },
    async createPCUserBillingAddress(e) {
      try {
        const t = await this.api.createProductionCenterUserBillingAddress(e);
        return t.status === 200 && (We("User Billing address created!"), await this.getUserAddresses(e.productionCenterId, e.uid, !0)), t;
      } catch (t) {
        return Oe(this.weblinkMessages.thereWasAProblemWithCreatingBillingAddress || "There was a problem with creating Billing address"), t;
      }
    },
    async updatePCUserBillingAddress(e) {
      try {
        const t = await this.api.updateProductionCenterUserBillingAddress(e);
        return t.status === 200 && (We("User Billing address updated!"), this.userAddressMap.delete(e.uid), await Jt.invalidateQueries({ queryKey: Na(e.productionCenterId, e.uid), exact: !0 })), t;
      } catch (t) {
        return Oe(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating Billing address"), t;
      }
    },
    async deletePCUserBillingAddress(e) {
      try {
        (await this.api.deleteProductionCenterUserBillingAddress(e)).status === 200 && (We("User Billing address removed!"), this.userAddressMap.clear(), await Jt.invalidateQueries({ queryKey: Ts(e.productionCenterId) }));
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithRemovingBillingAddress || "There was a problem with removing Billing address");
      }
    },
    async updateBillingAddress(e) {
      try {
        (await this.api.updateUserBillingAddress(e)).status === 200 && We("User Billing address updated!");
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingBillingAddress || "There was a problem with updating Billing address");
      }
    },
    async verifyProductionCenterUserBillingAddress(e) {
      try {
        (await this.api.verifyProductionCenterUserBillingAddress(e)).status === 200 && (await this.getUserAddresses(e.pcid, e.uid, !0), We("User Billing address verified!"));
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithVerifyingBillingAddress || "There was a problem with verifying Billing address");
      }
    },
    async createPCUserShippingAddress(e) {
      try {
        const t = await this.api.createProductionCenterUserShippingAddress(e);
        return t.status === 200 && (We("User Shipping address created!"), this.userAddressMap.delete(e.uid), await Jt.invalidateQueries({ queryKey: Na(e.productionCenterId, e.uid), exact: !0 })), t;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithCreatingShippingAddress || "There was a problem with creating Shipping address");
      }
    },
    async updatePCUserShippingAddress(e) {
      try {
        const t = await this.api.updateProductionCenterUserShippingAddress(e);
        return t.status === 200 && (We("User Shipping address updated!"), this.userAddressMap.delete(e.uid), await Jt.invalidateQueries({ queryKey: Na(e.productionCenterId, e.uid), exact: !0 })), t;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingShippingAddress || "There was a problem with updating Shipping address");
      }
    },
    async deletePCUserShippingAddress(e) {
      try {
        const t = await this.api.deleteProductionCenterUserShippingAddress(e);
        if (t.status === 200)
          return We("User Shipping address removed!"), this.userAddressMap.clear(), await Jt.invalidateQueries({ queryKey: Ts(e.productionCenterId) }), t.status === 200;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithRemovingShippingAddress || "There was a problem with removing Shipping address");
      }
    },
    async verifyProductionCenterUserShippingAddress(e) {
      try {
        (await this.api.verifyProductionCenterUserShippingAddress(e)).status === 200 && (await this.getUserAddresses(e.pcid, e.uid, !0), We("User Shipping address verified!"));
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithVerifyingShippingAddress || "There was a problem with verifying Shipping address");
      }
    },
    async deleteShippingAddress(e) {
      try {
        (await this.api.deleteUserShippingAddress(e)).status === 200 && We("User Shipping address deleted!");
        const n = this.shippingData.findIndex((a) => a.id === e);
        this.shippingData.splice(n, 1);
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithDeletingShippingAddress || "There was a problem with deleting Shipping address");
      }
    },
    async deleteBillingData(e) {
      try {
        (await this.api.deleteUserBillingAddress(e)).status === 200 && We("User shipping address deleted!");
        const n = this.billingData.findIndex((a) => a.id === e);
        this.billingData.splice(n, 1);
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithDeletingShippingAddress || "There was a problem with deleting shipping address");
      }
    },
    async updateEmailNotificationPrescriptionChange(e) {
      try {
        (await this.api.updateUserNotificationsPrescriptionUpdate(e)).status === 200 && We("User notifications updated!");
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingUserNotifications || "There was a problem with updating user notifications");
      }
    },
    async updateChatEmailNotificationChange(e) {
      try {
        (await this.api.updateUserChatNotificationsUpdate(e)).status === 200 && We("User notifications updated!");
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithUpdatingUserNotifications || "There was a problem with updating user notifications");
      }
    },
    async getUserSessionToken() {
      try {
        const { data: e } = await this.api.getUserSessionToken();
        return e.id;
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithGettingUserSessionToken || "There was a problem with getting user session token");
      }
    },
    async saveUserSettings(e, t) {
      try {
        await this.api.postUserSettingsKey(e, t);
      } catch {
        Oe(this.weblinkMessages.thereWasAProblemWithSavingUserSettings || "There was a problem with saving user settings");
      }
    },
    async updateTranslationMessages(e) {
      this.translationMessages = e, this.weblinkMessages = e.weblink;
    },
    async setUserTimezone(e) {
      try {
        await this.api.setUserTimezone(e), We("User timezone updated!");
      } catch {
        Oe("There was a problem with saving user timezone");
      }
    }
  }
}), Kb = {
  VIDEO_TUTORIAL: Zu,
  REMOTE_SUPPORT: ed
}, Cf = aa("utilStore", {
  state: () => {
    const e = T(window.innerWidth), t = T(window.innerHeight), n = T(i()), a = T(l()), s = T(r());
    window.addEventListener("resize", o), ye(e, o);
    function o() {
      e.value = window.innerWidth, c.isMobileView = e.value < 520, c.isTabletView = e.value < 1e3, c.screenSIze = e.value, c.screenType = i();
    }
    function i() {
      return e.value < 520 ? "sm" : e.value > 520 && e.value < 1500 ? "md" : "lg";
    }
    function r() {
      return e.value < 745 ? "sm" : e.value > 745 && e.value < 1180 ? "md" : "lg";
    }
    function l() {
      return Math.round((window.innerHeight - 384) / 45 + 2);
    }
    const c = un({
      isMobileView: e.value < 520,
      isTabletView: e.value < 1e3,
      screenType: n.value,
      screenSIze: e,
      screenHeight: t,
      dataTableRowCount: a,
      rgScreenType: s
    });
    return c;
  },
  actions: {
    async getInfoUrl(e, t = !0) {
      try {
        const { data: n } = await this.api.getInfoUrls([e]), a = n.find((s) => s.kind === e && s.url);
        if (a != null && a.url)
          return a.url;
      } catch {
      }
      return t ? Kb[e] : void 0;
    }
  }
}), fM = aa("guiConfigurationStore", {
  state: () => {
    const e = Hu(), t = un({
      colorScheme: e.colorScheme,
      componentTheme: e.componentTheme,
      theme: e.theme,
      topbarTheme: e.topbarTheme
    });
    return ye(e, () => {
      t.colorScheme = e.colorScheme, t.theme = e.theme, t.componentTheme = e.componentTheme, t.topbarTheme = e.topbarTheme;
    }), t;
  }
}), Wb = new Set(Object.values(V)), zb = {
  cz: V.CS,
  cn: V.ZH_HANS,
  zh: V.ZH_HANS
}, $b = {
  [V.CS]: "cz",
  [V.ZH_HANS]: "zh"
}, qb = {
  [V.ZH_HANS]: "webcad_translations_zh_Hans.json"
};
function Cc(e) {
  return qb[e] ?? `webcad_translations_${e}.json`;
}
const Jb = {
  [V.EN]: async () => import("./webcad_translations_en-BLdXDRmC.js"),
  [V.IT]: async () => import("./webcad_translations_it-BgUMb1-v.js"),
  [V.BG]: async () => import("./webcad_translations_bg-ydHZL7Jl.js"),
  [V.CS]: async () => import("./webcad_translations_cs-DjWw6Iqb.js"),
  [V.DA]: async () => import("./webcad_translations_da-Bo386hmo.js"),
  [V.DE]: async () => import("./webcad_translations_de-C9-S0CMk.js"),
  [V.ES]: async () => import("./webcad_translations_es-Cktk1DwA.js"),
  [V.FR]: async () => import("./webcad_translations_fr-b6ZHjjT-.js"),
  [V.HR]: async () => import("./webcad_translations_hr-DjWw6Iqb.js"),
  [V.HU]: async () => import("./webcad_translations_hu-BxQQimBR.js"),
  [V.JA]: async () => import("./webcad_translations_ja-DjWw6Iqb.js"),
  [V.KO]: async () => import("./webcad_translations_ko-DjWw6Iqb.js"),
  [V.LT]: async () => import("./webcad_translations_lt-DvH4EH6Z.js"),
  [V.NL]: async () => import("./webcad_translations_nl-DjWw6Iqb.js"),
  [V.PL]: async () => import("./webcad_translations_pl-DjWw6Iqb.js"),
  [V.PT]: async () => import("./webcad_translations_pt-CGQ2IATl.js"),
  [V.RO]: async () => import("./webcad_translations_ro-DuwA2e1O.js"),
  [V.SK]: async () => import("./webcad_translations_sk-CoxQYuDo.js"),
  [V.SL]: async () => import("./webcad_translations_sl-DjWw6Iqb.js"),
  [V.SV]: async () => import("./webcad_translations_sv-C7rEtDQU.js"),
  [V.TR]: async () => import("./webcad_translations_tr-BDMct_Gn.js"),
  [V.ZH_HANS]: async () => import("./webcad_translations_zh_Hans-DjWw6Iqb.js")
}, wc = {};
async function Ic(e) {
  const t = wc[e];
  if (t)
    return t;
  const a = (await Jb[e]()).default ?? {};
  return wc[e] = a, a;
}
function zn(e) {
  if (typeof e != "string")
    return V.EN;
  const t = e.trim().replaceAll("-", "_").toLowerCase(), n = zb[t];
  return n || (Wb.has(t) ? t : V.EN);
}
function Xb(e) {
  const t = zn(e);
  return $b[t] ?? t;
}
const Zb = aa("localizationStore", {
  state: () => ({
    loading: !1
  }),
  actions: {
    async getWebcadTranslations(e) {
      const t = zn(e);
      try {
        return await Ic(t);
      } catch (n) {
        console.error(`Translation load failed for ${Cc(t)} – falling back to en:`, n);
      }
      if (t === V.EN)
        return {};
      try {
        return await Ic(V.EN);
      } catch (n) {
        return console.error(`Translation fallback load failed for ${Cc(V.EN)}:`, n), {};
      }
    },
    async setAppLanguage(e) {
      const t = zn(e);
      localStorage.setItem("langApp", JSON.stringify(t));
    },
    getAppLanguage() {
      const e = localStorage.getItem("langApp");
      if (!e)
        return localStorage.setItem("langApp", JSON.stringify(V.EN)), V.EN;
      try {
        const t = JSON.parse(e), n = zn(t);
        return t !== n && localStorage.setItem("langApp", JSON.stringify(n)), n;
      } catch {
        return localStorage.setItem("langApp", JSON.stringify(V.EN)), V.EN;
      }
    }
  }
}), pM = aa("stlLibraryStore", {
  state: () => ({
    cachedResponse: void 0
  }),
  actions: {
    async loadSTLLibrary() {
      this.cachedResponse = (await this.stlApi.getAllObjects()).data;
    }
  }
}), mM = aa("testingProtocolStore", {
  state: () => ({
    loading: !1
  }),
  actions: {
    async getTestingScriptFromSauron(e, t, n) {
      try {
        return (await this.api.getPoolAsset(e, t, n)).data;
      } catch (a) {
        console.log("error at getTestingScriptFromSauron: ", a);
      }
    },
    async uploadTestingScriptToSauron(e, t) {
      try {
        await this.api.uploadPoolAsset(e, t);
      } catch (n) {
        console.log("error at uploadTestingScriptToSauron: ", n);
      }
    },
    async getAllTestingReports(e) {
      try {
        return (await this.api.getPoolAssetList(e)).data.filter((n) => n.name.includes("report"));
      } catch (t) {
        console.log("error at getAllTestingReports: ", t);
      }
    },
    async deleteTestingReport(e, t) {
      try {
        await this.api.deletePoolAsset(e, t);
      } catch (n) {
        console.log("error at deleteTestingReport: ", n);
      }
    }
  }
});
/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function dn(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Bc = {};
function ex(e) {
  Bc[e] || (Bc[e] = !0, dn(e));
}
const _n = typeof window < "u";
let Ct, Ia;
if (process.env.NODE_ENV !== "production") {
  const e = _n && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Ct = (t) => {
    e.mark(t);
  }, Ia = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const tx = /\{([0-9a-zA-Z]+)\}/g;
function ai(e, ...t) {
  return t.length === 1 && xe(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(tx, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const On = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), nx = (e, t, n) => ax({ l: e, k: t, s: n }), ax = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), $e = (e) => typeof e == "number" && isFinite(e), sx = (e) => qr(e) === "[object Date]", Oo = (e) => qr(e) === "[object RegExp]", si = (e) => be(e) && Object.keys(e).length === 0, Je = Object.assign, ox = Object.create, _e = (e = null) => ox(e);
let kc;
const fa = () => kc || (kc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : _e());
function _c(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Sc(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ix(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (a, s, o) => `${s}="${Sc(o)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (a, s, o) => `${s}='${Sc(o)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && dn("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((a) => {
    e = e.replace(a, "$1javascript&#58;");
  }), e;
}
const rx = Object.prototype.hasOwnProperty;
function Gt(e, t) {
  return rx.call(e, t);
}
const Ue = Array.isArray, Re = (e) => typeof e == "function", z = (e) => typeof e == "string", Qe = (e) => typeof e == "boolean", xe = (e) => e !== null && typeof e == "object", lx = (e) => xe(e) && Re(e.then) && Re(e.catch), wf = Object.prototype.toString, qr = (e) => wf.call(e), be = (e) => qr(e) === "[object Object]", cx = (e) => e == null ? "" : Ue(e) || be(e) && e.toString === wf ? JSON.stringify(e, null, 2) : String(e);
function Jr(e, t = "") {
  return e.reduce((n, a, s) => s === 0 ? n + a : n + t + a, "");
}
const Dc = 2;
function ux(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let s = 0;
  const o = [];
  for (let i = 0; i < a.length; i++)
    if (s += a[i].length + 1, s >= t) {
      for (let r = i - Dc; r <= i + Dc || n > s; r++) {
        if (r < 0 || r >= a.length)
          continue;
        const l = r + 1;
        o.push(`${l}${" ".repeat(3 - String(l).length)}|  ${a[r]}`);
        const c = a[r].length;
        if (r === i) {
          const u = t - (s - c) + 1, d = Math.max(1, n > s ? c - u : n - t);
          o.push("   |  " + " ".repeat(u) + "^".repeat(d));
        } else if (r > i) {
          if (n > s) {
            const u = Math.max(Math.min(n - s, c), 1);
            o.push("   |  " + "^".repeat(u));
          }
          s += c + 1;
        }
      }
      break;
    }
  return o.join(`
`);
}
function dx() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const s = e.get(n);
      s && s.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const s = e.get(n);
      s && s.splice(s.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((s) => s(a)), (e.get("*") || []).slice().map((s) => s(n, a));
    }
  };
}
const so = (e) => !xe(e) || Ue(e);
function vo(e, t) {
  if (so(e) || so(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: a, des: s } = n.pop();
    Object.keys(a).forEach((o) => {
      o !== "__proto__" && (xe(a[o]) && !xe(s[o]) && (s[o] = Array.isArray(a[o]) ? [] : _e()), so(s[o]) || so(a[o]) ? s[o] = a[o] : n.push({ src: a[o], des: s[o] }));
    });
  }
}
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function fx(e, t, n) {
  return { line: e, column: t, offset: n };
}
function ur(e, t, n) {
  return { start: e, end: t };
}
const ne = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, px = 17, mx = {
  // tokenizer error messages
  [ne.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [ne.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [ne.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [ne.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [ne.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [ne.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [ne.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [ne.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [ne.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [ne.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [ne.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [ne.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [ne.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [ne.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [ne.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [ne.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function rs(e, t, n = {}) {
  const { domain: a, messages: s, args: o } = n, i = process.env.NODE_ENV !== "production" ? ai((s || mx)[e] || "", ...o || []) : e, r = new SyntaxError(String(i));
  return r.code = e, t && (r.location = t), r.domain = a, r;
}
function Ax(e) {
  throw e;
}
const gx = /<\/?[\w\s="/.':;#-\/]+>/, hx = (e) => gx.test(e), $t = " ", vx = "\r", ot = `
`, yx = "\u2028", bx = "\u2029";
function xx(e) {
  const t = e;
  let n = 0, a = 1, s = 1, o = 0;
  const i = (S) => t[S] === vx && t[S + 1] === ot, r = (S) => t[S] === ot, l = (S) => t[S] === bx, c = (S) => t[S] === yx, u = (S) => i(S) || r(S) || l(S) || c(S), d = () => n, m = () => a, g = () => s, h = () => o, A = (S) => i(S) || l(S) || c(S) ? ot : t[S], f = () => A(n), p = () => A(n + o);
  function v() {
    return o = 0, u(n) && (a++, s = 0), i(n) && n++, n++, s++, t[n];
  }
  function b() {
    return i(n + o) && o++, o++, t[n + o];
  }
  function y() {
    n = 0, a = 1, s = 1, o = 0;
  }
  function _(S = 0) {
    o = S;
  }
  function M() {
    const S = n + o;
    for (; S !== n; )
      v();
    o = 0;
  }
  return {
    index: d,
    line: m,
    column: g,
    peekOffset: h,
    charAt: A,
    currentChar: f,
    currentPeek: p,
    next: v,
    peek: b,
    reset: y,
    resetPeek: _,
    skipToPeek: M
  };
}
const vn = void 0, Ex = ".", Tc = "'", Cx = "tokenizer";
function wx(e, t = {}) {
  const n = t.location !== !1, a = xx(e), s = () => a.index(), o = () => fx(a.line(), a.column(), a.index()), i = o(), r = s(), l = {
    currentType: 13,
    offset: r,
    startLoc: i,
    endLoc: i,
    lastType: 13,
    lastOffset: r,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = t;
  function d(E, I, R, ...W) {
    const we = c();
    if (I.column += R, I.offset += R, u) {
      const Se = n ? ur(we.startLoc, I) : null, ce = rs(E, Se, {
        domain: Cx,
        args: W
      });
      u(ce);
    }
  }
  function m(E, I, R) {
    E.endLoc = o(), E.currentType = I;
    const W = { type: I };
    return n && (W.loc = ur(E.startLoc, E.endLoc)), R != null && (W.value = R), W;
  }
  const g = (E) => m(
    E,
    13
    /* TokenTypes.EOF */
  );
  function h(E, I) {
    return E.currentChar() === I ? (E.next(), I) : (d(ne.EXPECTED_TOKEN, o(), 0, I), "");
  }
  function A(E) {
    let I = "";
    for (; E.currentPeek() === $t || E.currentPeek() === ot; )
      I += E.currentPeek(), E.peek();
    return I;
  }
  function f(E) {
    const I = A(E);
    return E.skipToPeek(), I;
  }
  function p(E) {
    if (E === vn)
      return !1;
    const I = E.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I === 95;
  }
  function v(E) {
    if (E === vn)
      return !1;
    const I = E.charCodeAt(0);
    return I >= 48 && I <= 57;
  }
  function b(E, I) {
    const { currentType: R } = I;
    if (R !== 2)
      return !1;
    A(E);
    const W = p(E.currentPeek());
    return E.resetPeek(), W;
  }
  function y(E, I) {
    const { currentType: R } = I;
    if (R !== 2)
      return !1;
    A(E);
    const W = E.currentPeek() === "-" ? E.peek() : E.currentPeek(), we = v(W);
    return E.resetPeek(), we;
  }
  function _(E, I) {
    const { currentType: R } = I;
    if (R !== 2)
      return !1;
    A(E);
    const W = E.currentPeek() === Tc;
    return E.resetPeek(), W;
  }
  function M(E, I) {
    const { currentType: R } = I;
    if (R !== 7)
      return !1;
    A(E);
    const W = E.currentPeek() === ".";
    return E.resetPeek(), W;
  }
  function S(E, I) {
    const { currentType: R } = I;
    if (R !== 8)
      return !1;
    A(E);
    const W = p(E.currentPeek());
    return E.resetPeek(), W;
  }
  function Y(E, I) {
    const { currentType: R } = I;
    if (!(R === 7 || R === 11))
      return !1;
    A(E);
    const W = E.currentPeek() === ":";
    return E.resetPeek(), W;
  }
  function K(E, I) {
    const { currentType: R } = I;
    if (R !== 9)
      return !1;
    const W = () => {
      const Se = E.currentPeek();
      return Se === "{" ? p(E.peek()) : Se === "@" || Se === "|" || Se === ":" || Se === "." || Se === $t || !Se ? !1 : Se === ot ? (E.peek(), W()) : le(E, !1);
    }, we = W();
    return E.resetPeek(), we;
  }
  function Z(E) {
    A(E);
    const I = E.currentPeek() === "|";
    return E.resetPeek(), I;
  }
  function le(E, I = !0) {
    const R = (we = !1, Se = "") => {
      const ce = E.currentPeek();
      return ce === "{" || ce === "@" || !ce ? we : ce === "|" ? !(Se === $t || Se === ot) : ce === $t ? (E.peek(), R(!0, $t)) : ce === ot ? (E.peek(), R(!0, ot)) : !0;
    }, W = R();
    return I && E.resetPeek(), W;
  }
  function re(E, I) {
    const R = E.currentChar();
    return R === vn ? vn : I(R) ? (E.next(), R) : null;
  }
  function Ee(E) {
    const I = E.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I >= 48 && I <= 57 || // 0-9
    I === 95 || // _
    I === 36;
  }
  function Ye(E) {
    return re(E, Ee);
  }
  function te(E) {
    const I = E.charCodeAt(0);
    return I >= 97 && I <= 122 || // a-z
    I >= 65 && I <= 90 || // A-Z
    I >= 48 && I <= 57 || // 0-9
    I === 95 || // _
    I === 36 || // $
    I === 45;
  }
  function pe(E) {
    return re(E, te);
  }
  function Ce(E) {
    const I = E.charCodeAt(0);
    return I >= 48 && I <= 57;
  }
  function _t(E) {
    return re(E, Ce);
  }
  function Ve(E) {
    const I = E.charCodeAt(0);
    return I >= 48 && I <= 57 || // 0-9
    I >= 65 && I <= 70 || // A-F
    I >= 97 && I <= 102;
  }
  function je(E) {
    return re(E, Ve);
  }
  function Ke(E) {
    let I = "", R = "";
    for (; I = _t(E); )
      R += I;
    return R;
  }
  function at(E) {
    let I = "";
    for (; ; ) {
      const R = E.currentChar();
      if (R === "{" || R === "}" || R === "@" || R === "|" || !R)
        break;
      if (R === $t || R === ot)
        if (le(E))
          I += R, E.next();
        else {
          if (Z(E))
            break;
          I += R, E.next();
        }
      else
        I += R, E.next();
    }
    return I;
  }
  function Xe(E) {
    f(E);
    let I = "", R = "";
    for (; I = pe(E); )
      R += I;
    const W = E.currentChar();
    if (W && W !== "}" && W !== vn && W !== $t && W !== ot && W !== "　") {
      const we = mn(E);
      return d(ne.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, R + we), R + we;
    }
    return E.currentChar() === vn && d(ne.UNTERMINATED_CLOSING_BRACE, o(), 0), R;
  }
  function ct(E) {
    f(E);
    let I = "";
    return E.currentChar() === "-" ? (E.next(), I += `-${Ke(E)}`) : I += Ke(E), E.currentChar() === vn && d(ne.UNTERMINATED_CLOSING_BRACE, o(), 0), I;
  }
  function pt(E) {
    return E !== Tc && E !== ot;
  }
  function Vt(E) {
    f(E), h(E, "'");
    let I = "", R = "";
    for (; I = re(E, pt); )
      I === "\\" ? R += Kt(E) : R += I;
    const W = E.currentChar();
    return W === ot || W === vn ? (d(ne.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, o(), 0), W === ot && (E.next(), h(E, "'")), R) : (h(E, "'"), R);
  }
  function Kt(E) {
    const I = E.currentChar();
    switch (I) {
      case "\\":
      case "'":
        return E.next(), `\\${I}`;
      case "u":
        return mt(E, I, 4);
      case "U":
        return mt(E, I, 6);
      default:
        return d(ne.UNKNOWN_ESCAPE_SEQUENCE, o(), 0, I), "";
    }
  }
  function mt(E, I, R) {
    h(E, I);
    let W = "";
    for (let we = 0; we < R; we++) {
      const Se = je(E);
      if (!Se) {
        d(ne.INVALID_UNICODE_ESCAPE_SEQUENCE, o(), 0, `\\${I}${W}${E.currentChar()}`);
        break;
      }
      W += Se;
    }
    return `\\${I}${W}`;
  }
  function Ot(E) {
    return E !== "{" && E !== "}" && E !== $t && E !== ot;
  }
  function mn(E) {
    f(E);
    let I = "", R = "";
    for (; I = re(E, Ot); )
      R += I;
    return R;
  }
  function An(E) {
    let I = "", R = "";
    for (; I = Ye(E); )
      R += I;
    return R;
  }
  function la(E) {
    const I = (R) => {
      const W = E.currentChar();
      return W === "{" || W === "@" || W === "|" || W === "(" || W === ")" || !W || W === $t ? R : (R += W, E.next(), I(R));
    };
    return I("");
  }
  function he(E) {
    f(E);
    const I = h(
      E,
      "|"
      /* TokenChars.Pipe */
    );
    return f(E), I;
  }
  function gn(E, I) {
    let R = null;
    switch (E.currentChar()) {
      case "{":
        return I.braceNest >= 1 && d(ne.NOT_ALLOW_NEST_PLACEHOLDER, o(), 0), E.next(), R = m(
          I,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), f(E), I.braceNest++, R;
      case "}":
        return I.braceNest > 0 && I.currentType === 2 && d(ne.EMPTY_PLACEHOLDER, o(), 0), E.next(), R = m(
          I,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), I.braceNest--, I.braceNest > 0 && f(E), I.inLinked && I.braceNest === 0 && (I.inLinked = !1), R;
      case "@":
        return I.braceNest > 0 && d(ne.UNTERMINATED_CLOSING_BRACE, o(), 0), R = Nt(E, I) || g(I), I.braceNest = 0, R;
      default: {
        let we = !0, Se = !0, ce = !0;
        if (Z(E))
          return I.braceNest > 0 && d(ne.UNTERMINATED_CLOSING_BRACE, o(), 0), R = m(I, 1, he(E)), I.braceNest = 0, I.inLinked = !1, R;
        if (I.braceNest > 0 && (I.currentType === 4 || I.currentType === 5 || I.currentType === 6))
          return d(ne.UNTERMINATED_CLOSING_BRACE, o(), 0), I.braceNest = 0, Wt(E, I);
        if (we = b(E, I))
          return R = m(I, 4, Xe(E)), f(E), R;
        if (Se = y(E, I))
          return R = m(I, 5, ct(E)), f(E), R;
        if (ce = _(E, I))
          return R = m(I, 6, Vt(E)), f(E), R;
        if (!we && !Se && !ce)
          return R = m(I, 12, mn(E)), d(ne.INVALID_TOKEN_IN_PLACEHOLDER, o(), 0, R.value), f(E), R;
        break;
      }
    }
    return R;
  }
  function Nt(E, I) {
    const { currentType: R } = I;
    let W = null;
    const we = E.currentChar();
    switch ((R === 7 || R === 8 || R === 11 || R === 9) && (we === ot || we === $t) && d(ne.INVALID_LINKED_FORMAT, o(), 0), we) {
      case "@":
        return E.next(), W = m(
          I,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), I.inLinked = !0, W;
      case ".":
        return f(E), E.next(), m(
          I,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return f(E), E.next(), m(
          I,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return Z(E) ? (W = m(I, 1, he(E)), I.braceNest = 0, I.inLinked = !1, W) : M(E, I) || Y(E, I) ? (f(E), Nt(E, I)) : S(E, I) ? (f(E), m(I, 11, An(E))) : K(E, I) ? (f(E), we === "{" ? gn(E, I) || W : m(I, 10, la(E))) : (R === 7 && d(ne.INVALID_LINKED_FORMAT, o(), 0), I.braceNest = 0, I.inLinked = !1, Wt(E, I));
    }
  }
  function Wt(E, I) {
    let R = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (I.braceNest > 0)
      return gn(E, I) || g(I);
    if (I.inLinked)
      return Nt(E, I) || g(I);
    switch (E.currentChar()) {
      case "{":
        return gn(E, I) || g(I);
      case "}":
        return d(ne.UNBALANCED_CLOSING_BRACE, o(), 0), E.next(), m(
          I,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Nt(E, I) || g(I);
      default: {
        if (Z(E))
          return R = m(I, 1, he(E)), I.braceNest = 0, I.inLinked = !1, R;
        if (le(E))
          return m(I, 0, at(E));
        break;
      }
    }
    return R;
  }
  function hn() {
    const { currentType: E, offset: I, startLoc: R, endLoc: W } = l;
    return l.lastType = E, l.lastOffset = I, l.lastStartLoc = R, l.lastEndLoc = W, l.offset = s(), l.startLoc = o(), a.currentChar() === vn ? m(
      l,
      13
      /* TokenTypes.EOF */
    ) : Wt(a, l);
  }
  return {
    nextToken: hn,
    currentOffset: s,
    currentPosition: o,
    context: c
  };
}
const Ix = "parser", Bx = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function kx(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function _x(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(p, v, b, y, ..._) {
    const M = p.currentPosition();
    if (M.offset += y, M.column += y, n) {
      const S = t ? ur(b, M) : null, Y = rs(v, S, {
        domain: Ix,
        args: _
      });
      n(Y);
    }
  }
  function s(p, v, b) {
    const y = { type: p };
    return t && (y.start = v, y.end = v, y.loc = { start: b, end: b }), y;
  }
  function o(p, v, b, y) {
    t && (p.end = v, p.loc && (p.loc.end = b));
  }
  function i(p, v) {
    const b = p.context(), y = s(3, b.offset, b.startLoc);
    return y.value = v, o(y, p.currentOffset(), p.currentPosition()), y;
  }
  function r(p, v) {
    const b = p.context(), { lastOffset: y, lastStartLoc: _ } = b, M = s(5, y, _);
    return M.index = parseInt(v, 10), p.nextToken(), o(M, p.currentOffset(), p.currentPosition()), M;
  }
  function l(p, v) {
    const b = p.context(), { lastOffset: y, lastStartLoc: _ } = b, M = s(4, y, _);
    return M.key = v, p.nextToken(), o(M, p.currentOffset(), p.currentPosition()), M;
  }
  function c(p, v) {
    const b = p.context(), { lastOffset: y, lastStartLoc: _ } = b, M = s(9, y, _);
    return M.value = v.replace(Bx, kx), p.nextToken(), o(M, p.currentOffset(), p.currentPosition()), M;
  }
  function u(p) {
    const v = p.nextToken(), b = p.context(), { lastOffset: y, lastStartLoc: _ } = b, M = s(8, y, _);
    return v.type !== 11 ? (a(p, ne.UNEXPECTED_EMPTY_LINKED_MODIFIER, b.lastStartLoc, 0), M.value = "", o(M, y, _), {
      nextConsumeToken: v,
      node: M
    }) : (v.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, qt(v)), M.value = v.value || "", o(M, p.currentOffset(), p.currentPosition()), {
      node: M
    });
  }
  function d(p, v) {
    const b = p.context(), y = s(7, b.offset, b.startLoc);
    return y.value = v, o(y, p.currentOffset(), p.currentPosition()), y;
  }
  function m(p) {
    const v = p.context(), b = s(6, v.offset, v.startLoc);
    let y = p.nextToken();
    if (y.type === 8) {
      const _ = u(p);
      b.modifier = _.node, y = _.nextConsumeToken || p.nextToken();
    }
    switch (y.type !== 9 && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(y)), y = p.nextToken(), y.type === 2 && (y = p.nextToken()), y.type) {
      case 10:
        y.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(y)), b.key = d(p, y.value || "");
        break;
      case 4:
        y.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(y)), b.key = l(p, y.value || "");
        break;
      case 5:
        y.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(y)), b.key = r(p, y.value || "");
        break;
      case 6:
        y.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(y)), b.key = c(p, y.value || "");
        break;
      default: {
        a(p, ne.UNEXPECTED_EMPTY_LINKED_KEY, v.lastStartLoc, 0);
        const _ = p.context(), M = s(7, _.offset, _.startLoc);
        return M.value = "", o(M, _.offset, _.startLoc), b.key = M, o(b, _.offset, _.startLoc), {
          nextConsumeToken: y,
          node: b
        };
      }
    }
    return o(b, p.currentOffset(), p.currentPosition()), {
      node: b
    };
  }
  function g(p) {
    const v = p.context(), b = v.currentType === 1 ? p.currentOffset() : v.offset, y = v.currentType === 1 ? v.endLoc : v.startLoc, _ = s(2, b, y);
    _.items = [];
    let M = null;
    do {
      const K = M || p.nextToken();
      switch (M = null, K.type) {
        case 0:
          K.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(K)), _.items.push(i(p, K.value || ""));
          break;
        case 5:
          K.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(K)), _.items.push(r(p, K.value || ""));
          break;
        case 4:
          K.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(K)), _.items.push(l(p, K.value || ""));
          break;
        case 6:
          K.value == null && a(p, ne.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, qt(K)), _.items.push(c(p, K.value || ""));
          break;
        case 7: {
          const Z = m(p);
          _.items.push(Z.node), M = Z.nextConsumeToken || null;
          break;
        }
      }
    } while (v.currentType !== 13 && v.currentType !== 1);
    const S = v.currentType === 1 ? v.lastOffset : p.currentOffset(), Y = v.currentType === 1 ? v.lastEndLoc : p.currentPosition();
    return o(_, S, Y), _;
  }
  function h(p, v, b, y) {
    const _ = p.context();
    let M = y.items.length === 0;
    const S = s(1, v, b);
    S.cases = [], S.cases.push(y);
    do {
      const Y = g(p);
      M || (M = Y.items.length === 0), S.cases.push(Y);
    } while (_.currentType !== 13);
    return M && a(p, ne.MUST_HAVE_MESSAGES_IN_PLURAL, b, 0), o(S, p.currentOffset(), p.currentPosition()), S;
  }
  function A(p) {
    const v = p.context(), { offset: b, startLoc: y } = v, _ = g(p);
    return v.currentType === 13 ? _ : h(p, b, y, _);
  }
  function f(p) {
    const v = wx(p, Je({}, e)), b = v.context(), y = s(0, b.offset, b.startLoc);
    return t && y.loc && (y.loc.source = p), y.body = A(v), e.onCacheKey && (y.cacheKey = e.onCacheKey(p)), b.currentType !== 13 && a(v, ne.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, p[b.offset] || ""), o(y, v.currentOffset(), v.currentPosition()), y;
  }
  return { parse: f };
}
function qt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Sx(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (o) => (n.helpers.add(o), o) };
}
function Mc(e, t) {
  for (let n = 0; n < e.length; n++)
    Xr(e[n], t);
}
function Xr(e, t) {
  switch (e.type) {
    case 1:
      Mc(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Mc(e.items, t);
      break;
    case 6: {
      Xr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Dx(e, t = {}) {
  const n = Sx(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Xr(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function Tx(e) {
  const t = e.body;
  return t.type === 2 ? Lc(t) : t.cases.forEach((n) => Lc(n)), e;
}
function Lc(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = Jr(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const Mx = "minifier";
function La(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      La(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let a = 0; a < n.length; a++)
        La(n[a]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let a = 0; a < n.length; a++)
        La(n[a]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      La(t.key), t.k = t.key, delete t.key, t.modifier && (La(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw rs(ne.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Mx,
          args: [e.type]
        });
  }
  delete e.type;
}
const Lx = "parser";
function Ox(e, t) {
  const { filename: n, breakLineCode: a, needIndent: s } = t, o = t.location !== !1, i = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: s,
    indentLevel: 0
  };
  o && e.loc && (i.source = e.loc.source);
  const r = () => i;
  function l(A, f) {
    i.code += A;
  }
  function c(A, f = !0) {
    const p = f ? a : "";
    l(s ? p + "  ".repeat(A) : p);
  }
  function u(A = !0) {
    const f = ++i.indentLevel;
    A && c(f);
  }
  function d(A = !0) {
    const f = --i.indentLevel;
    A && c(f);
  }
  function m() {
    c(i.indentLevel);
  }
  return {
    context: r,
    push: l,
    indent: u,
    deindent: d,
    newline: m,
    helper: (A) => `_${A}`,
    needIndent: () => i.needIndent
  };
}
function Nx(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Xa(e, t.key), t.modifier ? (e.push(", "), Xa(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Rx(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const s = t.items.length;
  for (let o = 0; o < s && (Xa(e, t.items[o]), o !== s - 1); o++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function Px(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const s = t.cases.length;
    for (let o = 0; o < s && (Xa(e, t.cases[o]), o !== s - 1); o++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function Fx(e, t) {
  t.body ? Xa(e, t.body) : e.push("null");
}
function Xa(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Fx(e, t);
      break;
    case 1:
      Px(e, t);
      break;
    case 2:
      Rx(e, t);
      break;
    case 6:
      Nx(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw rs(ne.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Lx,
          args: [t.type]
        });
  }
}
const Qx = (e, t = {}) => {
  const n = z(t.mode) ? t.mode : "normal", a = z(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], r = Ox(e, {
    filename: a,
    breakLineCode: s,
    needIndent: o
  });
  r.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), r.indent(o), i.length > 0 && (r.push(`const { ${Jr(i.map((u) => `${u}: _${u}`), ", ")} } = ctx`), r.newline()), r.push("return "), Xa(r, e), r.deindent(o), r.push("}"), delete e.helpers;
  const { code: l, map: c } = r.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ux(e, t = {}) {
  const n = Je({}, t), a = !!n.jit, s = !!n.minify, o = n.optimize == null ? !0 : n.optimize, r = _x(n).parse(e);
  return a ? (o && Tx(r), s && La(r), { ast: r, code: "" }) : (Dx(r, n), Qx(r, n));
}
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Gx() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fa().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (fa().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Yt(e) {
  return xe(e) && Zr(e) === 0 && (Gt(e, "b") || Gt(e, "body"));
}
const If = ["b", "body"];
function Yx(e) {
  return oa(e, If);
}
const Bf = ["c", "cases"];
function jx(e) {
  return oa(e, Bf, []);
}
const kf = ["s", "static"];
function Hx(e) {
  return oa(e, kf);
}
const _f = ["i", "items"];
function Vx(e) {
  return oa(e, _f, []);
}
const Sf = ["t", "type"];
function Zr(e) {
  return oa(e, Sf);
}
const Df = ["v", "value"];
function oo(e, t) {
  const n = oa(e, Df);
  if (n != null)
    return n;
  throw Ns(t);
}
const Tf = ["m", "modifier"];
function Kx(e) {
  return oa(e, Tf);
}
const Mf = ["k", "key"];
function Wx(e) {
  const t = oa(e, Mf);
  if (t)
    return t;
  throw Ns(
    6
    /* NodeTypes.Linked */
  );
}
function oa(e, t, n) {
  for (let a = 0; a < t.length; a++) {
    const s = t[a];
    if (Gt(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Lf = [
  ...If,
  ...Bf,
  ...kf,
  ..._f,
  ...Mf,
  ...Tf,
  ...Df,
  ...Sf
];
function Ns(e) {
  return new Error(`unhandled node type: ${e}`);
}
function _i(e) {
  return (n) => zx(n, e);
}
function zx(e, t) {
  const n = Yx(t);
  if (n == null)
    throw Ns(
      0
      /* NodeTypes.Resource */
    );
  if (Zr(n) === 1) {
    const o = jx(n);
    return e.plural(o.reduce((i, r) => [
      ...i,
      Oc(e, r)
    ], []));
  } else
    return Oc(e, n);
}
function Oc(e, t) {
  const n = Hx(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = Vx(t).reduce((s, o) => [...s, dr(e, o)], []);
    return e.normalize(a);
  }
}
function dr(e, t) {
  const n = Zr(t);
  switch (n) {
    case 3:
      return oo(t, n);
    case 9:
      return oo(t, n);
    case 4: {
      const a = t;
      if (Gt(a, "k") && a.k)
        return e.interpolate(e.named(a.k));
      if (Gt(a, "key") && a.key)
        return e.interpolate(e.named(a.key));
      throw Ns(n);
    }
    case 5: {
      const a = t;
      if (Gt(a, "i") && $e(a.i))
        return e.interpolate(e.list(a.i));
      if (Gt(a, "index") && $e(a.index))
        return e.interpolate(e.list(a.index));
      throw Ns(n);
    }
    case 6: {
      const a = t, s = Kx(a), o = Wx(a);
      return e.linked(dr(e, o), s ? dr(e, s) : void 0, e.type);
    }
    case 7:
      return oo(t, n);
    case 8:
      return oo(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const $x = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function qx(e, t) {
  t && hx(e) && dn(ai($x, { source: e }));
}
const Jx = (e) => e;
let io = _e();
function Xx(e, t = {}) {
  let n = !1;
  const a = t.onError || Ax;
  return t.onError = (s) => {
    n = !0, a(s);
  }, { ...Ux(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Zx(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && z(e)) {
    const n = Qe(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && qx(e, n);
    const s = (t.onCacheKey || Jx)(e), o = io[s];
    if (o)
      return o;
    const { ast: i, detectError: r } = Xx(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = _i(i);
    return r ? l : io[s] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Yt(e))
      return dn(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const n = e.cacheKey;
    if (n) {
      const a = io[n];
      return a || (io[n] = _i(e));
    } else
      return _i(e);
  }
}
let Rs = null;
function eE(e) {
  Rs = e;
}
function tE(e, t, n) {
  Rs && Rs.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const nE = /* @__PURE__ */ aE("function:translate");
function aE(e) {
  return (t) => Rs && Rs.emit(e, t);
}
const rt = {
  INVALID_ARGUMENT: px,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, sE = 24;
function Cn(e) {
  return rs(e, null, process.env.NODE_ENV !== "production" ? { messages: oE } : void 0);
}
const oE = {
  [rt.INVALID_ARGUMENT]: "Invalid arguments",
  [rt.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [rt.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [rt.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [rt.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [rt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [rt.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function el(e, t) {
  return t.locale != null ? Nc(t.locale) : Nc(e.locale);
}
let Si;
function Nc(e) {
  if (z(e))
    return e;
  if (Re(e)) {
    if (e.resolvedOnce && Si != null)
      return Si;
    if (e.constructor.name === "Function") {
      const t = e();
      if (lx(t))
        throw Cn(rt.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Si = t;
    } else
      throw Cn(rt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Cn(rt.NOT_SUPPORT_LOCALE_TYPE);
}
function iE(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Ue(t) ? t : xe(t) ? Object.keys(t) : z(t) ? [t] : [n]
  ])];
}
function Of(e, t, n) {
  const a = z(n) ? n : No, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let o = s.__localeChainCache.get(a);
  if (!o) {
    o = [];
    let i = [n];
    for (; Ue(i); )
      i = Rc(o, i, t);
    const r = Ue(t) || !be(t) ? t : t.default ? t.default : null;
    i = z(r) ? [r] : r, Ue(i) && Rc(o, i, !1), s.__localeChainCache.set(a, o);
  }
  return o;
}
function Rc(e, t, n) {
  let a = !0;
  for (let s = 0; s < t.length && Qe(a); s++) {
    const o = t[s];
    z(o) && (a = rE(e, t[s], n));
  }
  return a;
}
function rE(e, t, n) {
  let a;
  const s = t.split("-");
  do {
    const o = s.join("-");
    a = lE(e, o, n), s.splice(-1, 1);
  } while (s.length && a === !0);
  return a;
}
function lE(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (Ue(n) || be(n)) && n[s] && (a = n[s]);
  }
  return a;
}
const ia = [];
ia[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ia[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ia[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ia[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ia[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ia[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ia[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const cE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function uE(e) {
  return cE.test(e);
}
function dE(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function fE(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function pE(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : uE(t) ? dE(t) : "*" + t;
}
function mE(e) {
  const t = [];
  let n = -1, a = 0, s = 0, o, i, r, l, c, u, d;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = r : i += r;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), s++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, a = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, i === void 0 || (i = pE(i), i === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const h = e[n + 1];
    if (a === 5 && h === "'" || a === 6 && h === '"')
      return n++, r = "\\" + h, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, o = e[n], !(o === "\\" && g())) {
      if (l = fE(o), d = ia[a], c = d[l] || d.l || 8, c === 8 || (a = c[0], c[1] !== void 0 && (u = m[c[1]], u && (r = o, u() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const Pc = /* @__PURE__ */ new Map();
function AE(e, t) {
  return xe(e) ? e[t] : null;
}
function gE(e, t) {
  if (!xe(e))
    return null;
  let n = Pc.get(t);
  if (n || (n = mE(t), n && Pc.set(t, n)), !n)
    return null;
  const a = n.length;
  let s = e, o = 0;
  for (; o < a; ) {
    const i = n[o];
    if (Lf.includes(i) && Yt(s))
      return null;
    const r = s[i];
    if (r === void 0 || Re(s))
      return null;
    s = r, o++;
  }
  return s;
}
const ht = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, hE = 8, vE = {
  [ht.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [ht.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [ht.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [ht.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [ht.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [ht.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [ht.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ba(e, ...t) {
  return ai(vE[e], ...t);
}
const yE = "11.1.12", oi = -1, No = "en-US", Ro = "", Fc = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function bE() {
  return {
    upper: (e, t) => t === "text" && z(e) ? e.toUpperCase() : t === "vnode" && xe(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && z(e) ? e.toLowerCase() : t === "vnode" && xe(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && z(e) ? Fc(e) : t === "vnode" && xe(e) && "__v_isVNode" in e ? Fc(e.children) : e
  };
}
let Nf;
function xE(e) {
  Nf = e;
}
let Rf;
function EE(e) {
  Rf = e;
}
let Pf;
function CE(e) {
  Pf = e;
}
let Ff = null;
const wE = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Ff = e;
}, IE = /* @__NO_SIDE_EFFECTS__ */ () => Ff;
let Qf = null;
const Qc = (e) => {
  Qf = e;
}, BE = () => Qf;
let Uc = 0;
function kE(e = {}) {
  const t = Re(e.onWarn) ? e.onWarn : dn, n = z(e.version) ? e.version : yE, a = z(e.locale) || Re(e.locale) ? e.locale : No, s = Re(a) ? No : a, o = Ue(e.fallbackLocale) || be(e.fallbackLocale) || z(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, i = be(e.messages) ? e.messages : Di(s), r = be(e.datetimeFormats) ? e.datetimeFormats : Di(s), l = be(e.numberFormats) ? e.numberFormats : Di(s), c = Je(_e(), e.modifiers, bE()), u = e.pluralRules || _e(), d = Re(e.missing) ? e.missing : null, m = Qe(e.missingWarn) || Oo(e.missingWarn) ? e.missingWarn : !0, g = Qe(e.fallbackWarn) || Oo(e.fallbackWarn) ? e.fallbackWarn : !0, h = !!e.fallbackFormat, A = !!e.unresolving, f = Re(e.postTranslation) ? e.postTranslation : null, p = be(e.processor) ? e.processor : null, v = Qe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, b = !!e.escapeParameter, y = Re(e.messageCompiler) ? e.messageCompiler : Nf;
  process.env.NODE_ENV !== "production" && Re(e.messageCompiler) && ex(Ba(ht.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const _ = Re(e.messageResolver) ? e.messageResolver : Rf || AE, M = Re(e.localeFallbacker) ? e.localeFallbacker : Pf || iE, S = xe(e.fallbackContext) ? e.fallbackContext : void 0, Y = e, K = xe(Y.__datetimeFormatters) ? Y.__datetimeFormatters : /* @__PURE__ */ new Map(), Z = xe(Y.__numberFormatters) ? Y.__numberFormatters : /* @__PURE__ */ new Map(), le = xe(Y.__meta) ? Y.__meta : {};
  Uc++;
  const re = {
    version: n,
    cid: Uc,
    locale: a,
    fallbackLocale: o,
    messages: i,
    modifiers: c,
    pluralRules: u,
    missing: d,
    missingWarn: m,
    fallbackWarn: g,
    fallbackFormat: h,
    unresolving: A,
    postTranslation: f,
    processor: p,
    warnHtmlMessage: v,
    escapeParameter: b,
    messageCompiler: y,
    messageResolver: _,
    localeFallbacker: M,
    fallbackContext: S,
    onWarn: t,
    __meta: le
  };
  return re.datetimeFormats = r, re.numberFormats = l, re.__datetimeFormatters = K, re.__numberFormatters = Z, process.env.NODE_ENV !== "production" && (re.__v_emitter = Y.__v_emitter != null ? Y.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && tE(re, n, le), re;
}
const Di = (e) => ({ [e]: _e() });
function ii(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Uf(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function tl(e, t, n, a, s) {
  const { missing: o, onWarn: i } = e;
  if (process.env.NODE_ENV !== "production") {
    const r = e.__v_emitter;
    r && r.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (o !== null) {
    const r = o(e, n, t, s);
    return z(r) ? r : t;
  } else
    return process.env.NODE_ENV !== "production" && Uf(a, t) && i(Ba(ht.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function fs(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Gf(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function _E(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let a = n + 1; a < t.length; a++)
    if (Gf(e, t[a]))
      return !0;
  return !1;
}
const Gc = typeof Intl < "u", Yf = {
  dateTimeFormat: Gc && typeof Intl.DateTimeFormat < "u",
  numberFormat: Gc && typeof Intl.NumberFormat < "u"
};
function Yc(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __datetimeFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !Yf.dateTimeFormat)
    return o(Ba(ht.CANNOT_FORMAT_DATE)), Ro;
  const [l, c, u, d] = fr(...t), m = Qe(u.missingWarn) ? u.missingWarn : e.missingWarn, g = Qe(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, h = !!u.part, A = el(e, u), f = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    A
  );
  if (!z(l) || l === "")
    return new Intl.DateTimeFormat(A, d).format(c);
  let p = {}, v, b = null, y = A, _ = null;
  const M = "datetime format";
  for (let K = 0; K < f.length; K++) {
    if (v = _ = f[K], process.env.NODE_ENV !== "production" && A !== v && ii(g, l) && o(Ba(ht.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && A !== v) {
      const Z = e.__v_emitter;
      Z && Z.emit("fallback", {
        type: M,
        key: l,
        from: y,
        to: _,
        groupId: `${M}:${l}`
      });
    }
    if (p = n[v] || {}, b = p[l], be(b))
      break;
    tl(e, l, v, m, M), y = _;
  }
  if (!be(b) || !z(v))
    return a ? oi : l;
  let S = `${v}__${l}`;
  si(d) || (S = `${S}__${JSON.stringify(d)}`);
  let Y = r.get(S);
  return Y || (Y = new Intl.DateTimeFormat(v, Je({}, b, d)), r.set(S, Y)), h ? Y.formatToParts(c) : Y.format(c);
}
const jf = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function fr(...e) {
  const [t, n, a, s] = e, o = _e();
  let i = _e(), r;
  if (z(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Cn(rt.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    r = new Date(c);
    try {
      r.toISOString();
    } catch {
      throw Cn(rt.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (sx(t)) {
    if (isNaN(t.getTime()))
      throw Cn(rt.INVALID_DATE_ARGUMENT);
    r = t;
  } else if ($e(t))
    r = t;
  else
    throw Cn(rt.INVALID_ARGUMENT);
  return z(n) ? o.key = n : be(n) && Object.keys(n).forEach((l) => {
    jf.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), z(a) ? o.locale = a : be(a) && (i = a), be(s) && (i = s), [o.key || "", r, o, i];
}
function jc(e, t, n) {
  const a = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    a.__datetimeFormatters.has(o) && a.__datetimeFormatters.delete(o);
  }
}
function Hc(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: s, onWarn: o, localeFallbacker: i } = e, { __numberFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !Yf.numberFormat)
    return o(Ba(ht.CANNOT_FORMAT_NUMBER)), Ro;
  const [l, c, u, d] = pr(...t), m = Qe(u.missingWarn) ? u.missingWarn : e.missingWarn, g = Qe(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, h = !!u.part, A = el(e, u), f = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    A
  );
  if (!z(l) || l === "")
    return new Intl.NumberFormat(A, d).format(c);
  let p = {}, v, b = null, y = A, _ = null;
  const M = "number format";
  for (let K = 0; K < f.length; K++) {
    if (v = _ = f[K], process.env.NODE_ENV !== "production" && A !== v && ii(g, l) && o(Ba(ht.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && A !== v) {
      const Z = e.__v_emitter;
      Z && Z.emit("fallback", {
        type: M,
        key: l,
        from: y,
        to: _,
        groupId: `${M}:${l}`
      });
    }
    if (p = n[v] || {}, b = p[l], be(b))
      break;
    tl(e, l, v, m, M), y = _;
  }
  if (!be(b) || !z(v))
    return a ? oi : l;
  let S = `${v}__${l}`;
  si(d) || (S = `${S}__${JSON.stringify(d)}`);
  let Y = r.get(S);
  return Y || (Y = new Intl.NumberFormat(v, Je({}, b, d)), r.set(S, Y)), h ? Y.formatToParts(c) : Y.format(c);
}
const Hf = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function pr(...e) {
  const [t, n, a, s] = e, o = _e();
  let i = _e();
  if (!$e(t))
    throw Cn(rt.INVALID_ARGUMENT);
  const r = t;
  return z(n) ? o.key = n : be(n) && Object.keys(n).forEach((l) => {
    Hf.includes(l) ? i[l] = n[l] : o[l] = n[l];
  }), z(a) ? o.locale = a : be(a) && (i = a), be(s) && (i = s), [o.key || "", r, o, i];
}
function Vc(e, t, n) {
  const a = e;
  for (const s in n) {
    const o = `${t}__${s}`;
    a.__numberFormatters.has(o) && a.__numberFormatters.delete(o);
  }
}
const SE = (e) => e, DE = (e) => "", TE = "text", ME = (e) => e.length === 0 ? "" : Jr(e), LE = cx;
function Kc(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function OE(e) {
  const t = $e(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && ($e(e.named.count) || $e(e.named.n)) ? $e(e.named.count) ? e.named.count : $e(e.named.n) ? e.named.n : t : t;
}
function NE(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function RE(e = {}) {
  const t = e.locale, n = OE(e), a = xe(e.pluralRules) && z(t) && Re(e.pluralRules[t]) ? e.pluralRules[t] : Kc, s = xe(e.pluralRules) && z(t) && Re(e.pluralRules[t]) ? Kc : void 0, o = (p) => p[a(n, p.length, s)], i = e.list || [], r = (p) => i[p], l = e.named || _e();
  $e(e.pluralIndex) && NE(n, l);
  const c = (p) => l[p];
  function u(p, v) {
    const b = Re(e.messages) ? e.messages(p, !!v) : xe(e.messages) ? e.messages[p] : !1;
    return b || (e.parent ? e.parent.message(p) : DE);
  }
  const d = (p) => e.modifiers ? e.modifiers[p] : SE, m = be(e.processor) && Re(e.processor.normalize) ? e.processor.normalize : ME, g = be(e.processor) && Re(e.processor.interpolate) ? e.processor.interpolate : LE, h = be(e.processor) && z(e.processor.type) ? e.processor.type : TE, f = {
    list: r,
    named: c,
    plural: o,
    linked: (p, ...v) => {
      const [b, y] = v;
      let _ = "text", M = "";
      v.length === 1 ? xe(b) ? (M = b.modifier || M, _ = b.type || _) : z(b) && (M = b || M) : v.length === 2 && (z(b) && (M = b || M), z(y) && (_ = y || _));
      const S = u(p, !0)(f), Y = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        _ === "vnode" && Ue(S) && M ? S[0] : S
      );
      return M ? d(M)(Y, _) : Y;
    },
    message: u,
    type: h,
    interpolate: g,
    normalize: m,
    values: Je(_e(), i, l)
  };
  return f;
}
const Wc = () => "", Tt = (e) => Re(e);
function zc(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: s, messageCompiler: o, fallbackLocale: i, messages: r } = e, [l, c] = mr(...t), u = Qe(c.missingWarn) ? c.missingWarn : e.missingWarn, d = Qe(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, m = Qe(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, g = !!c.resolvedMessage, h = z(c.default) || Qe(c.default) ? Qe(c.default) ? o ? l : () => l : c.default : n ? o ? l : () => l : null, A = n || h != null && (z(h) || Re(h)), f = el(e, c);
  m && PE(c);
  let [p, v, b] = g ? [
    l,
    f,
    r[f] || _e()
  ] : Vf(e, l, f, i, d, u), y = p, _ = l;
  if (!g && !(z(y) || Yt(y) || Tt(y)) && A && (y = h, _ = y), !g && (!(z(y) || Yt(y) || Tt(y)) || !z(v)))
    return s ? oi : l;
  if (process.env.NODE_ENV !== "production" && z(y) && e.messageCompiler == null)
    return dn(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let M = !1;
  const S = () => {
    M = !0;
  }, Y = Tt(y) ? y : Kf(e, l, v, y, _, S);
  if (M)
    return y;
  const K = GE(e, v, b, c), Z = RE(K), le = FE(e, Y, Z);
  let re = a ? a(le, l) : le;
  if (m && z(re) && (re = ix(re)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Ee = {
      timestamp: Date.now(),
      key: z(l) ? l : Tt(y) ? y.key : "",
      locale: v || (Tt(y) ? y.locale : ""),
      format: z(y) ? y : Tt(y) ? y.source : "",
      message: re
    };
    Ee.meta = Je({}, e.__meta, /* @__PURE__ */ IE() || {}), nE(Ee);
  }
  return re;
}
function PE(e) {
  Ue(e.list) ? e.list = e.list.map((t) => z(t) ? _c(t) : t) : xe(e.named) && Object.keys(e.named).forEach((t) => {
    z(e.named[t]) && (e.named[t] = _c(e.named[t]));
  });
}
function Vf(e, t, n, a, s, o) {
  const { messages: i, onWarn: r, messageResolver: l, localeFallbacker: c } = e, u = c(e, a, n);
  let d = _e(), m, g = null, h = n, A = null;
  const f = "translate";
  for (let p = 0; p < u.length; p++) {
    if (m = A = u[p], process.env.NODE_ENV !== "production" && n !== m && !Gf(n, m) && ii(s, t) && r(Ba(ht.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const _ = e.__v_emitter;
      _ && _.emit("fallback", {
        type: f,
        key: t,
        from: h,
        to: A,
        groupId: `${f}:${t}`
      });
    }
    d = i[m] || _e();
    let v = null, b, y;
    if (process.env.NODE_ENV !== "production" && _n && (v = window.performance.now(), b = "intlify-message-resolve-start", y = "intlify-message-resolve-end", Ct && Ct(b)), (g = l(d, t)) === null && (g = d[t]), process.env.NODE_ENV !== "production" && _n) {
      const _ = window.performance.now(), M = e.__v_emitter;
      M && v && g && M.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: _ - v,
        groupId: `${f}:${t}`
      }), b && y && Ct && Ia && (Ct(y), Ia("intlify message resolve", b, y));
    }
    if (z(g) || Yt(g) || Tt(g))
      break;
    if (!_E(m, u)) {
      const _ = tl(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        o,
        f
      );
      _ !== t && (g = _);
    }
    h = A;
  }
  return [g, m, d];
}
function Kf(e, t, n, a, s, o) {
  const { messageCompiler: i, warnHtmlMessage: r } = e;
  if (Tt(a)) {
    const m = a;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (i == null) {
    const m = (() => a);
    return m.locale = n, m.key = t, m;
  }
  let l = null, c, u;
  process.env.NODE_ENV !== "production" && _n && (l = window.performance.now(), c = "intlify-message-compilation-start", u = "intlify-message-compilation-end", Ct && Ct(c));
  const d = i(a, QE(e, n, s, a, r, o));
  if (process.env.NODE_ENV !== "production" && _n) {
    const m = window.performance.now(), g = e.__v_emitter;
    g && l && g.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: m - l,
      groupId: `translate:${t}`
    }), c && u && Ct && Ia && (Ct(u), Ia("intlify message compilation", c, u));
  }
  return d.locale = n, d.key = t, d.source = a, d;
}
function FE(e, t, n) {
  let a = null, s, o;
  process.env.NODE_ENV !== "production" && _n && (a = window.performance.now(), s = "intlify-message-evaluation-start", o = "intlify-message-evaluation-end", Ct && Ct(s));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && _n) {
    const r = window.performance.now(), l = e.__v_emitter;
    l && a && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: r - a,
      groupId: `translate:${t.key}`
    }), s && o && Ct && Ia && (Ct(o), Ia("intlify message evaluation", s, o));
  }
  return i;
}
function mr(...e) {
  const [t, n, a] = e, s = _e();
  if (!z(t) && !$e(t) && !Tt(t) && !Yt(t))
    throw Cn(rt.INVALID_ARGUMENT);
  const o = $e(t) ? String(t) : (Tt(t), t);
  return $e(n) ? s.plural = n : z(n) ? s.default = n : be(n) && !si(n) ? s.named = n : Ue(n) && (s.list = n), $e(a) ? s.plural = a : z(a) ? s.default = a : be(a) && Je(s, a), [o, s];
}
function QE(e, t, n, a, s, o) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (i) => {
      if (o && o(i), process.env.NODE_ENV !== "production") {
        const r = UE(a), l = `Message compilation error: ${i.message}`, c = i.location && r && ux(r, i.location.start.offset, i.location.end.offset), u = e.__v_emitter;
        u && r && u.emit("compile-error", {
          message: r,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw i;
    },
    onCacheKey: (i) => nx(t, n, i)
  };
}
function UE(e) {
  if (z(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function GE(e, t, n, a) {
  const { modifiers: s, pluralRules: o, messageResolver: i, fallbackLocale: r, fallbackWarn: l, missingWarn: c, fallbackContext: u } = e, m = {
    locale: t,
    modifiers: s,
    pluralRules: o,
    messages: (g, h) => {
      let A = i(n, g);
      if (A == null && (u || h)) {
        const [, , f] = Vf(
          u || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          g,
          t,
          r,
          l,
          c
        );
        A = i(f, g);
      }
      if (z(A) || Yt(A)) {
        let f = !1;
        const v = Kf(e, g, t, A, g, () => {
          f = !0;
        });
        return f ? Wc : v;
      } else return Tt(A) ? A : Wc;
    }
  };
  return e.processor && (m.processor = e.processor), a.list && (m.list = a.list), a.named && (m.named = a.named), $e(a.plural) && (m.pluralIndex = a.plural), m;
}
Gx();
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const YE = "11.1.12";
function jE() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (fa().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (fa().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (fa().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fa().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const nt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: sE,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Ps(e, ...t) {
  return rs(e, null, process.env.NODE_ENV !== "production" ? { messages: HE, args: t } : void 0);
}
const HE = {
  [nt.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [nt.INVALID_ARGUMENT]: "Invalid argument",
  [nt.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [nt.NOT_INSTALLED]: "Need to install with `app.use` function",
  [nt.UNEXPECTED_ERROR]: "Unexpected error",
  [nt.REQUIRED_VALUE]: "Required in value: {0}",
  [nt.INVALID_VALUE]: "Invalid value",
  [nt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [nt.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [nt.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [nt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Ar = /* @__PURE__ */ On("__translateVNode"), gr = /* @__PURE__ */ On("__datetimeParts"), hr = /* @__PURE__ */ On("__numberParts"), vr = /* @__PURE__ */ On("__enableEmitter"), yr = /* @__PURE__ */ On("__disableEmitter"), VE = On("__setPluralRules"), Wf = /* @__PURE__ */ On("__injectWithOption"), br = /* @__PURE__ */ On("__dispose"), nn = {
  FALLBACK_TO_ROOT: hE,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, KE = {
  [nn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [nn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [nn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [nn.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [nn.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [nn.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Po(e, ...t) {
  return ai(KE[e], ...t);
}
function Fs(e) {
  if (!xe(e) || Yt(e))
    return e;
  for (const t in e)
    if (Gt(e, t))
      if (!t.includes("."))
        xe(e[t]) && Fs(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let s = e, o = !1;
        for (let i = 0; i < a; i++) {
          if (n[i] === "__proto__")
            throw new Error(`unsafe key: ${n[i]}`);
          if (n[i] in s || (s[n[i]] = _e()), !xe(s[n[i]])) {
            process.env.NODE_ENV !== "production" && dn(Po(nn.IGNORE_OBJ_FLATTEN, {
              key: n[i]
            })), o = !0;
            break;
          }
          s = s[n[i]];
        }
        if (o || (Yt(s) ? Lf.includes(n[a]) || delete e[t] : (s[n[a]] = e[t], delete e[t])), !Yt(s)) {
          const i = s[n[a]];
          xe(i) && Fs(i);
        }
      }
  return e;
}
function zf(e, t) {
  const { messages: n, __i18n: a, messageResolver: s, flatJson: o } = t, i = be(n) ? n : Ue(a) ? _e() : { [e]: _e() };
  if (Ue(a) && a.forEach((r) => {
    if ("locale" in r && "resource" in r) {
      const { locale: l, resource: c } = r;
      l ? (i[l] = i[l] || _e(), vo(c, i[l])) : vo(c, i);
    } else
      z(r) && vo(JSON.parse(r), i);
  }), s == null && o)
    for (const r in i)
      Gt(i, r) && Fs(i[r]);
  return i;
}
function $f(e) {
  return e.type;
}
function WE(e, t, n) {
  let a = xe(t.messages) ? t.messages : _e();
  "__i18nGlobal" in n && (a = zf(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(a);
  s.length && s.forEach((o) => {
    e.mergeLocaleMessage(o, a[o]);
  });
  {
    if (xe(t.datetimeFormats)) {
      const o = Object.keys(t.datetimeFormats);
      o.length && o.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (xe(t.numberFormats)) {
      const o = Object.keys(t.numberFormats);
      o.length && o.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function $c(e) {
  return B(Sp, null, e, 0);
}
const qc = "__INTLIFY_META__", Jc = () => [], zE = () => !1;
let Xc = 0;
function Zc(e) {
  return ((t, n, a, s) => e(n, a, za() || void 0, s));
}
const $E = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = za();
  let t = null;
  return e && (t = $f(e)[qc]) ? { [qc]: t } : null;
};
function qE(e = {}) {
  const { __root: t, __injectWithOption: n } = e, a = t === void 0, s = e.flatJson, o = _n ? T : wr;
  let i = Qe(e.inheritLocale) ? e.inheritLocale : !0;
  const r = o(
    // prettier-ignore
    t && i ? t.locale.value : z(e.locale) ? e.locale : No
  ), l = o(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : z(e.fallbackLocale) || Ue(e.fallbackLocale) || be(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r.value
  ), c = o(zf(r.value, e)), u = o(be(e.datetimeFormats) ? e.datetimeFormats : { [r.value]: {} }), d = o(be(e.numberFormats) ? e.numberFormats : { [r.value]: {} });
  let m = t ? t.missingWarn : Qe(e.missingWarn) || Oo(e.missingWarn) ? e.missingWarn : !0, g = t ? t.fallbackWarn : Qe(e.fallbackWarn) || Oo(e.fallbackWarn) ? e.fallbackWarn : !0, h = t ? t.fallbackRoot : Qe(e.fallbackRoot) ? e.fallbackRoot : !0, A = !!e.fallbackFormat, f = Re(e.missing) ? e.missing : null, p = Re(e.missing) ? Zc(e.missing) : null, v = Re(e.postTranslation) ? e.postTranslation : null, b = t ? t.warnHtmlMessage : Qe(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter;
  const _ = t ? t.modifiers : be(e.modifiers) ? e.modifiers : {};
  let M = e.pluralRules || t && t.pluralRules, S;
  S = (() => {
    a && Qc(null);
    const N = {
      version: YE,
      locale: r.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: _,
      pluralRules: M,
      missing: p === null ? void 0 : p,
      missingWarn: m,
      fallbackWarn: g,
      fallbackFormat: A,
      unresolving: !0,
      postTranslation: v === null ? void 0 : v,
      warnHtmlMessage: b,
      escapeParameter: y,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    N.datetimeFormats = u.value, N.numberFormats = d.value, N.__datetimeFormatters = be(S) ? S.__datetimeFormatters : void 0, N.__numberFormatters = be(S) ? S.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (N.__v_emitter = be(S) ? S.__v_emitter : void 0);
    const w = kE(N);
    return a && Qc(w), w;
  })(), fs(S, r.value, l.value);
  function K() {
    return [
      r.value,
      l.value,
      c.value,
      u.value,
      d.value
    ];
  }
  const Z = U({
    get: () => r.value,
    set: (N) => {
      S.locale = N, r.value = N;
    }
  }), le = U({
    get: () => l.value,
    set: (N) => {
      S.fallbackLocale = N, l.value = N, fs(S, r.value, N);
    }
  }), re = U(() => c.value), Ee = /* @__PURE__ */ U(() => u.value), Ye = /* @__PURE__ */ U(() => d.value);
  function te() {
    return Re(v) ? v : null;
  }
  function pe(N) {
    v = N, S.postTranslation = N;
  }
  function Ce() {
    return f;
  }
  function _t(N) {
    N !== null && (p = Zc(N)), f = N, S.missing = p;
  }
  function Ve(N, w) {
    return N !== "translate" || !w.resolvedMessage;
  }
  const je = (N, w, Q, oe, ve, At) => {
    K();
    let Ze;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (S.fallbackContext = t ? BE() : void 0), Ze = N(S);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (S.fallbackContext = void 0);
    }
    if (Q !== "translate exists" && // for not `te` (e.g `t`)
    $e(Ze) && Ze === oi || Q === "translate exists" && !Ze) {
      const [Rt, qs] = w();
      if (process.env.NODE_ENV !== "production" && t && z(Rt) && Ve(Q, qs) && (h && (ii(g, Rt) || Uf(m, Rt)) && dn(Po(nn.FALLBACK_TO_ROOT, {
        key: Rt,
        type: Q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ae } = S;
        Ae && h && Ae.emit("fallback", {
          type: Q,
          key: Rt,
          to: "global",
          groupId: `${Q}:${Rt}`
        });
      }
      return t && h ? oe(t) : ve(Rt);
    } else {
      if (At(Ze))
        return Ze;
      throw Ps(nt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ke(...N) {
    return je((w) => Reflect.apply(zc, null, [w, ...N]), () => mr(...N), "translate", (w) => Reflect.apply(w.t, w, [...N]), (w) => w, (w) => z(w));
  }
  function at(...N) {
    const [w, Q, oe] = N;
    if (oe && !xe(oe))
      throw Ps(nt.INVALID_ARGUMENT);
    return Ke(w, Q, Je({ resolvedMessage: !0 }, oe || {}));
  }
  function Xe(...N) {
    return je((w) => Reflect.apply(Yc, null, [w, ...N]), () => fr(...N), "datetime format", (w) => Reflect.apply(w.d, w, [...N]), () => Ro, (w) => z(w) || Ue(w));
  }
  function ct(...N) {
    return je((w) => Reflect.apply(Hc, null, [w, ...N]), () => pr(...N), "number format", (w) => Reflect.apply(w.n, w, [...N]), () => Ro, (w) => z(w) || Ue(w));
  }
  function pt(N) {
    return N.map((w) => z(w) || $e(w) || Qe(w) ? $c(String(w)) : w);
  }
  const Kt = {
    normalize: pt,
    interpolate: (N) => N,
    type: "vnode"
  };
  function mt(...N) {
    return je((w) => {
      let Q;
      const oe = w;
      try {
        oe.processor = Kt, Q = Reflect.apply(zc, null, [oe, ...N]);
      } finally {
        oe.processor = null;
      }
      return Q;
    }, () => mr(...N), "translate", (w) => w[Ar](...N), (w) => [$c(w)], (w) => Ue(w));
  }
  function Ot(...N) {
    return je((w) => Reflect.apply(Hc, null, [w, ...N]), () => pr(...N), "number format", (w) => w[hr](...N), Jc, (w) => z(w) || Ue(w));
  }
  function mn(...N) {
    return je((w) => Reflect.apply(Yc, null, [w, ...N]), () => fr(...N), "datetime format", (w) => w[gr](...N), Jc, (w) => z(w) || Ue(w));
  }
  function An(N) {
    M = N, S.pluralRules = M;
  }
  function la(N, w) {
    return je(() => {
      if (!N)
        return !1;
      const Q = z(w) ? w : r.value, oe = Nt(Q), ve = S.messageResolver(oe, N);
      return Yt(ve) || Tt(ve) || z(ve);
    }, () => [N], "translate exists", (Q) => Reflect.apply(Q.te, Q, [N, w]), zE, (Q) => Qe(Q));
  }
  function he(N) {
    let w = null;
    const Q = Of(S, l.value, r.value);
    for (let oe = 0; oe < Q.length; oe++) {
      const ve = c.value[Q[oe]] || {}, At = S.messageResolver(ve, N);
      if (At != null) {
        w = At;
        break;
      }
    }
    return w;
  }
  function gn(N) {
    const w = he(N);
    return w ?? (t ? t.tm(N) || {} : {});
  }
  function Nt(N) {
    return c.value[N] || {};
  }
  function Wt(N, w) {
    if (s) {
      const Q = { [N]: w };
      for (const oe in Q)
        Gt(Q, oe) && Fs(Q[oe]);
      w = Q[N];
    }
    c.value[N] = w, S.messages = c.value;
  }
  function hn(N, w) {
    c.value[N] = c.value[N] || {};
    const Q = { [N]: w };
    if (s)
      for (const oe in Q)
        Gt(Q, oe) && Fs(Q[oe]);
    w = Q[N], vo(w, c.value[N]), S.messages = c.value;
  }
  function E(N) {
    return u.value[N] || {};
  }
  function I(N, w) {
    u.value[N] = w, S.datetimeFormats = u.value, jc(S, N, w);
  }
  function R(N, w) {
    u.value[N] = Je(u.value[N] || {}, w), S.datetimeFormats = u.value, jc(S, N, w);
  }
  function W(N) {
    return d.value[N] || {};
  }
  function we(N, w) {
    d.value[N] = w, S.numberFormats = d.value, Vc(S, N, w);
  }
  function Se(N, w) {
    d.value[N] = Je(d.value[N] || {}, w), S.numberFormats = d.value, Vc(S, N, w);
  }
  Xc++, t && _n && (ye(t.locale, (N) => {
    i && (r.value = N, S.locale = N, fs(S, r.value, l.value));
  }), ye(t.fallbackLocale, (N) => {
    i && (l.value = N, S.fallbackLocale = N, fs(S, r.value, l.value));
  }));
  const ce = {
    id: Xc,
    locale: Z,
    fallbackLocale: le,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(N) {
      i = N, N && t && (r.value = t.locale.value, l.value = t.fallbackLocale.value, fs(S, r.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: re,
    get modifiers() {
      return _;
    },
    get pluralRules() {
      return M || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(N) {
      m = N, S.missingWarn = m;
    },
    get fallbackWarn() {
      return g;
    },
    set fallbackWarn(N) {
      g = N, S.fallbackWarn = g;
    },
    get fallbackRoot() {
      return h;
    },
    set fallbackRoot(N) {
      h = N;
    },
    get fallbackFormat() {
      return A;
    },
    set fallbackFormat(N) {
      A = N, S.fallbackFormat = A;
    },
    get warnHtmlMessage() {
      return b;
    },
    set warnHtmlMessage(N) {
      b = N, S.warnHtmlMessage = N;
    },
    get escapeParameter() {
      return y;
    },
    set escapeParameter(N) {
      y = N, S.escapeParameter = N;
    },
    t: Ke,
    getLocaleMessage: Nt,
    setLocaleMessage: Wt,
    mergeLocaleMessage: hn,
    getPostTranslationHandler: te,
    setPostTranslationHandler: pe,
    getMissingHandler: Ce,
    setMissingHandler: _t,
    [VE]: An
  };
  return ce.datetimeFormats = Ee, ce.numberFormats = Ye, ce.rt = at, ce.te = la, ce.tm = gn, ce.d = Xe, ce.n = ct, ce.getDateTimeFormat = E, ce.setDateTimeFormat = I, ce.mergeDateTimeFormat = R, ce.getNumberFormat = W, ce.setNumberFormat = we, ce.mergeNumberFormat = Se, ce[Wf] = n, ce[Ar] = mt, ce[gr] = mn, ce[hr] = Ot, process.env.NODE_ENV !== "production" && (ce[vr] = (N) => {
    S.__v_emitter = N;
  }, ce[yr] = () => {
    S.__v_emitter = void 0;
  }), ce;
}
function eu(e, t) {
}
const nl = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function JE({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, s) => [
    ...a,
    // prettier-ignore
    ...s.type === me ? s.children : [s]
  ], []) : t.reduce((n, a) => {
    const s = e[a];
    return s && (n[a] = s()), n;
  }, _e());
}
function qf() {
  return me;
}
Je({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => $e(e) || !isNaN(e)
  }
}, nl);
function XE(e) {
  return Ue(e) && !z(e[0]);
}
function Jf(e, t, n, a) {
  const { slots: s, attrs: o } = t;
  return () => {
    const i = { part: !0 };
    let r = _e();
    e.locale && (i.locale = e.locale), z(e.format) ? i.key = e.format : xe(e.format) && (z(e.format.key) && (i.key = e.format.key), r = Object.keys(e.format).reduce((m, g) => n.includes(g) ? Je(_e(), m, { [g]: e.format[g] }) : m, _e()));
    const l = a(e.value, i, r);
    let c = [i.key];
    Ue(l) ? c = l.map((m, g) => {
      const h = s[m.type], A = h ? h({ [m.type]: m.value, index: g, parts: l }) : [m.value];
      return XE(A) && (A[0].key = `${m.type}-${g}`), A;
    }) : z(l) && (c = [l]);
    const u = Je(_e(), o), d = z(e.tag) || xe(e.tag) ? e.tag : qf();
    return Qo(d, u, c);
  };
}
Je({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, nl);
const ZE = /* @__PURE__ */ On("global-vue-i18n");
function Nn(e = {}) {
  const t = za();
  if (t == null)
    throw Ps(nt.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Ps(nt.NOT_INSTALLED);
  const n = eC(t), a = nC(n), s = $f(t), o = tC(e, s);
  if (o === "global")
    return WE(a, e, s), a;
  if (o === "parent") {
    let l = aC(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && dn(Po(nn.NOT_FOUND_PARENT_SCOPE)), l = a), l;
  }
  const i = n;
  let r = i.__getInstance(t);
  if (r == null) {
    const l = Je({}, e);
    "__i18n" in s && (l.__i18n = s.__i18n), a && (l.__root = a), r = qE(l), i.__composerExtend && (r[br] = i.__composerExtend(r)), oC(i, t, r), i.__setInstance(t, r);
  } else
    process.env.NODE_ENV !== "production" && o === "local" && dn(Po(nn.DUPLICATE_USE_I18N_CALLING));
  return r;
}
function eC(e) {
  const t = Ht(e.isCE ? ZE : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Ps(e.isCE ? nt.NOT_INSTALLED_WITH_PROVIDE : nt.UNEXPECTED_ERROR);
  return t;
}
function tC(e, t) {
  return si(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function nC(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function aC(e, t, n = !1) {
  let a = null;
  const s = t.root;
  let o = sC(t, n);
  for (; o != null; ) {
    const i = e;
    if (e.mode === "composition")
      a = i.__getInstance(o);
    else if (__VUE_I18N_LEGACY_API__) {
      const r = i.__getInstance(o);
      r != null && (a = r.__composer, n && a && !a[Wf] && (a = null));
    }
    if (a != null || s === o)
      break;
    o = o.parent;
  }
  return a;
}
function sC(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function oC(e, t, n) {
  let a = null;
  Ge(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = dx();
      const s = n;
      s[vr] && s[vr](a), a.on("*", eu);
    }
  }, t), Mn(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", eu), s[yr] && s[yr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const o = s[br];
    o && (o(), delete s[br]);
  }, t);
}
Je({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, nl);
jE();
xE(Zx);
EE(gE);
CE(Of);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = fa();
  e.__INTLIFY__ = !0, eE(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Fa = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ea = globalThis, xs = "10.29.0";
function Xf() {
  return al(ea), ea;
}
function al(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || xs, t[xs] = t[xs] || {};
}
function sl(e, t, n = ea) {
  const a = n.__SENTRY__ = n.__SENTRY__ || {}, s = a[xs] = a[xs] || {};
  return s[e] || (s[e] = t());
}
const iC = "Sentry Logger ", tu = {};
function rC(e) {
  if (!("console" in ea))
    return e();
  const t = ea.console, n = {}, a = Object.keys(tu);
  a.forEach((s) => {
    const o = tu[s];
    n[s] = t[s], t[s] = o;
  });
  try {
    return e();
  } finally {
    a.forEach((s) => {
      t[s] = n[s];
    });
  }
}
function lC() {
  il().enabled = !0;
}
function cC() {
  il().enabled = !1;
}
function Zf() {
  return il().enabled;
}
function uC(...e) {
  ol("log", ...e);
}
function dC(...e) {
  ol("warn", ...e);
}
function fC(...e) {
  ol("error", ...e);
}
function ol(e, ...t) {
  Fa && Zf() && rC(() => {
    ea.console[e](`${iC}[${e}]:`, ...t);
  });
}
function il() {
  return Fa ? sl("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const yo = {
  /** Enable logging. */
  enable: lC,
  /** Disable logging. */
  disable: cC,
  /** Check if logging is enabled. */
  isEnabled: Zf,
  /** Log a message. */
  log: uC,
  /** Log a warning. */
  warn: dC,
  /** Log an error. */
  error: fC
}, pC = Object.prototype.toString;
function mC(e, t) {
  return pC.call(e) === `[object ${t}]`;
}
function AC(e) {
  return mC(e, "Object");
}
function gC(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function hC(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    Fa && yo.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function vC(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function yC() {
  const e = ea;
  return e.crypto || e.msCrypto;
}
let Ti;
function bC() {
  return Math.random() * 16;
}
function Es(e = yC()) {
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
  } catch {
  }
  return Ti || (Ti = "10000000100040008000" + 1e11), Ti.replace(
    /[018]/g,
    (t) => (
      // eslint-disable-next-line no-bitwise
      (t ^ (bC() & 15) >> t / 4).toString(16)
    )
  );
}
const ep = 1e3;
function tp() {
  return Date.now() / ep;
}
function xC() {
  const { performance: e } = ea;
  if (!(e != null && e.now) || !e.timeOrigin)
    return tp;
  const t = e.timeOrigin;
  return () => (t + e.now()) / ep;
}
let nu;
function EC() {
  return (nu ?? (nu = xC()))();
}
function CC(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || EC(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Es()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function np(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const a = { ...e };
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (a[s] = np(a[s], t[s], n - 1));
  return a;
}
function au() {
  return Es();
}
const xr = "_sentrySpan";
function su(e, t) {
  t ? hC(e, xr, t) : delete e[xr];
}
function ou(e) {
  return e[xr];
}
const wC = 100;
class ka {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Attributes */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._attributes = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: au(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new ka();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._attributes = { ...this._attributes }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, su(t, ou(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && CC(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, n) {
    return this.setTags({ [t]: n });
  }
  /**
   * Sets attributes onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   clicked_products: [130, 554, 292],
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */
  setAttributes(t) {
    return this._attributes = {
      ...this._attributes,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets an attribute onto the scope.
   *
   * TODO:
   * Currently, these attributes are not applied to any telemetry data but they will be in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('clicked_products', [130, 554, 292]);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAttribute(t, n) {
    return this.setAttributes({ [t]: n });
  }
  /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */
  removeAttribute(t) {
    return t in this._attributes && (delete this._attributes[t], this._notifyScopeListeners()), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, a = n instanceof ka ? n.getScopeData() : AC(n) ? t : void 0, {
      tags: s,
      attributes: o,
      extra: i,
      user: r,
      contexts: l,
      level: c,
      fingerprint: u = [],
      propagationContext: d
    } = a || {};
    return this._tags = { ...this._tags, ...s }, this._attributes = { ...this._attributes, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...l }, r && Object.keys(r).length && (this._user = r), c && (this._level = c), u.length && (this._fingerprint = u), d && (this._propagationContext = d), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._attributes = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, su(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: au(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, n) {
    var o;
    const a = typeof n == "number" ? n : wC;
    if (a <= 0)
      return this;
    const s = {
      timestamp: tp(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? vC(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(s), this._breadcrumbs.length > a && (this._breadcrumbs = this._breadcrumbs.slice(-a), (o = this._client) == null || o.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      attributes: this._attributes,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: ou(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = np(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, n) {
    const a = (n == null ? void 0 : n.event_id) || Es();
    if (!this._client)
      return Fa && yo.warn("No client configured on scope - will not capture exception!"), a;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: s,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, n, a) {
    const s = (a == null ? void 0 : a.event_id) || Es();
    if (!this._client)
      return Fa && yo.warn("No client configured on scope - will not capture message!"), s;
    const o = (a == null ? void 0 : a.syntheticException) ?? new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: o,
        ...a,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, n) {
    const a = (n == null ? void 0 : n.event_id) || Es();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: a }, this), a) : (Fa && yo.warn("No client configured on scope - will not capture event!"), a);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function IC() {
  return sl("defaultCurrentScope", () => new ka());
}
function BC() {
  return sl("defaultIsolationScope", () => new ka());
}
class kC {
  constructor(t, n) {
    let a;
    t ? a = t : a = new ka();
    let s;
    n ? s = n : s = new ka(), this._stack = [{ scope: a }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let a;
    try {
      a = t(n);
    } catch (s) {
      throw this._popScope(), s;
    }
    return gC(a) ? a.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), a);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Za() {
  const e = Xf(), t = al(e);
  return t.stack = t.stack || new kC(IC(), BC());
}
function _C(e) {
  return Za().withScope(e);
}
function SC(e, t) {
  const n = Za();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function iu(e) {
  return Za().withScope(() => e(Za().getIsolationScope()));
}
function DC() {
  return {
    withIsolationScope: iu,
    withScope: _C,
    withSetScope: SC,
    withSetIsolationScope: (e, t) => iu(t),
    getCurrentScope: () => Za().getScope(),
    getIsolationScope: () => Za().getIsolationScope()
  };
}
function TC(e) {
  const t = al(e);
  return t.acs ? t.acs : DC();
}
function MC() {
  const e = Xf();
  return TC(e).getIsolationScope();
}
function ru(e) {
  MC().setUser(e);
}
function LC() {
  return "default-blue";
}
const tt = un({
  preset: "Aura",
  primary: LC(),
  surface: null,
  darkTheme: !0,
  menuMode: "static"
}), Be = un({
  staticMenuDesktopInactive: !1,
  overlayMenuActive: !1,
  rightMenuActive: !1,
  configSidebarVisible: !0,
  staticMenuMobileActive: !1,
  menuHoverActive: !1,
  sidebarActive: !1,
  anchored: !1,
  activeMenuItem: null,
  overlaySubmenuActive: !1,
  rightMenuVisible: !1,
  searchBarActive: !1
}), Ta = T(null);
function ap() {
  const e = (te) => {
    tt.primary = te;
  }, t = (te) => {
    console.log("settan surface: ", te), tt.surface = te;
  }, n = (te) => {
    tt.preset = te;
  }, a = (te) => {
    console.log("layout.js setMenuMode mode: ", te), te.value, tt.menuMode = te, console.log("layoutConfig.menuMode: ", tt.menuMode), te === "static" && (Be.staticMenuDesktopInactive = !1);
  }, s = () => {
    Be.configSidebarVisible = !0;
  }, o = () => {
    Be.rightMenuVisible = !0;
  }, i = (te) => {
    const pe = document.getElementsByTagName("html")[0];
    localStorage.setItem("colorScheme", JSON.stringify(te.value ? $a.DARK : $a.LIGHT)), pe.classList.toggle("p-dark");
  }, r = (te) => {
    Be.activeMenuItem = te.value || te;
  }, l = (te) => {
    Be.overlaySubmenuActive = te, Be.menuHoverActive = te;
  }, c = () => {
    Be.staticMenuMobileActive = !Be.staticMenuMobileActive;
  }, u = () => {
    ye(b, (te) => {
      te ? A() : f();
    });
  }, d = () => {
    tt.menuMode === "overlay" && (Be.overlayMenuActive = !Be.overlayMenuActive), window.innerWidth > 991 ? Be.staticMenuDesktopInactive = !Be.staticMenuDesktopInactive : Be.staticMenuMobileActive = !Be.staticMenuMobileActive;
  }, m = () => {
    b.value && (v(), f()), Be.configSidebarVisible = !Be.configSidebarVisible;
  }, g = (te) => {
    Be.sidebarActive = te;
  }, h = () => {
    Be.anchored = !Be.anchored;
  }, A = () => {
    Ta.value || (Ta.value = (te) => {
      p(te) && v();
    }, document.addEventListener("click", Ta.value));
  }, f = () => {
    Ta.value && (document.removeEventListener("click", Ta.value), Ta.value = null);
  }, p = (te) => {
    const pe = document.querySelector(".layout-sidebar"), Ce = document.querySelector(".topbar-start > button");
    return !(pe != null && pe.isSameNode(te.target) || pe != null && pe.contains(te.target) || Ce != null && Ce.isSameNode(te.target) || Ce != null && Ce.contains(te.target));
  }, v = () => {
    Be.overlayMenuActive = !1, Be.overlaySubmenuActive = !1, Be.staticMenuMobileActive = !1, Be.menuHoverActive = !1, Be.configSidebarVisible = !1;
  }, b = U(() => Be.overlayMenuActive || Be.staticMenuMobileActive || Be.overlaySubmenuActive), y = U(() => window.innerWidth > 991), _ = U(() => tt.menuMode === "slim"), M = U(() => tt.menuMode === "slim-plus"), S = U(() => tt.menuMode === "static"), Y = U(() => tt.menuMode === "horizontal"), K = U(() => tt.menuMode === "overlay"), Z = U(() => tt.menuMode === "drawer"), le = U(() => tt.menuMode === "reveal"), re = U(() => tt.darkTheme), Ee = U(() => tt.primary), Ye = U(() => tt.surface);
  return {
    layoutConfig: tt,
    layoutState: Be,
    getPrimary: Ee,
    getSurface: Ye,
    isDarkTheme: re,
    setPrimary: e,
    setSurface: t,
    setPreset: n,
    setMenuMode: a,
    toggleDarkMode: i,
    onMenuToggle: d,
    setMenuStates: l,
    setStaticMenuMobile: c,
    watchSidebarActive: u,
    isSidebarActive: b,
    setActiveMenuItem: r,
    onConfigSidebarToggle: m,
    onSidebarToggle: g,
    onAnchorToggle: h,
    isSlim: _,
    isSlimPlus: M,
    isStatic: S,
    isDrawer: Z,
    isReveal: le,
    isHorizontal: Y,
    isDesktop: y,
    isOverlay: K,
    showConfigSidebar: s,
    showSidebar: o,
    unbindOutsideClickListener: f
  };
}
var OC = /* @__PURE__ */ ((e) => (e[e.CD_VIEWER = 1] = "CD_VIEWER", e[e.NORMAL = 2] = "NORMAL", e[e.START = 4] = "START", e[e.PRO = 8] = "PRO", e[e.DOUBLE_SCAN = 16] = "DOUBLE_SCAN", e[e.CAD = 32] = "CAD", e[e.SUBSCRIPTION = 64] = "SUBSCRIPTION", e[e.READ_ONLY = 128] = "READ_ONLY", e[e.PLAN = 256] = "PLAN", e))(OC || {}), NC = /* @__PURE__ */ ((e) => (e.SESSION_MODIFIED = "auth:session-modified", e))(NC || {});
const ro = jo(), RC = "ssp_enabled", PC = "three_shape_enabled", FC = "itero_enabled";
class QC {
  constructor(t, n = "SESSION_KEY") {
    ie(this, "sessionKey", "SESSION_KEY");
    ie(this, "authApi");
    ie(this, "sessionId");
    ie(this, "user");
    ie(this, "featureFlags", wr());
    ie(this, "productionCenterId");
    ie(this, "loginTokenRef");
    ie(this, "fallbackUser", {
      id: 0,
      username: "",
      name: "",
      lang: "en",
      additionalData: {
        language: "en",
        timezone: "UTC"
      }
    });
    ie(this, "GetParam", (t, n) => {
      const a = t + "=";
      let s = n.indexOf(a);
      if (s == -1)
        return "";
      s += a.length;
      let o = n.indexOf(";", s);
      return o == -1 && (o = n.length), n.substring(s, o + 1);
    });
    this.sessionKey = n, this.authApi = t, this.loadSession(), this.loginTokenRef = aA("PRESCRIPTION_LOGIN_TOKEN", null);
  }
  setProductionCenterId(t) {
    this.productionCenterId = t;
  }
  applyUserSessionSettings(t) {
    var i, r, l, c;
    if (!this.user)
      return;
    const n = ((i = t.user) == null ? void 0 : i.additionalData) ?? {}, a = ((l = (r = t.user) == null ? void 0 : r.settings) == null ? void 0 : l.colorTheme) ?? ((c = t.settings) == null ? void 0 : c.colorTheme);
    n.timezone && (this.user.timezone = n.timezone);
    const s = this.user;
    this.user.lang = zn(n.language ?? this.user.lang ?? "en");
    const o = $u(a);
    s.theme = o, ap().setPrimary(o), Kn().updateColorTheme(o), Ju(o);
  }
  applySessionFeatureFlags(t) {
    this.featureFlags.value = t.featureFlags && typeof t.featureFlags == "object" && !Array.isArray(t.featureFlags) ? t.featureFlags : void 0;
  }
  async login(t, n, a, s, o, i) {
    try {
      const { status: r, data: l } = await this.authApi.login(t, n, this.productionCenterId, a, s, o, i);
      if (r == 200 && l.success && l.user)
        return console.log("login data: ", l), this.sessionId = l.sessionid, this.user = l.user, this.user.weblinkRole = l.weblinkRole, this.user.weblinkPermissions = l.weblinkPermissions, this.applyUserSessionSettings(l), this.applySessionFeatureFlags(l), this.user.isElearningEnabled = l.isElearningEnabled, this.user.elearningURL = l.elearningURL, this.user.legacyProductionCenterEnabled = l.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = l.legacyProductionCenterAllowAddPc, this.saveSession(this.sessionId), ro.emit("auth:session-modified", this.user.username), !0;
    } catch (r) {
      console.error("Login error:", r);
    }
    return !1;
  }
  async loginWithToken(t) {
    const { status: n, data: a } = await this.authApi.getSessionFromToken(t);
    try {
      if (n == 200 && a.success)
        return this.sessionId = a.sessionid, this.user = a.user, this.applyUserSessionSettings(a), this.applySessionFeatureFlags(a), this.user.isElearningEnabled = a.isElearningEnabled, this.user.elearningURL = a.elearningURL, this.user.legacyProductionCenterEnabled = a.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = a.legacyProductionCenterAllowAddPc, this.setLoginToken(t), this.saveSession(this.sessionId), ro.emit("auth:session-modified", this.user.username), !0;
    } catch (s) {
      console.error("Login error:", s);
    }
    return !1;
  }
  setExternalSession(t) {
    this.sessionId = t;
  }
  async logout() {
    if (!this.sessionId) {
      console.error("Logout error: no session ID");
      return;
    }
    try {
      await this.authApi.logout(this.sessionId), this.clearSession();
    } catch (t) {
      console.error("Logout error:", t);
    }
  }
  async checkSession(t) {
    var n;
    if (!this.sessionId)
      return !1;
    try {
      const { data: a } = await this.authApi.checkSession(this.sessionId, this.productionCenterId, t);
      let s = !1;
      return this.user !== a.user && (s = !0), this.user = a.user, this.user.weblinkRole = a.weblinkRole, this.user.weblinkPermissions = a.weblinkPermissions, this.applyUserSessionSettings(a), this.applySessionFeatureFlags(a), this.user.isElearningEnabled = a.isElearningEnabled, this.user.elearningURL = a.elearningURL, this.user.legacyProductionCenterEnabled = a.legacyProductionCenterEnabled, this.user.legacyProductionCenterAllowAddPc = a.legacyProductionCenterAllowAddPc, s && this.sessionModified(), a.success;
    } catch (a) {
      console.error("Session error:", a);
      const s = (n = a == null ? void 0 : a.response) == null ? void 0 : n.status;
      return (s === 401 || s === 403) && this.clearSession(), !1;
    }
  }
  getSessionLicence() {
    if (!this.user)
      return;
    const t = this.user.licenseRemainingDays < 1;
    t && console.error("License Remaining Days is 0");
    const n = this.user.licenseExtraParams;
    let a = this.user.licenseType;
    t && (a = "START"), this.GetParam("ITAKA_VERSION", n) == "1" && a == "PLAN" && (a = "START");
    let s = 1;
    return a == "START" || a == "MOBILE" || a == "CAD" ? s = 68 : a == "PRO" ? s = 72 : a == "PLAN" ? s = 320 : a == "PRO" ? s = 72 : (a == "DESIGN" || a == "CAD+") && (s = 66), (a == "CAD" || a == "CAD+") && (s += 32), { versionType: s, licenseType: a, licenseExtraParams: this.user.licenseExtraParams };
  }
  hasEditableAsPro() {
    if (!this.user)
      return;
    this.user.licenseRemainingDays < 1 && console.error("License Remaining Days is 0");
    const t = this.user.licenseExtraParams, n = this.user.licenseType, a = n === "DESIGN" || n === "CAD+", s = wl(t, "CAN_SHARE_PRO");
    return a && s;
  }
  hasOpenAllProjectsParam() {
    if (!this.user)
      return;
    this.user.licenseRemainingDays < 1 && console.error("License Remaining Days is 0");
    const t = this.user.licenseExtraParams;
    return wl(t, "OPEN_ALL_PROJECT");
  }
  async getNumberOfExportsTokens(t = Qp.PLANNER) {
    if (await this.checkSession(t), !this.user)
      return 0;
    const n = this.user.licenseExtraParams, a = this.GetParam("STL_EXPORTS_AVAILABLE", n);
    return parseInt(a);
  }
  async createLoginToken() {
    const { data: t } = await this.authApi.getLoginToken();
    return t.id;
  }
  isAuthenticated() {
    return this.sessionId != null;
  }
  loadSession() {
    const t = localStorage.getItem(this.sessionKey);
    t ? this.sessionId = t : this.sessionId = void 0, this.sessionModified();
  }
  clearSession() {
    localStorage.removeItem(this.sessionKey), this.loginTokenRef.value = null, this.sessionId = void 0, this.user = void 0, this.featureFlags.value = void 0, this.sessionModified();
  }
  saveSession(t) {
    localStorage.setItem(this.sessionKey, t);
  }
  getUser() {
    if (this.user)
      return this.user;
    if (this.sessionId)
      return this.fallbackUser;
    throw Error("User is not authenticated!");
  }
  hasSessionFeatureFlag(t, n = !1) {
    if (!this.featureFlags.value)
      return n;
    const a = this.featureFlags.value[t];
    return a === void 0 ? n : a === "1";
  }
  isSspEnabled() {
    return this.hasSessionFeatureFlag(RC, !0);
  }
  isThreeShapeEnabled() {
    return this.hasSessionFeatureFlag(PC);
  }
  isIteroEnabled() {
    return this.hasSessionFeatureFlag(FC);
  }
  async updateUserLang(t) {
    if (!this.user)
      return;
    const n = zn(t), a = Xb(n);
    this.user.lang = n, this.user.additionalData || (this.user.additionalData = {}), this.user.additionalData.language = a;
    try {
      await this.authApi.updateUserData(this.user.additionalData), We("User application language updated!");
    } catch {
      Oe("Error setting language!");
    }
  }
  updateUserSetttings(t) {
    t && (this.user ? (Object.assign(this.user, t), t.additionalData && (this.user.additionalData = { ...this.user.additionalData || {}, ...t.additionalData }), t.settings && typeof t.settings == "object" && !Array.isArray(t.settings) && (this.user.settings = { ...this.user.settings || {}, ...t.settings })) : this.user = t);
  }
  getSessionId() {
    if (!this.sessionId) throw Error("Session id is null!");
    if (!this.isAuthenticated()) throw Error("Not authenticated!");
    return this.sessionId;
  }
  getLoginToken() {
    return this.loginTokenRef.value;
  }
  testPrescription(t, n) {
    this.setLoginToken(t), this.saveSession(n);
  }
  requestPasswordReset(t) {
    return this.authApi.requestPasswordReset(t);
  }
  setLoginToken(t) {
    this.loginTokenRef.value = t;
  }
  sessionModified() {
    var n;
    const t = this.isAuthenticated() ? (n = this.user) == null ? void 0 : n.username : null;
    console.log("Setting Sentry user: ", t), ru(t ? {
      username: t
    } : null), ro.emit("auth:session-modified", t);
  }
  getEventBus() {
    return ro;
  }
}
const UC = {
  symbol: Symbol(),
  install(e, t) {
    const n = new Up(t.axiosInstance), a = new QC(n, t.authSessionKey);
    e.config.globalProperties.$auth = a, e.provide(this.symbol, a);
  }
};
function sp() {
  const e = Ht(UC.symbol);
  if (!e) throw new Error("AuthPlugin is null!");
  return e;
}
const GC = { class: "app-language-grid" }, YC = ["for"], rl = /* @__PURE__ */ j({
  __name: "AppLanguageComponent",
  setup(e) {
    const t = Zb(), n = [
      V.EN,
      V.IT,
      V.DE,
      V.ES,
      V.FR,
      V.PT,
      V.HR,
      V.SL,
      V.BG,
      V.HU,
      V.RO,
      V.DA,
      V.SV,
      V.SK,
      V.LT
    ], a = Nn(), s = T(zn(a.locale.value)), o = sp(), i = async (r) => {
      const l = await t.getWebcadTranslations(r);
      await o.updateUserLang(r), l && (a.setLocaleMessage(r, l), a.locale.value = r, t.setAppLanguage(r), typeof window < "u" && window.dispatchEvent(new CustomEvent("app-language-changed", { detail: r })));
    };
    return ye(
      () => a.locale.value,
      (r) => {
        s.value = zn(r);
      },
      { immediate: !0 }
    ), (r, l) => {
      const c = se("RadioButton");
      return C(), O("div", GC, [
        (C(), O(me, null, qe(n, (u) => x("div", {
          class: "p-field-radiobutton app-language-option",
          key: u
        }, [
          B(c, {
            inputId: `lang-${u}`,
            modelValue: s.value,
            "onUpdate:modelValue": l[0] || (l[0] = (d) => s.value = d),
            name: "langMode",
            value: u,
            onChange: (d) => i(u)
          }, null, 8, ["inputId", "modelValue", "value", "onChange"]),
          x("label", {
            for: `lang-${u}`
          }, P(k(JA)(u)), 9, YC)
        ])), 64))
      ]);
    };
  }
});
var op = /* @__PURE__ */ ((e) => (e.PATIENT_LIST_FILTER = "patientListFilter", e.LANG = "lang", e.COLOR_THEME = "colorTheme", e))(op || {});
const jC = { class: "flex flex-col gap-4" }, HC = {
  key: 0,
  class: "mx-1 h-6 w-px flex-shrink-0 bg-white/25",
  "aria-hidden": "true"
}, ll = /* @__PURE__ */ j({
  __name: "AppThemeConfigComponent",
  props: {
    showOnlyColors: { type: Boolean, default: !1 },
    userTheme: { default: "dark" }
  },
  setup(e) {
    const { layoutConfig: t, setPrimary: n } = ap(), a = Ef();
    T([
      { name: "Light", value: !1 },
      { name: "Dark", value: !0 }
    ]), T(localStorage.getItem("colorScheme") === '"dark"'), T([
      { name: "Sidebar", value: sn.SIDEBAR },
      { name: "Horizontal", value: sn.HORIZONTAL }
    ]), T(localStorage.getItem("navBarPos") === '"sidebar"' ? sn.SIDEBAR : sn.HORIZONTAL);
    const s = T(Bo);
    T([
      {
        name: "slate",
        palette: {
          0: "#ffffff",
          50: "#f8fafc",
          100: "#f1f5f9",
          200: "#e2e8f0",
          300: "#cbd5e1",
          400: "#94a3b8",
          500: "#64748b",
          600: "#475569",
          700: "#334155",
          800: "#1e293b",
          900: "#0f172a",
          950: "#020617"
        }
      },
      {
        name: "gray",
        palette: {
          0: "#ffffff",
          50: "#f9fafb",
          100: "#f3f4f6",
          200: "#e5e7eb",
          300: "#d1d5db",
          400: "#9ca3af",
          500: "#6b7280",
          600: "#4b5563",
          700: "#374151",
          800: "#1f2937",
          900: "#111827",
          950: "#030712"
        }
      },
      {
        name: "zinc",
        palette: {
          0: "#ffffff",
          50: "#fafafa",
          100: "#f4f4f5",
          200: "#e4e4e7",
          300: "#d4d4d8",
          400: "#a1a1aa",
          500: "#71717a",
          600: "#52525b",
          700: "#3f3f46",
          800: "#27272a",
          900: "#18181b",
          950: "#09090b"
        }
      },
      {
        name: "neutral",
        palette: {
          0: "#ffffff",
          50: "#fafafa",
          100: "#f5f5f5",
          200: "#e5e5e5",
          300: "#d4d4d4",
          400: "#a3a3a3",
          500: "#737373",
          600: "#525252",
          700: "#404040",
          800: "#262626",
          900: "#171717",
          950: "#0a0a0a"
        }
      },
      {
        name: "stone",
        palette: {
          0: "#ffffff",
          50: "#fafaf9",
          100: "#f5f5f4",
          200: "#e7e5e4",
          300: "#d6d3d1",
          400: "#a8a29e",
          500: "#78716c",
          600: "#57534e",
          700: "#44403c",
          800: "#292524",
          900: "#1c1917",
          950: "#0c0a09"
        }
      },
      {
        name: "soho",
        palette: {
          0: "#ffffff",
          50: "#f4f4f4",
          100: "#e8e9e9",
          200: "#d2d2d4",
          300: "#bbbcbe",
          400: "#a5a5a9",
          500: "#8e8f93",
          600: "#77787d",
          700: "#616268",
          800: "#4a4b52",
          900: "#34343d",
          950: "#1d1e27"
        }
      },
      {
        name: "viva",
        palette: {
          0: "#ffffff",
          50: "#f3f3f3",
          100: "#e7e7e8",
          200: "#cfd0d0",
          300: "#b7b8b9",
          400: "#9fa1a1",
          500: "#87898a",
          600: "#6e7173",
          700: "#565a5b",
          800: "#3e4244",
          900: "#262b2c",
          950: "#0e1315"
        }
      },
      {
        name: "ocean",
        palette: {
          0: "#ffffff",
          50: "#fbfcfc",
          100: "#F7F9F8",
          200: "#EFF3F2",
          300: "#DADEDD",
          400: "#B1B7B6",
          500: "#828787",
          600: "#5F7274",
          700: "#415B61",
          800: "#29444E",
          900: "#183240",
          950: "#0c1920"
        }
      }
    ]);
    function o(d, m) {
      {
        const g = $u(m.name);
        n(g), Kn().updateColorTheme(g), Ju(g), a.saveUserSettings(op.COLOR_THEME, g);
      }
    }
    function i(d) {
      return t.primary === d.name;
    }
    function r(d) {
      return d.name === "noir" ? "var(--text-color)" : d.palette[500];
    }
    function l(d) {
      return i(d) ? d.name === "noir" ? "0 0 0 2px rgba(255, 255, 255, 0.92), 0 0 0 5px rgba(0, 0, 0, 0.86), 0 8px 18px rgba(0, 0, 0, 0.55)" : `0 0 0 1px rgba(255, 255, 255, 0.92), 0 0 0 2px color-mix(in srgb, ${d.palette[500]}, transparent 52%), 0 8px 18px color-mix(in srgb, ${d.palette[500]}, transparent 46%)` : "none";
    }
    function c(d) {
      return i(d) && d.name === "noir" ? "2px solid rgba(0, 0, 0, 0.95)" : i(d) ? "2px solid rgba(255, 255, 255, 0.95)" : `2px solid ${r(d)}`;
    }
    const u = T({
      root: {
        border: {
          radius: "50% !important"
        }
      }
    });
    return (d, m) => (se("SelectButton"), C(), O("div", jC, [
      x("div", null, [
        B(k(Sn), { class: "p-2 pt-4 pb-1 items-center gap-2" }, {
          default: D(() => [
            (C(!0), O(me, null, qe(s.value, (g, h) => (C(), O(me, {
              key: g.name
            }, [
              B(k(Vn), {
                rounded: "",
                onClick: (A) => o("primary", g),
                class: J([
                  "cursor-pointer w-6 h-6 rounded-full flex flex-shrink-0 items-center justify-center p-0 outline-none border-2 transition-all duration-150 ease-out",
                  { "translate-y-[-1px]": i(g) }
                ]),
                dt: u.value,
                style: Le({
                  width: "1.5rem !important",
                  height: "1.5rem !important",
                  backgroundColor: r(g),
                  border: c(g),
                  boxShadow: l(g)
                })
              }, null, 8, ["onClick", "class", "dt", "style"]),
              h === 0 ? (C(), O("span", HC)) : $("", !0)
            ], 64))), 128))
          ]),
          _: 1
        })
      ]),
      $("", !0)
    ]));
  }
}), VC = {}, KC = { class: "flex grow" };
function WC(e, t) {
  return C(), O("div", KC, [
    X(e.$slots, "default")
  ]);
}
const ca = /* @__PURE__ */ fe(VC, [["render", WC]]), zC = {}, $C = { class: "flex flex-col" };
function qC(e, t) {
  return C(), O("div", $C, [
    X(e.$slots, "default")
  ]);
}
const ls = /* @__PURE__ */ fe(zC, [["render", qC]]), JC = {}, XC = { class: "flex flex-row-wrap w-full" };
function ZC(e, t) {
  return C(), O("div", XC, [
    X(e.$slots, "default")
  ]);
}
const Sn = /* @__PURE__ */ fe(JC, [["render", ZC]]), ip = /* @__PURE__ */ j({
  __name: "UserSettingsDialog",
  setup(e) {
    const t = T(!1);
    return (n, a) => (C(), H(ls, { class: "gap-16px" }, {
      default: D(() => [
        B(k(cu), {
          header: n.$t("medic-web-framework.theme"),
          isCollapsed: t.value,
          "onUpdate:isCollapsed": a[0] || (a[0] = (s) => t.value = s)
        }, {
          default: D(() => [
            B(ll)
          ]),
          _: 1
        }, 8, ["header", "isCollapsed"]),
        B(k(cu), {
          header: n.$t("medic-web-framework.language"),
          isCollapsed: t.value,
          "onUpdate:isCollapsed": a[1] || (a[1] = (s) => t.value = s)
        }, {
          default: D(() => [
            B(Sn, { class: "rg-panel mt-4" }, {
              default: D(() => [
                B(rl)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["header", "isCollapsed"])
      ]),
      _: 1
    }));
  }
}), ew = { class: "p-12px" }, tw = { class: "top-nav-bar flex items-center" }, nw = ["src"], aw = { class: "p-12px" }, sw = { class: "top-nav-bar flex items-center" }, ow = ["src"], iw = { key: 0 }, rw = {
  key: 0,
  class: "gap-3",
  style: { display: "flex", "justify-content": "space-between", "align-items": "center", padding: "0.75rem 1rem" }
}, lw = { style: { display: "flex" } }, cw = { class: "wiz-project-name" }, uw = { class: "navbar-project-meta-label" }, dw = { class: "navbar-project-meta-value" }, fw = { class: "navbar-project-meta-label" }, pw = { class: "navbar-project-meta-value" }, mw = ["src"], Aw = { class: "wiz-project-name" }, gw = { key: 0 }, hw = { class: "p-card-title text-xl font-bold" }, vw = { class: "grid w-full" }, yw = { key: 0 }, bw = ["src"], xw = {
  key: 0,
  class: "topbar-dropdown-label"
}, Ew = ["onClick"], Cw = ["src"], ww = ["src"], Iw = ["onClick"], Bw = ["src"], kw = /* @__PURE__ */ j({
  __name: "RgGlobalNavbar",
  setup(e) {
    const t = Gu(), { t: n } = Nn(), a = T(!1), s = T([]), o = T([]), i = T(""), r = T(!1), l = T(!1), c = T(""), u = T(null), d = T(!1), m = T(!1), g = T(), h = T(), A = T(!1), f = T(), p = T(""), v = T(""), b = T(""), y = T(!1), _ = T(null), M = T(!1), S = T(), Y = T(!1), K = T(!1), Z = T([]), le = T(!1), re = T(""), Ee = T(!1), Ye = T(""), te = T(), pe = T(), Ce = T(!1), _t = Cf(), Ve = T(), je = T(), Ke = T([
      // ButtonEnum.SAVE,
      G.SAVE_AS,
      G.RESET,
      G.LAYOUT,
      G.SCREENSHOT,
      G.W_L,
      G.RULER,
      G.ADD_PATIENT,
      G.ADD_DOCTOR,
      G.NOTIFICATIONS,
      G.MATERIAL_LIBRARY,
      G.INSPECT,
      r.value ? "" : G.SETTINGS,
      r.value ? "" : G.PC_SETTINGS
    ]), at = T([
      G.PC_LIST,
      G.RG_WEB,
      G.PROFILE,
      G.USER_SETTINGS,
      G.LOGOUT,
      G.UNDO,
      G.REDO,
      G.INFO,
      r.value ? G.SETTINGS : "",
      G.HELP,
      G.SUPPORT,
      G.EXIT
    ]), Xe = T([]), ct = U(() => typeof navigator > "u" ? !1 : /Android.*Mobile|iPhone|iPod|Windows Phone|IEMobile|BlackBerry|Opera Mini/i.test(navigator.userAgent)), pt = U(() => !ct.value), Vt = U(() => _t.isMobileView);
    function Kt(w, Q) {
      const oe = new Set(Q);
      return w.filter((ve) => oe.has(ve));
    }
    De.on(Pt.SHOW_ONLY_LOGO, () => {
      a.value = !1, d.value = !0;
    }), De.on(Pt.TOGGLE_CAD_MODE, (w) => {
      if (console.log("Toggle cad mode in navbar", w.flag), le.value = w.flag, le.value) {
        const Q = Ke.value.findIndex((oe) => oe === G.SCREENSHOT);
        Q !== -1 && Ke.value.splice(Q, 1);
      } else
        Ke.value.push(G.SCREENSHOT);
    }), De.on(Pt.SHOW_UNVERIFIED_ADDRESS, (w) => {
      var oe;
      const Q = typeof w.flag == "boolean" ? w.flag : !!((oe = w.flag) != null && oe.flag);
      Ce.value = Q;
    }), De.on(Pt.SHOW_NAVBAR, (w) => {
      s.value = w.options.buttons ?? [], o.value = Kt(Ke.value, w.options.buttons ?? []), i.value = w.options.username ?? "", c.value = w.options.buildId ?? "", re.value = w.options.pcName ?? "", Ee.value = w.options.isElearningEnabled ?? w.options.isElarningEnabled ?? !1, Ye.value = w.options.elearningURL ?? "", r.value = w.options.isWizard ?? !1, l.value = w.options.showZimvieLogo ?? !1, m.value = w.options.showNavbarPosition ?? !1, g.value = w.options.pcStatuses, h.value = w.options.userStatuses ?? [], Y.value = w.options.userChatNotifications, K.value = w.options.hasPcSettingsAccess ?? !1, w.options.showDoctors !== void 0 && (M.value = !1), S.value = w.options.showDoctors, A.value = w.options.showMeasurementUnit ?? !1, w.options.showMeasurementUnit && (f.value = w.options.measurementUnit), r.value ? (at.value.push(G.SETTINGS), Ke.value = Ke.value.filter((Q) => Q !== G.SETTINGS)) : (Ke.value.push(G.SETTINGS), at.value = at.value.filter((Q) => Q !== G.SETTINGS)), i.value == "test_admin_1" && at.value.push(G.TESTING_VIEW), a.value = !0;
    }), De.on(Pt.HIDE_NAVBAR, () => {
      a.value = !1, d.value = !1;
    }), De.on(Pt.UPDATE_NAVBAR, (w) => {
      s.value = w.options.buttons ?? [], a.value = !0;
    }), De.on(Pt.ENABLE_NAVBAR_BUTTONS, (w) => {
      w.options.forEach((Q) => {
        Xe.value = Xe.value.filter((oe) => oe !== Q);
      });
    }), De.on(Pt.DISABLE_NAVBAR_BUTTONS, (w) => {
      w.options.forEach((Q) => {
        Xe.value.push(Q);
      });
    }), De.on(Pt.ADD_TOOLTIPS, (w) => {
      w.options.forEach((Q) => {
        Q.tooltip && (u.value = { [Q.button]: Q.tooltip });
      });
    }), De.on(Pt.SHOW_PROJECT_NAME, (w) => {
      if (typeof w.options == "string") {
        p.value = w.options, v.value = "", b.value = "", y.value = !1, _.value = null;
        return;
      }
      p.value = w.options.projectName ?? "", v.value = w.options.caseId ?? "", b.value = w.options.user ?? "", y.value = w.options.hasUnverifiedAddressWarning ?? !1, Ce.value = w.options.hasUnverifiedAddressWarning ?? !1, _.value = w.options.unverifiedAddressUserId ?? null;
    });
    function mt(w) {
      return w.split("_").map((ve, At) => At === 0 ? ve.toLowerCase() : ve.charAt(0).toUpperCase() + ve.slice(1).toLowerCase()).join("");
    }
    function Ot(w) {
      return w === G.PC_LIST && re.value === "" ? "shared.weblink" : `shared.${mt(G[w].toString())}`;
    }
    async function mn(w) {
      De.emit(Ma.NAVBAR_BUTTON_CLICKED, w);
    }
    function An() {
      _.value !== null && De.emit(Ma.PROJECT_UNVERIFIED_ADDRESS_CLICKED, _.value);
    }
    function la() {
      t.open(ip, {
        props: {
          closable: !0,
          modal: !0,
          header: ke("shared.settings"),
          style: { width: "60vw", minHeight: "70vh", maxHeight: "95vh" }
        }
      });
    }
    const he = (w) => {
      var Q, oe;
      if (w === G.E_LEARNING) {
        const ve = Ye.value.trim();
        ve.length > 0 && window.open(ve, "_blank", "noopener,noreferrer");
        return;
      }
      if (mn(w), w === G.RULER) {
        const ve = Ve.value;
        ve && event && ve[0].toggle(event);
      } else if (w == G.RULER_DISTANCE || w == G.RULER_ANGLE || w == G.RULER_ANNOTATION || w == G.RULER_ROI || w == G.RULER_CLEAR) {
        const ve = Ve.value;
        ve && event && ve[0].toggle(event);
      } else w === G.PROFILE ? la() : w === G.W_L ? (Q = document.getElementById("btn_w_l")) == null || Q.classList.toggle("btn-clicked") : w === G.INFO ? (oe = document.getElementById("btn_info")) == null || oe.classList.toggle("btn-clicked") : w === G.DISTANCE_UNIT_MM ? f.value = gs.Mm : w === G.DISTANCE_UNIT_INCH && (f.value = gs.Inch);
    }, gn = U(() => le.value ? [
      {
        id: "plane",
        label: ke("implant-planner.plane"),
        command: () => {
          he(G.RULER_PLANE);
        }
      },
      {
        id: "sphere",
        label: ke("implant-planner.sphere"),
        command: () => {
          he(G.RULER_SPHERE);
        }
      },
      {
        id: "tetrahedron",
        label: ke("implant-planner.tetrahedron"),
        command: () => {
          he(G.RULER_TETRAHEDRON);
        }
      },
      {
        id: "ruler_distance",
        label: ke("shared.distance"),
        command: () => {
          he(G.RULER_DISTANCE);
        }
      },
      {
        id: "ruler_angle",
        label: ke("shared.angle"),
        command: () => {
          he(G.RULER_ANGLE);
        }
      },
      {
        id: "landmark",
        label: ke("implant-planner.landmark"),
        command: () => {
          he(G.RULER_LANDMARK);
        }
      },
      {
        id: "ruler_annotation",
        label: ke("shared.rulerAnnotation"),
        command: () => {
          he(G.RULER_ANNOTATION);
        }
      },
      {
        id: "ruler_roi",
        label: ke("shared.roi"),
        command: () => {
          he(G.RULER_ROI);
        }
      },
      {
        id: "ruler_clear",
        label: ke("shared.rulerClear"),
        command: () => {
          he(G.RULER_CLEAR);
        }
      },
      {
        id: "ruler_clear",
        label: ke("implant-planner.clearAllExceptAnnotation"),
        command: () => {
          he(G.RULER_CLEAR_EXCEPT);
        }
      }
    ] : [
      {
        id: "ruler_distance",
        label: ke("shared.distance"),
        command: () => {
          he(G.RULER_DISTANCE);
        }
      },
      {
        id: "ruler_angle",
        label: ke("shared.angle"),
        command: () => {
          he(G.RULER_ANGLE);
        }
      },
      {
        id: "ruler_annotation",
        label: ke("shared.rulerAnnotation"),
        command: () => {
          he(G.RULER_ANNOTATION);
        }
      },
      {
        id: "ruler_roi",
        label: ke("shared.roi"),
        command: () => {
          he(G.RULER_ROI);
        }
      },
      {
        id: "ruler_clear",
        label: ke("shared.rulerClear"),
        command: () => {
          he(G.RULER_CLEAR);
        }
      }
    ]), Nt = U(() => {
      var w;
      return g.value ? ((w = g.value) == null ? void 0 : w.length) > 0 : !1;
    }), Wt = U(() => !r.value && (v.value.length > 0 || b.value.length > 0)), hn = U(() => {
      var oe, ve, At;
      let w = T(
        (oe = h.value) == null ? void 0 : oe.filter(function(Ze) {
          return Ze != "";
        })
      );
      const Q = (ve = g.value) == null ? void 0 : ve.map((Ze) => ({
        ...Ze,
        selected: !1
      }));
      return Q && ((At = w.value) == null || At.forEach((Ze) => {
        Q[Q.findIndex((Rt) => Rt.name == Ze)].selected = !0;
      })), Q;
    }), E = async (w) => {
      var Q, oe, ve;
      if (w.selected)
        (Q = h.value) == null || Q.push(w.name), De.emit(Ma.USER_EMAIL_NOTIFICATION_CLICKED, h.value);
      else {
        let At = (oe = h.value) == null ? void 0 : oe.findIndex((Ze) => Ze == w.name);
        At && ((ve = h.value) == null || ve.splice(At, 1), De.emit(Ma.USER_EMAIL_NOTIFICATION_CLICKED, h.value));
      }
    }, I = async (w) => {
      Y.value = w, De.emit(Ma.USER_CHAT_EMAIL_NOTIFICATION_CLICKED, Y.value);
    }, R = async () => {
      await mn(G.SHOW_DOCTOR_PATIENT_LIST);
    }, W = U(() => Ee.value && Ye.value.trim().length > 0), we = U(() => {
      const w = [
        {
          label: n("shared.videoTutorial"),
          icon: "icon_top_nav_video_tutorial",
          button: G.VIDEO_TUTORIAL
        }
      ];
      return W.value && w.push({
        label: n("shared.eLearning"),
        icon: "icon_top_nav_e_learning",
        button: G.E_LEARNING
      }), s.value.includes(G.OPEN_TICKET) && w.push({
        label: n("shared.openTicket"),
        icon: "icon_top_nav_open_ticket",
        button: G.OPEN_TICKET
      }), s.value.includes(G.REMOTE_SUPPORT) && w.push({
        label: n("shared.remoteSupport"),
        icon: "icon_top_nav_remote_support",
        button: G.REMOTE_SUPPORT
      }), w;
    }), Se = (w) => {
      pe.value[0].toggle(w);
    }, ce = U(() => {
      if (r.value)
        return [
          {
            items: [
              {
                label: n("shared.exit"),
                icon: "icon_top_nav_logout",
                button: G.EXIT
              }
            ]
          }
        ];
      const w = [
        {
          label: n("shared.userAccount"),
          icon: "rg_profile_info",
          button: G.PROFILE_INFO
        },
        {
          label: n("shared.resetPassword"),
          icon: "rg_reset_password",
          button: G.RESET_PASSWORD
        },
        {
          label: n("shared.settings"),
          icon: "settings_white",
          button: G.USER_SETTINGS
        },
        {
          label: n("shared.logout"),
          icon: "icon_top_nav_logout",
          button: G.LOGOUT
        }
      ];
      return K.value && w.splice(3, 0, {
        label: n("shared.pcSettings"),
        icon: "settings_white",
        button: G.PC_SETTINGS
      }), [
        {
          items: w
        }
      ];
    }), N = (w) => {
      te.value[0].toggle(w);
    };
    return Ge(() => {
      XA();
    }), (w, Q) => {
      const oe = se("TieredMenu"), ve = se("AccordionTab"), At = se("Accordion"), Ze = se("Menu"), Rt = ws("tooltip"), qs = ws("ripple");
      return C(), O(me, null, [
        an(x("div", ew, [
          x("nav", tw, [
            B(ae, { class: "flex-row grow align-center items-center" }, {
              default: D(() => [
                B(ae, { class: "justify-center items-center w-full" }, {
                  default: D(() => [
                    x("a", {
                      id: "logoContainer",
                      class: "cursor-pointer logo-wrapper flex items-center",
                      style: Le(ct.value ? "width: 90px !important" : ""),
                      onClick: Q[0] || (Q[0] = (Ae) => he(k(G).RG_LOGO))
                    }, [
                      x("img", {
                        alt: "RG Logo",
                        src: k(Oi)("rg_logo_official"),
                        class: "object-contain",
                        draggable: "false"
                      }, null, 8, nw)
                    ], 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 512), [
          [Li, d.value && !a.value]
        ]),
        an(x("div", aw, [
          x("nav", sw, [
            B(ae, {
              class: J(["flex-row grow align-center items-center", { "ml-3": !Vt.value }])
            }, {
              default: D(() => [
                B(ae, { class: "gap-8 justify-start" }, {
                  default: D(() => [
                    x("a", {
                      id: "navbar_rg_logo",
                      class: "cursor-pointer logo-wrapper flex items-center",
                      style: Le(ct.value ? "width: 90px !important" : ""),
                      onClick: Q[1] || (Q[1] = (Ae) => he(k(G).RG_LOGO))
                    }, [
                      x("img", {
                        alt: "RG Logo",
                        src: k(Oi)("rg_logo_official"),
                        class: "object-contain",
                        draggable: "false",
                        style: { "max-height": "40px !important" }
                      }, null, 8, ow)
                    ], 4)
                  ]),
                  _: 1
                }),
                B(ae, {
                  class: "justify-start gap-2 pl-4",
                  style: { flex: "1 1 0" }
                }, {
                  default: D(() => [
                    (C(!0), O(me, null, qe(o.value, (Ae) => (C(), O(me, { key: Ae }, [
                      Ke.value.includes(Ae) ? (C(), O("a", iw, [
                        B(ho, {
                          class: "padding-top-nav",
                          id: `btn_${k(G)[Ae].toLowerCase()}`,
                          icon: `icon_top_nav_${k(G)[Ae].toLowerCase()}`,
                          iconPos: k(Wn).TOP,
                          iconType: k(ge).TOP_NAVBAR_ICON,
                          disabled: Xe.value.includes(Ae),
                          tooltipBottom: w.$t(Ot(Ae)),
                          onClick: (Pe) => he(Ae)
                        }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]),
                        k(G)[Ae].toLowerCase() === "ruler" ? (C(), H(k(Bs), {
                          key: 0,
                          id: "overlay_ruler_panel",
                          ref_for: !0,
                          ref_key: "opRuler",
                          ref: Ve,
                          showCloseIcon: !1,
                          appendTo: "body",
                          style: { "max-width": "350px" }
                        }, {
                          default: D(() => [
                            B(oe, { model: gn.value }, null, 8, ["model"]),
                            A.value ? (C(), O("div", rw, [
                              Te(P(w.$t("shared.measurementUnit")) + " ", 1),
                              x("div", lw, [
                                (C(), H(k(Vn), {
                                  class: "h-2-2rem",
                                  key: f.value,
                                  disabled: f.value == k(gs).Mm,
                                  label: w.$t("shared.mm"),
                                  onClick: Q[2] || (Q[2] = (Pe) => he(k(G).DISTANCE_UNIT_MM))
                                }, null, 8, ["disabled", "label"])),
                                (C(), H(k(Vn), {
                                  class: "h-2-2rem",
                                  key: f.value,
                                  disabled: f.value == k(gs).Inch,
                                  label: w.$t("shared.in"),
                                  style: { "margin-left": "0.25rem" },
                                  onClick: Q[3] || (Q[3] = (Pe) => he(k(G).DISTANCE_UNIT_INCH))
                                }, null, 8, ["disabled", "label"]))
                              ])
                            ])) : $("", !0)
                          ]),
                          _: 1
                        }, 512)) : $("", !0)
                      ])) : $("", !0)
                    ], 64))), 128))
                  ]),
                  _: 1
                }),
                r.value && !re.value ? (C(), H(ae, {
                  key: 0,
                  title: p.value,
                  style: { cursor: "pointer", "justify-content": "center", flex: "1 1 0", "min-width": "0" }
                }, {
                  default: D(() => [
                    x("span", cw, P(p.value), 1)
                  ]),
                  _: 1
                }, 8, ["title"])) : (C(), H(ls, {
                  key: 1,
                  class: "justify-center items-center centered-x",
                  style: { cursor: "pointer", flex: "1 1 0", "min-width": "0" }
                }, {
                  default: D(() => [
                    Wt.value ? (C(), H(Sn, {
                      key: 0,
                      class: "justify-center items-center gap-2 navbar-project-meta-row"
                    }, {
                      default: D(() => [
                        v.value ? (C(), H(ae, {
                          key: 0,
                          class: "navbar-project-meta-chip gap-2",
                          title: `${w.$t("weblink.caseId")}: ${v.value}`
                        }, {
                          default: D(() => [
                            x("span", uw, P(w.$t("weblink.caseId")) + ":", 1),
                            x("span", dw, P(v.value), 1),
                            Q[8] || (Q[8] = x("span", null, "//", -1))
                          ]),
                          _: 1
                        }, 8, ["title"])) : $("", !0),
                        b.value ? (C(), H(ae, {
                          key: 1,
                          class: "navbar-project-meta-chip gap-2",
                          title: `${w.$t("shared.user")}: ${b.value}`
                        }, {
                          default: D(() => [
                            x("span", fw, P(w.$t("shared.user")) + ":", 1),
                            x("span", pw, P(b.value), 1),
                            Ce.value ? an((C(), O("img", {
                              key: 0,
                              src: k(Io)("rg_warning"),
                              class: "navbar-project-meta-warning cursor-pointer",
                              onClick: xt(An, ["stop"])
                            }, null, 8, mw)), [
                              [
                                Rt,
                                w.$t("medic-web-framework.unverifiedUserAddress"),
                                void 0,
                                { bottom: !0 }
                              ]
                            ]) : $("", !0)
                          ]),
                          _: 1
                        }, 8, ["title"])) : $("", !0),
                        B(ae, {
                          id: "navbar-project-shared-users-slot",
                          class: "navbar-project-shared-users-slot"
                        })
                      ]),
                      _: 1
                    })) : $("", !0),
                    r.value ? (C(), H(Sn, {
                      key: 1,
                      class: "justify-center"
                    }, {
                      default: D(() => [
                        x("span", Aw, P(p.value), 1)
                      ]),
                      _: 1
                    })) : $("", !0)
                  ]),
                  _: 1
                })),
                B(ae, {
                  class: "justify-end",
                  style: { flex: "1 1 0" }
                }, {
                  default: D(() => [
                    Q[12] || (Q[12] = x("div", { class: "grid flex-column align-center mr-3 top-navbar-hide-sm" }, null, -1)),
                    r.value ? (C(), H(ae, {
                      key: 0,
                      class: "align-center gap-2 mr-3",
                      style: { flex: "3 1 0", "justify-content": "end" }
                    }, {
                      default: D(() => [
                        (C(!0), O(me, null, qe(s.value, (Ae) => (C(), O(me, { key: Ae }, [
                          at.value.includes(Ae) ? (C(), O("a", gw, [
                            B(ho, {
                              class: "padding-top-nav",
                              id: `btn_${k(G)[Ae].toLowerCase()}`,
                              icon: `icon_top_nav_${k(G)[Ae].toLowerCase()}`,
                              iconPos: k(Wn).TOP,
                              iconType: k(ge).TOP_NAVBAR_ICON,
                              disabled: Xe.value.includes(Ae),
                              tooltipBottom: w.$t(Ot(Ae)),
                              onClick: (Pe) => he(Ae)
                            }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]),
                            k(G)[Ae].toLowerCase() == "profile" || k(G)[Ae].toLowerCase() == "user_settings" ? (C(), H(k(Bs), {
                              key: 0,
                              id: "overlay_profile_panel",
                              ref_for: !0,
                              ref_key: "opProfile",
                              ref: je,
                              showCloseIcon: !0,
                              appendTo: "body",
                              class: "all-radius w-3/12 md:w-4/12 sm:w-5/12"
                            }, {
                              default: D(() => [
                                x("div", hw, P(w.$t("shared.userSettings")), 1),
                                B(At, {
                                  "active-index": 0,
                                  class: "mt-2"
                                }, {
                                  default: D(() => [
                                    Nt.value ? (C(), H(ve, {
                                      key: 0,
                                      header: w.$t("shared.notifications")
                                    }, {
                                      default: D(() => [
                                        B(q_, {
                                          "status-list": hn.value,
                                          "onUpdate:statusList": Q[4] || (Q[4] = (Pe) => hn.value = Pe),
                                          "email-chat-notification": Y.value,
                                          "onUpdate:emailChatNotification": Q[5] || (Q[5] = (Pe) => Y.value = Pe),
                                          "email-status-notification": Z.value,
                                          "onUpdate:emailStatusNotification": Q[6] || (Q[6] = (Pe) => Z.value = Pe),
                                          onUpdateStatusNotification: E,
                                          onUpdateEmailChatNotification: I
                                        }, null, 8, ["status-list", "email-chat-notification", "email-status-notification"])
                                      ]),
                                      _: 1
                                    }, 8, ["header"])) : $("", !0),
                                    B(ve, {
                                      header: w.$t("medic-web-framework.theme")
                                    }, {
                                      default: D(() => [
                                        B(ll, { showOnlyColors: !1 })
                                      ]),
                                      _: 1
                                    }, 8, ["header"]),
                                    B(ve, {
                                      header: w.$t("medic-web-framework.language")
                                    }, {
                                      default: D(() => [
                                        B(rl)
                                      ]),
                                      _: 1
                                    }, 8, ["header"]),
                                    M.value ? (C(), H(ve, {
                                      key: 1,
                                      header: w.$t("medic-web-framework.patientListSettings")
                                    }, {
                                      default: D(() => [
                                        B(ae, { class: "w-full status-step-container" }, {
                                          default: D(() => [
                                            x("div", vw, [
                                              B(ae, { class: "flex-row w-full mt-4" }, {
                                                default: D(() => [
                                                  B(ca, { class: "gap-2" }, {
                                                    default: D(() => [
                                                      Q[9] || (Q[9] = x("span", { class: "flex pi pi-users align-center" }, null, -1)),
                                                      x("span", null, P(w.$t("medic-web-framework.showDoctorsOnPatientList")), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  B(ae, null, {
                                                    default: D(() => [
                                                      B(mo, {
                                                        id: "switchShowDoctors",
                                                        state: S.value,
                                                        "onUpdate:state": Q[7] || (Q[7] = (Pe) => S.value = Pe),
                                                        onChange: R
                                                      }, null, 8, ["state"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["header"])) : $("", !0)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512)) : $("", !0)
                          ])) : $("", !0)
                        ], 64))), 128))
                      ]),
                      _: 1
                    })) : $("", !0),
                    r.value ? $("", !0) : (C(), H(ae, {
                      key: 1,
                      class: "align-center gap-2 mr-2 justify-end",
                      style: { "margin-right": "15px !important", flex: "1 1 0" }
                    }, {
                      default: D(() => [
                        (C(!0), O(me, null, qe(s.value, (Ae) => (C(), O(me, { key: Ae }, [
                          at.value.includes(Ae) ? (C(), O("a", yw, [
                            Ae === k(G).USER_SETTINGS ? (C(), O(me, { key: 0 }, [
                              B(k(Vn), {
                                type: "button",
                                class: J([
                                  "m-u-button web-rg-navbar-btn w-full navbar-btn p-12px gap-16px topbar-dropdown-trigger",
                                  { "min-w-150px": !ct.value }
                                ]),
                                onClick: N,
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_menu"
                              }, {
                                default: D(() => [
                                  x("img", {
                                    src: k(Xs)("rg_account_circle")
                                  }, null, 8, bw),
                                  pt.value ? (C(), O("span", xw, P(i.value), 1)) : $("", !0),
                                  Q[10] || (Q[10] = x("i", { class: "pi pi-chevron-down" }, null, -1))
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              B(Ze, {
                                ref_for: !0,
                                ref_key: "menu",
                                ref: te,
                                id: "overlay_menu",
                                class: "topbar-dropdown-menu",
                                model: ce.value,
                                popup: !0
                              }, {
                                item: D(({ item: Pe }) => {
                                  var cs;
                                  return [
                                    an((C(), O("span", {
                                      class: J(["p-menu-item-rg w-150px gap-16px", { "opacity-50 pointer-events-none": (cs = Xe.value) == null ? void 0 : cs.includes(Pe.button) }]),
                                      onClick: (Ip) => he(Pe.button)
                                    }, [
                                      x("img", {
                                        src: k(Xs)(Pe.icon || "")
                                      }, null, 8, Cw),
                                      x("span", null, P(Pe.label), 1)
                                    ], 10, Ew)), [
                                      [qs]
                                    ])
                                  ];
                                }),
                                _: 2
                              }, 1032, ["model"])
                            ], 64)) : Ae === k(G).HELP ? (C(), O(me, { key: 1 }, [
                              B(k(Vn), {
                                type: "button",
                                class: "m-u-button web-rg-navbar-btn w-full navbar-btn p-12px gap-16px topbar-dropdown-trigger",
                                onClick: Se,
                                "aria-haspopup": "true",
                                "aria-controls": "overlay_menu"
                              }, {
                                default: D(() => [
                                  x("img", {
                                    src: k(Xs)("icon_top_nav_support")
                                  }, null, 8, ww),
                                  Q[11] || (Q[11] = x("i", { class: "pi pi-chevron-down" }, null, -1))
                                ]),
                                _: 1
                              }),
                              B(Ze, {
                                ref_for: !0,
                                ref_key: "menuHelp",
                                ref: pe,
                                id: "overlay_menu",
                                class: "topbar-dropdown-menu",
                                model: we.value,
                                popup: !0
                              }, {
                                item: D(({ item: Pe }) => {
                                  var cs;
                                  return [
                                    an((C(), O("span", {
                                      class: J(["p-menu-item-rg w-150px gap-16px", { "opacity-50 pointer-events-none": (cs = Xe.value) == null ? void 0 : cs.includes(Pe.button) }]),
                                      onClick: (Ip) => he(Pe.button)
                                    }, [
                                      x("img", {
                                        src: k(Xs)(Pe.icon || "")
                                      }, null, 8, Bw),
                                      x("span", null, P(Pe.label), 1)
                                    ], 10, Iw)), [
                                      [qs]
                                    ])
                                  ];
                                }),
                                _: 2
                              }, 1032, ["model"])
                            ], 64)) : (C(), H(ho, {
                              key: 2,
                              class: "padding-top-nav h-49px topbar-dropdown-trigger",
                              id: `btn_${k(G)[Ae].toLowerCase()}`,
                              icon: `icon_top_nav_${k(G)[Ae].toLowerCase()}`,
                              iconPos: k(Wn).TOP,
                              iconType: k(ge).TOP_NAVBAR_ICON,
                              disabled: Ae !== k(G).USER_SETTINGS && Xe.value.includes(Ae),
                              tooltipBottom: w.$t(Ot(Ae)),
                              onClick: (Pe) => he(Ae)
                            }, null, 8, ["id", "icon", "iconPos", "iconType", "disabled", "tooltipBottom", "onClick"]))
                          ])) : $("", !0)
                        ], 64))), 128))
                      ]),
                      _: 1
                    }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ], 512), [
          [Li, a.value]
        ])
      ], 64);
    };
  }
}), AM = /* @__PURE__ */ fe(kw, [["__scopeId", "data-v-665dd86b"]]), _w = { class: "text-sm text-gray-500" }, Sw = { class: "p-card-title text-xl font-bold" }, gM = /* @__PURE__ */ j({
  __name: "UserProfileDropdown",
  props: {
    username: {},
    usernameModifiers: {}
  },
  emits: ["update:username"],
  setup(e) {
    const t = Ie(e, "username"), n = T(), a = (s) => {
      n.value.toggle(s);
    };
    return (s, o) => {
      const i = se("AccordionTab"), r = se("Accordion");
      return C(), O(me, null, [
        B(ae, {
          class: "cursor-pointer p-2 h-56 grow",
          style: { border: "1px var(--p-rg-outlined-button-border-color) solid", "border-radius": "16px" },
          onClick: a
        }, {
          default: D(() => [
            B(ca, null, {
              default: D(() => [
                B(ls, { class: "ml-2" }, {
                  default: D(() => [
                    x("span", null, P(t.value), 1),
                    x("span", _w, P(t.value) + "@3diemme.it", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            B(ae, { class: "align-center mr-4" }, {
              default: D(() => [...o[0] || (o[0] = [
                x("span", { class: "pi pi-chevron-down" }, null, -1)
              ])]),
              _: 1
            })
          ]),
          _: 1
        }),
        B(k(Bs), {
          id: "popover_profile_panel",
          ref_key: "popoverProfile",
          ref: n,
          showCloseIcon: !0,
          appendTo: "body",
          class: "w-3/12 md:w-4/12 sm:w-5/12"
        }, {
          default: D(() => [
            x("div", Sw, P(s.$t("shared.userSettings")), 1),
            B(r, {
              "active-index": 0,
              class: "mt-2"
            }, {
              default: D(() => [
                B(i, {
                  header: s.$t("medic-web-framework.theme")
                }, {
                  default: D(() => [
                    B(ll, { showOnlyColors: !1 })
                  ]),
                  _: 1
                }, 8, ["header"]),
                B(i, {
                  header: s.$t("medic-web-framework.language")
                }, {
                  default: D(() => [
                    B(rl)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ], 64);
    };
  }
}), Dw = {
  id: "navbar_rg_logo",
  class: "cursor-pointer flex items-center ml-4",
  style: { width: "160px" }
}, Tw = ["src"], hM = /* @__PURE__ */ j({
  __name: "RgLogoUserDropdown",
  props: {
    username: {},
    usernameModifiers: {}
  },
  emits: ["update:username"],
  setup(e) {
    return Ie(e, "username"), (t, n) => (C(), H(ae, {
      class: "gap-8 h-56 gap-4-md-screen",
      style: "width: 100%; max-width: 550px !important;"
    }, {
      default: D(() => [
        x("a", Dw, [
          x("img", {
            alt: "RG Logo",
            src: k(Oi)("rg_logo_official"),
            class: "object-contain w-full",
            draggable: "false"
          }, null, 8, Tw)
        ])
      ]),
      _: 1
    }));
  }
}), vM = /* @__PURE__ */ j({
  __name: "UserProfileTemp",
  setup(e) {
    const t = Gu(), n = () => {
      t.open(ip, {
        props: {
          closable: !0,
          modal: !0,
          header: ke("shared.settings"),
          style: { width: "60vw", minHeight: "70vh", maxHeight: "95vh" }
        }
      });
    };
    return (a, s) => (C(), H(ho, {
      class: "mt-0 web-rg-icon-btn",
      id: "btn_user_settings",
      icon: "icon_top_nav_user_settings",
      iconPos: k(Wn).TOP,
      iconType: k(ge).TOP_NAVBAR_ICON,
      onClick: n,
      style: { height: "56px !important", width: "56px !important" }
    }, null, 8, ["iconPos", "iconType"]));
  }
}), yM = /* @__PURE__ */ j({
  __name: "MCard",
  props: {
    flex: { type: Boolean }
  },
  setup(e) {
    const t = e, n = U(() => t.flex ? "flex" : "flex-none");
    return (a, s) => (C(), O("div", {
      class: J([[n.value], "card menu-item-tab-background margin-t-30 margin-l-20px"])
    }, [
      X(a.$slots, "default")
    ], 2));
  }
}), bM = /* @__PURE__ */ j({
  __name: "MGridItem",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = U(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (C(), O("div", {
      class: J([[n.value], "flex items-center"])
    }, [
      X(a.$slots, "default")
    ], 2));
  }
}), xM = /* @__PURE__ */ j({
  __name: "MGridItemCenter",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = U(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (C(), O("div", {
      class: J([[n.value], "flex justify-center items-center"])
    }, [
      X(a.$slots, "default")
    ], 2));
  }
}), EM = /* @__PURE__ */ j({
  __name: "MGridItemEnd",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = U(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (C(), O("div", {
      class: J([[n.value], "col flex justify-end items-center"])
    }, [
      X(a.$slots, "default")
    ], 2));
  }
}), Mw = {}, Lw = {
  class: "col",
  style: { "flex-grow": "10" }
};
function Ow(e, t) {
  return C(), O("div", Lw, [
    X(e.$slots, "default")
  ]);
}
const CM = /* @__PURE__ */ fe(Mw, [["render", Ow]]), wM = /* @__PURE__ */ j({
  __name: "MGridItemStart",
  props: {
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = U(() => t.width > 0 ? "col-" + t.width : "col");
    return (a, s) => (C(), O("div", {
      class: J([[n.value], "flex justify-start items-center"])
    }, [
      X(a.$slots, "default")
    ], 2));
  }
}), IM = /* @__PURE__ */ j({
  __name: "MGridRow",
  props: {
    noPadding: { type: Boolean, default: !1 },
    width: { default: 0 }
  },
  setup(e) {
    const t = e, n = U(() => t.noPadding ? "grid-nogutter" : ""), a = U(() => t.width > 0 ? "col-" + t.width : "");
    return (s, o) => (C(), O("div", {
      class: J([[n.value, a.value], "flex flex-row-wrap"])
    }, [
      X(s.$slots, "default"),
      X(s.$slots, "item")
    ], 2));
  }
}), Nw = {}, Rw = { style: { color: "#a5a5a5" } };
function Pw(e, t) {
  return C(), O("div", Rw, [
    X(e.$slots, "default")
  ]);
}
const BM = /* @__PURE__ */ fe(Nw, [["render", Pw]]), kM = /* @__PURE__ */ j({
  __name: "RgTitle",
  props: {
    sizeClass: { default: "text-4xl" }
  },
  setup(e) {
    const t = e;
    return (n, a) => (C(), O("div", {
      class: J(t.sizeClass)
    }, [
      X(n.$slots, "default")
    ], 2));
  }
}), Fw = {}, Qw = { class: "text-xl" };
function Uw(e, t) {
  return C(), O("div", Qw, [
    X(e.$slots, "default")
  ]);
}
const _M = /* @__PURE__ */ fe(Fw, [["render", Uw]]);
function ri(e, t, n) {
  const a = (s) => {
    t(s);
  };
  n ? (ye(n, () => {
    n.value ? document.addEventListener(e, a) : document.removeEventListener(e, a);
  }), n.value && document.addEventListener(e, a)) : Uo(
    () => document.addEventListener(e, a)
  ), Mn(
    () => document.removeEventListener(e, a)
  );
}
let lo = 0, wn;
const rp = () => (wn || (wn = document.createElement("div"), document.body.append(wn)), wn), lu = () => wn || rp(), Gw = () => {
  wn == null || wn.remove(), wn = null;
};
function cl() {
  return Uo(() => {
    lo === 0 && rp(), lo++;
  }), Mn(() => {
    lo--, lo === 0 && Gw();
  }), {
    getElement: () => lu(),
    createChildElement: () => {
      const n = document.createElement("div");
      return lu().append(n), n;
    }
  };
}
const Yw = { class: "modalBackground" }, jw = {
  class: "p-dialog-header",
  style: { "border-top-right-radius": "20px", "border-top-left-radius": "20px" }
}, Hw = { class: "p-dialog-title" }, Vw = { class: "p-dialog-content" }, Kw = { class: "p-dialog-footer" }, Sa = /* @__PURE__ */ j({
  __name: "MModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: { default: "" },
    text: { default: "" },
    onClose: {},
    onClickOutside: {}
  },
  setup(e) {
    const t = e, { visible: n, onClose: a, onClickOutside: s } = ft(t), i = cl().getElement(), r = (c) => {
      var u;
      c.key === "Escape" && ((u = a == null ? void 0 : a.value) == null || u.call(a));
    };
    a != null && a.value && ri("keyup", r, n);
    const l = T(null);
    return s != null && s.value && ti(
      l,
      () => {
        var c;
        n.value && ((c = s.value) == null || c.call(s));
      },
      n
    ), (c, u) => k(n) ? (C(), H(Dp, {
      key: 0,
      to: k(i)
    }, [
      x("div", Yw, [
        x("div", {
          ref_key: "modalDiv",
          ref: l,
          class: "p-dialog p-component",
          style: { "user-select": "none" }
        }, [
          x("div", jw, [
            x("span", Hw, [
              X(c.$slots, "header", {}, () => [
                Te(P(e.header), 1)
              ])
            ]),
            k(a) ? (C(), O("button", {
              key: 0,
              class: "p-dialog-header-icon p-dialog-header-close p-link",
              onClick: u[0] || (u[0] = //@ts-ignore
              (...d) => k(a) && k(a)(...d))
            }, "✕")) : $("", !0)
          ]),
          x("div", Vw, [
            X(c.$slots, "default", {}, () => [
              Te(P(e.text), 1)
            ])
          ]),
          x("div", Kw, [
            x("div", null, [
              X(c.$slots, "actions")
            ])
          ])
        ], 512)
      ])
    ], 8, ["to"])) : $("", !0);
  }
}), Ww = {}, zw = {
  class: "p-button p-component p-button-text p-button-outlined",
  style: { display: "flex", "justify-content": "center", "align-items": "center" }
};
function $w(e, t) {
  return C(), O("button", zw, [
    X(e.$slots, "default")
  ]);
}
const ta = /* @__PURE__ */ fe(Ww, [["render", $w]]), qw = { style: { display: "flex", "justify-content": "center" } }, Jw = /* @__PURE__ */ j({
  __name: "MColorPickerModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    defaultColor: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s, defaultColor: o } = ft(n), i = T({
      r: o.value[0],
      g: o.value[1],
      b: o.value[2]
    }), r = () => {
      a("confirm", [i.value.r, i.value.g, i.value.b]);
    }, l = () => {
      a("cancel");
    }, c = T(null);
    return ye(s, async () => {
      var u;
      s.value && (await Tn(), (u = c.value) == null || u.$el.focus());
    }), Ge(() => {
      var u;
      s.value && ((u = c.value) == null || u.$el.focus());
    }), (u, d) => {
      const m = se("font-awesome-icon");
      return C(), H(Sa, {
        onClose: l,
        visible: k(s)
      }, {
        header: D(() => [
          X(u.$slots, "header", {}, () => [
            Te(P(e.header), 1)
          ])
        ]),
        default: D(() => [
          B(k(kr), {
            modelValue: i.value,
            "onUpdate:modelValue": d[0] || (d[0] = (g) => i.value = g),
            inline: !0,
            format: "rgb"
          }, null, 8, ["modelValue"])
        ]),
        actions: D(() => [
          x("div", qw, [
            B(ta, {
              ref_key: "okButtonRef",
              ref: c,
              onClick: r
            }, {
              default: D(() => [
                B(m, { icon: "check" }),
                Te(" " + P(u.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            B(ta, { onClick: l }, {
              default: D(() => [
                B(m, { icon: "times" }),
                Te(" " + P(u.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), Xw = { style: { display: "flex", "justify-content": "center" } }, Zw = /* @__PURE__ */ j({
  __name: "MConfirmModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {}
  },
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = ft(n), o = () => {
      a(
        "confirm"
        /* CONFIRM */
      );
    }, i = () => {
      a(
        "cancel"
        /* CANCEL */
      );
    }, r = T(null);
    return ye(s, async () => {
      var l;
      s.value && (await Tn(), (l = r.value) == null || l.$el.focus());
    }), Ge(() => {
      var l;
      s.value && ((l = r.value) == null || l.$el.focus());
    }), (l, c) => {
      const u = se("font-awesome-icon");
      return C(), H(Sa, {
        onClose: i,
        visible: k(s)
      }, {
        header: D(() => [
          X(l.$slots, "header", {}, () => [
            Te(P(e.header), 1)
          ])
        ]),
        default: D(() => [
          X(l.$slots, "default", {}, () => [
            Te(P(e.text), 1)
          ])
        ]),
        actions: D(() => [
          x("div", Xw, [
            B(ta, {
              ref_key: "okButtonRef",
              ref: r,
              onClick: o
            }, {
              default: D(() => [
                B(u, { icon: "check" }),
                Te(" " + P(l.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            B(ta, { onClick: i }, {
              default: D(() => [
                B(u, { icon: "times" }),
                Te(" " + P(l.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), eI = { key: 0 }, tI = /* @__PURE__ */ j({
  __name: "MDialog",
  props: {
    modelValue: {},
    visible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = T(e.modelValue), a = T(n.value.visible), s = () => {
      a.value = !0;
    }, o = () => {
      a.value = !1;
    }, i = U(() => n.value.btnModalCSS ? n.value.btnModalCSS !== "hidden" : !1);
    return (r, l) => (C(), O(me, null, [
      i.value ? (C(), O("div", eI, [
        B(NA, {
          class: "menu-item-tab-button-lg margin-t-10 test-NN",
          onClick: s
        }, {
          default: D(() => {
            var c;
            return [
              Te(P((c = n.value) == null ? void 0 : c.buttonLabel), 1)
            ];
          }),
          _: 1
        })
      ])) : $("", !0),
      B(k(Ru), {
        visible: a.value,
        "onUpdate:visible": l[0] || (l[0] = (c) => a.value = c),
        breakpoints: { "960px": "75vw" },
        style: { width: "50vw" },
        header: r.$t("medic-web-framework.header")
      }, {
        footer: D(() => [
          B(k(Vn), {
            class: "p-button-text",
            icon: "pi pi-times",
            label: r.$t("medic-web-framework.no"),
            onClick: o
          }, null, 8, ["label"]),
          B(k(Vn), {
            autofocus: "",
            icon: "pi pi-check",
            label: r.$t("medic-web-framework.yes"),
            onClick: o
          }, null, 8, ["label"])
        ]),
        default: D(() => [
          x("p", null, [
            X(r.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 8, ["visible", "header"])
    ], 64));
  }
}), SM = /* @__PURE__ */ fe(tI, [["__scopeId", "data-v-06912748"]]), nI = { style: { display: "flex", "justify-content": "center" } }, aI = /* @__PURE__ */ j({
  __name: "MInfoModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {}
  },
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = ft(n), o = () => {
      a("confirm");
    }, i = T(null);
    return ye(s, async () => {
      var r;
      s.value && (await Tn(), (r = i.value) == null || r.$el.focus());
    }), Ge(() => {
      var r;
      s.value && ((r = i.value) == null || r.$el.focus());
    }), (r, l) => {
      const c = se("font-awesome-icon");
      return C(), H(Sa, {
        onClose: o,
        visible: k(s)
      }, {
        header: D(() => [
          X(r.$slots, "header", {}, () => [
            Te(P(e.header), 1)
          ])
        ]),
        default: D(() => [
          X(r.$slots, "default", {}, () => [
            Te(P(e.text), 1)
          ])
        ]),
        actions: D(() => [
          x("div", nI, [
            B(ta, {
              ref_key: "okButtonRef",
              ref: i,
              onClick: o
            }, {
              default: D(() => [
                B(c, { icon: "check" }),
                Te(" " + P(r.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), sI = {
  class: "flex flex-row",
  style: { "justify-content": "space-around", "align-items": "baseline" }
}, oI = {
  key: 0,
  class: "flex"
}, iI = { style: { display: "flex", "justify-content": "center" } }, rI = /* @__PURE__ */ j({
  __name: "MTextInputModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    text: {},
    label: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = ft(n), o = T(n.text), i = T(null), r = () => {
      a("confirm", o.value);
    }, l = () => {
      a("cancel");
    }, c = T(null);
    return ye(s, async () => {
      var u, d;
      s.value && (await Tn(), ((u = i.value) == null ? void 0 : u.firstChild).focus(), ((d = i.value) == null ? void 0 : d.firstChild).select());
    }), Ge(() => {
      var u, d;
      s.value && (((u = i.value) == null ? void 0 : u.firstChild).focus(), ((d = i.value) == null ? void 0 : d.firstChild).select());
    }), (u, d) => (C(), H(Sa, {
      onClose: l,
      visible: k(s)
    }, {
      header: D(() => [
        X(u.$slots, "header", {}, () => [
          Te(P(e.header), 1)
        ])
      ]),
      default: D(() => [
        x("div", sI, [
          n.label ? (C(), O("div", oI, [
            X(u.$slots, "label", {}, () => [
              Te(P(e.label), 1)
            ])
          ])) : $("", !0),
          x("div", {
            class: "flex",
            ref_key: "textInputRef",
            ref: i
          }, [
            B(k(_r), {
              modelValue: o.value,
              "onUpdate:modelValue": d[0] || (d[0] = (m) => o.value = m),
              type: "text"
            }, null, 8, ["modelValue"])
          ], 512)
        ])
      ]),
      actions: D(() => [
        x("div", iI, [
          B(wt, {
            class: "btn-wizard-md mr-2",
            icon: "pi pi-check",
            ref_key: "okButtonRef",
            ref: c,
            onClick: r,
            label: u.$t("shared.ok")
          }, null, 8, ["label"]),
          B(wt, {
            class: "btn-wizard-md p-button-text",
            background: !1,
            outlined: !0,
            icon: "pi pi-times",
            label: u.$t("shared.cancel"),
            onClick: l
          }, null, 8, ["label"])
        ])
      ]),
      _: 3
    }, 8, ["visible"]));
  }
}), lI = { style: { "font-weight": "bold" } }, cI = { style: { "font-weight": "bold" } }, uI = { style: { display: "flex", "justify-content": "center" } }, dI = /* @__PURE__ */ j({
  __name: "MViewerHelpModal",
  props: {
    visible: { type: Boolean, default: !1 }
  },
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s } = ft(n), o = () => {
      a("confirm");
    }, i = T(null);
    return ye(s, async () => {
      var r;
      s.value && (await Tn(), (r = i.value) == null || r.$el.focus());
    }), Ge(() => {
      var r;
      s.value && ((r = i.value) == null || r.$el.focus());
    }), (r, l) => {
      const c = se("font-awesome-icon");
      return C(), H(Sa, {
        onClose: o,
        visible: k(s)
      }, {
        header: D(() => [
          X(r.$slots, "header", {}, () => [
            Te(P(r.$t("shared.help")), 1)
          ])
        ]),
        default: D(() => [
          x("div", null, [
            x("p", lI, P(r.$t("medic-web-framework.commonCommands")), 1),
            x("p", null, P(r.$t("medic-web-framework.leftMouseDragRotate")), 1),
            x("p", null, P(r.$t("medic-web-framework.mouseWheelZoom")), 1),
            x("p", null, P(r.$t("medic-web-framework.rightMouseDragZoom")), 1),
            x("p", null, P(r.$t("medic-web-framework.middleMouseDragPan")), 1),
            x("p", null, P(r.$t("medic-web-framework.leftRightMouseDragPan")), 1),
            x("p", null, P(r.$t("medic-web-framework.middleMouseClickCenter")), 1),
            x("p", null, P(r.$t("medic-web-framework.rightMouseClickObjectMenu")), 1),
            l[0] || (l[0] = x("br", null, null, -1)),
            x("p", cI, P(r.$t("medic-web-framework.inspectionMode")), 1),
            x("p", null, P(r.$t("medic-web-framework.leftMouseClickCenter")), 1),
            x("p", null, P(r.$t("medic-web-framework.mouseWheelOnInspectionWindowChangePlane")), 1),
            x("p", null, P(r.$t("medic-web-framework.clickOnObjectListItemCenter")), 1),
            x("p", null, P(r.$t("medic-web-framework.dragTheEdgesOfTheInspectionIndicatorToRotateThePlaneDragTheBlueArrowInTheTopRightCornerOfTheInspectionIndicatorToChangePlane")), 1),
            x("p", null, P(r.$t("medic-web-framework.gridSizeOnTheInspectionWindowIsMm")), 1),
            l[1] || (l[1] = x("br", null, null, -1)),
            x("p", null, P(r.$t("medic-web-framework.clickTheOrientationHeadIndicatorInTheBottomLeftCornerToChangeTheOrientation")), 1)
          ])
        ]),
        actions: D(() => [
          x("div", uI, [
            B(ta, {
              ref_key: "okButtonRef",
              ref: i,
              onClick: o
            }, {
              default: D(() => [
                B(c, { icon: "check" }),
                Te(" " + P(r.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), fI = /* @__PURE__ */ j({
  __name: "MUErrorModal",
  emits: ["confirm", "reject", "cancel"],
  setup(e, { emit: t }) {
    const n = Ht("dialogRef"), a = n.value.data, s = t, o = T(ke("shared.ok")), i = T(!0), r = T(!0), l = T(ke("shared.cancel")), c = T(ke("shared.cancel"));
    Ge(() => {
      a.showYesNo && (o.value = ke("medic-web-framework.yes"), l.value = ke("medic-web-framework.no")), a.showCancel || (i.value = !1), a.showAll || (r.value = !1);
    });
    const u = () => {
      s("confirm"), n.value.close();
    }, d = () => {
      s("reject"), n.value.close();
    }, m = () => {
      s("cancel"), n.value.close();
    };
    return (g, h) => (C(), O(me, null, [
      B(ae, { style: { "flex-direction": "column" } }, {
        default: D(() => [
          B(ae, { style: { "white-space": "pre-wrap", "justify-content": "start", "padding-bottom": "2rem", "padding-top": "2rem" } }, {
            default: D(() => [
              X(g.$slots, "default", {}, () => [
                Te(P(k(a).message), 1)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      B(ae, { class: "p-dialog-footer justify-center" }, {
        default: D(() => [
          B(k(ni), {
            autofocus: "",
            class: "mt-6",
            label: o.value,
            onClick: h[0] || (h[0] = (A) => u())
          }, null, 8, ["label"]),
          i.value ? (C(), H(k(Lo), {
            key: 0,
            class: "mt-6",
            label: l.value,
            onClick: d
          }, null, 8, ["label"])) : $("", !0),
          r.value ? (C(), H(k(Lo), {
            key: 1,
            class: "mt-6",
            label: c.value,
            onClick: m
          }, null, 8, ["label"])) : $("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), DM = /* @__PURE__ */ j({
  __name: "MUSelectModal",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Ht("dialogRef"), a = n.value.data, s = t, { t: o } = Nn(), i = T("OK"), r = T(!0), l = T("Cancel"), c = T(a.options.length > 0 ? a.options[0] : "");
    Ge(() => {
      a.showYesNo && (i.value = o("medic-web-framework.yes"), l.value = o("medic-web-framework.no")), a.showCancel || (r.value = !1);
    });
    const u = () => {
      s("confirm", c.value), n.value.close();
    }, d = () => {
      s("reject"), n.value.close();
    };
    return (m, g) => (C(), O(me, null, [
      B(ae, { style: { "flex-direction": "column" } }, {
        default: D(() => [
          B(k(Yo), {
            modelValue: c.value,
            "onUpdate:modelValue": g[0] || (g[0] = (h) => c.value = h),
            options: k(a).options,
            class: "grow mt-1 w-full"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      B(ae, { class: "p-dialog-footer justify-center" }, {
        default: D(() => [
          B(k(Lo), {
            autofocus: "",
            class: "mt-6",
            label: i.value,
            onClick: g[1] || (g[1] = (h) => u())
          }, null, 8, ["label"]),
          r.value ? (C(), H(k(ni), {
            key: 0,
            class: "mt-6",
            label: l.value,
            onClick: d
          }, null, 8, ["label"])) : $("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), bo = jo();
class pI {
  async input(t) {
    return new Promise((n) => {
      bo.emit("show", {
        options: t,
        resolve: n
      });
    });
  }
}
const mI = {
  key: 0,
  class: "p-error"
}, TM = /* @__PURE__ */ j({
  __name: "InputDialog",
  setup(e) {
    const t = T(!1);
    let n = un({
      title: "",
      message: "",
      acceptLabel: "",
      rejectLabel: "",
      inputValue: "",
      showing: !1,
      okCancelLayout: void 0,
      dismissableMask: void 0
    }), a = null;
    function s(l) {
      a && (a(l), a = null), n.inputValue = "", t.value = !1;
    }
    async function o(l) {
      bo.emit("validate-input", l);
    }
    async function i() {
      s(n.inputValue || "");
    }
    function r() {
      s();
    }
    return bo.on("show", (l) => {
      t.value = !0, Object.assign(n, l.options), a = l.resolve;
    }), bo.on("validate-result", (l) => {
      try {
        n.invalid = !l.valid, n.invalidMsg = l.message;
      } catch {
        throw Error("Check InputEventBus.on function in InputDialog.vue");
      }
    }), ye(
      () => t.value,
      () => {
        t.value == !1 && a && s();
      }
    ), (l, c) => {
      const u = se("InputText"), d = se("Dialog");
      return C(), H(d, {
        visible: t.value,
        "onUpdate:visible": c[1] || (c[1] = (m) => t.value = m),
        header: k(n).title,
        modal: !0,
        dismissableMask: k(n).dismissableMask ?? !1,
        onKeyup: Is(i, ["enter"])
      }, {
        footer: D(() => [
          B(xf, {
            acceptLabel: k(n).acceptLabel,
            rejectLabel: k(n).rejectLabel,
            disabled: k(n).invalid,
            onAccept: i,
            onReject: r
          }, null, 8, ["acceptLabel", "rejectLabel", "disabled"])
        ]),
        default: D(() => [
          B(ls, { class: "gap-16px" }, {
            default: D(() => [
              x("span", null, P(k(n).message), 1),
              B(u, {
                modelValue: k(n).inputValue,
                "onUpdate:modelValue": c[0] || (c[0] = (m) => k(n).inputValue = m),
                class: J([k(n).invalid ? "p-invalid" : ""]),
                autofocus: "true",
                onInput: o
              }, null, 8, ["modelValue", "class"]),
              k(n).invalid ? (C(), O("small", mI, P(k(n).invalidMsg), 1)) : $("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible", "header", "dismissableMask"]);
    };
  }
}), AI = {}, gI = { class: "w-full h-full flex justify-center items-center" }, hI = { class: "flex flex-col" }, vI = { class: "text-white text-3xl font-bold pt-12" };
function yI(e, t) {
  return C(), O("div", gI, [
    x("div", hI, [
      x("div", vI, [
        X(e.$slots, "default")
      ])
    ])
  ]);
}
const MM = /* @__PURE__ */ fe(AI, [["render", yI]]), bI = j({
  name: "MColorPicker",
  props: {
    color: {
      type: String,
      required: !0
    }
  },
  emits: ["colorValueChanged"],
  components: {
    ColorPicker: kr
  },
  setup(e, { emit: t }) {
    const n = T(e.color);
    return {
      colorPicker: n,
      getColorValue: () => {
        t("colorValueChanged", n.value);
      }
    };
  }
});
function xI(e, t, n, a, s, o) {
  const i = se("ColorPicker");
  return C(), H(i, {
    modelValue: e.colorPicker,
    "onUpdate:modelValue": t[0] || (t[0] = (r) => e.colorPicker = r),
    defaultColor: "ff0000",
    onChange: e.getColorValue
  }, null, 8, ["modelValue", "onChange"]);
}
const LM = /* @__PURE__ */ fe(bI, [["render", xI]]), EI = {}, CI = { class: "flex split" };
function wI(e, t) {
  return C(), O("div", CI, [
    X(e.$slots, "default")
  ]);
}
const OM = /* @__PURE__ */ fe(EI, [["render", wI]]), II = { class: "font-semibold" }, BI = { class: "mt-6 mb-0" }, kI = /* @__PURE__ */ j({
  __name: "MFileUpload",
  props: /* @__PURE__ */ It({
    multiple: { type: Boolean, default: !1 },
    fileLimit: { default: 1e7 },
    placeholder: { default: "Drag and drop files to here to add object." },
    accept: { default: ".stl,.ply,.obj,.estl,.xstl,.png,.jpg,.jpeg" },
    maxFileSize: { default: 1e8 },
    showUploadButton: { type: Boolean, default: !1 },
    showRemoveButton: { type: Boolean, default: !1 }
  }, {
    removeFiles: { type: Boolean, required: !1, default: !1 },
    removeFilesModifiers: {}
  }),
  emits: /* @__PURE__ */ It(["fileSelection", "removeSelection", "uploadEvent"], ["update:removeFiles"]),
  setup(e, { emit: t }) {
    const n = e, a = t, s = Ie(e, "removeFiles"), o = T([]), i = T(0), r = T(0), l = T(0), c = () => {
      i.value = 0, l.value = 0;
    }, u = (h, A, f) => {
      A(f), i.value -= parseInt(Bl(h.size)), l.value = i.value / 10, o.value = [], r.value = Math.random() * 100, a("removeSelection");
    }, d = (h) => {
      o.value = h.files, a("fileSelection", o.value);
    }, m = () => {
      a("uploadEvent", o.value);
    };
    ye(s, () => {
      s.value && (o.value = [], r.value = Math.random() * 100);
    });
    const g = U(() => o.value ? o.value.length > 0 : 0);
    return (h, A) => {
      const f = se("Button"), p = se("FileUpload");
      return C(), H(p, {
        name: "demo[]",
        customUpload: !0,
        onUpload: c,
        multiple: n.multiple,
        fileLimit: n.fileLimit,
        accept: n.accept,
        "max-file-size": n.maxFileSize,
        onSelect: d,
        key: r.value
      }, {
        header: D(({ chooseCallback: v, clearCallback: b, files: y }) => [
          B(ae, { class: "flex-wrap justify-between items-center flex-1 gap-2" }, {
            default: D(() => [
              B(ae, { class: "gap-2 -mt-1 -ml-1" }, {
                default: D(() => [
                  B(f, {
                    onClick: (_) => v(),
                    icon: "pi pi-plus",
                    class: J([g.value ? "opacity-40 pointer-events-none" : "", "p-button-rounded"])
                  }, null, 8, ["onClick", "class"]),
                  n.showUploadButton ? (C(), H(f, {
                    key: 0,
                    onClick: m,
                    icon: "pi pi-cloud-upload",
                    class: "p-button-rounded p-button-success",
                    disabled: !y || !g.value
                  }, null, 8, ["disabled"])) : $("", !0),
                  n.showRemoveButton ? (C(), H(f, {
                    key: 1,
                    onClick: (_) => b(),
                    icon: "pi pi-times",
                    class: "p-button-rounded p-button-danger",
                    disabled: !y || !g.value
                  }, null, 8, ["onClick", "disabled"])) : $("", !0)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        content: D(({ files: v, removeUploadedFileCallback: b }) => [
          g.value ? (C(), H(ae, {
            key: 0,
            class: "justify-center items-center h-full"
          }, {
            default: D(() => [
              B(ae, { class: "flex-wrap p-0 sm:p-20 gap-20 justify-center" }, {
                default: D(() => [
                  (C(!0), O(me, null, qe(v, (y, _) => (C(), H(ae, {
                    key: y.name + y.type + y.size,
                    class: "card m-0 px-12 flex-col border border-surface items-center gap-6 mt-2",
                    style: { background: "#ffffff0d !important" }
                  }, {
                    default: D(() => [
                      x("span", II, P(y.name), 1),
                      x("div", null, P(k(Bl)(y.size)), 1),
                      B(f, {
                        icon: "pi pi-times",
                        onClick: (M) => u(y, b, _),
                        class: "p-button-outlined p-button-danger p-button-rounded"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)) : $("", !0)
        ]),
        empty: D(() => [
          B(ae, { class: "items-center justify-center flex-col mt-6" }, {
            default: D(() => [
              A[0] || (A[0] = x("i", {
                class: "pi pi-cloud-upload border-2 rounded-full",
                style: { "font-size": "5rem", padding: "2.5rem" }
              }, null, -1)),
              x("p", BI, P(n.placeholder), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["multiple", "fileLimit", "accept", "max-file-size"]);
    };
  }
}), NM = /* @__PURE__ */ fe(kI, [["__scopeId", "data-v-d4c7e5cc"]]), _I = j({
  props: {
    title: String
  }
}), SI = { class: "min-w-0 text-xs" }, DI = { class: "border-b whitespace-nowrap overflow-hidden overflow-ellipsis" }, TI = { class: "h-4 overflow-hidden overflow-ellipsis" };
function MI(e, t, n, a, s, o) {
  return C(), O("div", SI, [
    x("div", DI, P(e.title), 1),
    x("div", TI, [
      X(e.$slots, "default")
    ])
  ]);
}
const RM = /* @__PURE__ */ fe(_I, [["render", MI]]), PM = /* @__PURE__ */ j({
  __name: "MInputNumber",
  props: {
    modelValue: { default: 0 },
    cssClass: { default: "" },
    mode: { default: "decimal" },
    step: { default: 1 },
    min: { default: 0 },
    max: { default: 1e4 },
    showButtons: { type: Boolean, default: !0 },
    useGrouping: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { modelValue: s, mode: o, step: i, min: r, max: l, showButtons: c, cssClass: u } = ft(n), d = (m) => {
      a("update:modelValue", m);
    };
    return (m, g) => (C(), H(k(Go), {
      class: J(k(u)),
      max: k(l),
      min: k(r),
      mode: k(o),
      modelValue: k(s),
      showButtons: k(c),
      step: k(i),
      "use-grouping": e.useGrouping,
      "onUpdate:modelValue": d
    }, null, 8, ["class", "max", "min", "mode", "modelValue", "showButtons", "step", "use-grouping"]));
  }
}), LI = /* @__PURE__ */ j({
  __name: "MListComponent",
  props: {
    model: {},
    modelValue: {},
    listStyle: {},
    filterPlaceholder: {},
    disableScrollIntoView: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "userChange"],
  setup(e, { emit: t }) {
    const n = T(null), a = e, s = t, { model: o, disableScrollIntoView: i } = ft(a), r = T(null);
    qn(() => {
      r.value = a.modelValue ?? null, a.modelValue && !i.value && l();
    });
    function l() {
      const u = n.value, d = o.value.findIndex((m) => {
        var g;
        return m.name === ((g = a.modelValue) == null ? void 0 : g.name);
      });
      u && d !== -1 && Tn(() => {
        var g;
        let m = (g = u.list) == null ? void 0 : g.children;
        if (m) {
          const h = m[d];
          h && h.scrollIntoView({ behavior: "auto", block: "start", container: "nearest" });
        }
      });
    }
    ye(r, () => {
      s("input", k(r.value)), s("update:modelValue", k(r.value));
    });
    function c() {
      s("userChange", k(r.value));
    }
    return (u, d) => (C(), H(k(Uu), {
      modelValue: r.value,
      "onUpdate:modelValue": d[0] || (d[0] = (m) => r.value = m),
      filter: !0,
      "list-style": a.listStyle,
      options: k(o),
      class: "list-box",
      filterPlaceholder: a.filterPlaceholder,
      optionLabel: "name",
      ref_key: "listBoxRef",
      ref: n,
      style: { background: "var(--p-rg-component-background-color) !important" },
      onKeydown: d[1] || (d[1] = xt(() => {
      }, ["stop"])),
      onKeypress: d[2] || (d[2] = xt(() => {
      }, ["stop"])),
      onChange: c
    }, {
      loader: D(() => [
        x("span", null, P(u.$t("shared.loading")), 1)
      ]),
      empty: D(() => [
        X(u.$slots, "empty", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["modelValue", "list-style", "options", "filterPlaceholder"]));
  }
}), FM = /* @__PURE__ */ fe(LI, [["__scopeId", "data-v-212c786f"]]), OI = { class: "w-full h-full flex justify-center items-center vertical-center horizontal-center" }, NI = { class: "flex flex-col" }, RI = { class: "w-full text-2xl text-bold font-bold pt-12" }, QM = /* @__PURE__ */ j({
  __name: "MLoading",
  props: {
    strokeWidth: {},
    hideSpinner: { type: Boolean }
  },
  setup(e) {
    const t = e;
    let n = T(2);
    return qn(() => {
      t.strokeWidth && (n.value = t.strokeWidth);
    }), (a, s) => (C(), O("div", OI, [
      x("div", NI, [
        e.hideSpinner ? $("", !0) : (C(), H(k(oA), {
          key: 0,
          animationDuration: "0.6s",
          class: "p-progress-spinner-circle",
          strokeWidth: k(n).toString()
        }, null, 8, ["strokeWidth"])),
        x("div", RI, [
          X(a.$slots, "default")
        ])
      ])
    ]));
  }
}), PI = j({
  props: {
    value: Number,
    animate: Boolean,
    showValue: Boolean
  }
});
function FI(e, t, n, a, s, o) {
  const i = se("ProgressBar");
  return C(), H(i, {
    "show-value": e.showValue,
    value: e.value,
    pt: { value: { style: { transition: "none" } } }
  }, null, 8, ["show-value", "value"]);
}
const UM = /* @__PURE__ */ fe(PI, [["render", FI]]), QI = j({
  props: {
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = T(!1), a = () => {
      n.value = !1;
    }, s = () => {
      n.value = !n.value;
    }, o = T(null);
    ti(o, a, n), ri(
      "keyup",
      (u) => {
        u.key === "Escape" && a();
      },
      n
    );
    const i = () => {
      e.disabled || s();
    }, r = (u) => {
      t("update:modelValue", u), a();
    }, l = T(null), c = U(() => l.value ? "calc(100vh - " + l.value.getBoundingClientRect().bottom + "px - 2px)" : "");
    return {
      root: o,
      select: l,
      menuVisible: n,
      onClick: i,
      onSelect: r,
      dropdownMaxHeight: c
    };
  }
}), UI = {
  ref: "root",
  class: "relative w-48"
}, GI = { class: "overflow-hidden overflow-ellipsis whitespace-nowrap" }, YI = ["onClick"], jI = { class: "overflow-hidden overflow-ellipsis whitespace-nowrap" };
function HI(e, t, n, a, s, o) {
  const i = se("font-awesome-icon");
  return C(), O("div", UI, [
    x("div", {
      ref: "select",
      class: J([{ "border-gray-300 text-gray-300": e.disabled }, "h-8 border px-2 py-1 flex justify-between items-center"]),
      onClick: t[0] || (t[0] = (r) => e.onClick())
    }, [
      x("div", GI, P(e.modelValue), 1),
      B(i, {
        class: "ml-1",
        icon: "caret-down"
      })
    ], 2),
    e.menuVisible ? (C(), O("div", {
      key: 0,
      style: Le({ maxHeight: e.dropdownMaxHeight }),
      class: "absolute inset-x-0 z-10 border border-t-0 overflow-y-auto select-none"
    }, [
      (C(!0), O(me, null, qe(e.options, (r, l) => (C(), O("div", {
        key: l,
        class: "flex items-center w-full min-w-0 px-2 py-1 bg-not-selected hover:bg-selected",
        onClick: (c) => e.onSelect(r)
      }, [
        x("div", jI, P(r), 1)
      ], 8, YI))), 128))
    ], 4)) : $("", !0)
  ], 512);
}
const GM = /* @__PURE__ */ fe(QI, [["render", HI]]), VI = {
  class: "flex flex-row gap-3",
  style: { "align-items": "center" }
}, KI = {
  key: 3,
  class: "flex",
  style: { "flex-grow": "1", "flex-shrink": "1", "flex-basis": "60px" }
}, WI = /* @__PURE__ */ j({
  __name: "MSlider",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    disabled: { type: Boolean, default: !1 },
    hideValueInput: { type: Boolean, default: !1 },
    scrollable: { type: Boolean },
    fractionDigits: {},
    showButtons: { type: Boolean },
    label: {},
    unitLabel: {},
    textSizeClass: {},
    smallFont: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, a = T(0), s = t;
    function o(h) {
      return Number(Wu(h));
    }
    const { fractionDigits: i, step: r } = ft(n), l = U(() => i.value != null ? i.value : o(r.value));
    qn(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ge(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), ye(
      () => a,
      () => {
        s("update:modelValue", a.value), c(a.value);
      },
      { deep: !0 }
    );
    const c = (h) => {
      s("change", h);
    }, u = Math.floor(n.step) === n.step ? 0 : n.step.toString().split(".")[1].length || 0, d = (h) => {
      n.scrollable && h.deltaY !== 0 && (h.deltaY < 0 ? m() : g(), h.preventDefault());
    }, m = () => {
      a.value = Number(Math.min(a.value + n.step, n.max).toFixed(u)), c(a.value);
    }, g = () => {
      a.value = Number(Math.max(a.value - n.step, n.min).toFixed(u)), c(a.value);
    };
    return (h, A) => (C(), O("div", VI, [
      n.label ? (C(), H(ae, { key: 0 }, {
        default: D(() => [
          x("span", {
            class: J([n.textSizeClass ? e.textSizeClass : "text-sm", "ml-1"]),
            style: { "user-select": "none" }
          }, P(n.label), 3)
        ]),
        _: 1
      })) : $("", !0),
      n.showButtons ? (C(), H(wt, {
        key: 1,
        disabled: n.disabled,
        "is-toolbar-button": !0,
        icon: "pi pi-minus",
        onClick: g,
        iconFont: "1.3rem",
        style: { height: "24px !important", width: "24px !important", "border-radius": "8px", padding: "0" }
      }, null, 8, ["disabled"])) : $("", !0),
      x("div", Ir(Lu({ wheel: e.scrollable ? d : null }, !0), { style: { display: "flex", "align-items": "center", "flex-grow": "5", "flex-shrink": "1", "flex-basis": "0" } }), [
        B(k(Sr), {
          modelValue: a.value,
          "onUpdate:modelValue": A[0] || (A[0] = (f) => a.value = f),
          max: n.max,
          min: n.min,
          step: n.step,
          class: "w-full",
          disabled: n.disabled,
          onChange: c
        }, null, 8, ["modelValue", "max", "min", "step", "disabled"])
      ], 16),
      n.showButtons ? (C(), H(wt, {
        key: 2,
        disabled: n.disabled,
        "is-toolbar-button": !0,
        icon: "pi pi-plus",
        onClick: m,
        iconFont: "1.3rem",
        style: { height: "24px !important", width: "24px !important", "border-radius": "8px", padding: "0" }
      }, null, 8, ["disabled"])) : $("", !0),
      n.hideValueInput ? $("", !0) : (C(), O("div", KI, [
        B(k(Go), {
          modelValue: a.value,
          "onUpdate:modelValue": A[1] || (A[1] = (f) => a.value = f),
          step: n.step,
          disabled: n.disabled,
          min: n.min,
          max: n.max,
          suffix: e.unitLabel,
          "min-fraction-digits": l.value,
          "max-fraction-digits": l.value,
          fluid: "",
          pt: {
            pcInputText: {
              root: {
                style: {
                  height: "28px !important",
                  fontSize: e.smallFont ? "0.75rem" : "0.875rem",
                  lineSize: "1.25rem"
                }
              }
            }
          },
          style: { height: "28px !important" }
        }, null, 8, ["modelValue", "step", "disabled", "min", "max", "suffix", "min-fraction-digits", "max-fraction-digits", "pt"])
      ]))
    ]));
  }
}), YM = /* @__PURE__ */ fe(WI, [["__scopeId", "data-v-7a2824fe"]]), zI = {
  class: "flex flex-row gap-1",
  style: { "align-items": "center" }
}, $I = {
  key: 1,
  class: "flex",
  style: { "flex-grow": "1", "flex-shrink": "1", "flex-basis": "35px" }
}, qI = /* @__PURE__ */ j({
  __name: "MSliderFixedWidth",
  props: {
    modelValue: {},
    min: {},
    max: {},
    step: {},
    disabled: { type: Boolean, default: !1 },
    hideValueInput: { type: Boolean, default: !1 },
    scrollable: { type: Boolean },
    fractionDigits: {},
    showButtons: { type: Boolean },
    label: {},
    unitLabel: {},
    textSizeClass: {},
    longStrings: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, a = T(0), s = t;
    function o(m) {
      return Number(Wu(m));
    }
    const i = T(n.fractionDigits != null ? n.fractionDigits : o(n.step));
    qn(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), Ge(() => {
      (n.modelValue || n.modelValue == 0) && (a.value = n.modelValue);
    }), ye(
      () => a,
      () => {
        s("update:modelValue", a.value);
      },
      { deep: !0 }
    );
    const r = (m) => {
      s("change", m);
    }, l = Math.floor(n.step) === n.step ? 0 : n.step.toString().split(".")[1].length || 0, c = (m) => {
      n.scrollable && m.deltaY !== 0 && (m.deltaY < 0 ? u() : d());
    }, u = () => {
      a.value = Number(Math.min(a.value + n.step, n.max).toFixed(l)), r(a.value);
    }, d = () => {
      a.value = Number(Math.max(a.value - n.step, n.min).toFixed(l)), r(a.value);
    };
    return (m, g) => (C(), O("div", zI, [
      n.label ? (C(), H(ae, {
        key: 0,
        class: J([(e.longStrings, "col-4 no-padding")])
      }, {
        default: D(() => [
          x("span", {
            class: J([n.textSizeClass ? e.textSizeClass : "text-sm", "ml-1"]),
            style: { "user-select": "none" }
          }, P(n.label), 3)
        ]),
        _: 1
      }, 8, ["class"])) : $("", !0),
      B(ae, {
        class: J([(e.longStrings, "col-4")])
      }, {
        default: D(() => [
          n.showButtons ? (C(), H(wt, {
            key: 0,
            disabled: n.disabled,
            "is-toolbar-button": !0,
            icon: "pi pi-minus",
            onClick: d,
            "icon-src-height": "21px",
            "icon-src-width": "21px",
            style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
          }, null, 8, ["disabled"])) : $("", !0),
          x("div", Ir(Lu({ wheel: e.scrollable ? c : null }, !0), { style: { display: "flex", "align-items": "center", "flex-grow": "5", "flex-shrink": "1", "flex-basis": "0" } }), [
            B(k(Sr), {
              modelValue: a.value,
              "onUpdate:modelValue": g[0] || (g[0] = (h) => a.value = h),
              max: n.max,
              min: n.min,
              step: n.step,
              class: "w-full",
              disabled: n.disabled,
              onChange: r
            }, null, 8, ["modelValue", "max", "min", "step", "disabled"])
          ], 16),
          n.showButtons ? (C(), H(wt, {
            key: 1,
            disabled: n.disabled,
            "is-toolbar-button": !0,
            icon: "pi pi-plus",
            onClick: u,
            "icon-src-height": "21px",
            "icon-src-width": "21px",
            style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
          }, null, 8, ["disabled"])) : $("", !0)
        ]),
        _: 1
      }, 8, ["class"]),
      n.hideValueInput ? $("", !0) : (C(), O("div", $I, [
        B(k(Go), {
          modelValue: a.value,
          "onUpdate:modelValue": g[1] || (g[1] = (h) => a.value = h),
          step: n.step,
          disabled: n.disabled,
          min: n.min,
          max: n.max,
          suffix: e.unitLabel,
          "min-fraction-digits": i.value,
          "max-fraction-digits": i.value,
          fluid: "",
          pt: {
            pcInputText: {
              root: {
                style: {
                  height: "28px !important",
                  fontSize: "0.875rem",
                  lineSize: "1.25rem"
                }
              }
            }
          },
          style: { height: "28px !important" }
        }, null, 8, ["modelValue", "step", "disabled", "min", "max", "suffix", "min-fraction-digits", "max-fraction-digits"])
      ]))
    ]));
  }
}), jM = /* @__PURE__ */ fe(qI, [["__scopeId", "data-v-16493cc9"]]), JI = { class: "items-center justify-center flex mt-1 text-light-gray" }, HM = /* @__PURE__ */ j({
  __name: "MStepper",
  props: {
    steps: { required: !0 },
    stepsModifiers: {},
    activeStepSortOrder: { required: !1, default: 1 },
    activeStepSortOrderModifiers: {}
  },
  emits: ["update:steps", "update:activeStepSortOrder"],
  setup(e) {
    const t = Ie(e, "steps"), n = Ie(e, "activeStepSortOrder");
    return (a, s) => {
      const o = se("Divider");
      return C(), H(k(lA), { value: n.value }, {
        default: D(() => [
          B(k(iA), {
            class: "w-full grow flex",
            pt: { root: { "data-pc-name": "wkStepList" } },
            "data-cy": "wkStepList"
          }, {
            default: D(() => [
              (C(!0), O(me, null, qe(t.value, (i, r) => (C(), H(k(rA), {
                disabled: !0,
                asChild: "",
                value: i.id,
                key: i.id
              }, {
                default: D(() => [
                  B(ae, null, {
                    default: D(() => [
                      B(ls, null, {
                        default: D(() => [
                          s[0] || (s[0] = x("button", { class: "px-4" }, [
                            x("span", {
                              class: J([
                                "rounded-full border-2 w-12 h-12 inline-flex items-center justify-center",
                                {
                                  "text-primary-contrast border-primary": !0
                                }
                              ])
                            }, [
                              x("span", { class: "circle" })
                            ])
                          ], -1)),
                          x("span", JI, P(i.name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      r + 1 != t.value.length ? (C(), H(o, {
                        key: 0,
                        class: J(["-mt-2", (t.value.length ?? 0) > 4 ? "w-70px" : "w-120px"]),
                        style: { color: "var(--primary-color)" }
                      }, null, 8, ["class"])) : $("", !0)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]);
    };
  }
}), VM = /* @__PURE__ */ j({
  __name: "MSwitch",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ie(e, "modelValue");
    return (n, a) => {
      const s = se("InputSwitch");
      return C(), O("div", null, [
        B(s, {
          modelValue: t.value.state,
          "onUpdate:modelValue": a[0] || (a[0] = (o) => t.value.state = o),
          disabled: t.value.disabled,
          onClick: a[1] || (a[1] = (o) => t.value.clicked = !0)
        }, null, 8, ["modelValue", "disabled"])
      ]);
    };
  }
}), XI = /* @__PURE__ */ j({
  __name: "MSwitchStyled",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    Br((a) => ({
      e53cb5bc: n.value
    }));
    const t = Ie(e, "modelValue"), n = U(() => t.value.state ? "#43c261" : "var(--webcad-primary-text-color)");
    return (a, s) => (C(), O("div", null, [
      B(k(Qu), {
        modelValue: t.value.state,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => t.value.state = o),
        disabled: t.value.disabled
      }, null, 8, ["modelValue", "disabled"])
    ]));
  }
}), KM = /* @__PURE__ */ fe(XI, [["__scopeId", "data-v-f8baae53"]]), ZI = {}, eB = { class: "card flex" }, tB = { class: "flex flex-col w-full h-full" };
function nB(e, t) {
  return C(), O("div", eB, [
    x("div", tB, [
      X(e.$slots, "header"),
      X(e.$slots, "tabs"),
      X(e.$slots, "default")
    ])
  ]);
}
const WM = /* @__PURE__ */ fe(ZI, [["render", nB]]), aB = {
  class: "m-tab-item-link",
  role: "presentation"
}, sB = { class: "m-tab-item-text" }, zM = /* @__PURE__ */ j({
  __name: "MTabItem",
  props: /* @__PURE__ */ It({
    index: {}
  }, {
    state: { required: !0 },
    stateModifiers: {}
  }),
  emits: ["update:state"],
  setup(e) {
    const t = e, n = Ie(e, "state"), a = () => {
      n.value = t.index;
    };
    return (s, o) => (C(), O("li", {
      class: J([{ "m-tab-item-selected": n.value === t.index }, "m-tab-item"]),
      role: "tab",
      onClick: a
    }, [
      x("a", aB, [
        x("span", sB, [
          X(s.$slots, "default")
        ]),
        x("span", null, [
          X(s.$slots, "after")
        ])
      ])
    ], 2));
  }
}), oB = j({
  props: {
    // eslint-disable-next-line no-undef
    id: {
      type: Number,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    imgSrc: {
      type: String,
      required: !0
    },
    index: Number,
    selected: Boolean
  },
  setup(e, { emit: t }) {
    const n = T("bg-purple-500"), a = U(() => e.imgSrc);
    return qn(() => {
      e.id == e.index ? n.value = "p-highlight" : n.value = "";
    }), {
      cssClass: n,
      cIconSrc: a,
      onClick: () => {
        t("update:modelValue", e.index);
      }
    };
  }
}), iB = { class: "product-item" }, rB = { class: "image-container" }, lB = ["src"], cB = { class: "product-list-detail" }, uB = { class: "flex justify-center flex-wrap text-3xl font-semibold text-center" };
function dB(e, t, n, a, s, o) {
  return C(), O("li", {
    class: J([{ "p-highlight": e.selected }, "p-orderlist-item pointer"]),
    "aria-selected": "false",
    role: "option",
    tabindex: "0"
  }, [
    x("div", iB, [
      x("div", rB, [
        x("img", {
          isMenuIcon: !0,
          src: e.cIconSrc,
          draggable: "false"
        }, null, 8, lB)
      ]),
      x("div", cB, [
        x("span", uB, P(e.name), 1)
      ])
    ]),
    t[0] || (t[0] = x("span", {
      class: "p-ink",
      style: { height: "2085px", width: "2085px", top: "-967.667px", left: "-635.5px" }
    }, null, -1))
  ], 2);
}
const fB = /* @__PURE__ */ fe(oB, [["render", dB]]), pB = { class: "p-orderlist p-component h-full" }, mB = {
  key: 0,
  class: "p-orderlist-controls"
}, AB = { class: "p-orderlist-list-container h-full" }, gB = {
  key: 0,
  class: "p-orderlist-header"
}, hB = {
  "aria-multiselectable": !0,
  class: "p-orderlist-list",
  role: "listbox"
}, $M = /* @__PURE__ */ j({
  __name: "MTemplates",
  props: {
    templates: {},
    showControls: { type: Boolean, default: !0 },
    header: { default: "" }
  },
  emits: ["selectionChanged"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = T(), o = (l, c) => {
      s.value !== c && (s.value = c, a("selectionChanged", l ?? {}));
    }, i = (l, c) => {
      o(l, c);
    }, { templates: r } = ft(n);
    return (l, c) => (C(), O("div", pB, [
      e.showControls ? (C(), O("div", mB, [...c[0] || (c[0] = [
        Tp('<button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-up p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-double-up p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-down p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button><button class="p-button p-component p-button-icon-only" type="button"><span class="pi pi-angle-double-down p-button-icon"></span><span class="p-button-label"> </span><span class="p-ink"></span></button>', 4)
      ])])) : $("", !0),
      x("div", AB, [
        e.header ? (C(), O("div", gB, P(e.header), 1)) : $("", !0),
        x("ul", hB, [
          (C(!0), O(me, null, qe(k(r), (u) => (C(), H(fB, {
            key: u.id,
            id: Number(u.id),
            imgSrc: u.image ?? "",
            name: u.name,
            selected: u.id == s.value,
            onClick: (d) => i(u, Number(u.id))
          }, null, 8, ["id", "imgSrc", "name", "selected", "onClick"]))), 128))
        ])
      ])
    ]));
  }
}), vB = { class: "flex items-center gap-2" }, yB = { class: "text-2xl" }, bB = ["src", "alt"], cu = /* @__PURE__ */ j({
  __name: "MTogglePanel",
  props: /* @__PURE__ */ It({
    header: { default: "" }
  }, {
    isCollapsed: { default: !0 },
    isCollapsedModifiers: {}
  }),
  emits: ["update:isCollapsed"],
  setup(e) {
    const t = Ie(e, "isCollapsed"), n = e;
    function a() {
      t.value = !t.value;
    }
    return (s, o) => {
      const i = se("Panel");
      return C(), H(i, {
        collapsed: t.value,
        "onUpdate:collapsed": o[0] || (o[0] = (r) => t.value = r),
        class: "w-full"
      }, {
        header: D(() => [
          x("div", vB, [
            x("span", yB, P(n.header), 1)
          ])
        ]),
        icons: D(() => [
          x("img", {
            class: "cursor-pointer",
            src: k(Io)("rg_expand_circle_down"),
            alt: s.$t("shared.expandPanel"),
            onClick: a
          }, null, 8, bB)
        ]),
        default: D(() => [
          X(s.$slots, "default")
        ]),
        _: 3
      }, 8, ["collapsed"]);
    };
  }
}), xB = j({
  props: {
    text: String
  }
}), EB = { class: "h-6 w-max bg-black bg-opacity-50 text-white text-xs flex items-center px-2" };
function CB(e, t, n, a, s, o) {
  return C(), O("div", EB, [
    X(e.$slots, "default", {}, () => [
      Te(P(e.text), 1)
    ])
  ]);
}
const wB = /* @__PURE__ */ fe(xB, [["render", CB]]), IB = {
  symbol: Symbol(),
  install(e) {
    const t = new Vb();
    e.config.globalProperties.$navbar = t, e.provide(this.symbol, t);
  }
};
function BB() {
  return Dr(IB.symbol);
}
const kB = { class: "unsupported-browser-card" }, _B = { class: "unsupported-browser-title" }, SB = { class: "unsupported-browser-subtitle" }, DB = { class: "unsupported-browser-steps" }, TB = { class: "unsupported-browser-url-row" }, MB = ["value"], LB = { class: "unsupported-browser-actions" }, qM = /* @__PURE__ */ j({
  __name: "MUnsupportedBrowser",
  setup(e) {
    const t = cA(), n = BB(), { t: a } = Nn();
    Ge(() => {
      n.showOnlyLogo();
    });
    const s = U(() => {
      const r = t.query.targetUrl;
      return typeof r == "string" && r.length > 0 ? r : Array.isArray(r) && typeof r[0] == "string" && r[0].length > 0 ? r[0] : window.location.href;
    }), o = async () => {
      var l;
      const r = s.value;
      try {
        if ((l = navigator.clipboard) != null && l.writeText)
          await navigator.clipboard.writeText(r);
        else {
          const c = document.createElement("textarea");
          c.value = r, c.setAttribute("readonly", ""), c.style.position = "absolute", c.style.left = "-9999px", document.body.appendChild(c), c.select(), document.execCommand("copy"), document.body.removeChild(c);
        }
        We(a("weblink.copiedToClipboard"));
      } catch (c) {
        console.error(c);
      }
    }, i = () => {
      const r = s.value;
      try {
        const l = new URL(r, window.location.origin);
        l.searchParams.set("allowUnsupportedBrowser", "1"), window.location.href = l.toString();
      } catch {
        const l = r.includes("?") ? "&" : "?";
        window.location.href = `${r}${l}allowUnsupportedBrowser=1`;
      }
    };
    return (r, l) => {
      const c = se("Divider");
      return C(), H(Sn, { class: "unsupported-browser-page" }, {
        default: D(() => [
          x("section", kB, [
            B(Sn, { class: "items-center gap-2" }, {
              default: D(() => [
                l[0] || (l[0] = x("i", {
                  class: "pi pi-info-circle pc-coming-soon-icon",
                  "aria-hidden": "true",
                  style: { "font-size": "2.05rem" }
                }, null, -1)),
                x("h1", _B, P(k(a)("shared.unsupportedBrowser")), 1)
              ]),
              _: 1
            }),
            B(c),
            x("p", SB, P(k(a)("shared.rgWebIsOfficiallySupportedOnlyOnGoogleChrome")), 1),
            x("ol", DB, [
              x("li", null, P(k(a)("shared.forTheBestExperienceAndFullFunctionalityPleaseUseGoogleChrome")), 1)
            ]),
            x("div", TB, [
              x("input", {
                value: s.value,
                readonly: "",
                class: "unsupported-browser-url-input pc-settings-input"
              }, null, 8, MB),
              B(wt, {
                class: "h-51px all-radius-16",
                label: k(a)("shared.copyUrl"),
                icon: "pi pi-copy",
                style: { color: "var(--p-text-color)", background: "var(--primary-color) !important" },
                onClick: o
              }, null, 8, ["label"])
            ]),
            x("div", LB, [
              B(wt, {
                class: "h-51px all-radius-16 unsupported-browser-open-anyway-button",
                label: k(a)("shared.openProjectAnyway"),
                icon: "pi pi-external-link",
                style: { color: "var(--p-text-color)" },
                onClick: i
              }, null, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      });
    };
  }
}), OB = { class: "flex flex-col" }, NB = { class: "pb-2 pt-2" }, RB = /* @__PURE__ */ j({
  __name: "SendMediaMessageDialog",
  props: {
    visible: { type: Boolean },
    model: {},
    confirmEvent: { type: Function }
  },
  setup(e) {
    const t = T(""), n = T(!1), a = {
      width: "40vw",
      maxWidth: "95vw"
    }, s = {
      "1800px": "50vw",
      "960px": "75vw",
      "640px": "95vw"
    }, o = e;
    ye(
      () => o.visible,
      () => {
        t.value = "", n.value = o.visible;
      }
    );
    function i() {
      n.value = !1;
    }
    function r() {
      n.value = !1, o.confirmEvent && o.confirmEvent(o.model, t.value);
    }
    const l = U(() => {
      var u;
      const c = (((u = o.model) == null ? void 0 : u.filename) ?? "").toLowerCase();
      return c.endsWith(".pdf") || c.endsWith(".txt") || c.endsWith(".xml") || c.endsWith(".pts") || c.endsWith(".constructioninfo") || c.endsWith(".docx") || c.endsWith(".xlsx") || c.endsWith(".zip") ? "p-img-document" : "p-img-image p-img-image-custom";
    });
    return (c, u) => {
      const d = se("InputText"), m = se("Dialog");
      return C(), H(m, {
        visible: n.value,
        "onUpdate:visible": u[1] || (u[1] = (g) => n.value = g),
        modal: !0,
        header: c.$t("medic-web-framework.sendMessage"),
        style: a,
        breakpoints: s,
        onKeyup: Is(r, ["enter"])
      }, {
        footer: D(() => [
          B(xf, {
            acceptLabel: c.$t("medic-web-framework.send"),
            rejectLabel: c.$t("shared.cancel"),
            onAccept: r,
            onReject: i
          }, null, 8, ["acceptLabel", "rejectLabel"])
        ]),
        default: D(() => [
          x("div", OB, [
            B(k(Fu), {
              src: e.model.thumbnailImageSrc,
              imageClass: l.value,
              class: "w-280px"
            }, null, 8, ["src", "imageClass"]),
            x("span", NB, P(c.$t("medic-web-framework.enterAMessage")), 1),
            B(d, {
              modelValue: t.value,
              "onUpdate:modelValue": u[0] || (u[0] = (g) => t.value = g),
              autofocus: "true"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "header"]);
    };
  }
}), JM = /* @__PURE__ */ fe(RB, [["__scopeId", "data-v-92cd45a3"]]), PB = { id: "dropAreaWrapper" }, FB = {
  key: 0,
  class: "flex flex-col gap-6 items-center justify-center",
  id: "dropArea",
  style: {
    position: "absolute",
    inset: "0px",
    background: "rgba(91, 91, 91, 0.5)",
    zIndex: "10000",
    pointerEvents: "none"
  }
}, QB = { class: "upload-container w-2/12 flex flex-col items-center justify-center gap-6" }, UB = {
  class: "text-4xl bold mt-6",
  style: { "text-align": "center", color: "var(--webcad-primary-color-darker)" }
}, GB = { class: "mb-6" }, YB = ["src"], jB = /* @__PURE__ */ j({
  __name: "MUploadDropArea",
  props: /* @__PURE__ */ It({
    iconSrc: {},
    accept: { default: "" }
  }, {
    enabled: { type: Boolean, required: !0 },
    enabledModifiers: {}
  }),
  emits: /* @__PURE__ */ It(["filesDropped", "invalidFileType"], ["update:enabled"]),
  setup(e, { emit: t }) {
    const n = Ie(e, "enabled"), a = e, s = t, o = sa(), i = U(() => o.getAssetUrl(`${a.iconSrc}`)), r = T(!1);
    let l = 0;
    return Ge(() => {
      window.addEventListener("dragenter", function(c) {
        if (l++, c.dataTransfer && c.dataTransfer.items) {
          for (let u = 0; u < c.dataTransfer.items.length; u++)
            if (c.dataTransfer.items[u].kind === "file" && n.value) {
              r.value || (r.value = !0), c.preventDefault();
              return;
            }
        }
      }), window.addEventListener("dragover", function(c) {
        n.value && c.preventDefault();
      }), window.addEventListener("dragleave", function(c) {
        l--, console.log("dragleave"), l === 0 && n.value && (r.value = !1, c.preventDefault());
      }), document.addEventListener("drop", function(c) {
        var u;
        if (l = 0, n.value && r.value) {
          r.value = !1, c.preventDefault();
          const d = Array.from(((u = c.dataTransfer) == null ? void 0 : u.files) || []);
          zu(
            d.map((m) => m.name),
            a.accept != "" ? a.accept : void 0
          ) ? s("invalidFileType") : s("filesDropped", d);
        }
      });
    }), (c, u) => (C(), O("div", PB, [
      r.value ? (C(), O("div", FB, [
        x("div", QB, [
          x("span", UB, P(c.$t("medic-web-framework.dropFilesForUpload")), 1),
          x("div", GB, [
            x("img", {
              src: i.value,
              style: Le([{
                height: "5vh !important",
                width: "5vw !important",
                filter: "invert(100%)"
              }, { "align-items": "center", display: "flex" }]),
              alt: "icon",
              class: "h-full",
              draggable: "false"
            }, null, 8, YB)
          ])
        ])
      ])) : $("", !0)
    ]));
  }
}), XM = /* @__PURE__ */ fe(jB, [["__scopeId", "data-v-3b53436b"]]), HB = ["disabled"], VB = ["src"], KB = { class: "flex ml-2" }, ZM = /* @__PURE__ */ j({
  __name: "MChooseFolderButton",
  props: {
    iconSrc: {},
    rawUpload: { type: Boolean },
    borderRadius: {},
    disabled: { type: Boolean }
  },
  emits: ["folderSelected", "folderSelectedRaw"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = sa(), o = U(() => s.getAssetUrl(`${n.iconSrc}`)), i = (r) => {
      if (n.rawUpload) {
        a("folderSelectedRaw", r);
        return;
      }
      const l = r.target;
      let c = [];
      l.files && (c = Array.from(l.files)), a("folderSelected", c);
    };
    return (r, l) => (C(), H(k(ae), null, {
      default: D(() => [
        x("input", {
          type: "file",
          id: "filePickerImportProject",
          name: "fileList",
          class: "hidden",
          webkitdirectory: "",
          onChange: i,
          disabled: n.disabled
        }, null, 40, HB),
        x("label", {
          class: "p-button btn-wizard-md p-component p-fileupload-choose flex flex-row",
          style: Le({ verticalAlign: "middle", borderRadius: n.borderRadius ?? void 0 }),
          for: "filePickerImportProject"
        }, [
          x("img", {
            src: o.value,
            style: Le([{
              height: "14px !important",
              width: "14px !important"
            }, { "align-items": "center" }]),
            alt: "icon",
            class: "h-full flex",
            draggable: "false"
          }, null, 8, VB),
          x("span", KB, P(r.$t("web-rg.chooseFolder")), 1)
        ], 4)
      ]),
      _: 1
    }));
  }
}), eL = /* @__PURE__ */ j({
  __name: "MUploadFileButton",
  props: {
    accept: {},
    chooseLabel: {},
    class: {},
    disabled: { type: Boolean },
    showOnlyIcon: { type: Boolean }
  },
  emits: ["filesSelected", "invalidFileType"],
  setup(e, { emit: t }) {
    const { t: n } = Nn(), a = e, s = U(() => a.showOnlyIcon ?? !1), o = U(() => s.value ? "" : a.chooseLabel !== void 0 ? a.chooseLabel : n("web-rg.chooseFile")), i = U(() => a.class ?? ""), r = U(() => a.disabled ?? !1), l = t, c = (u) => {
      zu(
        u.files.map((d) => d.name),
        a.accept !== "" ? a.accept : void 0
      ) ? l("invalidFileType") : l("filesSelected", u.files);
    };
    return (u, d) => {
      const m = se("FileUpload");
      return C(), H(m, {
        customUpload: !0,
        accept: a.accept,
        disabled: r.value,
        onUploader: c,
        maxFileSize: 1e9,
        auto: !0,
        mode: "basic",
        multiple: !0,
        showUploadButton: !1,
        showCancelButton: !1,
        chooseLabel: o.value,
        class: J(i.value),
        pt: {
          chooseButton: {
            class: ["btn-wizard-md", { "p-button-icon-only": s.value }]
          }
        }
      }, null, 8, ["accept", "disabled", "chooseLabel", "class", "pt"]);
    };
  }
}), WB = { style: { position: "relative" } }, zB = { style: { "z-index": "1000", position: "absolute", "margin-top": "0.5rem", "margin-left": "0.75rem", display: "inline-block" } }, $B = {
  key: 0,
  class: "pi pi-check bold",
  style: { color: "var(--webcad-primary-color)" }
}, qB = { class: "ml-2 font-bold text-xl" }, JB = /* @__PURE__ */ j({
  __name: "ImageListItem",
  props: /* @__PURE__ */ It({
    item: {}
  }, {
    itemSelected: { type: Boolean, required: !0 },
    itemSelectedModifiers: {}
  }),
  emits: ["update:itemSelected"],
  setup(e) {
    const t = Ie(e, "itemSelected"), n = e, { item: a } = ft(n);
    function s(o) {
      t.value = !t.value, o.stopPropagation();
    }
    return (o, i) => {
      const r = se("Image");
      return C(), O("div", WB, [
        x("div", zB, [
          k(a).selected ? (C(), O("i", $B)) : $("", !0),
          x("span", qB, P(k(a).name), 1)
        ]),
        B(r, {
          alt: k(a).name,
          src: k(a).preview,
          class: J("flex w-full h-full object-contain img-card-size"),
          imageClass: [k(a).selected ? "border-2 border-round-xl" : ""],
          style: { "object-fit": "cover", height: "100% !important" },
          pt: {
            image: {
              style: {
                background: "transparent !important",
                maxHeight: "17rem",
                borderRadius: "8px"
              }
            },
            previewMask: {
              style: {
                borderRadius: "8px"
              }
            }
          },
          preview: ""
        }, {
          indicatoricon: D(() => [
            x("div", {
              class: "w-full h-full flex flex-col justify-start",
              onClick: i[0] || (i[0] = (l) => s(l))
            })
          ]),
          _: 1
        }, 8, ["alt", "src", "imageClass"]),
        X(o.$slots, "default", {}, void 0, !0)
      ]);
    };
  }
}), XB = /* @__PURE__ */ fe(JB, [["__scopeId", "data-v-6d4af382"]]), tL = /* @__PURE__ */ j({
  __name: "ImageList",
  props: /* @__PURE__ */ It({
    singleSelected: { type: Boolean }
  }, {
    items: { required: !0 },
    itemsModifiers: {}
  }),
  emits: ["update:items"],
  setup(e) {
    const t = Ie(e, "items"), n = e, a = (s) => {
      if (n.singleSelected) {
        t.value.forEach((i) => i.selected = !1);
        const o = t.value.find((i) => i == s);
        o && (o.selected = !0);
      }
    };
    return (s, o) => (C(!0), O(me, null, qe(t.value, (i, r) => (C(), O("div", { key: r }, [
      B(XB, {
        item: i,
        itemSelected: i.selected,
        "onUpdate:itemSelected": [(l) => i.selected = l, (l) => a(i)]
      }, {
        default: D(() => [
          X(s.$slots, "default")
        ]),
        _: 3
      }, 8, ["item", "itemSelected", "onUpdate:itemSelected"])
    ]))), 128));
  }
}), ZB = /* @__PURE__ */ j({
  __name: "MUSwitch",
  props: {
    state: { type: Boolean, required: !0 },
    stateModifiers: {},
    disabled: { type: Boolean },
    disabledModifiers: {}
  },
  emits: ["update:state", "update:disabled"],
  setup(e) {
    Br((c) => ({
      v32545e1d: i.value,
      v67d24c8c: o.value,
      v814475c2: r.value,
      b665f1b6: s.value,
      v76aed69f: l.value
    }));
    const t = Ie(e, "state"), n = Ie(e, "disabled"), a = () => {
      t.value = !t.value;
    }, s = U(() => t.value ? "#43c261" : "var(--p-text-color)"), o = U(() => "var(--p-text-color)"), i = U(() => t.value ? "var(--p-primary-color)" : "transparent"), r = U(() => t.value ? "#0096a5" : "rgba(200,200,200,0.3)"), l = U(() => t.value ? "16px" : "2px");
    return (c, u) => (C(), H(ae, {
      class: "flex-row",
      style: { "align-items": "center" }
    }, {
      default: D(() => [
        X(c.$slots, "falseLabel", {}, void 0, !0),
        x("div", {
          class: J(["switch", { disabled: n.value, "switch-on": t.value, "switch-off": !t.value }]),
          onClick: a
        }, [...u[0] || (u[0] = [
          x("div", { class: "switch__dot" }, null, -1)
        ])], 2),
        X(c.$slots, "trueLabel", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), nL = /* @__PURE__ */ fe(ZB, [["__scopeId", "data-v-2575cbb7"]]), ek = { class: "flex flex-wrap gap-6" }, tk = { class: "flex items-center" }, nk = {
  for: "ingredient1",
  class: "ml-2"
}, ak = { class: "flex items-center" }, sk = {
  for: "ingredient2",
  class: "ml-2"
}, ok = { class: "flex items-center" }, ik = {
  for: "ingredient3",
  class: "ml-2"
}, rk = { style: { display: "flex", "justify-content": "center" } }, lk = /* @__PURE__ */ j({
  __name: "MTransparencyModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    transparency: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const a = T(e.transparency), s = t, o = () => {
      s("confirm", a.value);
    }, i = () => {
      s("cancel");
    }, r = T(null);
    return (l, c) => {
      const u = se("RadioButton"), d = se("font-awesome-icon");
      return C(), H(Sa, {
        onClose: i,
        visible: e.visible
      }, {
        header: D(() => [
          X(l.$slots, "header", {}, () => [
            Te(P(e.header), 1)
          ])
        ]),
        default: D(() => [
          x("div", ek, [
            x("div", tk, [
              B(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[0] || (c[0] = (m) => a.value = m),
                inputId: "transparency1",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              x("label", nk, P(l.$t("shared.")), 1)
            ]),
            x("div", ak, [
              B(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[1] || (c[1] = (m) => a.value = m),
                inputId: "transparency2",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              x("label", sk, P(l.$t("shared.")), 1)
            ]),
            x("div", ok, [
              B(u, {
                modelValue: a.value,
                "onUpdate:modelValue": c[2] || (c[2] = (m) => a.value = m),
                inputId: "transparency3",
                name: "transparency"
              }, null, 8, ["modelValue"]),
              x("label", ik, P(l.$t("shared.")), 1)
            ])
          ])
        ]),
        actions: D(() => [
          x("div", rk, [
            B(ta, {
              ref_key: "okButtonRef",
              ref: r,
              onClick: o
            }, {
              default: D(() => [
                B(d, { icon: "check" }),
                Te(" " + P(l.$t("shared.ok")), 1)
              ]),
              _: 1
            }, 512),
            B(ta, { onClick: i }, {
              default: D(() => [
                B(d, { icon: "times" }),
                Te(" " + P(l.$t("shared.cancel")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
});
function Bt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function _a(e) {
  var t = Bt(e).Element;
  return e instanceof t || e instanceof Element;
}
function Lt(e) {
  var t = Bt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ul(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Bt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var ba = Math.max, Fo = Math.min, es = Math.round;
function Er() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function lp() {
  return !/^((?!chrome|android).)*safari/i.test(Er());
}
function ts(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var a = e.getBoundingClientRect(), s = 1, o = 1;
  t && Lt(e) && (s = e.offsetWidth > 0 && es(a.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && es(a.height) / e.offsetHeight || 1);
  var i = _a(e) ? Bt(e) : window, r = i.visualViewport, l = !lp() && n, c = (a.left + (l && r ? r.offsetLeft : 0)) / s, u = (a.top + (l && r ? r.offsetTop : 0)) / o, d = a.width / s, m = a.height / o;
  return {
    width: d,
    height: m,
    top: u,
    right: c + d,
    bottom: u + m,
    left: c,
    x: c,
    y: u
  };
}
function dl(e) {
  var t = Bt(e), n = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function ck(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function uk(e) {
  return e === Bt(e) || !Lt(e) ? dl(e) : ck(e);
}
function fn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ra(e) {
  return ((_a(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function fl(e) {
  return ts(ra(e)).left + dl(e).scrollLeft;
}
function Dn(e) {
  return Bt(e).getComputedStyle(e);
}
function pl(e) {
  var t = Dn(e), n = t.overflow, a = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + a);
}
function dk(e) {
  var t = e.getBoundingClientRect(), n = es(t.width) / e.offsetWidth || 1, a = es(t.height) / e.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function fk(e, t, n) {
  n === void 0 && (n = !1);
  var a = Lt(t), s = Lt(t) && dk(t), o = ra(t), i = ts(e, s, n), r = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((fn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  pl(o)) && (r = uk(t)), Lt(t) ? (l = ts(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = fl(o))), {
    x: i.left + r.scrollLeft - l.x,
    y: i.top + r.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function cp(e) {
  var t = ts(e), n = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: a
  };
}
function li(e) {
  return fn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ul(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ra(e)
  );
}
function up(e) {
  return ["html", "body", "#document"].indexOf(fn(e)) >= 0 ? e.ownerDocument.body : Lt(e) && pl(e) ? e : up(li(e));
}
function Cs(e, t) {
  var n;
  t === void 0 && (t = []);
  var a = up(e), s = a === ((n = e.ownerDocument) == null ? void 0 : n.body), o = Bt(a), i = s ? [o].concat(o.visualViewport || [], pl(a) ? a : []) : a, r = t.concat(i);
  return s ? r : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    r.concat(Cs(li(i)))
  );
}
function pk(e) {
  return ["table", "td", "th"].indexOf(fn(e)) >= 0;
}
function uu(e) {
  return !Lt(e) || // https://github.com/popperjs/popper-core/issues/837
  Dn(e).position === "fixed" ? null : e.offsetParent;
}
function mk(e) {
  var t = /firefox/i.test(Er()), n = /Trident/i.test(Er());
  if (n && Lt(e)) {
    var a = Dn(e);
    if (a.position === "fixed")
      return null;
  }
  var s = li(e);
  for (ul(s) && (s = s.host); Lt(s) && ["html", "body"].indexOf(fn(s)) < 0; ) {
    var o = Dn(s);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function ci(e) {
  for (var t = Bt(e), n = uu(e); n && pk(n) && Dn(n).position === "static"; )
    n = uu(n);
  return n && (fn(n) === "html" || fn(n) === "body" && Dn(n).position === "static") ? t : n || mk(e) || t;
}
var jt = "top", pn = "bottom", na = "right", In = "left", ml = "auto", ui = [jt, pn, na, In], ns = "start", Qs = "end", Ak = "clippingParents", dp = "viewport", ps = "popper", gk = "reference", du = /* @__PURE__ */ ui.reduce(function(e, t) {
  return e.concat([t + "-" + ns, t + "-" + Qs]);
}, []), hk = /* @__PURE__ */ [].concat(ui, [ml]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ns, t + "-" + Qs]);
}, []), vk = "beforeRead", yk = "read", bk = "afterRead", xk = "beforeMain", Ek = "main", Ck = "afterMain", wk = "beforeWrite", Ik = "write", Bk = "afterWrite", kk = [vk, yk, bk, xk, Ek, Ck, wk, Ik, Bk];
function _k(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function s(o) {
    n.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(r) {
      if (!n.has(r)) {
        var l = t.get(r);
        l && s(l);
      }
    }), a.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || s(o);
  }), a;
}
function Sk(e) {
  var t = _k(e);
  return kk.reduce(function(n, a) {
    return n.concat(t.filter(function(s) {
      return s.phase === a;
    }));
  }, []);
}
function Dk(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Tk(e) {
  var t = e.reduce(function(n, a) {
    var s = n[a.name];
    return n[a.name] = s ? Object.assign({}, s, a, {
      options: Object.assign({}, s.options, a.options),
      data: Object.assign({}, s.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
function Mk(e, t) {
  var n = Bt(e), a = ra(e), s = n.visualViewport, o = a.clientWidth, i = a.clientHeight, r = 0, l = 0;
  if (s) {
    o = s.width, i = s.height;
    var c = lp();
    (c || !c && t === "fixed") && (r = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: r + fl(e),
    y: l
  };
}
function Lk(e) {
  var t, n = ra(e), a = dl(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, o = ba(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), i = ba(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), r = -a.scrollLeft + fl(e), l = -a.scrollTop;
  return Dn(s || n).direction === "rtl" && (r += ba(n.clientWidth, s ? s.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: r,
    y: l
  };
}
function Ok(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ul(n)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Cr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Nk(e, t) {
  var n = ts(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function fu(e, t, n) {
  return t === dp ? Cr(Mk(e, n)) : _a(t) ? Nk(t, n) : Cr(Lk(ra(e)));
}
function Rk(e) {
  var t = Cs(li(e)), n = ["absolute", "fixed"].indexOf(Dn(e).position) >= 0, a = n && Lt(e) ? ci(e) : e;
  return _a(a) ? t.filter(function(s) {
    return _a(s) && Ok(s, a) && fn(s) !== "body";
  }) : [];
}
function Pk(e, t, n, a) {
  var s = t === "clippingParents" ? Rk(e) : [].concat(t), o = [].concat(s, [n]), i = o[0], r = o.reduce(function(l, c) {
    var u = fu(e, c, a);
    return l.top = ba(u.top, l.top), l.right = Fo(u.right, l.right), l.bottom = Fo(u.bottom, l.bottom), l.left = ba(u.left, l.left), l;
  }, fu(e, i, a));
  return r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
function $n(e) {
  return e.split("-")[0];
}
function as(e) {
  return e.split("-")[1];
}
function fp(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function pp(e) {
  var t = e.reference, n = e.element, a = e.placement, s = a ? $n(a) : null, o = a ? as(a) : null, i = t.x + t.width / 2 - n.width / 2, r = t.y + t.height / 2 - n.height / 2, l;
  switch (s) {
    case jt:
      l = {
        x: i,
        y: t.y - n.height
      };
      break;
    case pn:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case na:
      l = {
        x: t.x + t.width,
        y: r
      };
      break;
    case In:
      l = {
        x: t.x - n.width,
        y: r
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = s ? fp(s) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case ns:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case Qs:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function mp() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Fk(e) {
  return Object.assign({}, mp(), e);
}
function Qk(e, t) {
  return t.reduce(function(n, a) {
    return n[a] = e, n;
  }, {});
}
function Al(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, s = a === void 0 ? e.placement : a, o = n.strategy, i = o === void 0 ? e.strategy : o, r = n.boundary, l = r === void 0 ? Ak : r, c = n.rootBoundary, u = c === void 0 ? dp : c, d = n.elementContext, m = d === void 0 ? ps : d, g = n.altBoundary, h = g === void 0 ? !1 : g, A = n.padding, f = A === void 0 ? 0 : A, p = Fk(typeof f != "number" ? f : Qk(f, ui)), v = m === ps ? gk : ps, b = e.rects.popper, y = e.elements[h ? v : m], _ = Pk(_a(y) ? y : y.contextElement || ra(e.elements.popper), l, u, i), M = ts(e.elements.reference), S = pp({
    reference: M,
    element: b,
    placement: s
  }), Y = Cr(Object.assign({}, b, S)), K = m === ps ? Y : M, Z = {
    top: _.top - K.top + p.top,
    bottom: K.bottom - _.bottom + p.bottom,
    left: _.left - K.left + p.left,
    right: K.right - _.right + p.right
  }, le = e.modifiersData.offset;
  if (m === ps && le) {
    var re = le[s];
    Object.keys(Z).forEach(function(Ee) {
      var Ye = [na, pn].indexOf(Ee) >= 0 ? 1 : -1, te = [jt, pn].indexOf(Ee) >= 0 ? "y" : "x";
      Z[Ee] += re[te] * Ye;
    });
  }
  return Z;
}
var pu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function mu() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Uk(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, a = n === void 0 ? [] : n, s = t.defaultOptions, o = s === void 0 ? pu : s;
  return function(r, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, pu, o),
      modifiersData: {},
      elements: {
        reference: r,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], m = !1, g = {
      state: u,
      setOptions: function(p) {
        var v = typeof p == "function" ? p(u.options) : p;
        A(), u.options = Object.assign({}, o, u.options, v), u.scrollParents = {
          reference: _a(r) ? Cs(r) : r.contextElement ? Cs(r.contextElement) : [],
          popper: Cs(l)
        };
        var b = Sk(Tk([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = b.filter(function(y) {
          return y.enabled;
        }), h(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var p = u.elements, v = p.reference, b = p.popper;
          if (mu(v, b)) {
            u.rects = {
              reference: fk(v, ci(b), u.options.strategy === "fixed"),
              popper: cp(b)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(Z) {
              return u.modifiersData[Z.name] = Object.assign({}, Z.data);
            });
            for (var y = 0; y < u.orderedModifiers.length; y++) {
              if (u.reset === !0) {
                u.reset = !1, y = -1;
                continue;
              }
              var _ = u.orderedModifiers[y], M = _.fn, S = _.options, Y = S === void 0 ? {} : S, K = _.name;
              typeof M == "function" && (u = M({
                state: u,
                options: Y,
                name: K,
                instance: g
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Dk(function() {
        return new Promise(function(f) {
          g.forceUpdate(), f(u);
        });
      }),
      destroy: function() {
        A(), m = !0;
      }
    };
    if (!mu(r, l))
      return g;
    g.setOptions(c).then(function(f) {
      !m && c.onFirstUpdate && c.onFirstUpdate(f);
    });
    function h() {
      u.orderedModifiers.forEach(function(f) {
        var p = f.name, v = f.options, b = v === void 0 ? {} : v, y = f.effect;
        if (typeof y == "function") {
          var _ = y({
            state: u,
            name: p,
            instance: g,
            options: b
          }), M = function() {
          };
          d.push(_ || M);
        }
      });
    }
    function A() {
      d.forEach(function(f) {
        return f();
      }), d = [];
    }
    return g;
  };
}
var co = {
  passive: !0
};
function Gk(e) {
  var t = e.state, n = e.instance, a = e.options, s = a.scroll, o = s === void 0 ? !0 : s, i = a.resize, r = i === void 0 ? !0 : i, l = Bt(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, co);
  }), r && l.addEventListener("resize", n.update, co), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, co);
    }), r && l.removeEventListener("resize", n.update, co);
  };
}
const Yk = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Gk,
  data: {}
};
function jk(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = pp({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Hk = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: jk,
  data: {}
};
var Vk = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Kk(e, t) {
  var n = e.x, a = e.y, s = t.devicePixelRatio || 1;
  return {
    x: es(n * s) / s || 0,
    y: es(a * s) / s || 0
  };
}
function Au(e) {
  var t, n = e.popper, a = e.popperRect, s = e.placement, o = e.variation, i = e.offsets, r = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, m = i.x, g = m === void 0 ? 0 : m, h = i.y, A = h === void 0 ? 0 : h, f = typeof u == "function" ? u({
    x: g,
    y: A
  }) : {
    x: g,
    y: A
  };
  g = f.x, A = f.y;
  var p = i.hasOwnProperty("x"), v = i.hasOwnProperty("y"), b = In, y = jt, _ = window;
  if (c) {
    var M = ci(n), S = "clientHeight", Y = "clientWidth";
    if (M === Bt(n) && (M = ra(n), Dn(M).position !== "static" && r === "absolute" && (S = "scrollHeight", Y = "scrollWidth")), M = M, s === jt || (s === In || s === na) && o === Qs) {
      y = pn;
      var K = d && M === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        M[S]
      );
      A -= K - a.height, A *= l ? 1 : -1;
    }
    if (s === In || (s === jt || s === pn) && o === Qs) {
      b = na;
      var Z = d && M === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        M[Y]
      );
      g -= Z - a.width, g *= l ? 1 : -1;
    }
  }
  var le = Object.assign({
    position: r
  }, c && Vk), re = u === !0 ? Kk({
    x: g,
    y: A
  }, Bt(n)) : {
    x: g,
    y: A
  };
  if (g = re.x, A = re.y, l) {
    var Ee;
    return Object.assign({}, le, (Ee = {}, Ee[y] = v ? "0" : "", Ee[b] = p ? "0" : "", Ee.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + A + "px)" : "translate3d(" + g + "px, " + A + "px, 0)", Ee));
  }
  return Object.assign({}, le, (t = {}, t[y] = v ? A + "px" : "", t[b] = p ? g + "px" : "", t.transform = "", t));
}
function Wk(e) {
  var t = e.state, n = e.options, a = n.gpuAcceleration, s = a === void 0 ? !0 : a, o = n.adaptive, i = o === void 0 ? !0 : o, r = n.roundOffsets, l = r === void 0 ? !0 : r, c = {
    placement: $n(t.placement),
    variation: as(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Au(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Au(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const zk = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Wk,
  data: {}
};
function $k(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var a = t.styles[n] || {}, s = t.attributes[n] || {}, o = t.elements[n];
    !Lt(o) || !fn(o) || (Object.assign(o.style, a), Object.keys(s).forEach(function(i) {
      var r = s[i];
      r === !1 ? o.removeAttribute(i) : o.setAttribute(i, r === !0 ? "" : r);
    }));
  });
}
function qk(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var s = t.elements[a], o = t.attributes[a] || {}, i = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : n[a]), r = i.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Lt(s) || !fn(s) || (Object.assign(s.style, r), Object.keys(o).forEach(function(l) {
        s.removeAttribute(l);
      }));
    });
  };
}
const Jk = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: $k,
  effect: qk,
  requires: ["computeStyles"]
};
var Xk = [Yk, Hk, zk, Jk], gl = /* @__PURE__ */ Uk({
  defaultModifiers: Xk
}), Zk = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xo(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Zk[t];
  });
}
var e_ = {
  start: "end",
  end: "start"
};
function gu(e) {
  return e.replace(/start|end/g, function(t) {
    return e_[t];
  });
}
function t_(e, t) {
  t === void 0 && (t = {});
  var n = t, a = n.placement, s = n.boundary, o = n.rootBoundary, i = n.padding, r = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? hk : l, u = as(a), d = u ? r ? du : du.filter(function(h) {
    return as(h) === u;
  }) : ui, m = d.filter(function(h) {
    return c.indexOf(h) >= 0;
  });
  m.length === 0 && (m = d);
  var g = m.reduce(function(h, A) {
    return h[A] = Al(e, {
      placement: A,
      boundary: s,
      rootBoundary: o,
      padding: i
    })[$n(A)], h;
  }, {});
  return Object.keys(g).sort(function(h, A) {
    return g[h] - g[A];
  });
}
function n_(e) {
  if ($n(e) === ml)
    return [];
  var t = xo(e);
  return [gu(e), t, gu(t)];
}
function a_(e) {
  var t = e.state, n = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, r = i === void 0 ? !0 : i, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, m = n.altBoundary, g = n.flipVariations, h = g === void 0 ? !0 : g, A = n.allowedAutoPlacements, f = t.options.placement, p = $n(f), v = p === f, b = l || (v || !h ? [xo(f)] : n_(f)), y = [f].concat(b).reduce(function(ct, pt) {
      return ct.concat($n(pt) === ml ? t_(t, {
        placement: pt,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: h,
        allowedAutoPlacements: A
      }) : pt);
    }, []), _ = t.rects.reference, M = t.rects.popper, S = /* @__PURE__ */ new Map(), Y = !0, K = y[0], Z = 0; Z < y.length; Z++) {
      var le = y[Z], re = $n(le), Ee = as(le) === ns, Ye = [jt, pn].indexOf(re) >= 0, te = Ye ? "width" : "height", pe = Al(t, {
        placement: le,
        boundary: u,
        rootBoundary: d,
        altBoundary: m,
        padding: c
      }), Ce = Ye ? Ee ? na : In : Ee ? pn : jt;
      _[te] > M[te] && (Ce = xo(Ce));
      var _t = xo(Ce), Ve = [];
      if (o && Ve.push(pe[re] <= 0), r && Ve.push(pe[Ce] <= 0, pe[_t] <= 0), Ve.every(function(ct) {
        return ct;
      })) {
        K = le, Y = !1;
        break;
      }
      S.set(le, Ve);
    }
    if (Y)
      for (var je = h ? 3 : 1, Ke = function(pt) {
        var Vt = y.find(function(Kt) {
          var mt = S.get(Kt);
          if (mt)
            return mt.slice(0, pt).every(function(Ot) {
              return Ot;
            });
        });
        if (Vt)
          return K = Vt, "break";
      }, at = je; at > 0; at--) {
        var Xe = Ke(at);
        if (Xe === "break") break;
      }
    t.placement !== K && (t.modifiersData[a]._skip = !0, t.placement = K, t.reset = !0);
  }
}
const hl = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: a_,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function s_(e) {
  return e === "x" ? "y" : "x";
}
function Eo(e, t, n) {
  return ba(e, Fo(t, n));
}
function o_(e, t, n) {
  var a = Eo(e, t, n);
  return a > n ? n : a;
}
function i_(e) {
  var t = e.state, n = e.options, a = e.name, s = n.mainAxis, o = s === void 0 ? !0 : s, i = n.altAxis, r = i === void 0 ? !1 : i, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, m = n.tether, g = m === void 0 ? !0 : m, h = n.tetherOffset, A = h === void 0 ? 0 : h, f = Al(t, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), p = $n(t.placement), v = as(t.placement), b = !v, y = fp(p), _ = s_(y), M = t.modifiersData.popperOffsets, S = t.rects.reference, Y = t.rects.popper, K = typeof A == "function" ? A(Object.assign({}, t.rects, {
    placement: t.placement
  })) : A, Z = typeof K == "number" ? {
    mainAxis: K,
    altAxis: K
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, K), le = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, re = {
    x: 0,
    y: 0
  };
  if (M) {
    if (o) {
      var Ee, Ye = y === "y" ? jt : In, te = y === "y" ? pn : na, pe = y === "y" ? "height" : "width", Ce = M[y], _t = Ce + f[Ye], Ve = Ce - f[te], je = g ? -Y[pe] / 2 : 0, Ke = v === ns ? S[pe] : Y[pe], at = v === ns ? -Y[pe] : -S[pe], Xe = t.elements.arrow, ct = g && Xe ? cp(Xe) : {
        width: 0,
        height: 0
      }, pt = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : mp(), Vt = pt[Ye], Kt = pt[te], mt = Eo(0, S[pe], ct[pe]), Ot = b ? S[pe] / 2 - je - mt - Vt - Z.mainAxis : Ke - mt - Vt - Z.mainAxis, mn = b ? -S[pe] / 2 + je + mt + Kt + Z.mainAxis : at + mt + Kt + Z.mainAxis, An = t.elements.arrow && ci(t.elements.arrow), la = An ? y === "y" ? An.clientTop || 0 : An.clientLeft || 0 : 0, he = (Ee = le == null ? void 0 : le[y]) != null ? Ee : 0, gn = Ce + Ot - he - la, Nt = Ce + mn - he, Wt = Eo(g ? Fo(_t, gn) : _t, Ce, g ? ba(Ve, Nt) : Ve);
      M[y] = Wt, re[y] = Wt - Ce;
    }
    if (r) {
      var hn, E = y === "x" ? jt : In, I = y === "x" ? pn : na, R = M[_], W = _ === "y" ? "height" : "width", we = R + f[E], Se = R - f[I], ce = [jt, In].indexOf(p) !== -1, N = (hn = le == null ? void 0 : le[_]) != null ? hn : 0, w = ce ? we : R - S[W] - Y[W] - N + Z.altAxis, Q = ce ? R + S[W] + Y[W] - N - Z.altAxis : Se, oe = g && ce ? o_(w, R, Q) : Eo(g ? w : we, R, g ? Q : Se);
      M[_] = oe, re[_] = oe - R;
    }
    t.modifiersData[a] = re;
  }
}
const vl = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: i_,
  requiresIfExists: ["offset"]
};
function aL(e, t, n) {
  let a, s = null;
  const o = T(null), i = T(!1), r = () => {
    s && (Ne(null, s), s.remove(), s = null);
  }, l = () => {
    r(), i.value = !1;
  }, c = (u) => {
    i.value && l(), u.preventDefault(), s = document.createElement("div"), document.body.appendChild(s);
    const d = B(I_, {
      items: t.value,
      options: {
        showIcons: n
      }
    });
    a && (d.appContext = a), Ne(d, s), s.style.position = "absolute", s.style.left = u.clientX + "px", s.style.top = u.clientY + "px";
    const m = s.firstElementChild;
    o.value = gl(s, m, {
      placement: "right-start",
      modifiers: [hl, vl]
    }), i.value = !0;
  };
  ti(T(s), l, i), ri(
    "keyup",
    (u) => {
      u.key === "Escape" && l();
    },
    i
  ), Ge(() => {
    var u, d;
    a = (u = za()) == null ? void 0 : u.appContext, (d = e.value) == null || d.addEventListener("contextmenu", c);
  }), Mn(() => {
    var u;
    (u = e.value) == null || u.removeEventListener("contextmenu", c), r();
  });
}
const sL = (e) => {
  const t = () => {
    if (typeof window > "u" || typeof navigator > "u")
      return {};
    const i = e ? e() : {}, r = i.browser ?? {}, l = i.os ?? {}, c = i.device ?? {}, u = window.screen ? `${window.screen.width}x${window.screen.height}` : "unknown", d = navigator.language || navigator.languages && navigator.languages[0] || "unknown";
    return {
      browserName: r.name ?? "unknown",
      browserVersion: r.version ?? "unknown",
      osName: l.name ?? "unknown",
      osVersion: l.version ?? "unknown",
      deviceType: c.type ?? "desktop",
      screenSize: u,
      timezoneOffset: String((/* @__PURE__ */ new Date()).getTimezoneOffset()),
      language: d
    };
  }, n = (i) => Object.keys(i).sort().map((r) => `${r}=${i[r]}`).join("|"), a = (i) => {
    let r = "";
    return i.forEach((l) => {
      r += String.fromCharCode(l);
    }), btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
  }, s = async (i) => {
    var d;
    if (typeof window > "u" || !((d = window.crypto) != null && d.subtle))
      return "";
    const r = n(i), l = new TextEncoder().encode(r), c = await window.crypto.subtle.digest("SHA-256", l), u = new Uint8Array(c);
    return a(u).slice(0, 22);
  };
  return {
    collectClientSignals: t,
    normalizeSignals: n,
    generateVisitorId: s,
    generateVisitorScore: async (i) => {
      const r = await s({ ...i, score: "1" });
      if (!r)
        return 0;
      const l = r.charCodeAt(0), c = r.charCodeAt(1);
      return Math.min(100, Math.abs(l + c) % 101);
    }
  };
};
function oL(e, t, n, a) {
  let s = !1;
  const o = (f) => {
    switch (t) {
      case "left":
        return f.buttons % 2 === 1;
      case "middle":
        return f.buttons % 8 === 1;
      case "right":
        return f.buttons % 4 === 1;
    }
  }, i = (f) => {
    switch (n) {
      case "offset":
        return [f.offsetX, f.offsetY];
      case "client":
        return [f.clientX, f.clientY];
      case "page":
        return [f.pageX, f.pageY];
      case "screen":
        return [f.screenX, f.screenY];
    }
  }, r = (f) => {
    o(f) && c(...i(f));
  }, l = (f) => {
    o(f) || d(...i(f));
  }, c = (f, p) => {
    var v;
    s = !0, h(), (v = a.onDragStart) == null || v.call(a, f, p);
  }, u = (f) => {
    var p;
    if (s) {
      if (!o(f)) {
        d(...i(f));
        return;
      }
      f.preventDefault(), (p = a.onDrag) == null || p.call(a, ...i(f));
    }
  }, d = (f, p) => {
    var v;
    s && (s = !1, A(), (v = a.onDragEnd) == null || v.call(a, f, p));
  }, m = (f) => {
    f.addEventListener("mousedown", r), document.addEventListener("mouseup", l);
  }, g = (f) => {
    f.removeEventListener("mousedown", r), document.removeEventListener("mouseup", l);
  }, h = () => {
    document.addEventListener("mousemove", u);
  }, A = () => {
    document.removeEventListener("mousemove", u);
  };
  document.addEventListener(
    "contextmenu",
    (f) => {
      f.ctrlKey && (f.preventDefault(), f.stopPropagation());
    },
    { capture: !0 }
  ), e.value && m(e.value), ye(e, (f, p) => {
    p && g(p), f && m(f);
  }), Mn(() => {
    A();
  });
}
function r_(e, t, n) {
  qn(() => {
    t.modelValue && Object.assign(e, t.modelValue);
  }), ye(
    () => e,
    () => {
      n("update:modelValue", e);
    },
    { deep: !0 }
  );
}
function iL(e, t) {
  const n = new ResizeObserver((a) => {
    for (const s of a)
      s.target === e.value && t(s.contentRect);
  });
  e.value && n.observe(e.value), ye(e, (a, s) => {
    s && n.unobserve(s), a && n.observe(a);
  }), Mn(() => {
    n.disconnect();
  });
}
function rL(e, t, n = 200) {
  let a = null;
  const s = T(null), o = () => {
    a && (Ne(null, a), a.remove(), a = null);
  }, i = cl();
  let r, l;
  const c = () => {
    window.clearTimeout(r), l = window.setTimeout(() => {
      o();
    }, n);
  }, u = () => {
    window.clearTimeout(l), r = window.setTimeout(() => {
      if (!e.value)
        return;
      a = document.createElement("div"), i.getElement().append(a);
      const f = B(wB, {
        text: k(t)
      });
      Ne(f, a), s.value = gl(e.value, a, {
        modifiers: [hl, vl]
      });
    }, n);
  };
  let d = !1;
  const m = () => {
    !d && e.value && (e.value.addEventListener("mouseover", u), e.value.addEventListener("mouseout", c), d = !0);
  }, g = () => {
    var f, p;
    (f = e.value) == null || f.removeEventListener("mouseover", u), (p = e.value) == null || p.removeEventListener("mouseout", c), d = !1;
  }, h = () => {
    m();
  }, A = () => {
    g(), c();
  };
  ye(e, () => {
    e.value ? h() : A();
  }), Ge(() => {
    h();
  }), Mn(() => {
    A();
  });
}
const l_ = { style: { "font-size": "12px", "margin-bottom": "0.25rem" } }, c_ = { style: { display: "flex", "align-items": "center", gap: "0.5rem" } }, u_ = ["min", "max", "step", "value", "disabled", "onInput"], d_ = { style: { "font-size": "12px", "min-width": "42px", "text-align": "right" } }, f_ = {
  key: 1,
  class: "pi pi-angle-right",
  style: { "margin-left": "auto" }
}, hu = /* @__PURE__ */ j({
  __name: "MContextMenu",
  props: {
    menuItems: {},
    menuItemsModel: {},
    x: {},
    y: {},
    callback: { type: Function }
  },
  emits: ["select", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, s = T();
    ri("keyup", (c) => {
      c.key === "Escape" && a("cancel");
    });
    const o = U(() => n.menuItems.map((c, u) => ({ label: c, command: () => a("select", u) }))), i = (c) => c.__isSlider === !0, r = (c, u) => {
      const d = u.target, m = Number(d.value);
      c.__sliderValue = m, c.__onValueChanged(m);
    }, l = (c) => {
      c.preventDefault();
    };
    return Ge(async () => {
      if (document.addEventListener("contextmenu", l, { capture: !0 }), await Tn(), s.value) {
        const c = new PointerEvent("click", { clientX: n.x, clientY: n.y });
        s.value.show(c), c.stopImmediatePropagation();
      } else
        throw Error("div.value and/or menu.value is undefined");
    }), Mn(() => {
      document.removeEventListener("contextmenu", l, { capture: !0 });
    }), (c, u) => (C(), O("div", {
      style: { position: "absolute", inset: "0" },
      onClick: u[3] || (u[3] = xt((d) => a("cancel"), ["self"])),
      onContextmenuCapture: u[4] || (u[4] = xt(() => {
      }, ["prevent", "stop"]))
    }, [
      B(k(Nu), {
        ref_key: "menu",
        ref: s,
        model: e.menuItemsModel ?? o.value,
        onHide: u[2] || (u[2] = (d) => e.menuItemsModel ? a("cancel") : void 0)
      }, {
        item: D(({ item: d, props: m }) => [
          i(d) ? (C(), O("div", {
            key: 0,
            style: { padding: "0.35rem 0.8rem", "min-width": "220px" },
            onMousedown: u[0] || (u[0] = xt(() => {
            }, ["stop"])),
            onClick: u[1] || (u[1] = xt(() => {
            }, ["stop"]))
          }, [
            x("div", l_, P(d.label), 1),
            x("div", c_, [
              x("input", {
                min: d.__sliderMin,
                max: d.__sliderMax,
                step: d.__sliderStep,
                value: d.__sliderValue,
                disabled: !!d.disabled,
                type: "range",
                style: { width: "150px" },
                onInput: xt((g) => r(d, g), ["stop"])
              }, null, 40, u_),
              x("span", d_, P(Number(d.__sliderValue).toFixed(0)), 1)
            ])
          ], 32)) : (C(), O("a", Ir({ key: 1 }, m.action, { style: { display: "flex", "align-items": "center", gap: "0.5rem" } }), [
            d.icon ? (C(), O("span", {
              key: 0,
              class: J(d.icon)
            }, null, 2)) : $("", !0),
            x("span", null, P(d.label), 1),
            d.items ? (C(), O("span", f_)) : $("", !0)
          ], 16))
        ]),
        _: 1
      }, 8, ["model"])
    ], 32));
  }
}), p_ = { style: { display: "flex", "flex-direction": "column", gap: "0.75rem", "min-width": "360px" } }, m_ = { style: { display: "flex", "flex-direction": "column", gap: "0.25rem" } }, A_ = { style: { display: "flex", "flex-direction": "column", gap: "0.25rem" } }, g_ = { style: { display: "flex", "justify-content": "center" } }, h_ = /* @__PURE__ */ j({
  __name: "MSaveAsModal",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    name: {},
    options: {},
    selectedType: {},
    nameLabel: { default: "Name" },
    typeLabel: { default: "Type" }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: s, name: o, selectedType: i, options: r } = ft(n), l = T(o.value), c = r.value.length > 0 ? r.value[0].value : 0, u = T(typeof i.value == "number" ? i.value : c), d = T(null), m = () => {
      var A, f, p, v;
      (f = (A = d.value) == null ? void 0 : A.firstChild) == null || f.focus(), (v = (p = d.value) == null ? void 0 : p.firstChild) == null || v.select();
    };
    ye(s, async () => {
      s.value && (await Tn(), m());
    }), ye(o, (A) => {
      l.value = A;
    }), ye(i, (A) => {
      u.value = typeof A == "number" ? A : c;
    }), Ge(() => {
      s.value && m();
    });
    const g = () => {
      a("confirm", l.value, u.value);
    }, h = () => {
      a("cancel");
    };
    return (A, f) => (C(), H(Sa, {
      onClose: h,
      visible: k(s)
    }, {
      header: D(() => [
        X(A.$slots, "header", {}, () => [
          Te(P(e.header), 1)
        ])
      ]),
      default: D(() => [
        x("div", p_, [
          x("div", m_, [
            x("div", null, P(e.nameLabel), 1),
            x("div", {
              ref_key: "nameInputRef",
              ref: d
            }, [
              B(k(_r), {
                modelValue: l.value,
                "onUpdate:modelValue": f[0] || (f[0] = (p) => l.value = p),
                type: "text",
                style: { width: "100%" }
              }, null, 8, ["modelValue"])
            ], 512)
          ]),
          x("div", A_, [
            x("div", null, P(e.typeLabel), 1),
            B(k(Yo), {
              modelValue: u.value,
              "onUpdate:modelValue": f[1] || (f[1] = (p) => u.value = p),
              options: k(r),
              optionLabel: "label",
              optionValue: "value",
              style: { width: "100%" }
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ]),
      actions: D(() => [
        x("div", g_, [
          B(wt, {
            class: "btn-wizard-md mr-2",
            icon: "pi pi-check",
            onClick: g,
            label: A.$t("shared.ok")
          }, null, 8, ["label"]),
          B(wt, {
            class: "btn-wizard-md p-button-text",
            background: !1,
            outlined: !0,
            icon: "pi pi-times",
            label: A.$t("shared.cancel"),
            onClick: h
          }, null, 8, ["label"])
        ])
      ]),
      _: 3
    }, 8, ["visible"]));
  }
});
function xn() {
  let e;
  const t = T(!1), n = () => (t.value = !0, new Promise((s) => {
    e = s;
  })), a = (s) => {
    t.value = !1, e && e(s);
  };
  return {
    visible: Mp(t),
    ask: n,
    tell: a
  };
}
function lL() {
  var m;
  let e = (m = za()) == null ? void 0 : m.appContext;
  Uo(() => {
    var g;
    e = (g = za()) == null ? void 0 : g.appContext;
  });
  const t = cl();
  return {
    showSaveAsModal: (g, h, A, f, p, v) => {
      const b = document.createElement("div");
      t.getElement().append(b);
      const y = xn(), _ = () => {
        b && Ne(null, b), b.remove();
      }, M = (K, Z) => {
        y.tell({ name: K, type: Z }), _();
      }, S = () => {
        y.tell(null), _();
      }, Y = B(h_, {
        container: t.getElement(),
        visible: !0,
        onConfirm: M,
        onCancel: S,
        header: g,
        name: h,
        options: A,
        selectedType: f,
        nameLabel: p,
        typeLabel: v
      });
      return e && (Y.appContext = e), Ne(Y, b), y.ask();
    },
    showChangeTransparencyModal: (g, h) => {
      const A = document.createElement("div");
      t.getElement().append(A);
      const f = xn(), p = () => {
        A && Ne(null, A), A.remove();
      }, v = (_) => {
        f.tell(_), p();
      }, b = () => {
        f.tell(null), p();
      }, y = B(lk, {
        container: t.getElement(),
        visible: !0,
        onConfirm: v,
        onCancel: b,
        header: g,
        transparency: h
      });
      return e && (y.appContext = e), Ne(y, A), f.ask();
    },
    showColorPickerModal: (g, h) => {
      const A = document.createElement("div");
      t.getElement().append(A);
      const f = xn(), p = () => {
        A && Ne(null, A), A.remove();
      }, v = (_) => {
        f.tell(_), p();
      }, b = () => {
        f.tell(null), p();
      }, y = B(Jw, {
        container: t.getElement(),
        visible: !0,
        onConfirm: v,
        onCancel: b,
        header: g,
        defaultColor: h
      });
      return e && (y.appContext = e), Ne(y, A), f.ask();
    },
    showConfirmModal: (g, h) => {
      const A = document.createElement("div");
      t.getElement().append(A);
      const f = xn(), p = () => {
        A && Ne(null, A), A.remove();
      }, v = () => {
        f.tell(!0), p();
      }, b = () => {
        f.tell(!1), p();
      }, y = B(Zw, {
        container: t.getElement(),
        visible: !0,
        onConfirm: v,
        onCancel: b,
        header: g,
        text: h
      });
      return e && (y.appContext = e), Ne(y, A), f.ask();
    },
    showInfoModal: (g, h) => {
      const A = document.createElement("div");
      t.getElement().append(A);
      const f = xn(), p = () => {
        A && Ne(null, A), A.remove();
      }, v = () => {
        f.tell(), p();
      }, b = B(aI, {
        container: t.getElement(),
        visible: !0,
        onConfirm: v,
        header: g,
        text: h
      });
      return e && (b.appContext = e), Ne(b, A), f.ask();
    },
    showViewerHelpModal: () => {
      const g = document.createElement("div");
      t.getElement().append(g);
      const h = xn(), A = () => {
        g && Ne(null, g), g.remove();
      }, f = () => {
        h.tell(), A();
      }, p = B(dI, {
        container: t.getElement(),
        visible: !0,
        onConfirm: f
      });
      return e && (p.appContext = e), Ne(p, g), h.ask();
    },
    showTextInputModal: (g, h, A) => {
      const f = document.createElement("div");
      t.getElement().append(f);
      const p = xn(), v = () => {
        f && Ne(null, f), f.remove();
      }, b = (M) => {
        p.tell(M), v();
      }, y = () => {
        p.tell(null), v();
      }, _ = B(rI, {
        container: t.getElement(),
        visible: !0,
        onConfirm: b,
        onCancel: y,
        header: g,
        text: h,
        label: A
      });
      return e && (_.appContext = e), Ne(_, f), p.ask();
    },
    showContextMenu: (g, h, A) => new Promise((f) => {
      const p = document.createElement("div");
      t.getElement().append(p);
      const v = () => {
        p && Ne(null, p), p.remove();
      }, b = (M) => {
        v(), f(M);
      }, y = () => {
        v(), f(null);
      }, _ = B(hu, {
        container: t.getElement(),
        x: h,
        y: A,
        menuItems: g,
        onSelect: b,
        onCancel: y
      });
      e && (_.appContext = e), Ne(_, p);
    }),
    showContextMenu2: (g, h, A) => new Promise((f) => {
      const p = document.createElement("div");
      t.getElement().append(p);
      let v = null, b = !1, y = !1, _ = !1;
      const M = () => {
        p && Ne(null, p), p.remove();
      }, S = () => {
        _ || (_ = !0, setTimeout(() => {
          M(), f();
        }, 0));
      }, Y = () => {
        y || _ || (y = !0, setTimeout(() => {
          if (y = !1, !(!b || _)) {
            if (v) {
              v.finally(() => {
                v = null, Y();
              });
              return;
            }
            S();
          }
        }, 0));
      }, K = () => {
        b = !0, Y();
      }, Z = (te) => te.map((pe) => {
        const Ce = {
          ...pe,
          items: pe.items ? Z(pe.items) : void 0
        };
        return pe.command && (Ce.command = async (_t) => {
          const Ve = pe.command, je = Promise.resolve(Ve ? Ve(_t) : void 0).then(() => {
          });
          v = je;
          try {
            await je;
          } finally {
            v === je && (v = null), b && Y();
          }
        }), Ce;
      }), le = Z(g), re = (te) => {
        K();
      }, Ee = () => {
        K();
      }, Ye = B(hu, {
        container: t.getElement(),
        x: h,
        y: A,
        menuItems: [],
        menuItemsModel: le,
        onSelect: re,
        onCancel: Ee
      });
      e && (Ye.appContext = e), Ne(Ye, p);
    }),
    showMUErrorModal: (g, h, A, f) => {
      const p = document.createElement("div");
      t.getElement().append(p);
      const v = xn(), b = () => {
        p && Ne(null, p), p.remove();
      }, y = (S) => {
        v.tell(S), b();
      }, _ = () => {
        v.tell(!1), b();
      }, M = B(fI, {
        container: t.getElement(),
        visible: !0,
        onConfirm: y,
        onCancel: _,
        header: g,
        text: h,
        showCancel: A,
        showYesNo: f
      });
      return e && (M.appContext = e), Ne(M, p), v.ask();
    }
  };
}
const vu = {
  showIcons: !1,
  menuStyle: void 0,
  menuClass: {},
  itemStyle: void 0,
  itemClass: ["hover:bg-selected"]
  // if hover: class is set in "class=" it seems to override the options, so we set it here
};
var Ap = /* @__PURE__ */ ((e) => (e.EDIT_NOTES = "editNotesModal", e.RENAME_OBJECT = "renameObjectModal", e))(Ap || {});
const v_ = j({
  components: {
    MIcon: $r
  },
  props: {
    items: {
      type: Array,
      required: !0
    },
    options: {
      type: Object,
      default: vu
    }
  },
  emits: [
    "itemSelected"
    /* ITEM_SELECTED */
  ],
  setup(e, { emit: t }) {
    const n = xn();
    n.visible.value = !1;
    const a = async () => {
      console.log("show modal example"), n.visible.value = !0;
      const v = await n.ask();
      console.log("modal closed, value:", v);
    }, s = T(!1), o = T(!1), i = T(1), r = { ...vu, ...e.options }, l = T(-1), c = (v, b) => {
      l.value = b;
    }, u = (v) => {
      t("itemSelected", v);
    }, d = T({ name: "Median Filter (Noise Reduction)", code: 0 });
    let m = un({
      value: 29,
      isRange: !1,
      iconSrc: "",
      minValue: 0,
      maxValue: 100,
      step: 1
    });
    const g = () => {
      s.value = !1;
    }, h = () => {
      o.value = !1;
    }, A = T([]), f = T(), p = T(null);
    return ye(
      f,
      () => {
        p.value && p.value.destroy();
        const v = A.value[l.value];
        f.value && v && (p.value = gl(v, f.value, {
          placement: "right-start",
          modifiers: [hl, vl]
        }));
      },
      {
        flush: "post"
      }
    ), Lp(() => {
      A.value = [];
    }), Op(() => {
      p.value && p.value.destroy();
    }), {
      mergedOptions: r,
      selectedIndex: l,
      onItemHover: c,
      emitItemSelected: u,
      itemDivs: A,
      subMenu: f,
      notesModalVisible: s,
      id: i,
      showModalExample: a,
      modalExample: n,
      closeTest: g,
      ModalViews: Ap,
      renameObjectModalVisible: o,
      closeRenameObjectModal: h,
      filterWizSliderModel: m,
      selectedItem: d
    };
  }
}), y_ = ["onMouseenter"], b_ = { class: "flex w-full justify-between items-center pointer-events-none" }, x_ = { class: "overflow-hidden whitespace-nowrap pointer-events-none" }, E_ = { key: 0 }, C_ = {
  key: 0,
  style: {}
};
function w_(e, t, n, a, s, o) {
  const i = se("m-icon"), r = se("MMenu", !0);
  return C(), O("div", {
    class: J([e.mergedOptions.menuClass, "p-menu p-component p-menu-overlay absolute flex-col select-none bg-not-selected all-radius min-w-220 z-50"]),
    style: Le(e.mergedOptions.menuStyle)
  }, [
    (C(!0), O(me, null, qe(e.items, (l, c) => (C(), O("div", {
      key: c,
      ref_for: !0,
      ref: (u) => {
        u && (e.itemDivs[c] = u);
      },
      class: "flex"
    }, [
      x("div", {
        class: J([[{ "pl-2": !e.mergedOptions.showIcons }, e.mergedOptions.itemClass], "w-rem-17 h-8 flex pr-2 items-center main-text-color"]),
        style: Le(e.mergedOptions.itemStyle),
        onMouseenter: xt((u) => e.onItemHover(l, c), ["stop"])
      }, [
        e.options.showIcons ? (C(), H(i, {
          key: 0,
          faIcon: l.iconFa,
          src: l.iconImg,
          class: "w-4/12 h-8"
        }, null, 8, ["faIcon", "src"])) : $("", !0),
        x("div", b_, [
          x("div", x_, P(l.text), 1),
          l.subItems ? (C(), O("div", E_, "▸")) : $("", !0)
        ])
      ], 46, y_),
      l.subItems && e.selectedIndex === c ? (C(), O("div", C_, [
        B(r, {
          ref_for: !0,
          ref: "subMenu",
          items: l.subItems,
          options: e.options,
          onItemSelected: (u) => e.emitItemSelected(l)
        }, null, 8, ["items", "options", "onItemSelected"])
      ])) : $("", !0)
    ], 512))), 128))
  ], 6);
}
const I_ = /* @__PURE__ */ fe(v_, [["render", w_]]), B_ = { class: "p-0 all-radius-16" }, k_ = { class: "mt-2" }, __ = {
  class: "flex w-full min-w-0 picklist-header-row",
  style: { "max-height": "35px !important" }
}, S_ = ["innerHTML"], D_ = { class: "hidden" }, T_ = {
  key: 1,
  class: "col-span-5 flex flex-col justify-end picklist-actions"
}, M_ = { class: "flex flex-row gap-1 w-full" }, L_ = ["src"], O_ = /* @__PURE__ */ j({
  __name: "MPickListItem",
  props: {
    modelValue: {},
    id: {},
    name: {},
    imgSrc: {},
    header: {},
    index: {},
    selected: { type: Boolean },
    selectedKey: {},
    callbacks: {},
    visible: { type: Boolean },
    isLocked: { type: Boolean },
    isTracked: { type: Boolean },
    hideHeader: { type: Boolean }
  },
  emits: ["update:modelValue", "update:pickListItemSelected"],
  setup(e, { emit: t }) {
    const n = e, a = un(zA()), { t: s } = Nn(), o = t;
    r_(a, n, o), qn(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    }), ye(
      () => a,
      () => {
        o("update:modelValue", a);
      },
      { deep: !0 }
    );
    const i = T("bg-purple-500");
    qn(() => {
      n.id == n.index ? i.value = "p-highlight" : i.value = "";
    });
    const r = U(() => n.selected ? "var(--p-primary-color) !important" : ""), l = U(() => n.header.replace(/-/g, "-<wbr>")), c = T([
      {
        id: "object_hide",
        label: n.visible ? s("medic-web-engine.hideObject") : s("medic-web-engine.showObject"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.hideObject(n.selectedKey);
        }
      },
      {
        id: "object_delete",
        label: s("implant-planner.deleteObject"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.deleteObject(n.selectedKey);
        }
      },
      {
        id: "object_notes",
        label: s("shared.editNotes"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.editNotes(n.selectedKey);
        }
      },
      // { // TODO do I need this (has own icon)
      //     id: "object_unlock",
      //     label: "Toggle Lock Object",
      //     command: () => {
      //         const l = this.context.objects.getLockStatus(key);
      //         if (l != null) {
      //             this.context.objects.changeLockStatus(key, !l);
      //             updateDeferred();
      //         }
      //     },
      // },
      {
        id: "object_change_color",
        label: s("shared.changeColor"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.changeColor(n.selectedKey);
        }
      },
      {
        id: "object_change_transparency",
        label: s("medic-web-engine.changeTransparency"),
        items: [0, 30, 60].map((h) => ({
          label: h ? h + "%" : s("medic-web-engine.opaque"),
          command: () => {
            var A;
            d(), (A = n.callbacks) == null || A.changeTransparency(n.selectedKey, h);
          }
        }))
      },
      {
        label: s("medic-web-engine.toggleWireframe"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.toggleWireframe(n.selectedKey);
        }
      },
      {
        label: s("medic-web-engine.matchObject"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.matchObject(n.selectedKey);
        }
      },
      {
        id: "object_rename",
        label: s("medic-web-engine.renameObject"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.renameObject(n.selectedKey);
        }
      }
    ]);
    n.isTracked || (console.log("NotTracked!!"), c.value.push({
      id: "object_type_change",
      label: s("medic-web-engine.changeObjectType"),
      items: [
        "Marker Scan",
        "Anatomy",
        "Antagonist",
        "Waxup-Prosthesis",
        "Bone Surface",
        "Bone Graft",
        "Surgical Guide",
        "Bone Reduction Guide",
        "Acrylic Flange",
        "Bar",
        "Other"
      ].map((h) => ({
        label: h,
        command: () => {
          var A;
          d(), (A = n.callbacks) == null || A.changeObjectType(n.selectedKey, h);
        }
      }))
    })), c.value.push(
      {
        id: "object_duplicate",
        label: s("medic-web-engine.duplicateObject"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.duplicateObject(n.selectedKey);
        }
      },
      {
        label: s("medic-web-engine.calculateVolume"),
        command: () => {
          var h;
          d(), (h = n.callbacks) == null || h.calculateVolume(n.selectedKey);
        }
      }
    );
    const u = T(), d = () => {
      u.value.toggle(event);
    }, m = () => {
      var h;
      (h = n.callbacks) == null || h.toogleObjectVisibility(n.selectedKey);
    }, g = () => {
      var h;
      (h = n.callbacks) == null || h.toggleObjectPlacement(n.selectedKey);
    };
    return (h, A) => {
      const f = se("TieredMenu"), p = ws("tooltip");
      return C(), O("li", {
        "aria-selected": "false",
        class: "p-picklist-item",
        role: "option",
        tabindex: "0",
        style: Le({
          borderRadius: "16px",
          background: r.value
        })
      }, [
        x("div", B_, [
          x("div", null, [
            x("div", k_, [
              x("div", __, [
                e.hideHeader ? $("", !0) : (C(), O("div", {
                  key: 0,
                  class: J([e.callbacks ? "flex grow min-w-0 picklist-header-text" : " flex w-full justify-center items-center"])
                }, [
                  an(x("span", {
                    class: J(["mt-4 text-l cursor-pointer", [e.callbacks ? "ml-2 wrap-text" : "text-center"]]),
                    innerHTML: l.value
                  }, null, 10, S_), [
                    [
                      p,
                      e.header,
                      void 0,
                      { top: !0 }
                    ]
                  ]),
                  x("div", D_, [
                    B(wb)
                  ])
                ], 2)),
                e.callbacks ? (C(), O("div", T_, [
                  x("div", M_, [
                    B(wt, {
                      class: "grow shrink",
                      toggled: !e.isLocked,
                      "is-toolbar-button": !0,
                      onToggledChange: g,
                      togglable: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      iconSrc: e.isLocked ? "/icons/new_icons/ik_object_placement.svg" : "/icons/new_icons/ik_object_placement_black.svg",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }, null, 8, ["toggled", "iconSrc"]),
                    B(wt, {
                      class: "grow shrink",
                      "is-toolbar-button": !0,
                      iconSrc: e.visible ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      onClick: m,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }, null, 8, ["iconSrc"]),
                    B(wt, {
                      class: "grow shrink mr-2",
                      "is-toolbar-button": !0,
                      iconSrc: "/icons/new_icons/ik_menu_28.svg",
                      onClick: d,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px", width: "28px", "border-radius": "8px" }
                    }),
                    B(k(Bs), {
                      id: "overlay_ruler_panel",
                      ref_key: "opMenuDropdown",
                      ref: u,
                      showCloseIcon: !1,
                      appendTo: "body",
                      style: { "max-width": "350px" }
                    }, {
                      default: D(() => [
                        B(f, {
                          id: "object_list_dropdown_tiered_menu",
                          model: c.value
                        }, null, 8, ["model"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])) : $("", !0)
              ]),
              x("img", {
                src: e.imgSrc,
                class: "w-full mt-2 cursor-pointer picklist-image",
                draggable: "false"
              }, null, 8, L_)
            ])
          ])
        ])
      ], 4);
    };
  }
}), yu = /* @__PURE__ */ fe(O_, [["__scopeId", "data-v-1f202838"]]), N_ = {
  key: 0,
  class: "p-picklist-header"
}, R_ = {
  class: "w-full mt-2",
  style: { "list-style-type": "none" }
}, P_ = {
  "aria-multiselectable": "true",
  class: "p-picklist-list p-picklist-source w-full",
  role: "listbox"
}, F_ = /* @__PURE__ */ j({
  __name: "MPickList",
  props: {
    header: { default: "" },
    items: {},
    selected: { type: Boolean, default: !0 },
    showItemsDropdown: { type: Boolean, default: !1 },
    hideDropdown: { type: Boolean },
    callbacks: {},
    forceSelected: { default: "" },
    heightStyle: { default: "" },
    style: { default: "" }
  },
  emits: ["hideObject", "pickListItemSelected"],
  setup(e, { emit: t }) {
    Br((h) => ({
      v23980a96: h.heightStyle
    }));
    const n = e, a = t, s = T(n.items), o = T(), i = (h) => {
      var A;
      return (A = s == null ? void 0 : s.value) == null ? void 0 : A.find((f) => f.id == h.toString());
    }, r = (h) => {
      o.value = i(h);
    };
    n.forceSelected && n.forceSelected != "" && r(Number(n.forceSelected));
    const l = T(-1), c = (h, A) => {
      l.value !== A && (l.value = A ?? 0, a("pickListItemSelected", h ?? {}));
    };
    function u() {
      s.value.forEach((h) => h.isSelected = !1);
    }
    const d = () => {
      u();
      const h = s.value.find((A) => {
        var f;
        return A.id === ((f = o.value) == null ? void 0 : f.id.toString());
      });
      h && o.value && (h.isSelected = !0, c(h, Number(h.id)));
    }, m = (h, A) => {
      u(), r(Number(h.id)), c(h, A);
    }, g = T(Math.random());
    return ye(
      () => n.forceSelected,
      () => {
        console.log("ForceSelected:", n.forceSelected), n.showItemsDropdown && n.forceSelected && (r(Number(n.forceSelected)), g.value = Math.random());
      }
    ), (h, A) => (C(), O("div", {
      class: "p-picklist p-component h-full w-full",
      style: Le(n.style)
    }, [
      e.header ? (C(), O("div", N_)) : $("", !0),
      e.showItemsDropdown ? (C(), O("div", {
        key: 1,
        class: "p-picklist-header w-full",
        style: Le(n.heightStyle)
      }, [
        an(B(k(Yo), {
          class: "w-full",
          modelValue: o.value,
          "onUpdate:modelValue": A[0] || (A[0] = (f) => o.value = f),
          options: s.value,
          "option-label": "header",
          placeholder: h.$t("medic-web-framework.selectItem"),
          onChange: d
        }, null, 8, ["modelValue", "options", "placeholder"]), [
          [Li, !e.hideDropdown]
        ]),
        x("div", R_, [
          o.value ? (C(), H(yu, {
            header: o.value.header,
            "hide-header": !0,
            index: l.value,
            imgSrc: o.value.imgSrc,
            selected: !0,
            selectedKey: o.value.id,
            callbacks: e.callbacks ?? void 0,
            visible: o.value.isVisible,
            isTracked: o.value.isTracked,
            isLocked: o.value.isLocked,
            key: g.value
          }, null, 8, ["header", "index", "imgSrc", "selectedKey", "callbacks", "visible", "isTracked", "isLocked"])) : $("", !0)
        ])
      ], 4)) : (C(), O("div", {
        key: 2,
        style: Le(n.heightStyle)
      }, [
        x("ul", P_, [
          (C(!0), O(me, null, qe(s.value, (f, p) => (C(), O("div", {
            key: f.header
          }, [
            (C(), H(yu, {
              header: f.header,
              index: l.value,
              imgSrc: f.imgSrc,
              selected: p == l.value || ((f == null ? void 0 : f.isSelected) ?? !1),
              selectedKey: f.id,
              callbacks: e.callbacks ?? void 0,
              visible: f.isVisible,
              key: g.value,
              isTracked: f.isTracked,
              isLocked: f.isLocked,
              onClick: (v) => m(f, p)
            }, null, 8, ["header", "index", "imgSrc", "selected", "selectedKey", "callbacks", "visible", "isTracked", "isLocked", "onClick"]))
          ]))), 128))
        ])
      ], 4))
    ], 4));
  }
}), cL = /* @__PURE__ */ fe(F_, [["__scopeId", "data-v-d2d2b2f8"]]), Q_ = { class: "text-2xl" }, U_ = { class: "text-justify" }, bu = "cookieSetting", uL = /* @__PURE__ */ j({
  __name: "MCookieBanner",
  props: {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ie(e, "modelValue");
    localStorage.getItem(bu) || (t.value = !0);
    const a = (i) => {
      localStorage.setItem(bu, i);
    }, s = () => {
      a("all"), t.value = !1;
    }, o = () => {
      a("essential"), t.value = !1;
    };
    return (i, r) => {
      const l = se("Dialog");
      return C(), H(l, {
        modal: "",
        visible: t.value,
        "onUpdate:visible": r[0] || (r[0] = (c) => t.value = c),
        style: { width: "720px" },
        breakpoints: { "960px": "75vw", "640px": "100vw" }
      }, {
        header: D(() => [
          x("span", Q_, P(i.$t("medic-web-framework.weUseCookiesToImproveYourExperience")), 1)
        ]),
        footer: D(() => [
          B(ae, { class: "justify-center gap-4" }, {
            default: D(() => [
              B(Lo, {
                label: i.$t("medic-web-framework.acceptEssential"),
                icon: "pi pi-check",
                onClick: o
              }, null, 8, ["label"]),
              B(ni, {
                id: "btnAcceptAllCookies",
                label: i.$t("medic-web-framework.acceptAll"),
                icon: "pi pi-check",
                onClick: s
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        default: D(() => [
          B(ae, { class: "items-start justify-center" }, {
            default: D(() => [
              x("p", U_, P(i.$t("medic-web-framework.cookiesHelpUsImproveYourExperienceOnOurWebsiteTheyAllowUsToRememberPreferencesUnderstandHowPeopleUseOurSiteAndDeliverRelevantContent")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]);
    };
  }
}), dL = /* @__PURE__ */ j({
  __name: "WeblinkUploadInvalidComponent",
  setup(e) {
    const t = Ht("dialogRef");
    return (n, a) => (C(), O(me, null, [
      B(ae, { class: "flex-col -mt-2 gap-16px" }, {
        default: D(() => [
          x("span", null, P(n.$t("medic-web-framework.supportedTypes")), 1),
          B(ae, { class: "flex-row-wrap gap-4" }, {
            default: D(() => [
              (C(!0), O(me, null, qe(k(Vu), (s) => (C(), H(k(Ou), {
                label: s,
                key: s
              }, null, 8, ["label"]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      B(k(Pu), { class: "mt-1" }),
      B(ae, null, {
        default: D(() => [
          a[1] || (a[1] = x("div", { class: "grow" }, null, -1)),
          B(ni, {
            label: n.$t("shared.close"),
            onClick: a[0] || (a[0] = (s) => k(t).close())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), G_ = {
  class: "text-4xl bold",
  style: { "text-align": "center", color: "var(--webcad-primary-color-darker)" }
}, fL = /* @__PURE__ */ j({
  __name: "WeblinkUploadNoPatientIdComponent",
  setup(e) {
    const t = Ht("dialogRef");
    return (n, a) => {
      const s = se("Divider"), o = se("Button");
      return C(), O(me, null, [
        B(ae, { class: "justify-center" }, {
          default: D(() => [
            x("span", G_, P(n.$t("medic-web-framework.pleaseSelectPatientFromPatientList")), 1)
          ]),
          _: 1
        }),
        B(s, { class: "mt-1" }),
        B(ae, null, {
          default: D(() => [
            a[1] || (a[1] = x("div", { class: "grow" }, null, -1)),
            B(o, {
              class: "p-button p-component w-2/12 flex items-center justify-center",
              label: n.$t("shared.close"),
              onClick: a[0] || (a[0] = (i) => k(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Y_ = { class: "w-full pt-2" }, j_ = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" }, H_ = { class: "flex col-span-6 pointer items-center gap-3" }, V_ = { class: "flex col-span-6 justify-end" }, K_ = { class: "flex gap-2" }, W_ = { class: "flex align-center" }, z_ = { class: "flex gap-2" }, $_ = { class: "flex align-center" }, q_ = /* @__PURE__ */ j({
  __name: "AppNotificationConfigComponent",
  props: /* @__PURE__ */ It({
    hideEmailControls: { type: Boolean, default: !1 }
  }, {
    statusList: {},
    statusListModifiers: {},
    emailChatNotification: { type: Boolean, required: !0 },
    emailChatNotificationModifiers: {},
    emailStatusNotification: { required: !0 },
    emailStatusNotificationModifiers: {},
    emailOrderCreatedNotifications: { type: Boolean, required: !0 },
    emailOrderCreatedNotificationsModifiers: {}
  }),
  emits: /* @__PURE__ */ It(["updateStatusNotification", "updateEmailChatNotification"], ["update:statusList", "update:emailChatNotification", "update:emailStatusNotification", "update:emailOrderCreatedNotifications"]),
  setup(e, { emit: t }) {
    const n = Ie(e, "statusList"), a = Ie(e, "emailChatNotification"), s = Ie(e, "emailStatusNotification"), o = Ie(e, "emailOrderCreatedNotifications"), i = Cf(), r = T(i.isMobileView), l = t, c = e, u = () => {
      if (n.value) {
        const g = n.value.filter((h) => h.selected).map((h) => h.name);
        l("updateStatusNotification", g);
      }
    }, d = (g) => {
      l("updateEmailChatNotification", !g);
    }, m = (g) => {
      if (!n.value) return;
      const h = n.value.filter((f) => f.selected).map((f) => f.name), A = g ? h.filter((f) => f !== "ORDER_CREATED") : Array.from(/* @__PURE__ */ new Set([...h, "ORDER_CREATED"]));
      l("updateStatusNotification", A);
    };
    return Ge(() => {
      n.value && s.value && n.value.forEach((g) => {
        g.selected = s.value.includes(g.name);
      });
    }), ye(
      i.$state,
      (g) => {
        r.value = g.isMobileView;
      },
      { deep: !0 }
    ), (g, h) => {
      const A = se("Divider");
      return C(), O(me, null, [
        x("div", Y_, [
          x("div", j_, [
            (C(!0), O(me, null, qe(n.value, (f, p) => (C(), H(k(ae), {
              class: "rg-panel gap-4",
              key: f.name
            }, {
              default: D(() => [
                x("div", H_, [
                  x("span", {
                    style: Le(`background-color: ${f.color};`),
                    class: "transparent-dot-lg"
                  }, null, 4),
                  x("span", null, P(f.displayString), 1)
                ]),
                B(k(ca)),
                x("div", V_, [
                  B(mo, {
                    id: `status_switch_${p}`,
                    state: f.selected,
                    "onUpdate:state": (v) => f.selected = v,
                    onChange: u
                  }, null, 8, ["id", "state", "onUpdate:state"])
                ])
              ]),
              _: 2
            }, 1024))), 128))
          ])
        ]),
        c.hideEmailControls ? $("", !0) : (C(), H(A, { key: 0 })),
        c.hideEmailControls ? $("", !0) : (C(), H(k(Sn), {
          key: 1,
          class: "flex w-full gap-6"
        }, {
          default: D(() => [
            B(k(ca), { class: "rg-panel" }, {
              default: D(() => [
                x("span", K_, [
                  h[2] || (h[2] = x("span", { class: "flex pi pi-inbox align-center" }, null, -1)),
                  x("span", W_, P(g.$t("medic-web-framework.sendMeAnEmailForNewChatMessages")), 1)
                ]),
                B(k(ca)),
                B(mo, {
                  id: "switchEmailChatNotifications",
                  class: "flex align-center",
                  state: a.value,
                  "onUpdate:state": h[0] || (h[0] = (f) => a.value = f),
                  onChange: d
                }, null, 8, ["state"])
              ]),
              _: 1
            }),
            B(k(ca), { class: "rg-panel" }, {
              default: D(() => [
                x("span", z_, [
                  h[3] || (h[3] = x("span", { class: "flex pi pi-inbox align-center" }, null, -1)),
                  x("span", $_, P(g.$t("medic-web-framework.sendMeAnEmailForNewCreatedOrder")), 1)
                ]),
                B(k(ca)),
                B(mo, {
                  id: "switchEmailOrderNotifications",
                  class: "flex align-center",
                  state: o.value,
                  "onUpdate:state": h[1] || (h[1] = (f) => o.value = f),
                  onChange: m
                }, null, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      ], 64);
    };
  }
});
function gp(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var s = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(n, a, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), n;
}
var hp = {}, Et = {}, Us = {};
Object.defineProperty(Us, "__esModule", {
  value: !0
});
var vp = Us.TIMEZONES = void 0, J_ = [{
  country: "CI",
  name: "Africa/Abidjan",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "GH",
  name: "Africa/Accra",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "ET",
  name: "Africa/Addis_Ababa",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "DZ",
  name: "Africa/Algiers",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ER",
  name: "Africa/Asmara",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "ER",
  name: "Africa/Asmera",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "ML",
  name: "Africa/Bamako",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "CF",
  name: "Africa/Bangui",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "GM",
  name: "Africa/Banjul",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "GW",
  name: "Africa/Bissau",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "MW",
  name: "Africa/Blantyre",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "CG",
  name: "Africa/Brazzaville",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "BI",
  name: "Africa/Bujumbura",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "EG",
  name: "Africa/Cairo",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "MA",
  name: "Africa/Casablanca",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ES",
  name: "Africa/Ceuta",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GN",
  name: "Africa/Conakry",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "SN",
  name: "Africa/Dakar",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "TZ",
  name: "Africa/Dar_es_Salaam",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "DJ",
  name: "Africa/Djibouti",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "CM",
  name: "Africa/Douala",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "EH",
  name: "Africa/El_Aaiun",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "SL",
  name: "Africa/Freetown",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BW",
  name: "Africa/Gaborone",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZW",
  name: "Africa/Harare",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZA",
  name: "Africa/Johannesburg",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "SS",
  name: "Africa/Juba",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "UG",
  name: "Africa/Kampala",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "SD",
  name: "Africa/Khartoum",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RW",
  name: "Africa/Kigali",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "CD",
  name: "Africa/Kinshasa",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "NG",
  name: "Africa/Lagos",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GA",
  name: "Africa/Libreville",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "TG",
  name: "Africa/Lome",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "AO",
  name: "Africa/Luanda",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "CD",
  name: "Africa/Lubumbashi",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "ZM",
  name: "Africa/Lusaka",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Maputo"
}, {
  country: "GQ",
  name: "Africa/Malabo",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "MZ",
  name: "Africa/Maputo",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "LS",
  name: "Africa/Maseru",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Johannesburg"
}, {
  country: "SZ",
  name: "Africa/Mbabane",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Johannesburg"
}, {
  country: "SO",
  name: "Africa/Mogadishu",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "LR",
  name: "Africa/Monrovia",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "KE",
  name: "Africa/Nairobi",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "TD",
  name: "Africa/Ndjamena",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "NE",
  name: "Africa/Niamey",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "MR",
  name: "Africa/Nouakchott",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BF",
  name: "Africa/Ouagadougou",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "BJ",
  name: "Africa/Porto-Novo",
  status: "Link",
  offset: "+01:00",
  link: "Africa/Lagos"
}, {
  country: "ST",
  name: "Africa/Sao_Tome",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "ML",
  name: "Africa/Timbuktu",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "LY",
  name: "Africa/Tripoli",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "TN",
  name: "Africa/Tunis",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "NA",
  name: "Africa/Windhoek",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "US",
  name: "America/Adak",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "US",
  name: "America/Anchorage",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "AI",
  name: "America/Anguilla",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "AG",
  name: "America/Antigua",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Araguaina",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Buenos_Aires",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Catamarca",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/ComodRivadavia",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Catamarca"
}, {
  country: "AR",
  name: "America/Argentina/Cordoba",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Jujuy",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/La_Rioja",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Mendoza",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Rio_Gallegos",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Salta",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/San_Juan",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/San_Luis",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Tucuman",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AR",
  name: "America/Argentina/Ushuaia",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AW",
  name: "America/Aruba",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "PY",
  name: "America/Asuncion",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Atikokan",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "US",
  name: "America/Atka",
  status: "Link",
  offset: "−10:00",
  link: "America/Adak"
}, {
  country: "BR",
  name: "America/Bahia",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "MX",
  name: "America/Bahia_Banderas",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BB",
  name: "America/Barbados",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "BR",
  name: "America/Belem",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "BZ",
  name: "America/Belize",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Blanc-Sablon",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Boa_Vista",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CO",
  name: "America/Bogota",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Boise",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "AR",
  name: "America/Buenos_Aires",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Buenos_Aires"
}, {
  country: "CA",
  name: "America/Cambridge_Bay",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "BR",
  name: "America/Campo_Grande",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Cancun",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "VE",
  name: "America/Caracas",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "AR",
  name: "America/Catamarca",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Catamarca"
}, {
  country: "GF",
  name: "America/Cayenne",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "KY",
  name: "America/Cayman",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "US",
  name: "America/Chicago",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Chihuahua",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ciudad_Juarez",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Coral_Harbour",
  status: "Link",
  offset: "−05:00",
  link: "America/Panama"
}, {
  country: "AR",
  name: "America/Cordoba",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Cordoba"
}, {
  country: "CR",
  name: "America/Costa_Rica",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Creston",
  status: "Link",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "BR",
  name: "America/Cuiaba",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CW",
  name: "America/Curacao",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GL",
  name: "America/Danmarkshavn",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "CA",
  name: "America/Dawson",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Dawson_Creek",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Denver",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Detroit",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "DM",
  name: "America/Dominica",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Edmonton",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "BR",
  name: "America/Eirunepe",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "SV",
  name: "America/El_Salvador",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ensenada",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "CA",
  name: "America/Fort_Nelson",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Fort_Wayne",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "BR",
  name: "America/Fortaleza",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Glace_Bay",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "GL",
  name: "America/Godthab",
  status: "Link",
  offset: "−02:00",
  link: "America/Nuuk"
}, {
  country: "CA",
  name: "America/Goose_Bay",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "TC",
  name: "America/Grand_Turk",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "GD",
  name: "America/Grenada",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GP",
  name: "America/Guadeloupe",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "GT",
  name: "America/Guatemala",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "EC",
  name: "America/Guayaquil",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "GY",
  name: "America/Guyana",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Halifax",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CU",
  name: "America/Havana",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "MX",
  name: "America/Hermosillo",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Indianapolis",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Knox",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Marengo",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Petersburg",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Tell_City",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Vevay",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Vincennes",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indiana/Winamac",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Indianapolis",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "CA",
  name: "America/Inuvik",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Iqaluit",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "JM",
  name: "America/Jamaica",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "AR",
  name: "America/Jujuy",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Jujuy"
}, {
  country: "US",
  name: "America/Juneau",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "US",
  name: "America/Kentucky/Louisville",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Kentucky/Monticello",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Knox_IN",
  status: "Link",
  offset: "−06:00",
  link: "America/Indiana/Knox"
}, {
  country: "BQ",
  name: "America/Kralendijk",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BO",
  name: "America/La_Paz",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "PE",
  name: "America/Lima",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "US",
  name: "America/Los_Angeles",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "US",
  name: "America/Louisville",
  status: "Link",
  offset: "−05:00",
  link: "America/Kentucky/Louisville"
}, {
  country: "SX",
  name: "America/Lower_Princes",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Maceio",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "NI",
  name: "America/Managua",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Manaus",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MF",
  name: "America/Marigot",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "MQ",
  name: "America/Martinique",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Matamoros",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Mazatlan",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "AR",
  name: "America/Mendoza",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Mendoza"
}, {
  country: "US",
  name: "America/Menominee",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "MX",
  name: "America/Merida",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Metlakatla",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "MX",
  name: "America/Mexico_City",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PM",
  name: "America/Miquelon",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Moncton",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "MX",
  name: "America/Monterrey",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "UY",
  name: "America/Montevideo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Montreal",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "MS",
  name: "America/Montserrat",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BS",
  name: "America/Nassau",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "US",
  name: "America/New_York",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "CA",
  name: "America/Nipigon",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "US",
  name: "America/Nome",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "BR",
  name: "America/Noronha",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/Beulah",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/Center",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/North_Dakota/New_Salem",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "GL",
  name: "America/Nuuk",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "MX",
  name: "America/Ojinaga",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PA",
  name: "America/Panama",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "CA",
  name: "America/Pangnirtung",
  status: "Link",
  offset: "−05:00",
  link: "America/Iqaluit"
}, {
  country: "SR",
  name: "America/Paramaribo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "US",
  name: "America/Phoenix",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "HT",
  name: "America/Port-au-Prince",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "TT",
  name: "America/Port_of_Spain",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "BR",
  name: "America/Porto_Acre",
  status: "Link",
  offset: "−05:00",
  link: "America/Rio_Branco"
}, {
  country: "BR",
  name: "America/Porto_Velho",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "PR",
  name: "America/Puerto_Rico",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CL",
  name: "America/Punta_Arenas",
  status: "Canonical",
  offset: "−03:00",
  link: "Magallanes Region"
}, {
  country: "CA",
  name: "America/Rainy_River",
  status: "Link",
  offset: "−06:00",
  link: "America/Winnipeg"
}, {
  country: "CA",
  name: "America/Rankin_Inlet",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Recife",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CA",
  name: "America/Regina",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "CA",
  name: "America/Resolute",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "BR",
  name: "America/Rio_Branco",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "AR",
  name: "America/Rosario",
  status: "Link",
  offset: "−03:00",
  link: "America/Argentina/Cordoba"
}, {
  country: "MX",
  name: "America/Santa_Isabel",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "BR",
  name: "America/Santarem",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "CL",
  name: "America/Santiago",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "DO",
  name: "America/Santo_Domingo",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "BR",
  name: "America/Sao_Paulo",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "GL",
  name: "America/Scoresbysund",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "US",
  name: "America/Shiprock",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "America/Sitka",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "BL",
  name: "America/St_Barthelemy",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/St_Johns",
  status: "Canonical",
  offset: "−03:30",
  link: ""
}, {
  country: "KN",
  name: "America/St_Kitts",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "LC",
  name: "America/St_Lucia",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "VI",
  name: "America/St_Thomas",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "VC",
  name: "America/St_Vincent",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Swift_Current",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "HN",
  name: "America/Tegucigalpa",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "GL",
  name: "America/Thule",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "CA",
  name: "America/Thunder_Bay",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "MX",
  name: "America/Tijuana",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "CA",
  name: "America/Toronto",
  status: "Canonical",
  offset: "−05:00",
  link: ""
}, {
  country: "VG",
  name: "America/Tortola",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Vancouver",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "VI",
  name: "America/Virgin",
  status: "Link",
  offset: "−04:00",
  link: "America/Puerto_Rico"
}, {
  country: "CA",
  name: "America/Whitehorse",
  status: "Canonical",
  offset: "−07:00",
  link: ""
}, {
  country: "CA",
  name: "America/Winnipeg",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "US",
  name: "America/Yakutat",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "CA",
  name: "America/Yellowknife",
  status: "Link",
  offset: "−07:00",
  link: "America/Edmonton"
}, {
  country: "AQ",
  name: "Antarctica/Casey",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/Davis",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/DumontDUrville",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "AU",
  name: "Antarctica/Macquarie",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/Mawson",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/McMurdo",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "AQ",
  name: "Antarctica/Palmer",
  status: "Canonical",
  offset: "−03:00",
  link: "Chilean Antarctica Region"
}, {
  country: "AQ",
  name: "Antarctica/Rothera",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AQ",
  name: "Antarctica/South_Pole",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "AQ",
  name: "Antarctica/Syowa",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "AQ",
  name: "Antarctica/Troll",
  status: "Canonical",
  offset: "+00:00",
  link: "+01:00"
}, {
  country: "AQ",
  name: "Antarctica/Vostok",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "SJ",
  name: "Arctic/Longyearbyen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "YE",
  name: "Asia/Aden",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "KZ",
  name: "Asia/Almaty",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "JO",
  name: "Asia/Amman",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Anadyr",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Aqtau",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Aqtobe",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "TM",
  name: "Asia/Ashgabat",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "TM",
  name: "Asia/Ashkhabad",
  status: "Link",
  offset: "+05:00",
  link: "Asia/Ashgabat"
}, {
  country: "KZ",
  name: "Asia/Atyrau",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "IQ",
  name: "Asia/Baghdad",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "BH",
  name: "Asia/Bahrain",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Qatar"
}, {
  country: "AZ",
  name: "Asia/Baku",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "TH",
  name: "Asia/Bangkok",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Barnaul",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "LB",
  name: "Asia/Beirut",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "KG",
  name: "Asia/Bishkek",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "BN",
  name: "Asia/Brunei",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Kuching"
}, {
  country: "IN",
  name: "Asia/Calcutta",
  status: "Link",
  offset: "+05:30",
  link: "Asia/Kolkata"
}, {
  country: "RU",
  name: "Asia/Chita",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Choibalsan",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Chongqing",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "CN",
  name: "Asia/Chungking",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "LK",
  name: "Asia/Colombo",
  status: "Canonical",
  offset: "+05:30",
  link: ""
}, {
  country: "BD",
  name: "Asia/Dacca",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Dhaka"
}, {
  country: "SY",
  name: "Asia/Damascus",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "BD",
  name: "Asia/Dhaka",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "TL",
  name: "Asia/Dili",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "AE",
  name: "Asia/Dubai",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "TJ",
  name: "Asia/Dushanbe",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "CY",
  name: "Asia/Famagusta",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "PS",
  name: "Asia/Gaza",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Harbin",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "PS",
  name: "Asia/Hebron",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "VN",
  name: "Asia/Ho_Chi_Minh",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "HK",
  name: "Asia/Hong_Kong",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Hovd",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Irkutsk",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "TR",
  name: "Asia/Istanbul",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Istanbul"
}, {
  country: "ID",
  name: "Asia/Jakarta",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Jayapura",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "IL",
  name: "Asia/Jerusalem",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "AF",
  name: "Asia/Kabul",
  status: "Canonical",
  offset: "+04:30",
  link: ""
}, {
  country: "RU",
  name: "Asia/Kamchatka",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "PK",
  name: "Asia/Karachi",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Kashgar",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Urumqi"
}, {
  country: "NP",
  name: "Asia/Kathmandu",
  status: "Canonical",
  offset: "+05:45",
  link: ""
}, {
  country: "NP",
  name: "Asia/Katmandu",
  status: "Link",
  offset: "+05:45",
  link: "Asia/Kathmandu"
}, {
  country: "RU",
  name: "Asia/Khandyga",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "IN",
  name: "Asia/Kolkata",
  status: "Canonical",
  offset: "+05:30",
  link: "Time in India"
}, {
  country: "RU",
  name: "Asia/Krasnoyarsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "MY",
  name: "Asia/Kuala_Lumpur",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Singapore"
}, {
  country: "MY",
  name: "Asia/Kuching",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "KW",
  name: "Asia/Kuwait",
  status: "Link",
  offset: "+03:00",
  link: "Asia/Riyadh"
}, {
  country: "MO",
  name: "Asia/Macao",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Macau"
}, {
  country: "MO",
  name: "Asia/Macau",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Magadan",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Makassar",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "PH",
  name: "Asia/Manila",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "OM",
  name: "Asia/Muscat",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "CY",
  name: "Asia/Nicosia",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Novokuznetsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Novosibirsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Omsk",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Oral",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KH",
  name: "Asia/Phnom_Penh",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "ID",
  name: "Asia/Pontianak",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "KP",
  name: "Asia/Pyongyang",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "QA",
  name: "Asia/Qatar",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Qostanay",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KZ",
  name: "Asia/Qyzylorda",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "MM",
  name: "Asia/Rangoon",
  status: "Link",
  offset: "+06:30",
  link: "Asia/Yangon"
}, {
  country: "SA",
  name: "Asia/Riyadh",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "VN",
  name: "Asia/Saigon",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Ho_Chi_Minh"
}, {
  country: "RU",
  name: "Asia/Sakhalin",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "UZ",
  name: "Asia/Samarkand",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "KR",
  name: "Asia/Seoul",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "CN",
  name: "Asia/Shanghai",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "SG",
  name: "Asia/Singapore",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Srednekolymsk",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "TW",
  name: "Asia/Taipei",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "UZ",
  name: "Asia/Tashkent",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "GE",
  name: "Asia/Tbilisi",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "IR",
  name: "Asia/Tehran",
  status: "Canonical",
  offset: "+03:30",
  link: ""
}, {
  country: "IL",
  name: "Asia/Tel_Aviv",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Jerusalem"
}, {
  country: "BT",
  name: "Asia/Thimbu",
  status: "Link",
  offset: "+06:00",
  link: "Asia/Thimphu"
}, {
  country: "BT",
  name: "Asia/Thimphu",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "JP",
  name: "Asia/Tokyo",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Tomsk",
  status: "Canonical",
  offset: "+07:00",
  link: ""
}, {
  country: "ID",
  name: "Asia/Ujung_Pandang",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Makassar"
}, {
  country: "MN",
  name: "Asia/Ulaanbaatar",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "MN",
  name: "Asia/Ulan_Bator",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Ulaanbaatar"
}, {
  country: "CN",
  name: "Asia/Urumqi",
  status: "Canonical",
  offset: "+06:00",
  link: "Asia/Urumqi"
}, {
  country: "RU",
  name: "Asia/Ust-Nera",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "LA",
  name: "Asia/Vientiane",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "RU",
  name: "Asia/Vladivostok",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "RU",
  name: "Asia/Yakutsk",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "MM",
  name: "Asia/Yangon",
  status: "Canonical",
  offset: "+06:30",
  link: ""
}, {
  country: "RU",
  name: "Asia/Yekaterinburg",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "AM",
  name: "Asia/Yerevan",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "PT",
  name: "Atlantic/Azores",
  status: "Canonical",
  offset: "−01:00",
  link: ""
}, {
  country: "BM",
  name: "Atlantic/Bermuda",
  status: "Canonical",
  offset: "−04:00",
  link: ""
}, {
  country: "ES",
  name: "Atlantic/Canary",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "CV",
  name: "Atlantic/Cape_Verde",
  status: "Canonical",
  offset: "−01:00",
  link: ""
}, {
  country: "FO",
  name: "Atlantic/Faeroe",
  status: "Link",
  offset: "+00:00",
  link: "Atlantic/Faroe"
}, {
  country: "FO",
  name: "Atlantic/Faroe",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "SJ",
  name: "Atlantic/Jan_Mayen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "PT",
  name: "Atlantic/Madeira",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "IS",
  name: "Atlantic/Reykjavik",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "GS",
  name: "Atlantic/South_Georgia",
  status: "Canonical",
  offset: "−02:00",
  link: ""
}, {
  country: "SH",
  name: "Atlantic/St_Helena",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "FK",
  name: "Atlantic/Stanley",
  status: "Canonical",
  offset: "−03:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/ACT",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Adelaide",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Brisbane",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Broken_Hill",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Canberra",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Currie",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Hobart"
}, {
  country: "AU",
  name: "Australia/Darwin",
  status: "Canonical",
  offset: "+09:30",
  link: ""
}, {
  country: "AU",
  name: "Australia/Eucla",
  status: "Canonical",
  offset: "+08:45",
  link: ""
}, {
  country: "AU",
  name: "Australia/Hobart",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/LHI",
  status: "Link",
  offset: "+10:30",
  link: "Australia/Lord_Howe"
}, {
  country: "AU",
  name: "Australia/Lindeman",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Lord_Howe",
  status: "Canonical",
  offset: "+10:30",
  link: "This is the only time zone in the world that uses 30-minute DST transitions."
}, {
  country: "AU",
  name: "Australia/Melbourne",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/North",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Darwin"
}, {
  country: "AU",
  name: "Australia/NSW",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Sydney"
}, {
  country: "AU",
  name: "Australia/Perth",
  status: "Canonical",
  offset: "+08:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Queensland",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Brisbane"
}, {
  country: "AU",
  name: "Australia/South",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Adelaide"
}, {
  country: "AU",
  name: "Australia/Sydney",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "AU",
  name: "Australia/Tasmania",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Hobart"
}, {
  country: "AU",
  name: "Australia/Victoria",
  status: "Link",
  offset: "+10:00",
  link: "Australia/Melbourne"
}, {
  country: "AU",
  name: "Australia/West",
  status: "Link",
  offset: "+08:00",
  link: "Australia/Perth"
}, {
  country: "AU",
  name: "Australia/Yancowinna",
  status: "Link",
  offset: "+09:30",
  link: "Australia/Broken_Hill"
}, {
  country: "BR",
  name: "Brazil/Acre",
  status: "Link",
  offset: "−05:00",
  link: "America/Rio_Branco"
}, {
  country: "BR",
  name: "Brazil/DeNoronha",
  status: "Link",
  offset: "−02:00",
  link: "America/Noronha"
}, {
  country: "BR",
  name: "Brazil/East",
  status: "Link",
  offset: "−03:00",
  link: "America/Sao_Paulo"
}, {
  country: "BR",
  name: "Brazil/West",
  status: "Link",
  offset: "−04:00",
  link: "America/Manaus"
}, {
  country: "CA",
  name: "Canada/Atlantic",
  status: "Link",
  offset: "−04:00",
  link: "America/Halifax"
}, {
  country: "CA",
  name: "Canada/Central",
  status: "Link",
  offset: "−06:00",
  link: "America/Winnipeg"
}, {
  country: "CA",
  name: "Canada/Eastern",
  status: "Link",
  offset: "−05:00",
  link: "America/Toronto"
}, {
  country: "CA",
  name: "Canada/Mountain",
  status: "Link",
  offset: "−07:00",
  link: "America/Edmonton"
}, {
  country: "CA",
  name: "Canada/Newfoundland",
  status: "Link",
  offset: "−03:30",
  link: "America/St_Johns"
}, {
  country: "CA",
  name: "Canada/Pacific",
  status: "Link",
  offset: "−08:00",
  link: "America/Vancouver"
}, {
  country: "CA",
  name: "Canada/Saskatchewan",
  status: "Link",
  offset: "−06:00",
  link: "America/Regina"
}, {
  country: "CA",
  name: "Canada/Yukon",
  status: "Link",
  offset: "−07:00",
  link: "America/Whitehorse"
}, {
  country: "",
  name: "CET",
  status: "Canonical",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "CL",
  name: "Chile/Continental",
  status: "Link",
  offset: "−04:00",
  link: "America/Santiago"
}, {
  country: "CL",
  name: "Chile/EasterIsland",
  status: "Link",
  offset: "−06:00",
  link: "Pacific/Easter"
}, {
  country: "",
  name: "CST6CDT",
  status: "Canonical",
  offset: "−06:00",
  link: "America/Chicago"
}, {
  country: "CU",
  name: "Cuba",
  status: "Link",
  offset: "−05:00",
  link: "America/Havana"
}, {
  country: "",
  name: "EET",
  status: "Canonical",
  offset: "+02:00",
  link: "Europe/Sofia"
}, {
  country: "EG",
  name: "Egypt",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Cairo"
}, {
  country: "IE",
  name: "Eire",
  status: "Link",
  offset: "+00:00",
  link: "Europe/Dublin"
}, {
  country: "",
  name: "EST",
  status: "Canonical",
  offset: "−05:00",
  link: "America/Cancun"
}, {
  country: "",
  name: "EST5EDT",
  status: "Canonical",
  offset: "−05:00",
  link: "America/New_York"
}, {
  country: "",
  name: "Etc/GMT",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "",
  name: "Etc/GMT+0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/GMT+1",
  status: "Canonical",
  offset: "−01:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+10",
  status: "Canonical",
  offset: "−10:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+11",
  status: "Canonical",
  offset: "−11:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+12",
  status: "Canonical",
  offset: "−12:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+2",
  status: "Canonical",
  offset: "−02:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+3",
  status: "Canonical",
  offset: "−03:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+4",
  status: "Canonical",
  offset: "−04:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+5",
  status: "Canonical",
  offset: "−05:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+6",
  status: "Canonical",
  offset: "−06:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+7",
  status: "Canonical",
  offset: "−07:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+8",
  status: "Canonical",
  offset: "−08:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT+9",
  status: "Canonical",
  offset: "−09:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/GMT-1",
  status: "Canonical",
  offset: "+01:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-10",
  status: "Canonical",
  offset: "+10:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-11",
  status: "Canonical",
  offset: "+11:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-12",
  status: "Canonical",
  offset: "+12:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-13",
  status: "Canonical",
  offset: "+13:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-14",
  status: "Canonical",
  offset: "+14:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-2",
  status: "Canonical",
  offset: "+02:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-3",
  status: "Canonical",
  offset: "+03:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-4",
  status: "Canonical",
  offset: "+04:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-5",
  status: "Canonical",
  offset: "+05:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-6",
  status: "Canonical",
  offset: "+06:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-7",
  status: "Canonical",
  offset: "+07:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-8",
  status: "Canonical",
  offset: "+08:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT-9",
  status: "Canonical",
  offset: "+09:00",
  link: "Etc area description"
}, {
  country: "",
  name: "Etc/GMT0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/Greenwich",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Etc/UCT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Etc/Universal",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Etc/UTC",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "",
  name: "Etc/Zulu",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "NL",
  name: "Europe/Amsterdam",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Brussels"
}, {
  country: "AD",
  name: "Europe/Andorra",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Astrakhan",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "GR",
  name: "Europe/Athens",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "GB",
  name: "Europe/Belfast",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "RS",
  name: "Europe/Belgrade",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "DE",
  name: "Europe/Berlin",
  status: "Canonical",
  offset: "+01:00",
  link: "Trizone"
}, {
  country: "SK",
  name: "Europe/Bratislava",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Prague"
}, {
  country: "BE",
  name: "Europe/Brussels",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RO",
  name: "Europe/Bucharest",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "HU",
  name: "Europe/Budapest",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "DE",
  name: "Europe/Busingen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Zurich"
}, {
  country: "MD",
  name: "Europe/Chisinau",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "DK",
  name: "Europe/Copenhagen",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "IE",
  name: "Europe/Dublin",
  status: "Canonical",
  offset: "+00:00",
  link: "Irish Standard Time"
}, {
  country: "GI",
  name: "Europe/Gibraltar",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "GG",
  name: "Europe/Guernsey",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "FI",
  name: "Europe/Helsinki",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "IM",
  name: "Europe/Isle_of_Man",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "TR",
  name: "Europe/Istanbul",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "JE",
  name: "Europe/Jersey",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "RU",
  name: "Europe/Kaliningrad",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Kiev",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "RU",
  name: "Europe/Kirov",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Kyiv",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "PT",
  name: "Europe/Lisbon",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "SI",
  name: "Europe/Ljubljana",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "GB",
  name: "Europe/London",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "LU",
  name: "Europe/Luxembourg",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Brussels"
}, {
  country: "ES",
  name: "Europe/Madrid",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "MT",
  name: "Europe/Malta",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "AX",
  name: "Europe/Mariehamn",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Helsinki"
}, {
  country: "BY",
  name: "Europe/Minsk",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "MC",
  name: "Europe/Monaco",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "RU",
  name: "Europe/Moscow",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "CY",
  name: "Europe/Nicosia",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Nicosia"
}, {
  country: "NO",
  name: "Europe/Oslo",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "FR",
  name: "Europe/Paris",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "ME",
  name: "Europe/Podgorica",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "CZ",
  name: "Europe/Prague",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "LV",
  name: "Europe/Riga",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "IT",
  name: "Europe/Rome",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Samara",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "SM",
  name: "Europe/San_Marino",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Rome"
}, {
  country: "BA",
  name: "Europe/Sarajevo",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "RU",
  name: "Europe/Saratov",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Simferopol",
  status: "Canonical",
  offset: "+03:00",
  link: "Disputed - Reflects data in the TZDB."
}, {
  country: "MK",
  name: "Europe/Skopje",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "BG",
  name: "Europe/Sofia",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "SE",
  name: "Europe/Stockholm",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Berlin"
}, {
  country: "EE",
  name: "Europe/Tallinn",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "AL",
  name: "Europe/Tirane",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "MD",
  name: "Europe/Tiraspol",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Chisinau"
}, {
  country: "RU",
  name: "Europe/Ulyanovsk",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "UA",
  name: "Europe/Uzhgorod",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "LI",
  name: "Europe/Vaduz",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Zurich"
}, {
  country: "VA",
  name: "Europe/Vatican",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Rome"
}, {
  country: "AT",
  name: "Europe/Vienna",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "LT",
  name: "Europe/Vilnius",
  status: "Canonical",
  offset: "+02:00",
  link: ""
}, {
  country: "RU",
  name: "Europe/Volgograd",
  status: "Canonical",
  offset: "+03:00",
  link: ""
}, {
  country: "PL",
  name: "Europe/Warsaw",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "HR",
  name: "Europe/Zagreb",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Belgrade"
}, {
  country: "UA",
  name: "Europe/Zaporozhye",
  status: "Link",
  offset: "+02:00",
  link: "Europe/Kyiv"
}, {
  country: "CH",
  name: "Europe/Zurich",
  status: "Canonical",
  offset: "+01:00",
  link: ""
}, {
  country: "",
  name: "Factory",
  status: "Canonical",
  offset: "+00:00",
  link: ""
}, {
  country: "GB",
  name: "GB",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "GB",
  name: "GB-Eire",
  status: "Link",
  offset: "+00:00",
  link: "Europe/London"
}, {
  country: "",
  name: "GMT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT+0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT-0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "GMT0",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "",
  name: "Greenwich",
  status: "Link",
  offset: "+00:00",
  link: "Etc/GMT"
}, {
  country: "HK",
  name: "Hongkong",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Hong_Kong"
}, {
  country: "",
  name: "HST",
  status: "Canonical",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "IS",
  name: "Iceland",
  status: "Link",
  offset: "+00:00",
  link: "Africa/Abidjan"
}, {
  country: "MG",
  name: "Indian/Antananarivo",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "IO",
  name: "Indian/Chagos",
  status: "Canonical",
  offset: "+06:00",
  link: ""
}, {
  country: "CX",
  name: "Indian/Christmas",
  status: "Link",
  offset: "+07:00",
  link: "Asia/Bangkok"
}, {
  country: "CC",
  name: "Indian/Cocos",
  status: "Link",
  offset: "+06:30",
  link: "Asia/Yangon"
}, {
  country: "KM",
  name: "Indian/Comoro",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "TF",
  name: "Indian/Kerguelen",
  status: "Link",
  offset: "+05:00",
  link: "Indian/Maldives"
}, {
  country: "SC",
  name: "Indian/Mahe",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "MV",
  name: "Indian/Maldives",
  status: "Canonical",
  offset: "+05:00",
  link: ""
}, {
  country: "MU",
  name: "Indian/Mauritius",
  status: "Canonical",
  offset: "+04:00",
  link: ""
}, {
  country: "YT",
  name: "Indian/Mayotte",
  status: "Link",
  offset: "+03:00",
  link: "Africa/Nairobi"
}, {
  country: "RE",
  name: "Indian/Reunion",
  status: "Link",
  offset: "+04:00",
  link: "Asia/Dubai"
}, {
  country: "IR",
  name: "Iran",
  status: "Link",
  offset: "+03:30",
  link: "Asia/Tehran"
}, {
  country: "IL",
  name: "Israel",
  status: "Link",
  offset: "+02:00",
  link: "Asia/Jerusalem"
}, {
  country: "JM",
  name: "Jamaica",
  status: "Link",
  offset: "−05:00",
  link: "America/Jamaica"
}, {
  country: "JP",
  name: "Japan",
  status: "Link",
  offset: "+09:00",
  link: "Asia/Tokyo"
}, {
  country: "MH",
  name: "Kwajalein",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Kwajalein"
}, {
  country: "LY",
  name: "Libya",
  status: "Link",
  offset: "+02:00",
  link: "Africa/Tripoli"
}, {
  country: "",
  name: "MET",
  status: "Canonical",
  offset: "+01:00",
  link: "Europe/Paris"
}, {
  country: "MX",
  name: "Mexico/BajaNorte",
  status: "Link",
  offset: "−08:00",
  link: "America/Tijuana"
}, {
  country: "MX",
  name: "Mexico/BajaSur",
  status: "Link",
  offset: "−07:00",
  link: "America/Mazatlan"
}, {
  country: "MX",
  name: "Mexico/General",
  status: "Link",
  offset: "−06:00",
  link: "America/Mexico_City"
}, {
  country: "",
  name: "MST",
  status: "Canonical",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "",
  name: "MST7MDT",
  status: "Canonical",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "Navajo",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "NZ",
  name: "NZ",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Auckland"
}, {
  country: "NZ",
  name: "NZ-CHAT",
  status: "Link",
  offset: "+12:45",
  link: "Pacific/Chatham"
}, {
  country: "WS",
  name: "Pacific/Apia",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "NZ",
  name: "Pacific/Auckland",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "PG",
  name: "Pacific/Bougainville",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "NZ",
  name: "Pacific/Chatham",
  status: "Canonical",
  offset: "+12:45",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Chuuk",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "CL",
  name: "Pacific/Easter",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "VU",
  name: "Pacific/Efate",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Enderbury",
  status: "Link",
  offset: "+13:00",
  link: "Pacific/Kanton"
}, {
  country: "TK",
  name: "Pacific/Fakaofo",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "FJ",
  name: "Pacific/Fiji",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "TV",
  name: "Pacific/Funafuti",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "EC",
  name: "Pacific/Galapagos",
  status: "Canonical",
  offset: "−06:00",
  link: ""
}, {
  country: "PF",
  name: "Pacific/Gambier",
  status: "Canonical",
  offset: "−09:00",
  link: ""
}, {
  country: "SB",
  name: "Pacific/Guadalcanal",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "GU",
  name: "Pacific/Guam",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "US",
  name: "Pacific/Honolulu",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "US",
  name: "Pacific/Johnston",
  status: "Link",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "KI",
  name: "Pacific/Kanton",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Kiritimati",
  status: "Canonical",
  offset: "+14:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Kosrae",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "MH",
  name: "Pacific/Kwajalein",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "MH",
  name: "Pacific/Majuro",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "PF",
  name: "Pacific/Marquesas",
  status: "Canonical",
  offset: "−09:30",
  link: ""
}, {
  country: "UM",
  name: "Pacific/Midway",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "NR",
  name: "Pacific/Nauru",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "NU",
  name: "Pacific/Niue",
  status: "Canonical",
  offset: "−11:00",
  link: ""
}, {
  country: "NF",
  name: "Pacific/Norfolk",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "NC",
  name: "Pacific/Noumea",
  status: "Canonical",
  offset: "+11:00",
  link: ""
}, {
  country: "AS",
  name: "Pacific/Pago_Pago",
  status: "Canonical",
  offset: "−11:00",
  link: ""
}, {
  country: "PW",
  name: "Pacific/Palau",
  status: "Canonical",
  offset: "+09:00",
  link: ""
}, {
  country: "PN",
  name: "Pacific/Pitcairn",
  status: "Canonical",
  offset: "−08:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Pohnpei",
  status: "Link",
  offset: "+11:00",
  link: "Pacific/Guadalcanal"
}, {
  country: "FM",
  name: "Pacific/Ponape",
  status: "Link",
  offset: "+11:00",
  link: "Pacific/Guadalcanal"
}, {
  country: "PG",
  name: "Pacific/Port_Moresby",
  status: "Canonical",
  offset: "+10:00",
  link: ""
}, {
  country: "CK",
  name: "Pacific/Rarotonga",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "MP",
  name: "Pacific/Saipan",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Guam"
}, {
  country: "AS",
  name: "Pacific/Samoa",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "PF",
  name: "Pacific/Tahiti",
  status: "Canonical",
  offset: "−10:00",
  link: ""
}, {
  country: "KI",
  name: "Pacific/Tarawa",
  status: "Canonical",
  offset: "+12:00",
  link: ""
}, {
  country: "TO",
  name: "Pacific/Tongatapu",
  status: "Canonical",
  offset: "+13:00",
  link: ""
}, {
  country: "FM",
  name: "Pacific/Truk",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "UM",
  name: "Pacific/Wake",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "WF",
  name: "Pacific/Wallis",
  status: "Link",
  offset: "+12:00",
  link: "Pacific/Tarawa"
}, {
  country: "FM",
  name: "Pacific/Yap",
  status: "Link",
  offset: "+10:00",
  link: "Pacific/Port_Moresby"
}, {
  country: "PL",
  name: "Poland",
  status: "Link",
  offset: "+01:00",
  link: "Europe/Warsaw"
}, {
  country: "PT",
  name: "Portugal",
  status: "Link",
  offset: "+00:00",
  link: "Europe/Lisbon"
}, {
  country: "CN",
  name: "PRC",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Shanghai"
}, {
  country: "",
  name: "PST8PDT",
  status: "Canonical",
  offset: "−08:00",
  link: "America/Los_Angeles"
}, {
  country: "TW",
  name: "ROC",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Taipei"
}, {
  country: "KR",
  name: "ROK",
  status: "Link",
  offset: "+09:00",
  link: "Asia/Seoul"
}, {
  country: "SG",
  name: "Singapore",
  status: "Link",
  offset: "+08:00",
  link: "Asia/Singapore"
}, {
  country: "TR",
  name: "Turkey",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Istanbul"
}, {
  country: "",
  name: "UCT",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "",
  name: "Universal",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "US",
  name: "US/Alaska",
  status: "Link",
  offset: "−09:00",
  link: "America/Anchorage"
}, {
  country: "US",
  name: "US/Aleutian",
  status: "Link",
  offset: "−10:00",
  link: "America/Adak"
}, {
  country: "US",
  name: "US/Arizona",
  status: "Link",
  offset: "−07:00",
  link: "America/Phoenix"
}, {
  country: "US",
  name: "US/Central",
  status: "Link",
  offset: "−06:00",
  link: "America/Chicago"
}, {
  country: "US",
  name: "US/East-Indiana",
  status: "Link",
  offset: "−05:00",
  link: "America/Indiana/Indianapolis"
}, {
  country: "US",
  name: "US/Eastern",
  status: "Link",
  offset: "−05:00",
  link: "America/New_York"
}, {
  country: "US",
  name: "US/Hawaii",
  status: "Link",
  offset: "−10:00",
  link: "Pacific/Honolulu"
}, {
  country: "US",
  name: "US/Indiana-Starke",
  status: "Link",
  offset: "−06:00",
  link: "America/Indiana/Knox"
}, {
  country: "US",
  name: "US/Michigan",
  status: "Link",
  offset: "−05:00",
  link: "America/Detroit"
}, {
  country: "US",
  name: "US/Mountain",
  status: "Link",
  offset: "−07:00",
  link: "America/Denver"
}, {
  country: "US",
  name: "US/Pacific",
  status: "Link",
  offset: "−08:00",
  link: "America/Los_Angeles"
}, {
  country: "AS",
  name: "US/Samoa",
  status: "Link",
  offset: "−11:00",
  link: "Pacific/Pago_Pago"
}, {
  country: "",
  name: "UTC",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}, {
  country: "RU",
  name: "W-SU",
  status: "Link",
  offset: "+03:00",
  link: "Europe/Moscow"
}, {
  country: "",
  name: "WET",
  status: "Canonical",
  offset: "+00:00",
  link: "Europe/Lisbon"
}, {
  country: "",
  name: "Zulu",
  status: "Link",
  offset: "+00:00",
  link: "Etc/UTC"
}];
vp = Us.TIMEZONES = J_;
const X_ = /* @__PURE__ */ Yu({
  __proto__: null,
  get TIMEZONES() {
    return vp;
  },
  default: Us
}, [Us]), Z_ = /* @__PURE__ */ gp(X_);
Object.defineProperty(Et, "__esModule", {
  value: !0
});
var yp = Et.findTzByKey = xp = Et.findTzByName = bp = Et.tzRawData = Ep = Et.clientTz = wp = Et.listTz = void 0, yl = Z_, eS = yl.TIMEZONES, bp = Et.tzRawData = eS, bl = function(t) {
  return yl.TIMEZONES.find(function(n) {
    return n.name === t;
  });
};
yp = Et.findTzByKey = bl;
var tS = function(t, n) {
  var a = n || Cp();
  return a.find(function(s) {
    return s.included && s.included.includes(t);
  });
}, xp = Et.findTzByName = tS, xu = function(t) {
  var n = t.data, a = t.displayName, s = t.offset;
  return {
    value: n.name,
    label: "(GMT".concat(n.offset, ") ").concat(a),
    included: [n.name],
    country: n.country,
    offset: n.offset,
    offsetValue: s
  };
}, nS = function() {
  var t = Intl.DateTimeFormat().resolvedOptions().timeZone, n = bl(t);
  return n.status === "Deprecated" ? n.link : t;
}, Ep = Et.clientTz = nS, Eu = function(t) {
  var n = t.offset.split(/\d+/g), a;
  n[0] === "+" ? a = "+" : a = "-", t.offset = t.offset.replace(n[0], a);
  var s = +t.offset.replace(":", ""), o = t.name.split("/").slice(1), i = o.join("-").replace(/_/g, " "), r = "".concat(t.country, "_").concat(t.offset);
  return {
    key: r,
    offset: s,
    displayName: i
  };
}, Cp = function() {
  var t = yl.TIMEZONES.reduce(function(n, a) {
    if (a.status === "Deprecated") {
      if (a.link) {
        var s = bl(a.link), o = Eu(s), i = o.key, r = o.displayName, l = o.offset;
        n[i] ? n[i].included.push(a.name) : n[i] = xu({
          data: s,
          displayName: r,
          offset: l
        });
      }
    } else if (a.country !== "") {
      var c = Eu(a), u = c.key, d = c.displayName, m = c.offset;
      n[u] ? n[u].included && !n[u].included.includes(a.name) && (n[u].label += ", ".concat(d), n[u].included.push(a.name)) : n[u] = xu({
        data: a,
        displayName: d,
        offset: m
      });
    }
    return n;
  }, {});
  return Object.values(t).sort(function(n, a) {
    return n.offsetValue - a.offsetValue;
  });
}, wp = Et.listTz = Cp;
const aS = /* @__PURE__ */ Yu({
  __proto__: null,
  get clientTz() {
    return Ep;
  },
  default: Et,
  get findTzByKey() {
    return yp;
  },
  get findTzByName() {
    return xp;
  },
  get listTz() {
    return wp;
  },
  get tzRawData() {
    return bp;
  }
}, [Et]), sS = /* @__PURE__ */ gp(aS);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "listTz", {
    enumerable: !0,
    get: function() {
      return t.listTz;
    }
  }), Object.defineProperty(e, "clientTz", {
    enumerable: !0,
    get: function() {
      return t.clientTz;
    }
  }), Object.defineProperty(e, "findTzByName", {
    enumerable: !0,
    get: function() {
      return t.findTzByName;
    }
  }), Object.defineProperty(e, "tzRawData", {
    enumerable: !0,
    get: function() {
      return t.tzRawData;
    }
  }), Object.defineProperty(e, "findTzByKey", {
    enumerable: !0,
    get: function() {
      return t.findTzByKey;
    }
  });
  var t = sS;
})(hp);
const oS = 70, iS = 60, pL = /* @__PURE__ */ j({
  __name: "AppTimezoneComponent",
  setup(e) {
    const t = Ef(), n = Kn(), a = typeof window < "u" && window.innerHeight < 1200 ? iS : oS, s = T(), i = hp.listTz().flatMap((m) => d(m)), r = sp(), l = T(r.getUser()), c = T(l.value.additionalData.timezone), u = async (m) => {
      await t.setUserTimezone(m.value), n.updateUserTimezone(m.value);
    };
    function d(m) {
      if (!m.label || m.label.length <= a || !m.label.includes(","))
        return [m];
      const g = Array.isArray(m.included) && m.included.length ? m.included : [m.value], h = m.label.split(",").map((p) => p.trim()).filter(Boolean), A = m.label.match(/^\(GMT[^)]+\)/), f = A ? `${A[0]}` : "";
      return g.map((p, v) => {
        const b = h[v] ?? h[h.length - 1] ?? m.label, y = b.startsWith("(GMT") || !f ? b : `${f} ${b}`;
        return {
          ...m,
          value: p,
          label: y,
          included: [p]
        };
      });
    }
    return Ge(() => {
      n.getUserTimezone() !== "" ? s.value = i.find((m) => m.value === n.getUserTimezone()).value : c.value && (s.value = i.find((m) => m.value === c.value).value);
    }), (m, g) => (C(), H(k(Sn), null, {
      default: D(() => [
        B(k(Yo), {
          class: "w-full timezone-select",
          modelValue: s.value,
          "onUpdate:modelValue": g[0] || (g[0] = (h) => s.value = h),
          options: k(i),
          filter: "",
          "option-value": "value",
          "option-label": "label",
          "data-cy": "user-timezone-select",
          placeholder: m.$t("shared.selectTimezone"),
          onChange: u
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _: 1
    }));
  }
});
var di = /* @__PURE__ */ ((e) => (e.US = "en-US", e.EU = "it-IT", e))(di || {});
function mL(e, t, n) {
  const a = new Date(e);
  if (isNaN(a.getTime())) return "No Date Set";
  t || (t = di.EU);
  const s = a.getDate(), o = a.getMonth() + 1, i = a.getFullYear();
  return t.includes("US") ? a.toLocaleDateString(t, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    ...n
  }) : `${s.toString().padStart(2, "0")}.${o.toString().padStart(2, "0")}.${i}`;
}
function AL(e, t, n) {
  const a = new Date(e);
  return isNaN(a.getTime()) ? "No Time Set" : (t || (t = di.EU), a.toLocaleTimeString(t, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: t.includes("US"),
    ...n
  }));
}
function gL(e) {
  return e || (e = di.EU), {
    "en-US": "mm/dd/yy",
    "it-IT": "dd.mm.yy"
  }[e] || "dd.mm.yy";
}
var rS = /* @__PURE__ */ ((e) => (e[e.TEXT = 0] = "TEXT", e[e.DROPDOWN = 1] = "DROPDOWN", e[e.TEXT_OR_DROPDOWN = 2] = "TEXT_OR_DROPDOWN", e))(rS || {}), lS = /* @__PURE__ */ ((e) => (e[e.WORKFLOW = 0] = "WORKFLOW", e[e.STATUS = 1] = "STATUS", e[e.PRODUCTION_STEP = 2] = "PRODUCTION_STEP", e[e.OPERATOR = 3] = "OPERATOR", e[e.CONNECTION = 4] = "CONNECTION", e[e.MACHINE = 5] = "MACHINE", e))(lS || {}), cS = /* @__PURE__ */ ((e) => (e.technician = "technician", e.technicianFullScreen = "technicianFullScreen", e.customer = "customer", e))(cS || {}), uS = /* @__PURE__ */ ((e) => (e.ORDER_ATTACHMENT = "order_attachment", e.ORDER_NO_ATTACHMENT = "order_no_attachment", e.ORDER_FROM_WEBLINK = "order_from_weblink", e.PANDORA = "pandora", e))(uS || {}), dS = /* @__PURE__ */ ((e) => (e.WEBLINK = "weblink", e))(dS || {}), fS = /* @__PURE__ */ ((e) => (e[e.SAVING = 0] = "SAVING", e[e.UPLOADING = 1] = "UPLOADING", e[e.DONE = 2] = "DONE", e[e.ERROR = 3] = "ERROR", e))(fS || {}), pS = /* @__PURE__ */ ((e) => (e[e.INIT = 0] = "INIT", e[e.ADD = 1] = "ADD", e[e.EDIT = 2] = "EDIT", e[e.DELETE = 3] = "DELETE", e[e.ERROR = 4] = "ERROR", e))(pS || {});
const hL = (e) => e.name.toLowerCase().endsWith(".dcm") || e.type.toLowerCase() === "application/dicom", vL = (e) => e.reduce((t, n) => t + Math.max(1, Number(n.nOfFrames) || 1), 0), yL = (e, t = 5, n = 1e-4) => {
  if (e.length < t) return !1;
  const a = (o) => o.split("\\").map(Number), s = a(e[0].direction);
  return s.length < 6 || s.slice(0, 6).some((o) => !Number.isFinite(o)) ? !1 : e.slice(1, t).every((o) => {
    const i = a(o.direction);
    return i.length >= 6 && i.slice(0, 6).every((r, l) => Number.isFinite(r) && Math.abs(r - s[l]) <= n);
  });
}, bL = (e, t) => Number.isFinite(e) && e > 0 && t.every((n) => Number.isFinite(n) && n > 0), xL = (e, t, n, a) => {
  let s = e.get(t);
  s || (s = /* @__PURE__ */ new Map(), e.set(t, s));
  const o = s.get(n);
  o ? o.push(a) : s.set(n, [a]);
}, EL = (e) => {
  if (!e.length) return null;
  const t = Number(e[0].nOfFrames);
  if (t > 1) return { fileName: e[0].fileName, frameId: Math.floor(t / 2) };
  if (!e[0].slicePos)
    return { fileName: e[0].fileName, frameId: Math.floor(Number(e[0].nOfFrames) / 2) };
  const n = e[0].direction.split("\\").map(Number), a = [n[1] * n[5] - n[2] * n[4], n[2] * n[3] - n[0] * n[5], n[0] * n[4] - n[1] * n[3]], s = e.map((c) => ({
    slice: c,
    z: c.slicePos.split("\\").map(Number).reduce((u, d, m) => u + d * a[m], 0)
  })).filter(({ z: c }) => Number.isFinite(c));
  if (!s.length) return null;
  const o = Math.min(...s.map(({ z: c }) => c)), i = Math.max(...s.map(({ z: c }) => c)), r = (o + i) / 2;
  return { fileName: s.reduce((c, u) => Math.abs(u.z - r) <= Math.abs(c.z - r) ? u : c, s[0]).slice.fileName, frameId: -1 };
}, mS = (e) => e.length >= 132 && e[128] === 68 && e[129] === 73 && e[130] === 67 && e[131] === 77, CL = (e, t) => {
  if (mS(t)) return !0;
  if (t.length < 8) return !1;
  if (/\.(dcm|dicom|ima)$/i.test(e)) return !0;
  const n = new DataView(t.buffer, t.byteOffset, t.byteLength);
  return [!0, !1].some((a) => {
    if (![2, 8, 16, 24, 32, 40].includes(n.getUint16(0, a))) return !1;
    const s = String.fromCharCode(t[4], t[5]), o = /^(AE|AS|AT|CS|DA|DS|DT|FD|FL|IS|LO|LT|OB|OD|OF|OL|OV|OW|PN|SH|SL|SQ|SS|ST|SV|TM|UC|UI|UL|UN|UR|US|UT|UV)$/, i = n.getUint32(4, a);
    return o.test(s) || i <= t.length - 8 || i === 4294967295;
  });
}, wL = (e, t) => {
  const n = e;
  if (!n.GetVolumeMetadataJson) throw new Error("The DICOM engine must be updated to support volume validation.");
  return JSON.parse(n.GetVolumeMetadataJson(t));
}, Mi = (e) => (e || "").trim().toUpperCase().split("\\"), uo = (e, t) => !!e && e.length === t && e.every(Number.isFinite), fo = (e, t) => e.reduce((n, a, s) => n + a * t[s], 0), AS = (e) => [
  e[1] * e[5] - e[2] * e[4],
  e[2] * e[3] - e[0] * e[5],
  e[0] * e[4] - e[1] * e[3]
], gS = (e) => {
  const t = Mi(e.imageType), n = Mi(e.calculationTechnique), a = Mi(e.volumetricProperties);
  if (n.includes("CURVED_MPR") || a.includes("DISTORTED")) return "reformatted-image";
  if (t.some((s) => ["LOCALIZER", "SCOUT", "PROJECTION", "PANORAMIC", "PANORAMA", "CURVED_MPR"].includes(s)) || n.some((s) => ["MAX_IP", "MIN_IP", "VOLUME_RENDER", "SURFACE_RENDER"].includes(s)) || a.includes("SAMPLED"))
    return "projection-image";
}, IL = (e) => {
  const t = [], n = [];
  for (const d of e) {
    const m = d.metadata, g = m != null && m.readable ? m.frames.map(gS).find(Boolean) : "read-error";
    g ? t.push({ filename: d.fileName, reason: g }) : n.push(d);
  }
  const a = (d) => ({ slices: [], failures: [...t, { reason: d }] });
  if (!n.length) return { slices: n, failures: t };
  if (n.length > 1 && n.some((d) => d.metadata.frameCount > 1)) return a("invalid-geometry");
  const s = n.flatMap((d) => d.metadata.frames);
  if (s.length < 2) return a("single-plane");
  const o = n[0].metadata;
  if (n.some(
    ({ metadata: d }) => !d || !Number.isInteger(d.frameCount) || d.frameCount < 1 || d.frames.length !== d.frameCount || !uo(d.dimensions, 2) || d.dimensions.some((m, g) => m <= 0 || !Number.isInteger(m) || m !== o.dimensions[g])
  ) || s.some(
    (d) => !uo(d.direction, 6) || !uo(d.position, 3) || !uo(d.pixelSpacing, 2) || d.pixelSpacing.some((m) => m <= 0)
  ))
    return a("invalid-geometry");
  const i = s[0].direction, r = i.slice(0, 3), l = i.slice(3);
  if (Math.abs(fo(r, r) - 1) > 1e-3 || Math.abs(fo(l, l) - 1) > 1e-3 || Math.abs(fo(r, l)) > 1e-3)
    return a("invalid-geometry");
  if (s.some((d) => d.direction.some((m, g) => Math.abs(m - i[g]) > 1e-4)))
    return a("inconsistent-orientation");
  if (s.some((d) => d.pixelSpacing.some((m, g) => Math.abs(m - s[0].pixelSpacing[g]) > 1e-4)))
    return a("invalid-geometry");
  const c = AS(i), u = s.map((d) => fo(d.position, c)).sort((d, m) => d - m);
  return u.at(-1) - u[0] < 1e-4 ? a("single-plane") : u.some((d, m) => m > 0 && d - u[m - 1] < 1e-4) ? a("invalid-geometry") : { slices: n, failures: t };
}, BL = (e) => {
  const t = {
    "not-dicom": "not a DICOM image",
    "read-error": "DICOM metadata could not be read",
    "decode-error": "DICOM pixels could not be decoded",
    "single-plane": "single-plane image",
    "insufficient-slices": "insufficient slices",
    "inconsistent-orientation": "frames do not form a parallel volume",
    "invalid-geometry": "invalid volume geometry",
    "reformatted-image": "curved or distorted reformat",
    "projection-image": "X-ray, localizer, or projection image"
  };
  return [...new Set(e.map(({ reason: n }) => t[n]))].join("; ");
}, hS = {
  symbol: Symbol(),
  install(e) {
    const t = new pI();
    e.config.globalProperties.$input = t, e.provide(this.symbol, t);
  }
};
function kL() {
  return Dr(hS.symbol);
}
class vS {
  constructor(t) {
    ie(this, "instances");
    ie(this, "sessionId", "");
    this.instances = t;
  }
  applySession(t) {
    this.sessionId = t;
    for (const n of this.instances) {
      const a = n.defaults;
      a.params || (a.params = {}), a.headers.common.Authorization = `Bearer ${t}`;
    }
  }
}
const yS = {
  symbol: Symbol(),
  install(e, t) {
    const n = new vS(t.axiosInstances);
    e.config.globalProperties.$sessionManager = n, e.provide(this.symbol, n);
  }
};
function _L() {
  const e = Ht(yS.symbol);
  if (!e) throw new Error("SessionManager is null!");
  return e;
}
const bS = {
  symbol: Symbol(),
  install(e, t) {
    e.config.globalProperties.$serverApi = t, e.provide(this.symbol, t);
  }
};
function SL() {
  const e = Ht(bS.symbol);
  if (!e) throw new Error("ServerApi is null!");
  return e;
}
const xS = {
  symbol: Symbol(),
  install(e, t) {
    const n = new po.STLLibraryAPI(t.axiosInstance);
    e.config.globalProperties.$stlApi = n, e.provide(this.symbol, n);
  }
};
function DL() {
  const e = Ht(xS.symbol);
  if (!e) throw new Error("STLLibraryApi is null");
  return e;
}
export {
  Xd as AddressTypeEnum,
  pD as App,
  mD as AppConfig,
  V as AppLanguage,
  rl as AppLanguageComponent,
  Tr as AppName,
  q_ as AppNotificationConfigComponent,
  ll as AppThemeConfigComponent,
  pL as AppTimezoneComponent,
  mg as AppType,
  eT as ArrayBufferToBase64,
  $A as AssetPlugin,
  Ku as AssetPluginConfiguration,
  ro as AuthEventBus,
  NC as AuthEvents,
  QC as AuthPlugin,
  UC as AuthPluginVue,
  G as ButtonEnum,
  $a as ColorScheme,
  yn as ColorTheme,
  zA as CreateSliderModel,
  SD as CreateSliderRangeModel,
  DD as CreateSwitchModel,
  ed as DEFAULT_REMOTE_SUPPORT_URL,
  Zu as DEFAULT_VIDEO_TUTORIAL_URL,
  di as DateFormatEnum,
  xD as DefaultMap,
  ED as DownloadFile,
  rS as FieldTypeEnum,
  lS as Filter,
  kD as FilterMatchMode,
  ju as GUIConfiguration,
  mA as GUIConfigurationPluginInstaller,
  pA as GetColorScheme,
  fA as GetColorTheme,
  dA as GetDefaultPosition,
  Wn as IconPosition,
  ge as IconType,
  tL as ImageList,
  XB as ImageListItem,
  Dr as InjectPlugin,
  TM as InputDialog,
  bo as InputEventBus,
  hS as InputPluginVue,
  pI as InputService,
  NA as MButton,
  iM as MButtonMenu,
  yM as MCard,
  MM as MCenteredTextContainer,
  ZM as MChooseFolderButton,
  rM as MCloseButton,
  LM as MColorPicker,
  Jw as MColorPickerModal,
  Zw as MConfirmModal,
  ae as MContainer,
  ls as MContainerColumn,
  ca as MContainerGrow,
  Sn as MContainerRow,
  OM as MContainerSplit,
  uL as MCookieBanner,
  SM as MDialog,
  Nb as MDialogCancelButton,
  Lo as MDialogCancelButtonRedesign,
  Rb as MDialogConfirmButton,
  ni as MDialogConfirmButtonRedesign,
  xf as MDialogFooter,
  mo as MFSwitch,
  NM as MFileUpload,
  bM as MGridItem,
  xM as MGridItemCenter,
  EM as MGridItemEnd,
  CM as MGridItemExpand,
  wM as MGridItemStart,
  IM as MGridRow,
  $r as MIcon,
  ho as MIconButton,
  aI as MInfoModal,
  RM as MInfoRowItem,
  PM as MInputNumber,
  lM as MLargeIconButton,
  FM as MListComponent,
  QM as MLoading,
  I_ as MMenu,
  Sa as MModal,
  ta as MModalActionButton,
  cL as MPickList,
  yu as MPickListItem,
  UM as MProgressBar,
  GM as MSelect,
  YM as MSlider,
  jM as MSliderFixedWidth,
  HM as MStepper,
  VM as MSwitch,
  KM as MSwitchStyled,
  WM as MTabContainer,
  zM as MTabItem,
  fB as MTemplateItem,
  $M as MTemplates,
  cM as MTextButton,
  rI as MTextInputModal,
  wb as MToggleButton,
  cu as MTogglePanel,
  uM as MToolbarButton,
  wB as MTooltip,
  wt as MUButton,
  dM as MUDropdown,
  fI as MUErrorModal,
  Mb as MUInput,
  DM as MUSelectModal,
  nL as MUSwitch,
  qM as MUnsupportedBrowser,
  XM as MUploadDropArea,
  eL as MUploadFileButton,
  dI as MViewerHelpModal,
  gs as MeasurementsDistanceUnit,
  sn as MenuType,
  Pt as NavbarAction,
  De as NavbarEventBus,
  Ma as NavbarNamedEvents,
  IB as NavbarPluginVue,
  Vb as NavbarService,
  KA as NotificationType,
  YA as OemSerialNumber,
  Vs as OperatorPermissionsEnum,
  Hs as OperatorRoleEnum,
  cS as OrderListViewMode,
  uS as OrderTypeEnum,
  Bo as PRIMARY_THEME_ENTRIES,
  dS as PoolName,
  ly as QueryPluginVue,
  jA as REALGUIDE_WEB_BUILD_DATE,
  QA as RealGuideConfiguration,
  AM as RgGlobalNavbar,
  hM as RgLogoUserDropdown,
  _M as RgSubTitle,
  kM as RgTitle,
  xS as STLLibraryApiPluginVue,
  zT as STLLibraryCache,
  JM as SendMediaMessageDialog,
  bS as ServerApiPluginVue,
  vS as SessionManager,
  yS as SessionPluginVue,
  WT as SetupAppGui,
  WA as ShippingMessageType,
  OC as TVersionTypes,
  BM as TitleSmall,
  pS as UIFormState,
  fS as UIState,
  gM as UserProfileDropdown,
  vM as UserProfileTemp,
  ip as UserSettingsDialog,
  op as UserSettingsEnum,
  dL as WeblinkUploadInvalidComponent,
  fL as WeblinkUploadNoPatientIdComponent,
  ug as ZIMVIE_VIDEO_TUTORIAL_URL,
  oM as ZipGetData,
  zD as addClassToElementByClass,
  KD as addClassToElementId,
  xL as addDicomSeriesSlice,
  hT as advancedMeshFormats,
  oT as applyDefaultLayout,
  Ju as applyPrimeVuePrimaryTheme,
  wl as checkIfExtraParamEnabled,
  LD as cloneMaterialModel,
  wT as convertFileSizeToMb,
  Wu as countDecimals,
  bT as countLabelOccurrences,
  BD as createButtonModel,
  FA as createDevLogger,
  TD as createMaterialModel,
  MD as createMaterialModelWithName,
  uT as decodeFromBase64,
  CD as devLogger,
  gT as dicomFormats,
  cT as encodeToBase64,
  Oe as error,
  qT as exception,
  YD as extractSuffixes,
  sg as fileFormats,
  uy as findUserIdsByCachedAddress,
  mL as formatDateToLocale,
  Bl as formatFileSizeBytes,
  AL as formatTimeToLocale,
  ID as getAboutInfoModel,
  gL as getDateFormatFromLocale,
  sT as getDefaultColor,
  _D as getDefaultOperatorRoleModel,
  aT as getDefaultPallete,
  RD as getDefaultStatusModel,
  QD as getDefaultWorkflowModel,
  PD as getDefaultWorkflowRequestModel,
  UD as getDefaultWorkflowStatus,
  FD as getDefaultWorkflowStep,
  BL as getDicomImportFailureSummary,
  EL as getDicomMiddleSlice,
  vL as getDicomSeriesSliceCount,
  nT as getDocumentIcon,
  lT as getEnumKeyByValue,
  pT as getFileSuffixInURL,
  Io as getIconPath,
  Xs as getIconSrc,
  Oi as getImgSrc,
  ET as getKeyPrefix,
  JA as getLanguageName,
  hD as getNamespacedUuid,
  OD as getNewOperator,
  wD as getOemSerialNumber,
  ng as getPrimaryThemeEntry,
  qu as getPrimaryThemePresetExtension,
  GA as getRealGuideConfigurationIdentifier,
  mc as getSleeveOriginalName,
  DT as getStatusAppendMessage,
  _T as getStatusClass,
  ST as getStatusColor,
  BT as getStepClass,
  ZD as getStepNameTranslations,
  kT as getStepTextClass,
  yT as getStringBeforeFirstSlash,
  ao as getUserAddressLabel,
  fg as getVideoTutorialFallbackUrl,
  bD as hasAllowUnsupportedBrowser,
  yL as hasConsistentDicomOrientation,
  mS as hasDicomPart10Header,
  Ac as hasEditMaterialPermission,
  Ay as hasEditUsersPermission,
  my as hasEditWorkflowPermission,
  eM as hasPcSettingsAccess,
  tM as hasTestingViewAccess,
  zu as hasUnsupportedFile,
  bL as hasValidDicomSeriesGeometry,
  mT as imgExtendedFormats,
  og as imgFormats,
  JT as info,
  dT as initI18n,
  KT as invalidateUserAddressQueriesByAddress,
  GT as isBrowser,
  vD as isChromeUserAgent,
  hL as isDicomFile,
  CL as isDicomImportCandidate,
  yD as isIOSDevice,
  vT as isMeshFileFormat,
  HD as isMobileView,
  UT as isNode,
  VD as isTabletView,
  zs as isUserWeblinkAdmin,
  Jo as isUserWeblinkOperator,
  Xo as isUserWeblinkReadOnlyOperator,
  ZT as isUserWeblinkUser,
  tT as isValidDate,
  xT as labelAlreadyExists,
  Xu as meshFormats,
  rg as meshFormatsArray,
  zn as normalizeAppLanguage,
  Ho as normalizePrimaryTheme,
  QT as openSuppportTicket,
  MT as parseBase64CXml,
  CT as parseGenericObjectsToTree3,
  TT as parseStringCXml,
  YT as persistSessionCookie,
  GD as prepareStatusBodyModel,
  ND as prepareStepBodyModel,
  Ts as productionCenterUserAddressesQueryKey,
  Jt as queryClient,
  wL as readDicomVolumeMetadata,
  $D as removeClassToElementByClass,
  WD as removeClassToElementId,
  JD as removeElementStyle,
  IT as removeFileExtensions,
  jD as removeFileExtesion,
  ag as replaceSuffix,
  fT as replaceSuffixInURL,
  IL as selectDicomVolumeSeries,
  qD as setElementFullHeight,
  iT as setPatientListBackground,
  XA as setProfileBtnMargin,
  rT as setWizardBackground,
  $T as setupNotificationStore,
  gD as sha1,
  AD as sha256,
  We as success,
  AT as textureFormats,
  XD as toCamelCase,
  Xb as toRealguideLanguageCode,
  RT as toRemoteSupport,
  LT as toUserDashboard,
  OT as toUserForgetPassoword,
  NT as toVideoTutorial,
  PT as toWebRG,
  FT as toWeblinkPcSelection,
  ke as translation,
  Ec as useAppSettings,
  sa as useAssets,
  sp as useAuth,
  cl as useBodyContainerDiv,
  sL as useClientInfo,
  aL as useContextMenu,
  Hu as useGuiConfiguration,
  fM as useGuiConfigurationStore,
  kL as useInput,
  Zb as useLocalizationStore,
  xn as useModal,
  lL as useModals,
  oL as useMouseDrag,
  BB as useNavbar,
  os as useNotificationStore,
  ti as useOnClickOutside,
  ri as useOnGlobalKeyboardEvent,
  r_ as useReactiveModel,
  iL as useResizeObserver,
  DL as useSTLLibraryApi,
  pM as useSTLLibraryStore,
  SL as useServerApi,
  _L as useSessionManager,
  mM as useTestingProtocolStore,
  rL as useTooltip,
  Kn as useUserSettingsStore,
  Ef as useUserStore,
  Cf as useUtilStore,
  Na as userAddressQueryKey,
  cy as userAddressQueryOptions,
  ig as volumeFormats,
  XT as warn,
  Vu as weblinkUploadSupportedFormats,
  $u as writeStoredPrimaryTheme
};
//# sourceMappingURL=medicwebframework.js.map
